import * as React from 'react';
import React__default, { createContext, useState, useContext, forwardRef, useEffect, useRef, useCallback, useMemo, memo, Fragment as Fragment$1 } from 'react';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import registry, { Glyph } from './registry.js';
import { css, ClassNames, keyframes, createElement, Global } from '@emotion/react';
import AnimateHeight from 'react-animate-height';
import { CSSTransition, TransitionGroup, Transition } from 'react-transition-group';
import { useControlledState } from '@react-stately/utils';
import { FocusScope } from '@react-aria/focus';
import { createPortal } from 'react-dom';
import { useFloating as useFloating$1, arrow, offset as offset$1, size, flip, autoPlacement, autoUpdate } from '@floating-ui/react-dom';
import { VariableSizeList } from 'react-window';
import { addMonths, addYears } from 'date-fns';
import { useToaster, toast } from 'react-hot-toast';

var Breakpoint;
(function (Breakpoint) {
  Breakpoint["Sm"] = "sm";
  Breakpoint["Md"] = "md";
  Breakpoint["Lg"] = "lg";
  Breakpoint["Xl"] = "xl";
})(Breakpoint || (Breakpoint = {}));
var Color;
(function (Color) {
  Color["Dawn_1400"] = "dawn-1400";
  Color["Dawn_1300"] = "dawn-1300";
  Color["Dawn_1200"] = "dawn-1200";
  Color["Dawn_1100"] = "dawn-1100";
  Color["Dawn_1000"] = "dawn-1000";
  Color["Dawn_900"] = "dawn-900";
  Color["Dawn_800"] = "dawn-800";
  Color["Dawn_700"] = "dawn-700";
  Color["Dawn_600"] = "dawn-600";
  Color["Dawn_500"] = "dawn-500";
  Color["Dawn_400"] = "dawn-400";
  Color["Dawn_300"] = "dawn-300";
  Color["Dawn_200"] = "dawn-200";
  Color["Dawn_100"] = "dawn-100";
  Color["Dawn_50"] = "dawn-50";
  Color["Dawn_Base"] = "dawn-base";
  Color["Brownstone_1400"] = "brownstone-1400";
  Color["Brownstone_1400_A08"] = "brownstone-1400-a08";
  Color["Brownstone_1300"] = "brownstone-1300";
  Color["Brownstone_1200"] = "brownstone-1200";
  Color["Brownstone_1100"] = "brownstone-1100";
  Color["Brownstone_1000"] = "brownstone-1000";
  Color["Brownstone_900"] = "brownstone-900";
  Color["Brownstone_800"] = "brownstone-800";
  Color["Brownstone_700"] = "brownstone-700";
  Color["Brownstone_600"] = "brownstone-600";
  Color["Brownstone_500"] = "brownstone-500";
  Color["Brownstone_400"] = "brownstone-400";
  Color["Brownstone_300"] = "brownstone-300";
  Color["Brownstone_200"] = "brownstone-200";
  Color["Brownstone_100"] = "brownstone-100";
  Color["Brownstone_50"] = "brownstone-50";
  Color["Brownstone_700_A12"] = "brownstone-700-a12";
  Color["Brownstone_700_A21"] = "brownstone-700-a21";
  Color["Brownstone_Base"] = "brownstone-base";
  Color["Brownstone_Moonstone"] = "brownstone-moonstone";
  Color["Greystone_1400"] = "greystone-1400";
  Color["Greystone_1300"] = "greystone-1300";
  Color["Greystone_1200"] = "greystone-1200";
  Color["Greystone_1100"] = "greystone-1100";
  Color["Greystone_1000"] = "greystone-1000";
  Color["Greystone_900_A21"] = "greystone-900-a21";
  Color["Greystone_900"] = "greystone-900";
  Color["Greystone_800"] = "greystone-800";
  Color["Greystone_700"] = "greystone-700";
  Color["Greystone_600"] = "greystone-600";
  Color["Greystone_500"] = "greystone-500";
  Color["Greystone_400"] = "greystone-400";
  Color["Greystone_300"] = "greystone-300";
  Color["Greystone_200"] = "greystone-200";
  Color["Greystone_100"] = "greystone-100";
  Color["Greystone_50"] = "greystone-50";
  Color["Greystone_1400_A90"] = "greystone-1400-a90";
  Color["Greystone_1400_A50"] = "greystone-1400-a50";
  Color["Greystone_1400_A38"] = "greystone-1400-a38";
  Color["Greystone_1400_A16"] = "greystone-1400-a16";
  Color["Greystone_1400_A8"] = "greystone-1400-a8";
  Color["Greystone_700_A38"] = "greystone-700-a38";
  Color["Greystone_700_A16"] = "greystone-700-a16";
  Color["Greystone_Base"] = "greystone-base";
  Color["Greystone_DarkMatter"] = "greystone-darkmatter";
  Color["Sunset_1400"] = "sunset-1400";
  Color["Sunset_1300"] = "sunset-1300";
  Color["Sunset_1200"] = "sunset-1200";
  Color["Sunset_1100"] = "sunset-1100";
  Color["Sunset_1000"] = "sunset-1000";
  Color["Sunset_900"] = "sunset-900";
  Color["Sunset_800"] = "sunset-800";
  Color["Sunset_700"] = "sunset-700";
  Color["Sunset_600"] = "sunset-600";
  Color["Sunset_500"] = "sunset-500";
  Color["Sunset_400"] = "sunset-400";
  Color["Sunset_300"] = "sunset-300";
  Color["Sunset_200"] = "sunset-200";
  Color["Sunset_100"] = "sunset-100";
  Color["Sunset_50"] = "sunset-50";
  Color["Sunset_Base"] = "sunset-base";
  Color["Sunrise_1400"] = "sunrise-1400";
  Color["Sunrise_1300"] = "sunrise-1300";
  Color["Sunrise_1200"] = "sunrise-1200";
  Color["Sunrise_1100"] = "sunrise-1100";
  Color["Sunrise_1000"] = "sunrise-1000";
  Color["Sunrise_900"] = "sunrise-900";
  Color["Sunrise_800"] = "sunrise-800";
  Color["Sunrise_700"] = "sunrise-700";
  Color["Sunrise_600"] = "sunrise-600";
  Color["Sunrise_500"] = "sunrise-500";
  Color["Sunrise_400"] = "sunrise-400";
  Color["Sunrise_300"] = "sunrise-300";
  Color["Sunrise_200"] = "sunrise-200";
  Color["Sunrise_100"] = "sunrise-100";
  Color["Sunrise_50"] = "sunrise-50";
  Color["Sunrise_Base"] = "sunrise-base";
  Color["Slate_1400"] = "slate-1400";
  Color["Slate_1300"] = "slate-1300";
  Color["Slate_1200"] = "slate-1200";
  Color["Slate_1100"] = "slate-1100";
  Color["Slate_1000"] = "slate-1000";
  Color["Slate_900"] = "slate-900";
  Color["Slate_800"] = "slate-800";
  Color["Slate_700"] = "slate-700";
  Color["Slate_600"] = "slate-600";
  Color["Slate_500"] = "slate-500";
  Color["Slate_400"] = "slate-400";
  Color["Slate_300"] = "slate-300";
  Color["Slate_200"] = "slate-200";
  Color["Slate_100"] = "slate-100";
  Color["Slate_50"] = "slate-50";
  Color["Slate_Base"] = "slate-base";
  Color["Pebble_1400"] = "pebble-1400";
  Color["Pebble_1300"] = "pebble-1300";
  Color["Pebble_1200"] = "pebble-1200";
  Color["Pebble_1100"] = "pebble-1100";
  Color["Pebble_1000"] = "pebble-1000";
  Color["Pebble_900"] = "pebble-900";
  Color["Pebble_800"] = "pebble-800";
  Color["Pebble_700"] = "pebble-700";
  Color["Pebble_600"] = "pebble-600";
  Color["Pebble_500"] = "pebble-500";
  Color["Pebble_400"] = "pebble-400";
  Color["Pebble_300"] = "pebble-300";
  Color["Pebble_200"] = "pebble-200";
  Color["Pebble_100"] = "pebble-100";
  Color["Pebble_50"] = "pebble-50";
  Color["Pebble_Base"] = "pebble-base";
  Color["Ocean_1400"] = "ocean-1400";
  Color["Ocean_1300"] = "ocean-1300";
  Color["Ocean_1200"] = "ocean-1200";
  Color["Ocean_1100"] = "ocean-1100";
  Color["Ocean_1000"] = "ocean-1000";
  Color["Ocean_900"] = "ocean-900";
  Color["Ocean_800"] = "ocean-800";
  Color["Ocean_700"] = "ocean-700";
  Color["Ocean_600"] = "ocean-600";
  Color["Ocean_500"] = "ocean-500";
  Color["Ocean_400"] = "ocean-400";
  Color["Ocean_300"] = "ocean-300";
  Color["Ocean_200"] = "ocean-200";
  Color["Ocean_100"] = "ocean-100";
  Color["Ocean_50"] = "ocean-50";
  Color["Ocean_Base"] = "ocean-base";
  Color["Ultraviolet_1400"] = "ultraviolet-1400";
  Color["Ultraviolet_1300"] = "ultraviolet-1300";
  Color["Ultraviolet_1200"] = "ultraviolet-1200";
  Color["Ultraviolet_1100"] = "ultraviolet-1100";
  Color["Ultraviolet_1000"] = "ultraviolet-1000";
  Color["Ultraviolet_900"] = "ultraviolet-900";
  Color["Ultraviolet_800"] = "ultraviolet-800";
  Color["Ultraviolet_700"] = "ultraviolet-700";
  Color["Ultraviolet_600"] = "ultraviolet-600";
  Color["Ultraviolet_500"] = "ultraviolet-500";
  Color["Ultraviolet_400"] = "ultraviolet-400";
  Color["Ultraviolet_300"] = "ultraviolet-300";
  Color["Ultraviolet_200"] = "ultraviolet-200";
  Color["Ultraviolet_100"] = "ultraviolet-100";
  Color["Ultraviolet_50"] = "ultraviolet-50";
  Color["Ultraviolet_Base"] = "ultraviolet-base";
  Color["Dusk_1400"] = "dusk-1400";
  Color["Dusk_1300"] = "dusk-1300";
  Color["Dusk_1200"] = "dusk-1200";
  Color["Dusk_1100"] = "dusk-1100";
  Color["Dusk_1000"] = "dusk-1000";
  Color["Dusk_900"] = "dusk-900";
  Color["Dusk_800"] = "dusk-800";
  Color["Dusk_700"] = "dusk-700";
  Color["Dusk_600"] = "dusk-600";
  Color["Dusk_500"] = "dusk-500";
  Color["Dusk_400"] = "dusk-400";
  Color["Dusk_300"] = "dusk-300";
  Color["Dusk_200"] = "dusk-200";
  Color["Dusk_100"] = "dusk-100";
  Color["Dusk_50"] = "dusk-50";
  Color["Dusk_Base"] = "dusk-base";
  Color["Clay_1400"] = "clay-1400";
  Color["Clay_1300"] = "clay-1300";
  Color["Clay_1200"] = "clay-1200";
  Color["Clay_1100"] = "clay-1100";
  Color["Clay_1000"] = "clay-1000";
  Color["Clay_900"] = "clay-900";
  Color["Clay_800"] = "clay-800";
  Color["Clay_700"] = "clay-700";
  Color["Clay_600"] = "clay-600";
  Color["Clay_500"] = "clay-500";
  Color["Clay_400"] = "clay-400";
  Color["Clay_300"] = "clay-300";
  Color["Clay_200"] = "clay-200";
  Color["Clay_100"] = "clay-100";
  Color["Clay_50"] = "clay-50";
  Color["Clay_Base"] = "clay-base";
  Color["Evergreen_1400"] = "evergreen-1400";
  Color["Evergreen_1300"] = "evergreen-1300";
  Color["Evergreen_1200"] = "evergreen-1200";
  Color["Evergreen_1100"] = "evergreen-1100";
  Color["Evergreen_1000"] = "evergreen-1000";
  Color["Evergreen_900"] = "evergreen-900";
  Color["Evergreen_800"] = "evergreen-800";
  Color["Evergreen_700"] = "evergreen-700";
  Color["Evergreen_600"] = "evergreen-600";
  Color["Evergreen_500"] = "evergreen-500";
  Color["Evergreen_400"] = "evergreen-400";
  Color["Evergreen_300"] = "evergreen-300";
  Color["Evergreen_200"] = "evergreen-200";
  Color["Evergreen_100"] = "evergreen-100";
  Color["Evergreen_50"] = "evergreen-50";
  Color["Evergreen_Base"] = "evergreen-base";
  Color["Alert_500"] = "alert-500";
  Color["Alert_400"] = "alert-400";
  Color["Alert_300"] = "alert-300";
  Color["Alert_200"] = "alert-200";
  Color["Alert_100"] = "alert-100";
  Color["Alert_50"] = "alert-50";
  Color["Alert_Base"] = "alert-base";
  Color["Alert_50_A25"] = "alert-50-a25";
  Color["Warning_500"] = "warning-500";
  Color["Warning_400"] = "warning-400";
  Color["Warning_300"] = "warning-300";
  Color["Warning_200"] = "warning-200";
  Color["Warning_100"] = "warning-100";
  Color["Warning_50"] = "warning-50";
  Color["Warning_Base"] = "warning-base";
  Color["Warning_50_A25"] = "warning-50-a25";
  Color["Success_500"] = "success-500";
  Color["Success_400"] = "success-400";
  Color["Success_300"] = "success-300";
  Color["Success_200"] = "success-200";
  Color["Success_100"] = "success-100";
  Color["Success_50"] = "success-50";
  Color["Success_Base"] = "success-base";
  Color["Success_50_A25"] = "success-50-a25";
  Color["Info_500"] = "info-500";
  Color["Info_400"] = "info-400";
  Color["Info_300"] = "info-300";
  Color["Info_200"] = "info-200";
  Color["Info_100"] = "info-100";
  Color["Info_50"] = "info-50";
  Color["Info_Base"] = "info-base";
  Color["Info_50_A25"] = "info-50-a25";
  Color["White"] = "white";
  Color["White_A25"] = "white-a25";
  Color["White_A12"] = "white-a12";
  Color["Transparent"] = "transparent";
})(Color || (Color = {}));
var ColorPreset;
(function (ColorPreset) {
  ColorPreset["BackgroundLight_00"] = "background-light-00";
  ColorPreset["BackgroundLight_01"] = "background-light-01";
  ColorPreset["BackgroundLight_02"] = "background-light-02";
  ColorPreset["BackgroundLight_03"] = "background-light-03";
  ColorPreset["BackgroundLight_04"] = "background-light-04";
  ColorPreset["BackgroundDark_01"] = "background-dark-01";
  ColorPreset["BackgroundDark_02"] = "background-dark-02";
  ColorPreset["BackgroundDark_03"] = "background-dark-03";
  ColorPreset["BackgroundDark_04"] = "background-dark-04";
  ColorPreset["TextOnLight_01"] = "text-on-light-01";
  ColorPreset["TextOnLight_02"] = "text-on-light-02";
  ColorPreset["TextOnLight_03"] = "text-on-light-03";
  ColorPreset["TextOnDark_00"] = "text-on-dark-00";
  ColorPreset["TextOnDark_01"] = "text-on-dark-01";
  ColorPreset["TextOnDark_02"] = "text-on-dark-02";
  ColorPreset["TextOnDark_03"] = "text-on-dark-03";
  ColorPreset["IconOnLight_01"] = "icon-on-light-01";
  ColorPreset["IconOnLight_02"] = "icon-on-light-02";
  ColorPreset["IconOnLight_03"] = "icon-on-light-03";
  ColorPreset["IconOnLight_04"] = "icon-on-light-04";
  ColorPreset["IconOnDark_00"] = "icon-on-dark-00";
  ColorPreset["IconOnDark_01"] = "icon-on-dark-01";
  ColorPreset["IconOnDark_02"] = "icon-on-dark-02";
  ColorPreset["IconOnDark_03"] = "icon-on-dark-03";
  ColorPreset["IconOnDark_04"] = "icon-on-dark-04";
  ColorPreset["BorderOnLight_01"] = "border-on-light-01";
  ColorPreset["BorderOnLight_02"] = "border-on-light-02";
  ColorPreset["BorderOnLight_03"] = "border-on-light-03";
  ColorPreset["BorderOnLight_04"] = "border-on-light-04";
  ColorPreset["BorderOnLight_05"] = "border-on-light-05";
  ColorPreset["BorderOnDark_01"] = "border-on-dark-01";
  ColorPreset["BorderOnDark_02"] = "border-on-dark-02";
  ColorPreset["BorderOnDark_03"] = "border-on-dark-03";
  ColorPreset["BorderOnDark_04"] = "border-on-dark-04";
  ColorPreset["BorderOnDark_05"] = "border-on-dark-05";
  ColorPreset["AlertTextOnLight"] = "alert-text-on-light";
  ColorPreset["AlertIconOnLight"] = "alert-icon-on-light";
  ColorPreset["AlertBorderOnLight"] = "alert-border-on-light";
  ColorPreset["AlertTextOnDark"] = "alert-text-on-dark";
  ColorPreset["AlertIconOnDark"] = "alert-icon-on-dark";
  ColorPreset["AlertBorderOnDark"] = "alert-border-on-dark";
  ColorPreset["DataOnLight_01"] = "data-on-light-01";
  ColorPreset["DataOnLight_02"] = "data-on-light-02";
  ColorPreset["DataOnLight_03"] = "data-on-light-03";
  ColorPreset["DataOnLight_04"] = "data-on-light-04";
  ColorPreset["DataOnLight_05"] = "data-on-light-05";
  ColorPreset["DataOnLight_06"] = "data-on-light-06";
  ColorPreset["DataOnLight_07"] = "data-on-light-07";
  ColorPreset["DataOnLight_08"] = "data-on-light-08";
  ColorPreset["DataOnDark_01"] = "data-on-dark-01";
  ColorPreset["DataOnDark_02"] = "data-on-dark-02";
  ColorPreset["DataOnDark_03"] = "data-on-dark-03";
  ColorPreset["DataOnDark_04"] = "data-on-dark-04";
  ColorPreset["DataOnDark_05"] = "data-on-dark-05";
  ColorPreset["DataOnDark_06"] = "data-on-dark-06";
  ColorPreset["DataOnDark_07"] = "data-on-dark-07";
  ColorPreset["DataOnDark_08"] = "data-on-dark-08";
})(ColorPreset || (ColorPreset = {}));
var ButtonSize;
(function (ButtonSize) {
  ButtonSize["Sm"] = "sm";
  ButtonSize["Md"] = "md";
  ButtonSize["Lg"] = "lg";
})(ButtonSize || (ButtonSize = {}));
var TooltipTheme;
(function (TooltipTheme) {
  TooltipTheme["Light"] = "light";
  TooltipTheme["Dark"] = "dark";
})(TooltipTheme || (TooltipTheme = {}));
var FontWeight;
(function (FontWeight) {
  FontWeight[FontWeight["Light"] = 300] = "Light";
  FontWeight[FontWeight["Normal"] = 400] = "Normal";
  FontWeight[FontWeight["Medium"] = 500] = "Medium";
  FontWeight[FontWeight["SemiBold"] = 600] = "SemiBold";
  FontWeight[FontWeight["Bold"] = 700] = "Bold";
})(FontWeight || (FontWeight = {}));
var FontStyle;
(function (FontStyle) {
  FontStyle["Normal"] = "normal";
  FontStyle["Italic"] = "italic";
})(FontStyle || (FontStyle = {}));
var TypeScale;
(function (TypeScale) {
  TypeScale[TypeScale["Size_01"] = 1] = "Size_01";
  TypeScale[TypeScale["Size_02"] = 2] = "Size_02";
  TypeScale[TypeScale["Size_03"] = 3] = "Size_03";
  TypeScale[TypeScale["Size_04"] = 4] = "Size_04";
  TypeScale[TypeScale["Size_05"] = 5] = "Size_05";
  TypeScale[TypeScale["Size_06"] = 6] = "Size_06";
  TypeScale[TypeScale["Size_07"] = 7] = "Size_07";
  TypeScale[TypeScale["Size_08"] = 8] = "Size_08";
  TypeScale[TypeScale["Size_09"] = 9] = "Size_09";
  TypeScale[TypeScale["Size_10"] = 10] = "Size_10";
  TypeScale[TypeScale["Size_11"] = 11] = "Size_11";
  TypeScale[TypeScale["Size_12"] = 12] = "Size_12";
  TypeScale[TypeScale["Size_13"] = 13] = "Size_13";
  TypeScale[TypeScale["Size_14"] = 14] = "Size_14";
  TypeScale[TypeScale["Size_15"] = 15] = "Size_15";
  TypeScale[TypeScale["Size_16"] = 16] = "Size_16";
  TypeScale[TypeScale["Size_17"] = 17] = "Size_17";
  TypeScale[TypeScale["Size_18"] = 18] = "Size_18";
  TypeScale[TypeScale["Size_19"] = 19] = "Size_19";
  TypeScale[TypeScale["Size_20"] = 20] = "Size_20";
  TypeScale[TypeScale["Size_21"] = 21] = "Size_21";
  TypeScale[TypeScale["Size_22"] = 22] = "Size_22";
})(TypeScale || (TypeScale = {}));
var TypePreset;
(function (TypePreset) {
  TypePreset["Body_01"] = "body-01";
  TypePreset["Body_02"] = "body-02";
  TypePreset["Body_03"] = "body-03";
  TypePreset["Body_04"] = "body-04";
  TypePreset["LongForm_01"] = "longform-01";
  TypePreset["LongForm_02"] = "longform-02";
  TypePreset["LongForm_03"] = "longform-03";
  TypePreset["LongForm_04"] = "longform-04";
  TypePreset["Caption_01"] = "caption-01";
  TypePreset["Heading_01"] = "heading-01";
  TypePreset["Heading_02"] = "heading-02";
  TypePreset["Heading_03"] = "heading-03";
  TypePreset["Heading_04"] = "heading-04";
  TypePreset["Heading_05"] = "heading-05";
  TypePreset["Heading_06"] = "heading-06";
  TypePreset["Heading_07"] = "heading-07";
  TypePreset["Heading_08"] = "heading-08";
  TypePreset["Heading_09"] = "heading-09";
  TypePreset["Code_01"] = "code-01";
  TypePreset["Code_02"] = "code-02";
  TypePreset["Code_03"] = "code-03";
  TypePreset["Code_04"] = "code-04";
  TypePreset["Subheading_01"] = "subheading-01";
  TypePreset["Subheading_02"] = "subheading-02";
  TypePreset["Quote_01"] = "quote-01";
  TypePreset["Quote_02"] = "quote-02";
  TypePreset["Display_01"] = "display-01";
  TypePreset["Display_02"] = "display-02";
})(TypePreset || (TypePreset = {}));
var AlignItems;
(function (AlignItems) {
  AlignItems["Start"] = "start";
  AlignItems["End"] = "end";
  AlignItems["FlexStart"] = "flex-start";
  AlignItems["FlexEnd"] = "flex-end";
  AlignItems["Center"] = "center";
  AlignItems["Stretch"] = "stretch";
  AlignItems["Baseline"] = "baseline";
})(AlignItems || (AlignItems = {}));
var AlignContent;
(function (AlignContent) {
  AlignContent["Start"] = "start";
  AlignContent["End"] = "end";
  AlignContent["FlexStart"] = "flex-start";
  AlignContent["FlexEnd"] = "flex-end";
  AlignContent["Center"] = "center";
  AlignContent["SpaceAround"] = "space-around";
  AlignContent["SpaceBetween"] = "space-between";
})(AlignContent || (AlignContent = {}));
var JustifyItems;
(function (JustifyItems) {
  JustifyItems["Auto"] = "auto";
  JustifyItems["Normal"] = "normal";
  JustifyItems["Stretch"] = "stretch";
  JustifyItems["Start"] = "start";
  JustifyItems["End"] = "end";
  JustifyItems["Baseline"] = "baseline";
  JustifyItems["Center"] = "center";
})(JustifyItems || (JustifyItems = {}));
var JustifyContent;
(function (JustifyContent) {
  JustifyContent["Start"] = "start";
  JustifyContent["End"] = "end";
  JustifyContent["FlexStart"] = "flex-start";
  JustifyContent["FlexEnd"] = "flex-end";
  JustifyContent["Center"] = "center";
  JustifyContent["SpaceAround"] = "space-around";
  JustifyContent["SpaceBetween"] = "space-between";
})(JustifyContent || (JustifyContent = {}));
var TextAlign;
(function (TextAlign) {
  TextAlign["Left"] = "left";
  TextAlign["Right"] = "right";
  TextAlign["Center"] = "center";
  TextAlign["Justify"] = "justify";
})(TextAlign || (TextAlign = {}));
var TextWrap;
(function (TextWrap) {
  TextWrap["Normal"] = "normal";
  TextWrap["NoWrap"] = "nowrap";
})(TextWrap || (TextWrap = {}));
var Overflow;
(function (Overflow) {
  Overflow["Visible"] = "visible";
  Overflow["Hidden"] = "hidden";
  Overflow["Auto"] = "auto";
  Overflow["Scroll"] = "scroll";
})(Overflow || (Overflow = {}));
var ZIndex;
(function (ZIndex) {
  ZIndex[ZIndex["SecondaryNavigation"] = 100] = "SecondaryNavigation";
  ZIndex[ZIndex["Sidebar"] = 200] = "Sidebar";
  ZIndex[ZIndex["Dropdown"] = 300] = "Dropdown";
  ZIndex[ZIndex["Dialog"] = 400] = "Dialog";
  ZIndex[ZIndex["Tooltip"] = 450] = "Tooltip";
  ZIndex[ZIndex["Toast"] = 500] = "Toast";
  // keep this as the highest z-index
  ZIndex[ZIndex["SkipLink"] = 600] = "SkipLink";
})(ZIndex || (ZIndex = {}));
var HoverEffect;
(function (HoverEffect) {
  HoverEffect["Lift"] = "lift";
  HoverEffect["TextDecoration"] = "text-decoration";
})(HoverEffect || (HoverEffect = {}));
var ColorScheme;
(function (ColorScheme) {
  ColorScheme["OnLight"] = "on-light";
  ColorScheme["OnDark"] = "on-dark";
  ColorScheme["Auto"] = "auto";
})(ColorScheme || (ColorScheme = {}));
var InputGutter;
(function (InputGutter) {
  InputGutter["Sm"] = "sm";
  InputGutter["Md"] = "md";
})(InputGutter || (InputGutter = {}));
var FocusRing;
(function (FocusRing) {
  FocusRing["Heavy"] = "heavy";
  FocusRing["Inner"] = "inner";
})(FocusRing || (FocusRing = {}));
var AccessorySize;
(function (AccessorySize) {
  AccessorySize["Sm"] = "Sm";
  AccessorySize["Md"] = "Md";
  AccessorySize["Lg"] = "Lg";
})(AccessorySize || (AccessorySize = {}));

/* eslint-disable deprecation/deprecation */
const fontFamiliesConfig = {
  baseFontFamily: 'Haffer, "Helvetica Neue", Helvetica, Arial, sans-serif',
  serifFontFamily: "Para, Georgia, serif",
  monospaceFontFamily: '"DM Mono", Monaco, "Consolas", "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace',
  displayFontFamily: 'Nudge, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
const colors = {
  [Color.Dawn_1400]: "#252603",
  [Color.Dawn_1300]: "#4b4b06",
  [Color.Dawn_1200]: "#707109",
  [Color.Dawn_1100]: "#96970b",
  [Color.Dawn_1000]: "#bbbc0e",
  [Color.Dawn_900]: "#e1e211",
  [Color.Dawn_800]: "#eeef2d",
  [Color.Dawn_700]: "#f1f252",
  [Color.Dawn_600]: "#f3f468",
  [Color.Dawn_500]: "#f4f57d",
  [Color.Dawn_400]: "#f6f793",
  [Color.Dawn_300]: "#f8f9a9",
  [Color.Dawn_200]: "#fafabe",
  [Color.Dawn_100]: "#fbfcd4",
  [Color.Dawn_50]: "#fdfde9",
  [Color.Dawn_Base]: "#f1f252",
  [Color.Brownstone_1400]: "#1e1a14",
  [Color.Brownstone_1400_A08]: "rgba(30, 26, 20, 0.8)",
  [Color.Brownstone_1300]: "#3c3428",
  [Color.Brownstone_1200]: "#5b4e3c",
  [Color.Brownstone_1100]: "#796850",
  [Color.Brownstone_1000]: "#978264",
  [Color.Brownstone_900]: "#ac9b82",
  [Color.Brownstone_800]: "#c0b3a0",
  [Color.Brownstone_700]: "#d4cbbe",
  [Color.Brownstone_600]: "#d9d2c6",
  [Color.Brownstone_500]: "#dfd8ce",
  [Color.Brownstone_400]: "#e4dfd6",
  [Color.Brownstone_300]: "#eae5df",
  [Color.Brownstone_200]: "#efece7",
  [Color.Brownstone_100]: "#f4f2ef",
  [Color.Brownstone_50]: "#faf9f7",
  [Color.Brownstone_700_A12]: "rgba(212, 203, 190, 0.12)",
  [Color.Brownstone_700_A21]: "rgba(212, 203, 190, 0.21)",
  [Color.Brownstone_Base]: "#d4cbbe",
  [Color.Brownstone_Moonstone]: "#efece7",
  [Color.Greystone_1400]: "#1c1b18",
  [Color.Greystone_1300]: "#383530",
  [Color.Greystone_1200]: "#545048",
  [Color.Greystone_1100]: "#6e685e",
  [Color.Greystone_1000]: "#8c8579",
  [Color.Greystone_900]: "#a49e95",
  [Color.Greystone_900_A21]: "#a49e9536",
  [Color.Greystone_800]: "#bcb8b1",
  [Color.Greystone_700]: "#d4d1cd",
  [Color.Greystone_600]: "#d9d7d3",
  [Color.Greystone_500]: "#dfddda",
  [Color.Greystone_400]: "#e4e2e0",
  [Color.Greystone_300]: "#eae8e6",
  [Color.Greystone_200]: "#efeeec",
  [Color.Greystone_100]: "#f4f4f3",
  [Color.Greystone_50]: "#faf9f9",
  [Color.Greystone_1400_A90]: "rgba(28, 27, 24, 0.9)",
  [Color.Greystone_1400_A50]: "rgba(28, 27, 24, 0.5)",
  [Color.Greystone_1400_A38]: "rgba(28, 27, 24, 0.38)",
  [Color.Greystone_1400_A16]: "rgba(28, 27, 24, 0.16)",
  [Color.Greystone_1400_A8]: "rgba(28, 27, 24, 0.08)",
  [Color.Greystone_700_A38]: "rgba(212, 209, 205, 0.38)",
  [Color.Greystone_700_A16]: "rgba(212, 209, 205, 0.16)",
  [Color.Greystone_Base]: "#d4d1cd",
  [Color.Greystone_DarkMatter]: "#1c1b18",
  [Color.Sunset_1400]: "#230c00",
  [Color.Sunset_1300]: "#461700",
  [Color.Sunset_1200]: "#692300",
  [Color.Sunset_1100]: "#8c2f00",
  [Color.Sunset_1000]: "#af3a00",
  [Color.Sunset_900]: "#d24600",
  [Color.Sunset_800]: "#f55200",
  [Color.Sunset_700]: "#ff6619",
  [Color.Sunset_600]: "#ff7936",
  [Color.Sunset_500]: "#ff8c53",
  [Color.Sunset_400]: "#ff9f70",
  [Color.Sunset_300]: "#ffb38c",
  [Color.Sunset_200]: "#ffc6a9",
  [Color.Sunset_100]: "#ffd9c6",
  [Color.Sunset_50]: "#ffece2",
  [Color.Sunset_Base]: "#ff6619",
  [Color.Sunrise_1400]: "#251900",
  [Color.Sunrise_1300]: "#493100",
  [Color.Sunrise_1200]: "#6e4a00",
  [Color.Sunrise_1100]: "#936300",
  [Color.Sunrise_1000]: "#b77b00",
  [Color.Sunrise_900]: "#dc9400",
  [Color.Sunrise_800]: "#ffac01",
  [Color.Sunrise_700]: "#ffb826",
  [Color.Sunrise_600]: "#ffc141",
  [Color.Sunrise_500]: "#ffca5c",
  [Color.Sunrise_400]: "#ffd377",
  [Color.Sunrise_300]: "#ffdc93",
  [Color.Sunrise_200]: "#ffe4ae",
  [Color.Sunrise_100]: "#ffedc9",
  [Color.Sunrise_50]: "#fff6e4",
  [Color.Sunrise_Base]: "#ffb826",
  [Color.Slate_1400]: "#060807",
  [Color.Slate_1300]: "#0c100e",
  [Color.Slate_1200]: "#121815",
  [Color.Slate_1100]: "#18211c",
  [Color.Slate_1000]: "#1e2924",
  [Color.Slate_900]: "#25312b",
  [Color.Slate_800]: "#2b3932",
  [Color.Slate_700]: "#314139",
  [Color.Slate_600]: "#465d52",
  [Color.Slate_500]: "#5b7a6a",
  [Color.Slate_400]: "#719583",
  [Color.Slate_300]: "#8eaa9c",
  [Color.Slate_200]: "#aabfb5",
  [Color.Slate_100]: "#c6d5cd",
  [Color.Slate_50]: "#e3eae6",
  [Color.Slate_Base]: "#314139",
  [Color.Pebble_1400]: "#102019",
  [Color.Pebble_1300]: "#203f33",
  [Color.Pebble_1200]: "#305f4c",
  [Color.Pebble_1100]: "#407e66",
  [Color.Pebble_1000]: "#509e7f",
  [Color.Pebble_900]: "#6ab497",
  [Color.Pebble_800]: "#8ac4ad",
  [Color.Pebble_700]: "#a9d4c3",
  [Color.Pebble_600]: "#b4d9ca",
  [Color.Pebble_500]: "#bfded2",
  [Color.Pebble_400]: "#c9e4d9",
  [Color.Pebble_300]: "#d4e9e1",
  [Color.Pebble_200]: "#dfefe8",
  [Color.Pebble_100]: "#eaf4f0",
  [Color.Pebble_50]: "#f4faf7",
  [Color.Pebble_Base]: "#a9d4c3",
  [Color.Ocean_1400]: "#021a1d",
  [Color.Ocean_1300]: "#04343a",
  [Color.Ocean_1200]: "#064e57",
  [Color.Ocean_1100]: "#086774",
  [Color.Ocean_1000]: "#0a8191",
  [Color.Ocean_900]: "#0c9bae",
  [Color.Ocean_800]: "#0eb5cb",
  [Color.Ocean_700]: "#10cfe8",
  [Color.Ocean_600]: "#29d9f0",
  [Color.Ocean_500]: "#48def2",
  [Color.Ocean_400]: "#66e4f4",
  [Color.Ocean_300]: "#85e9f6",
  [Color.Ocean_200]: "#a3eff9",
  [Color.Ocean_100]: "#c2f4fb",
  [Color.Ocean_50]: "#e0fafd",
  [Color.Ocean_Base]: "#10cfe8",
  [Color.Ultraviolet_1400]: "#0a081b",
  [Color.Ultraviolet_1300]: "#140f36",
  [Color.Ultraviolet_1200]: "#1e1751",
  [Color.Ultraviolet_1100]: "#281f6b",
  [Color.Ultraviolet_1000]: "#322686",
  [Color.Ultraviolet_900]: "#3c2ea1",
  [Color.Ultraviolet_800]: "#4636bc",
  [Color.Ultraviolet_700]: "#5949cb",
  [Color.Ultraviolet_600]: "#6e60d2",
  [Color.Ultraviolet_500]: "#8377d8",
  [Color.Ultraviolet_400]: "#978ddf",
  [Color.Ultraviolet_300]: "#aca4e5",
  [Color.Ultraviolet_200]: "#c1bbec",
  [Color.Ultraviolet_100]: "#d6d2f2",
  [Color.Ultraviolet_50]: "#eae8f9",
  [Color.Ultraviolet_Base]: "#5949cb",
  [Color.Dusk_1400]: "#2a0928",
  [Color.Dusk_1300]: "#541250",
  [Color.Dusk_1200]: "#7e1c77",
  [Color.Dusk_1100]: "#a8259f",
  [Color.Dusk_1000]: "#d22fc6",
  [Color.Dusk_900]: "#db59d2",
  [Color.Dusk_800]: "#e483dd",
  [Color.Dusk_700]: "#edade9",
  [Color.Dusk_600]: "#efb7eb",
  [Color.Dusk_500]: "#f2c2ee",
  [Color.Dusk_400]: "#f4ccf1",
  [Color.Dusk_300]: "#f6d6f4",
  [Color.Dusk_200]: "#f8e0f7",
  [Color.Dusk_100]: "#fbebf9",
  [Color.Dusk_50]: "#fdf5fc",
  [Color.Dusk_Base]: "#edade9",
  [Color.Clay_1400]: "#130a07",
  [Color.Clay_1300]: "#25130f",
  [Color.Clay_1200]: "#381d16",
  [Color.Clay_1100]: "#4a261d",
  [Color.Clay_1000]: "#5d3024",
  [Color.Clay_900]: "#6f392c",
  [Color.Clay_800]: "#824333",
  [Color.Clay_700]: "#944c3a",
  [Color.Clay_600]: "#af5a45",
  [Color.Clay_500]: "#bf6f5b",
  [Color.Clay_400]: "#ca8776",
  [Color.Clay_300]: "#d49f92",
  [Color.Clay_200]: "#dfb7ad",
  [Color.Clay_100]: "#eacfc8",
  [Color.Clay_50]: "#f4e7e4",
  [Color.Clay_Base]: "#944c3a",
  [Color.Evergreen_1400]: "#0b1d0c",
  [Color.Evergreen_1300]: "#153918",
  [Color.Evergreen_1200]: "#205624",
  [Color.Evergreen_1100]: "#2b7230",
  [Color.Evergreen_1000]: "#368f3d",
  [Color.Evergreen_900]: "#40ab49",
  [Color.Evergreen_800]: "#54bf5c",
  [Color.Evergreen_700]: "#71c978",
  [Color.Evergreen_600]: "#83d089",
  [Color.Evergreen_500]: "#94d799",
  [Color.Evergreen_400]: "#a6deaa",
  [Color.Evergreen_300]: "#b8e4bb",
  [Color.Evergreen_200]: "#caebcc",
  [Color.Evergreen_100]: "#dbf2dd",
  [Color.Evergreen_50]: "#edf8ee",
  [Color.Evergreen_Base]: "#71c978",
  [Color.Alert_500]: "#b02a2a",
  [Color.Alert_400]: "#c52f2f",
  [Color.Alert_300]: "#d13f3f",
  [Color.Alert_200]: "#da6565",
  [Color.Alert_100]: "#df7878",
  [Color.Alert_50]: "#f4cfcf",
  [Color.Alert_Base]: "#d13f3f",
  [Color.Alert_50_A25]: "rgba(244, 207, 207, 0.25)",
  [Color.Warning_500]: "#a15000",
  [Color.Warning_400]: "#b65b00",
  [Color.Warning_300]: "#ca6500",
  [Color.Warning_200]: "#eb7908",
  [Color.Warning_100]: "#f08a25",
  [Color.Warning_50]: "#ffe0c1",
  [Color.Warning_Base]: "#ca6500",
  [Color.Warning_50_A25]: "rgba(255, 224, 193, 0.25)",
  [Color.Success_500]: "#0b6f4a",
  [Color.Success_400]: "#0c764f",
  [Color.Success_300]: "#0d8559",
  [Color.Success_200]: "#12b378",
  [Color.Success_100]: "#14c383",
  [Color.Success_50]: "#d0f5e7",
  [Color.Success_Base]: "#0d8559",
  [Color.Success_50_A25]: "rgba(192, 249, 228, 0.25)",
  [Color.Info_500]: "#2457be",
  [Color.Info_400]: "#2862d6",
  [Color.Info_300]: "#4074db",
  [Color.Info_200]: "#6690e2",
  [Color.Info_100]: "#799de6",
  [Color.Info_50]: "#d9e3f8",
  [Color.Info_Base]: "#4074db",
  [Color.Info_50_A25]: "rgba(217, 227, 248, 0.25)",
  [Color.White]: "#ffffff",
  [Color.White_A25]: "rgba(255, 255, 255, 0.25)",
  // TODO: support decimals in enum member names.
  // Currently A12 is representing an opacity of 0.125
  [Color.White_A12]: "rgba(255, 255, 255, 0.125)",
  [Color.Transparent]: "transparent"
};
const colorPresets = {
  [ColorPreset.BackgroundLight_00]: colors[Color.Dawn_700],
  [ColorPreset.BackgroundLight_01]: colors[Color.White],
  [ColorPreset.BackgroundLight_02]: colors[Color.Brownstone_50],
  [ColorPreset.BackgroundLight_03]: colors[Color.Brownstone_Moonstone],
  [ColorPreset.BackgroundLight_04]: colors[Color.Brownstone_300],
  [ColorPreset.BackgroundDark_01]: colors[Color.Brownstone_1400],
  [ColorPreset.BackgroundDark_02]: colors[Color.Slate_1100],
  [ColorPreset.BackgroundDark_03]: colors[Color.Slate_900],
  [ColorPreset.BackgroundDark_04]: colors[Color.Slate_700],
  [ColorPreset.TextOnLight_01]: colors[Color.Greystone_DarkMatter],
  [ColorPreset.TextOnLight_02]: colors[Color.Greystone_1200],
  [ColorPreset.TextOnLight_03]: colors[Color.Greystone_1100],
  [ColorPreset.TextOnDark_00]: colors[Color.Dawn_Base],
  [ColorPreset.TextOnDark_01]: colors[Color.Brownstone_Moonstone],
  [ColorPreset.TextOnDark_02]: colors[Color.Greystone_700],
  [ColorPreset.TextOnDark_03]: colors[Color.Greystone_800],
  [ColorPreset.IconOnLight_01]: colors[Color.Greystone_DarkMatter],
  [ColorPreset.IconOnLight_02]: colors[Color.Greystone_1200],
  [ColorPreset.IconOnLight_03]: colors[Color.Greystone_1100],
  [ColorPreset.IconOnLight_04]: colors[Color.Greystone_1100],
  [ColorPreset.IconOnDark_00]: colors[Color.Dawn_Base],
  [ColorPreset.IconOnDark_01]: colors[Color.Brownstone_Moonstone],
  [ColorPreset.IconOnDark_02]: colors[Color.Greystone_700],
  [ColorPreset.IconOnDark_03]: colors[Color.Greystone_800],
  [ColorPreset.IconOnDark_04]: colors[Color.Greystone_900],
  [ColorPreset.BorderOnLight_01]: colors[Color.Greystone_DarkMatter],
  [ColorPreset.BorderOnLight_02]: colors[Color.Greystone_1000],
  [ColorPreset.BorderOnLight_03]: colors[Color.Greystone_800],
  [ColorPreset.BorderOnLight_04]: colors[Color.Greystone_500],
  [ColorPreset.BorderOnLight_05]: colors[Color.Greystone_1400_A16],
  [ColorPreset.BorderOnDark_01]: colors[Color.Brownstone_Moonstone],
  [ColorPreset.BorderOnDark_02]: colors[Color.Greystone_1000],
  [ColorPreset.BorderOnDark_03]: colors[Color.Greystone_1200],
  [ColorPreset.BorderOnDark_04]: colors[Color.Greystone_1300],
  [ColorPreset.BorderOnDark_05]: colors[Color.White_A25],
  [ColorPreset.AlertTextOnLight]: colors[Color.Alert_400],
  [ColorPreset.AlertIconOnLight]: colors[Color.Alert_300],
  [ColorPreset.AlertBorderOnLight]: colors[Color.Alert_300],
  [ColorPreset.AlertTextOnDark]: colors[Color.Alert_100],
  [ColorPreset.AlertIconOnDark]: colors[Color.Alert_200],
  [ColorPreset.AlertBorderOnDark]: colors[Color.Alert_200],
  [ColorPreset.DataOnLight_01]: colors[Color.Sunset_800],
  [ColorPreset.DataOnLight_02]: colors[Color.Ultraviolet_700],
  [ColorPreset.DataOnLight_03]: colors[Color.Pebble_1000],
  [ColorPreset.DataOnLight_04]: colors[Color.Dusk_900],
  [ColorPreset.DataOnLight_05]: colors[Color.Clay_700],
  [ColorPreset.DataOnLight_06]: colors[Color.Sunrise_1000],
  [ColorPreset.DataOnLight_07]: colors[Color.Evergreen_1000],
  [ColorPreset.DataOnLight_08]: colors[Color.Ocean_900],
  [ColorPreset.DataOnDark_01]: colors[Color.Sunset_600],
  [ColorPreset.DataOnDark_02]: colors[Color.Ultraviolet_400],
  [ColorPreset.DataOnDark_03]: colors[Color.Pebble_800],
  [ColorPreset.DataOnDark_04]: colors[Color.Dusk_800],
  [ColorPreset.DataOnDark_05]: colors[Color.Clay_400],
  [ColorPreset.DataOnDark_06]: colors[Color.Sunrise_600],
  [ColorPreset.DataOnDark_07]: colors[Color.Evergreen_700],
  [ColorPreset.DataOnDark_08]: colors[Color.Ocean_600]
};
const defaultDesignTokens = {
  fontFamilies: {
    "sans-serif": fontFamiliesConfig.baseFontFamily,
    display: fontFamiliesConfig.displayFontFamily,
    monospace: fontFamiliesConfig.monospaceFontFamily,
    serif: fontFamiliesConfig.serifFontFamily
  },
  spacingBase: 16,
  borderRadiusBase: 16,
  breakpoints: {
    [Breakpoint.Sm]: "480px",
    [Breakpoint.Md]: "768px",
    [Breakpoint.Lg]: "1120px",
    [Breakpoint.Xl]: "1600px"
  },
  contentMaxWidth: ["100vw", "540px", "90vw", null, "1360px"],
  fontSizes: {
    [TypeScale.Size_01]: {
      fontSize: "12px",
      lineHeight: "16px"
    },
    [TypeScale.Size_02]: {
      fontSize: "14px",
      lineHeight: "20px"
    },
    [TypeScale.Size_03]: {
      fontSize: "16px",
      lineHeight: "22px"
    },
    [TypeScale.Size_04]: {
      fontSize: "18px",
      lineHeight: "24px"
    },
    [TypeScale.Size_05]: {
      fontSize: "20px",
      lineHeight: "28px"
    },
    [TypeScale.Size_06]: {
      fontSize: "24px",
      lineHeight: "32px"
    },
    [TypeScale.Size_07]: {
      fontSize: "28px",
      lineHeight: "34px"
    },
    [TypeScale.Size_08]: {
      fontSize: "32px",
      lineHeight: "38px"
    },
    [TypeScale.Size_09]: {
      fontSize: "36px",
      lineHeight: "44px"
    },
    [TypeScale.Size_10]: {
      fontSize: "42px",
      lineHeight: "50px"
    },
    [TypeScale.Size_11]: {
      fontSize: "48px",
      lineHeight: "58px"
    },
    [TypeScale.Size_12]: {
      fontSize: "54px",
      lineHeight: "65px"
    },
    [TypeScale.Size_13]: {
      fontSize: "60px",
      lineHeight: "72px"
    },
    [TypeScale.Size_14]: {
      fontSize: "68px",
      lineHeight: "82px"
    },
    [TypeScale.Size_15]: {
      fontSize: "76px",
      lineHeight: "90px"
    },
    [TypeScale.Size_16]: {
      fontSize: "84px",
      lineHeight: "100px"
    },
    [TypeScale.Size_17]: {
      fontSize: "92px",
      lineHeight: "110px"
    },
    [TypeScale.Size_18]: {
      fontSize: "102px",
      lineHeight: "122px"
    },
    [TypeScale.Size_19]: {
      fontSize: "112px",
      lineHeight: "134px"
    },
    [TypeScale.Size_20]: {
      fontSize: "122px",
      lineHeight: "146px"
    },
    [TypeScale.Size_21]: {
      fontSize: "132px",
      lineHeight: "158px"
    },
    [TypeScale.Size_22]: {
      fontSize: "144px",
      lineHeight: "172px"
    }
  },
  typePresets: {
    [TypePreset.Body_01]: {
      size: TypeScale.Size_02
    },
    [TypePreset.Body_02]: {
      size: TypeScale.Size_03
    },
    [TypePreset.Body_03]: {
      size: TypeScale.Size_04
    },
    [TypePreset.Body_04]: {
      size: TypeScale.Size_05
    },
    [TypePreset.LongForm_01]: {
      fontFamily: "serif",
      weight: FontWeight.Light,
      size: TypeScale.Size_02,
      lineHeight: TypeScale.Size_03
    },
    [TypePreset.LongForm_02]: {
      fontFamily: "serif",
      weight: FontWeight.Light,
      size: TypeScale.Size_03,
      lineHeight: TypeScale.Size_04
    },
    [TypePreset.LongForm_03]: {
      fontFamily: "serif",
      weight: FontWeight.Light,
      size: TypeScale.Size_04,
      lineHeight: TypeScale.Size_05
    },
    [TypePreset.LongForm_04]: {
      fontFamily: "serif",
      weight: FontWeight.Light,
      size: TypeScale.Size_05,
      lineHeight: TypeScale.Size_06
    },
    [TypePreset.Caption_01]: {
      size: TypeScale.Size_01
    },
    [TypePreset.Code_01]: {
      size: TypeScale.Size_02,
      fontFamily: "monospace"
    },
    [TypePreset.Code_02]: {
      size: TypeScale.Size_03,
      fontFamily: "monospace"
    },
    [TypePreset.Code_03]: {
      size: TypeScale.Size_04,
      fontFamily: "monospace"
    },
    [TypePreset.Code_04]: {
      size: TypeScale.Size_01,
      fontFamily: "monospace"
    },
    [TypePreset.Subheading_01]: {
      size: TypeScale.Size_05,
      fontFamily: "serif",
      weight: FontWeight.Light
    },
    [TypePreset.Subheading_02]: {
      size: TypeScale.Size_06,
      fontFamily: "serif",
      weight: FontWeight.Light
    },
    [TypePreset.Heading_01]: {
      size: TypeScale.Size_02,
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_02]: {
      size: TypeScale.Size_03,
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_03]: {
      size: TypeScale.Size_04,
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_04]: {
      size: TypeScale.Size_05,
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_05]: {
      size: [TypeScale.Size_05, TypeScale.Size_06],
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_06]: {
      size: [TypeScale.Size_06, TypeScale.Size_07],
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_07]: {
      size: [TypeScale.Size_07, TypeScale.Size_08, null, TypeScale.Size_09],
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_08]: {
      size: [TypeScale.Size_08, TypeScale.Size_10, null, TypeScale.Size_11],
      weight: FontWeight.SemiBold
    },
    [TypePreset.Heading_09]: {
      size: [TypeScale.Size_09, TypeScale.Size_11, null, TypeScale.Size_13],
      weight: FontWeight.SemiBold
    },
    [TypePreset.Quote_01]: {
      size: [TypeScale.Size_08, TypeScale.Size_10, null, TypeScale.Size_11],
      fontFamily: "serif",
      weight: FontWeight.Light
    },
    [TypePreset.Quote_02]: {
      size: [TypeScale.Size_05, null, TypeScale.Size_06],
      fontFamily: "serif",
      weight: FontWeight.Light
    },
    [TypePreset.Display_01]: {
      size: [TypeScale.Size_12, TypeScale.Size_17, null, TypeScale.Size_21],
      fontFamily: "display",
      weight: FontWeight.Bold
    },
    [TypePreset.Display_02]: {
      size: [TypeScale.Size_13, TypeScale.Size_18, null, TypeScale.Size_22],
      fontFamily: "display",
      weight: FontWeight.Bold
    }
  },
  elevation: {
    0: "none",
    1: "drop-shadow(0 0px 1px rgba(0,0,0,0.10))",
    2: "drop-shadow(0 1px 4px rgba(0,0,0,0.10))",
    3: "drop-shadow(0 2px 6px rgba(0,0,0,0.10))",
    4: "drop-shadow(0 6px 8px rgba(0,0,0,0.10))",
    5: "drop-shadow(0 10px 12px rgba(0,0,0,0.10))",
    6: "drop-shadow(0 16px 24px rgba(0,0,0,0.10))"
  },
  contentGutters: 1,
  gridGutters: [0.25, null, 0.5, 1],
  colors: {
    ...colors,
    ...colorPresets
  },
  colorPresets
};

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

const makeCSSValueHelper = f => {
  const helper = function calcCSSValue(args) {
    if (!Array.isArray(args)) {
      return f(args);
    }
    const first = f(args[0]);
    const second = f(args[1]);
    const third = args[2] == null ? "" : f(args[2]);
    const fourth = args[3] == null ? "" : f(args[3]);
    return `${first} ${second} ${third} ${fourth}`;
  };
  return helper;
};
const inputGutterStyle = (theme, props) => {
  const {
    size = InputGutter.Md,
    adjustmentVar
  } = props;
  return theme.responsive(size, val => {
    switch (val) {
      case InputGutter.Sm:
        let v = theme.spacing(0.5);
        let h = theme.spacing(0.75);
        v = adjustmentVar ? `calc(${v} - var(${adjustmentVar}, 0))` : v;
        h = adjustmentVar ? `calc(${h} - var(${adjustmentVar}, 0))` : h;
        return {
          padding: `${v} ${h}`
        };
      default:
        let p = theme.spacing(1);
        p = adjustmentVar ? `calc(${p} - var(${adjustmentVar}, 0))` : p;
        return {
          padding: p
        };
    }
  });
};

class DefaultTheme {
  constructor(tokens) {
    _defineProperty(this, "tokens", void 0);
    _defineProperty(this, "spacing", makeCSSValueHelper(scale => {
      return `${scale * this.tokens.spacingBase}px`;
    }));
    _defineProperty(this, "radius", makeCSSValueHelper(scale => {
      return `${scale * this.tokens.borderRadiusBase}px`;
    }));
    _defineProperty(this, "color", name => this.tokens.colors[name]);
    _defineProperty(this, "responsive", (values, interpolate) => {
      if (values == null) {
        return;
      }
      if (!Array.isArray(values)) {
        return interpolate(values, this);
      }
      const defaultValue = values[0];
      const defaultRules = defaultValue == null ? null : interpolate(defaultValue, this);
      const styles = defaultRules ? [defaultRules] : [];
      Object.values(Breakpoint).forEach((bp, i) => {
        const v = values[i + 1];
        if (v == null) {
          return;
        }
        const breakpoint = this.tokens.breakpoints[bp];
        if (!breakpoint) {
          return;
        }
        const mq = `@media (min-width: ${breakpoint})`;
        const rules = interpolate(v, this);
        styles.push({
          [mq]: rules
        });
      });
      return styles;
    });
    this.tokens = tokens;
  }
}

const ThemeContext = /*#__PURE__*/React.createContext({
  theme: new DefaultTheme(defaultDesignTokens)
});
const ThemeProvider = ({
  tokens = defaultDesignTokens,
  children
}) => {
  const value = React.useMemo(() => ({
    theme: new DefaultTheme(tokens)
  }), [tokens]);
  return jsx(ThemeContext.Provider, {
    value: value,
    children: children
  });
};
const useTheme = () => React.useContext(ThemeContext);

const style$1 = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  width: "1px",
  margin: "0 -1px -1px 0",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap"
};
const VisuallyHidden = /*#__PURE__*/React.forwardRef(function VisuallyHidden(props, ref) {
  return jsx("span", {
    css: style$1,
    ...props,
    ref: ref
  });
});

const skipLinkStyle = theme => ({
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: 0,
  overflow: "hidden",
  position: "absolute",
  "&:focus": {
    padding: "1rem",
    position: "fixed",
    top: "10px",
    left: "10px",
    background: theme.color(Color.White),
    zIndex: ZIndex.SkipLink,
    width: "auto",
    height: "auto",
    clip: "auto"
  }
});
const SkipLink = props => {
  const {
    targetId,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  return jsx("a", {
    css: skipLinkStyle(theme),
    ...rest,
    href: `#${targetId}`,
    children: props.children
  });
};

const iconStyle$1 = (theme, props) => [{
  display: "inline-block",
  flex: "0 0 auto"
}, props.color ? theme.responsive(props.color, c => ({
  color: theme.color(c)
})) : null, theme.responsive(props.size, s => ({
  width: s,
  height: s
})), theme.responsive(props.verticalAlign, verticalAlign => ({
  verticalAlign
}))];
const Icon = props => {
  const {
    theme
  } = useTheme();
  const {
    name,
    size,
    color,
    verticalAlign,
    ...rest
  } = props;
  const SVG = registry[name];
  return jsx(SVG, {
    css: iconStyle$1(theme, props),
    "aria-hidden": true,
    ...rest
  });
};

const ChevronToggle = ({
  mode,
  size
}) => {
  return jsx(Icon, {
    name: Glyph.ChevronRight,
    size: size,
    css: /*#__PURE__*/css({
      willChange: "transform",
      transition: `transform 250ms ease-in-out`,
      transform: mode === "open" ? "rotate(90deg)" : "rotate(0)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:ChevronToggle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZXZyb25Ub2dnbGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd3RCIsImZpbGUiOiJDaGV2cm9uVG9nZ2xlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBJY29uIGZyb20gXCIuL0ljb25cIjtcclxuaW1wb3J0IHsgR2x5cGggfSBmcm9tIFwiLi9yZWdpc3RyeVwiO1xyXG5jb25zdCBDaGV2cm9uVG9nZ2xlID0gKHsgbW9kZSwgc2l6ZSB9KSA9PiB7XHJcbiAgICByZXR1cm4gKDxJY29uIG5hbWU9e0dseXBoLkNoZXZyb25SaWdodH0gc2l6ZT17c2l6ZX0gY3NzPXt7XHJcbiAgICAgICAgICAgIHdpbGxDaGFuZ2U6IFwidHJhbnNmb3JtXCIsXHJcbiAgICAgICAgICAgIHRyYW5zaXRpb246IGB0cmFuc2Zvcm0gMjUwbXMgZWFzZS1pbi1vdXRgLFxyXG4gICAgICAgICAgICB0cmFuc2Zvcm06IG1vZGUgPT09IFwib3BlblwiID8gXCJyb3RhdGUoOTBkZWcpXCIgOiBcInJvdGF0ZSgwKVwiLFxyXG4gICAgICAgIH19Lz4pO1xyXG59O1xyXG5leHBvcnQgZGVmYXVsdCBDaGV2cm9uVG9nZ2xlO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGV2cm9uVG9nZ2xlLmpzeC5tYXAiXX0= */")
  });
};

const focusRingVar = "--flux-focus-ring";
const focusRingVal = `var(${focusRingVar}, 0 0 0 0 transparent)`;

const focusWidth = {
  inset: "2px",
  thin: "1px",
  heavy: "4px"
};
const activeFocusWidth = "--active-focus-width";
const heavyFocusRing = (theme, args) => {
  const {
    colorScheme,
    focusSelector
  } = args;
  const totalFocusWidth = `calc(${focusWidth.heavy} + ${focusWidth.thin})`;
  const onLightFocusRing = {
    [activeFocusWidth]: totalFocusWidth,
    [focusSelector]: {
      outline: "none",
      [focusRingVar]: `0 0 0 ${focusWidth.thin} ${theme.color(Color.Brownstone_50)}, 0 0 0 ${focusWidth.heavy} ${theme.color(Color.Greystone_DarkMatter)}`
    }
  };
  const onDarkFocusRing = {
    [activeFocusWidth]: totalFocusWidth,
    [focusSelector]: {
      outline: "none",
      [focusRingVar]: `0 0 0 ${focusWidth.thin} ${theme.color(Color.Slate_1100)}, 0 0 0 ${focusWidth.heavy} ${theme.color(Color.Brownstone_50)}`
    }
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return onLightFocusRing;
    case ColorScheme.OnDark:
      return onDarkFocusRing;
    case ColorScheme.Auto:
      return [onLightFocusRing, {
        "@media (prefers-color-scheme: dark)": onDarkFocusRing
      }];
  }
};
const innerFocusRing = (theme, args) => {
  const {
    colorScheme,
    focusSelector
  } = args;
  const onLightFocusRing = {
    [activeFocusWidth]: `${focusWidth.inset}`,
    [focusSelector]: {
      outline: "none",
      [focusRingVar]: `inset 0 0 0 ${focusWidth.inset} ${theme.color(Color.Greystone_DarkMatter)}`
    }
  };
  const onDarkFocusRing = {
    [activeFocusWidth]: `${focusWidth.inset}`,
    [focusSelector]: {
      outline: "none",
      [focusRingVar]: `inset 0 0 0 ${focusWidth.inset} ${theme.color(Color.Brownstone_50)}`
    }
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return onLightFocusRing;
    case ColorScheme.OnDark:
      return onDarkFocusRing;
    case ColorScheme.Auto:
      return [onLightFocusRing, {
        "@media (prefers-color-scheme: dark)": onDarkFocusRing
      }];
  }
};
const focusRingStyle = (theme, props) => {
  switch (props.variant) {
    case FocusRing.Heavy:
      return heavyFocusRing(theme, props);
    case FocusRing.Inner:
      return innerFocusRing(theme, props);
  }
};

var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["PrimaryOnLight"] = "primary-on-light";
  ButtonVariant["PrimaryOnDark"] = "primary-on-dark";
  ButtonVariant["PrimaryWhiteOnDark"] = "primary-white-on-dark";
  ButtonVariant["PrimaryAuto"] = "primary-auto";
  ButtonVariant["SecondaryOnLight"] = "secondary-on-light";
  ButtonVariant["SecondaryOnDark"] = "secondary-on-dark";
  ButtonVariant["SecondaryAuto"] = "secondary-auto";
  ButtonVariant["AlertOnLight"] = "alert-on-light";
  ButtonVariant["AlertOnDark"] = "alert-on-dark";
  ButtonVariant["AlertAuto"] = "alert-auto";
  ButtonVariant["TextOnLight"] = "text-on-light";
  ButtonVariant["TextOnDark"] = "text-on-dark";
  ButtonVariant["TextAuto"] = "text-auto";
  /**
   * @deprecated Inline variants are now deprecated and will be removed in a later
   * version. Please use `<PlainButton />` or `<PlainLink />` instead
   */
  ButtonVariant["Inline"] = "inline";
  /**
   * @deprecated Inline variants are now deprecated and will be removed in a later
   * version. Please use `<PlainButton />` or `<PlainLink />` instead
   */
  ButtonVariant["InlineUnderlined"] = "inline-underlined";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonLayout;
(function (ButtonLayout) {
  ButtonLayout["Inline"] = "inline";
  ButtonLayout["Full"] = "full";
})(ButtonLayout || (ButtonLayout = {}));
var ButtonGutter;
(function (ButtonGutter) {
  ButtonGutter["Sm"] = "sm";
  ButtonGutter["Md"] = "md";
})(ButtonGutter || (ButtonGutter = {}));
const omitButtonStyleProps = props => {
  const {
    variant,
    leftIcon,
    rightIcon,
    layout,
    size,
    ...rest
  } = props;
  return rest;
};

const roundedButtonSizeTokens = theme => {
  return {
    "--btn-gutter-inline-sm": theme.spacing(2),
    "--btn-gutter-block-sm": theme.spacing(0.5),
    "--btn-gutter-intra-sm": theme.spacing(0.5),
    "--btn-font-size-sm": theme.tokens.fontSizes[2].fontSize,
    "--btn-line-height-sm": theme.tokens.fontSizes[2].lineHeight,
    "--btn-border-radius-sm": theme.radius(2),
    "--btn-gutter-inline-md": theme.spacing(3),
    "--btn-gutter-block-md": theme.spacing(0.75),
    "--btn-gutter-intra-md": theme.spacing(0.5),
    "--btn-font-size-md": theme.tokens.fontSizes[3].fontSize,
    "--btn-line-height-md": theme.tokens.fontSizes[3].lineHeight,
    "--btn-border-radius-md": theme.radius(2),
    "--btn-gutter-inline-lg": theme.spacing(4),
    "--btn-gutter-block-lg": theme.spacing(1),
    "--btn-gutter-intra-lg": theme.spacing(0.5),
    "--btn-font-size-lg": theme.tokens.fontSizes[3].fontSize,
    "--btn-line-height-lg": theme.tokens.fontSizes[3].lineHeight,
    "--btn-border-radius-lg": theme.radius(2)
  };
};
const roundedButtonGeometryStyle = (theme, props) => {
  const {
    size,
    layout
  } = props;
  return [roundedButtonSizeTokens(theme), theme.responsive(size, v => {
    return {
      padding: `var(--btn-gutter-block-${v}) var(--btn-gutter-inline-${v})`,
      columnGap: `var(--btn-gutter-intra-${v})`,
      fontSize: `var(--btn-font-size-${v})`,
      lineHeight: `var(--btn-line-height-${v})`,
      borderRadius: `var(--btn-border-radius-${v})`
    };
  }), theme.responsive(layout, v => {
    return {
      width: v === ButtonLayout.Full ? "100%" : "auto",
      display: v === ButtonLayout.Full ? "grid" : "inline-grid"
    };
  })];
};
const roundedButtonColorStyle = (_, props) => {
  return [{
    backgroundColor: `var(--btn-${props.variant}-bg-default)`,
    color: `var(--btn-${props.variant}-fg-default)`,
    boxShadow: `inset 0 0 0 2px var(--btn-${props.variant}-border-default), ${focusRingVal}`,
    "&:hover, &:active": {
      backgroundColor: `var(--btn-${props.variant}-bg-hover)`,
      color: `var(--btn-${props.variant}-fg-hover)`,
      boxShadow: `inset 0 0 0 2px var(--btn-${props.variant}-border-hover), ${focusRingVal}`
    },
    "&:disabled": {
      backgroundColor: `var(--btn-${props.variant}-bg-disabled)`,
      color: `var(--btn-${props.variant}-fg-disabled)`,
      boxShadow: `inset 0 0 0 2px var(--btn-${props.variant}-border-disabled)`
    }
  }];
};
const roundedButtonStyle = (theme, props) => {
  return [{
    width: "auto",
    textAlign: "center",
    alignItems: "center",
    border: "none",
    appearance: "none",
    fontFamily: theme.tokens.fontFamilies["sans-serif"],
    fontWeight: FontWeight.SemiBold,
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
      "&:disabled": {
        textDecoration: "none"
      }
    },
    "&:disabled": {
      cursor: "not-allowed"
    },
    transition: "color 100ms, background 100ms, box-shadow 100ms"
  }, focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme: props.colorScheme,
    focusSelector: "&:focus-visible"
  }), roundedButtonGeometryStyle(theme, props), roundedButtonColorStyle(theme, props)];
};

const inlineStyle$1 = {
  textDecoration: "underline",
  textDecorationColor: "transparent",
  fontWeight: FontWeight.SemiBold,
  "&:hover, &:active": {
    textDecorationColor: "currentcolor"
  },
  "&:disabled": {
    textDecorationColor: "transparent",
    opacity: 0.6,
    cursor: "not-allowed"
  }
};
const inlineUnderlinedStyle = {
  textDecoration: "underline",
  fontWeight: "inherit",
  "&:hover, &:active": {
    textDecorationColor: "transparent"
  },
  "&:disabled": {
    textDecorationColor: "currentColor",
    opacity: 0.6,
    cursor: "not-allowed"
  }
};
const inlineButtonStyle = (theme, props) => {
  const {
    layout = ButtonLayout.Inline,
    size,
    variant
  } = props;
  return [{
    appearance: "none",
    padding: 0,
    margin: 0,
    background: "none",
    border: "none",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    textAlign: "inherit",
    cursor: "pointer",
    transition: "text-decoration-color 200ms",
    color: "inherit"
  },
  // Respect the value of the size prop if it is set and set the button size
  // based on the tokens used by rounded buttons since they seem sensible.
  // If the size prop is not set then continue to inherit the font-size and
  // line-height set by parent elements.
  roundedButtonSizeTokens(theme), theme.responsive(size, v => {
    return {
      fontSize: `var(--btn-font-size-${v})`,
      lineHeight: `var(--btn-line-height-${v})`
    };
  }), theme.responsive(layout, v => {
    if (v === ButtonLayout.Full) {
      return {
        display: "block",
        width: "100%"
      };
    } else {
      return {
        display: "inline",
        width: "auto"
      };
    }
  }), variant === ButtonVariant.Inline ? inlineStyle$1 : inlineUnderlinedStyle];
};

const textTokens = theme => {
  const vl = ButtonVariant.TextOnLight;
  const vd = ButtonVariant.TextOnDark;
  const va = ButtonVariant.TextAuto;
  return {
    [`--btn-${vl}-bg-default`]: theme.color(Color.Transparent),
    [`--btn-${vl}-fg-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vl}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vl}-bg-hover`]: theme.color(Color.Greystone_900_A21),
    [`--btn-${vl}-fg-hover`]: theme.color(Color.Greystone_1300),
    [`--btn-${vl}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vl}-bg-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vl}-fg-disabled`]: theme.color(Color.Greystone_1400_A38),
    [`--btn-${vl}-border-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-default`]: theme.color(Color.Transparent),
    [`--btn-${vd}-fg-default`]: theme.color(Color.Brownstone_50),
    [`--btn-${vd}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-hover`]: theme.color(Color.White_A12),
    [`--btn-${vd}-fg-hover`]: theme.color(Color.Brownstone_400),
    [`--btn-${vd}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vd}-fg-disabled`]: theme.color(Color.Greystone_700_A38),
    [`--btn-${vd}-border-disabled`]: theme.color(Color.Transparent),
    [`--btn-${va}-bg-default`]: `var(--btn-${vl}-bg-default)`,
    [`--btn-${va}-fg-default`]: `var(--btn-${vl}-fg-default)`,
    [`--btn-${va}-border-default`]: `var(--btn-${vl}-border-default)`,
    [`--btn-${va}-bg-hover`]: `var(--btn-${vl}-bg-hover)`,
    [`--btn-${va}-fg-hover`]: `var(--btn-${vl}-fg-hover)`,
    [`--btn-${va}-border-hover`]: `var(--btn-${vl}-border-hover)`,
    [`--btn-${va}-bg-disabled`]: `var(--btn-${vl}-bg-disabled)`,
    [`--btn-${va}-fg-disabled`]: `var(--btn-${vl}-fg-disabled)`,
    [`--btn-${va}-border-disabled`]: `var(--btn-${vl}-border-disabled)`,
    "@media (prefers-color-scheme: dark)": {
      [`--btn-${va}-bg-default`]: `var(--btn-${vd}-bg-default)`,
      [`--btn-${va}-fg-default`]: `var(--btn-${vd}-fg-default)`,
      [`--btn-${va}-border-default`]: `var(--btn-${vd}-border-default)`,
      [`--btn-${va}-bg-hover`]: `var(--btn-${vd}-bg-hover)`,
      [`--btn-${va}-fg-hover`]: `var(--btn-${vd}-fg-hover)`,
      [`--btn-${va}-border-hover`]: `var(--btn-${vd}-border-hover)`,
      [`--btn-${va}-bg-disabled`]: `var(--btn-${vd}-bg-disabled)`,
      [`--btn-${va}-fg-disabled`]: `var(--btn-${vd}-fg-disabled)`,
      [`--btn-${va}-border-disabled`]: `var(--btn-${vd}-border-disabled)`
    }
  };
};
const textButtonStyle = {
  textDecoration: "none",
  "&:hover, &:active": {
    textDecoration: "underline"
  },
  "&:disabled": {
    textDecoration: "none"
  }
};

const alertTokens = theme => {
  const vl = ButtonVariant.AlertOnLight;
  const vd = ButtonVariant.AlertOnDark;
  const va = ButtonVariant.AlertAuto;
  return {
    [`--btn-${vl}-bg-default`]: theme.color(Color.Alert_400),
    [`--btn-${vl}-fg-default`]: theme.color(Color.Brownstone_50),
    [`--btn-${vl}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vl}-bg-hover`]: theme.color(Color.Alert_300),
    [`--btn-${vl}-fg-hover`]: theme.color(Color.Brownstone_50),
    [`--btn-${vl}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vl}-bg-disabled`]: theme.color(Color.Greystone_1400_A8),
    [`--btn-${vl}-fg-disabled`]: theme.color(Color.Greystone_1400_A38),
    [`--btn-${vl}-borer-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-default`]: theme.color(Color.Alert_200),
    [`--btn-${vd}-fg-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vd}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-hover`]: theme.color(Color.Alert_100),
    [`--btn-${vd}-fg-hover`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vd}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-disabled`]: theme.color(Color.Greystone_700_A16),
    [`--btn-${vd}-fg-disabled`]: theme.color(Color.Greystone_700_A38),
    [`--btn-${vd}-border-disabled`]: theme.color(Color.Transparent),
    [`--btn-${va}-bg-default`]: `var(--btn-${vl}-bg-default)`,
    [`--btn-${va}-fg-default`]: `var(--btn-${vl}-fg-default)`,
    [`--btn-${va}-border-default`]: `var(--btn-${vl}-border-default)`,
    [`--btn-${va}-bg-hover`]: `var(--btn-${vl}-bg-hover)`,
    [`--btn-${va}-fg-hover`]: `var(--btn-${vl}-fg-hover)`,
    [`--btn-${va}-border-hover`]: `var(--btn-${vl}-border-hover)`,
    [`--btn-${va}-bg-disabled`]: `var(--btn-${vl}-bg-disabled)`,
    [`--btn-${va}-fg-disabled`]: `var(--btn-${vl}-fg-disabled)`,
    [`--btn-${va}-border-disabled`]: `var(--btn-${vl}-border-disabled)`,
    "@media (prefers-color-scheme: dark)": {
      [`--btn-${va}-bg-default`]: `var(--btn-${vd}-bg-default)`,
      [`--btn-${va}-fg-default`]: `var(--btn-${vd}-fg-default)`,
      [`--btn-${va}-border-default`]: `var(--btn-${vd}-border-default)`,
      [`--btn-${va}-bg-hover`]: `var(--btn-${vd}-bg-hover)`,
      [`--btn-${va}-fg-hover`]: `var(--btn-${vd}-fg-hover)`,
      [`--btn-${va}-border-hover`]: `var(--btn-${vd}-border-hover)`,
      [`--btn-${va}-bg-disabled`]: `var(--btn-${vd}-bg-disabled)`,
      [`--btn-${va}-fg-disabled`]: `var(--btn-${vd}-fg-disabled)`,
      [`--btn-${va}-border-disabled`]: `var(--btn-${vd}-border-disabled)`
    }
  };
};

const primaryTokens = theme => {
  const vl = ButtonVariant.PrimaryOnLight;
  const vd = ButtonVariant.PrimaryOnDark;
  const vw = ButtonVariant.PrimaryWhiteOnDark;
  const va = ButtonVariant.PrimaryAuto;
  return {
    [`--btn-${vl}-bg-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vl}-fg-default`]: theme.color(Color.Brownstone_50),
    [`--btn-${vl}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vl}-bg-hover`]: theme.color(Color.Greystone_1300),
    [`--btn-${vl}-fg-hover`]: theme.color(Color.Brownstone_50),
    [`--btn-${vl}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vl}-bg-disabled`]: theme.color(Color.Greystone_1400_A8),
    [`--btn-${vl}-fg-disabled`]: theme.color(Color.Greystone_1400_A38),
    [`--btn-${vl}-border-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-default`]: theme.color(Color.Dawn_Base),
    [`--btn-${vd}-fg-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vd}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-hover`]: theme.color(Color.Dawn_500),
    [`--btn-${vd}-fg-hover`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vd}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vd}-bg-disabled`]: theme.color(Color.Greystone_700_A16),
    [`--btn-${vd}-fg-disabled`]: theme.color(Color.Greystone_700_A38),
    [`--btn-${vd}-border-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vw}-bg-default`]: theme.color(Color.White),
    [`--btn-${vw}-fg-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vw}-border-default`]: theme.color(Color.Transparent),
    [`--btn-${vw}-bg-hover`]: theme.color(Color.Brownstone_50),
    [`--btn-${vw}-fg-hover`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vw}-border-hover`]: theme.color(Color.Transparent),
    [`--btn-${vw}-bg-disabled`]: theme.color(Color.Greystone_700_A16),
    [`--btn-${vw}-fg-disabled`]: theme.color(Color.Greystone_700_A38),
    [`--btn-${vw}-border-disabled`]: theme.color(Color.Transparent),
    [`--btn-${va}-bg-default`]: `var(--btn-${vl}-bg-default)`,
    [`--btn-${va}-fg-default`]: `var(--btn-${vl}-fg-default)`,
    [`--btn-${va}-border-default`]: `var(--btn-${vl}-border-default)`,
    [`--btn-${va}-bg-hover`]: `var(--btn-${vl}-bg-hover)`,
    [`--btn-${va}-fg-hover`]: `var(--btn-${vl}-fg-hover)`,
    [`--btn-${va}-border-hover`]: `var(--btn-${vl}-border-hover)`,
    [`--btn-${va}-bg-disabled`]: `var(--btn-${vl}-bg-disabled)`,
    [`--btn-${va}-fg-disabled`]: `var(--btn-${vl}-fg-disabled)`,
    [`--btn-${va}-border-disabled`]: `var(--btn-${vl}-border-disabled)`,
    "@media (prefers-color-scheme: dark)": {
      [`--btn-${va}-bg-default`]: `var(--btn-${vd}-bg-default)`,
      [`--btn-${va}-fg-default`]: `var(--btn-${vd}-fg-default)`,
      [`--btn-${va}-border-default`]: `var(--btn-${vd}-border-default)`,
      [`--btn-${va}-bg-hover`]: `var(--btn-${vd}-bg-hover)`,
      [`--btn-${va}-fg-hover`]: `var(--btn-${vd}-fg-hover)`,
      [`--btn-${va}-border-hover`]: `var(--btn-${vd}-border-hover)`,
      [`--btn-${va}-bg-disabled`]: `var(--btn-${vd}-bg-disabled)`,
      [`--btn-${va}-fg-disabled`]: `var(--btn-${vd}-fg-disabled)`,
      [`--btn-${va}-border-disabled`]: `var(--btn-${vd}-border-disabled)`
    }
  };
};

const secondaryTokens = theme => {
  const vl = ButtonVariant.SecondaryOnLight;
  const vd = ButtonVariant.SecondaryOnDark;
  const va = ButtonVariant.SecondaryAuto;
  return {
    [`--btn-${vl}-bg-default`]: theme.color(Color.Transparent),
    [`--btn-${vl}-fg-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vl}-border-default`]: theme.color(Color.Greystone_DarkMatter),
    [`--btn-${vl}-bg-hover`]: theme.color(Color.Transparent),
    [`--btn-${vl}-fg-hover`]: theme.color(Color.Greystone_1300),
    [`--btn-${vl}-border-hover`]: theme.color(Color.Greystone_1300),
    [`--btn-${vl}-bg-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vl}-fg-disabled`]: theme.color(Color.Greystone_1400_A38),
    [`--btn-${vl}-border-disabled`]: theme.color(Color.Greystone_1400_A8),
    [`--btn-${vd}-bg-default`]: theme.color(Color.Transparent),
    [`--btn-${vd}-fg-default`]: theme.color(Color.Brownstone_50),
    [`--btn-${vd}-border-default`]: theme.color(Color.Brownstone_50),
    [`--btn-${vd}-bg-hover`]: theme.color(Color.Transparent),
    [`--btn-${vd}-fg-hover`]: theme.color(Color.Brownstone_400),
    [`--btn-${vd}-border-hover`]: theme.color(Color.Brownstone_400),
    [`--btn-${vd}-bg-disabled`]: theme.color(Color.Transparent),
    [`--btn-${vd}-fg-disabled`]: theme.color(Color.Greystone_700_A38),
    [`--btn-${vd}-border-disabled`]: theme.color(Color.Greystone_700_A16),
    [`--btn-${va}-bg-default`]: `var(--btn-${vl}-bg-default)`,
    [`--btn-${va}-fg-default`]: `var(--btn-${vl}-fg-default)`,
    [`--btn-${va}-border-default`]: `var(--btn-${vl}-border-default)`,
    [`--btn-${va}-bg-hover`]: `var(--btn-${vl}-bg-hover)`,
    [`--btn-${va}-fg-hover`]: `var(--btn-${vl}-fg-hover)`,
    [`--btn-${va}-border-hover`]: `var(--btn-${vl}-border-hover)`,
    [`--btn-${va}-bg-disabled`]: `var(--btn-${vl}-bg-disabled)`,
    [`--btn-${va}-fg-disabled`]: `var(--btn-${vl}-fg-disabled)`,
    [`--btn-${va}-border-disabled`]: `var(--btn-${vl}-border-disabled)`,
    "@media (prefers-color-scheme: dark)": {
      [`--btn-${va}-bg-default`]: `var(--btn-${vd}-bg-default)`,
      [`--btn-${va}-fg-default`]: `var(--btn-${vd}-fg-default)`,
      [`--btn-${va}-border-default`]: `var(--btn-${vd}-border-default)`,
      [`--btn-${va}-bg-hover`]: `var(--btn-${vd}-bg-hover)`,
      [`--btn-${va}-fg-hover`]: `var(--btn-${vd}-fg-hover)`,
      [`--btn-${va}-border-hover`]: `var(--btn-${vd}-border-hover)`,
      [`--btn-${va}-bg-disabled`]: `var(--btn-${vd}-bg-disabled)`,
      [`--btn-${va}-fg-disabled`]: `var(--btn-${vd}-fg-disabled)`,
      [`--btn-${va}-border-disabled`]: `var(--btn-${vd}-border-disabled)`
    }
  };
};

const buttonVariantTokenStyle = (theme, {
  variant
}) => {
  switch (variant) {
    case ButtonVariant.PrimaryOnLight:
    case ButtonVariant.PrimaryOnDark:
    case ButtonVariant.PrimaryWhiteOnDark:
    case ButtonVariant.PrimaryAuto:
      return primaryTokens(theme);
    case ButtonVariant.SecondaryOnLight:
    case ButtonVariant.SecondaryOnDark:
    case ButtonVariant.SecondaryAuto:
      return secondaryTokens(theme);
    case ButtonVariant.AlertOnLight:
    case ButtonVariant.AlertOnDark:
    case ButtonVariant.AlertAuto:
      return alertTokens(theme);
    case ButtonVariant.TextOnLight:
    case ButtonVariant.TextOnDark:
    case ButtonVariant.TextAuto:
      return textTokens(theme);
    case ButtonVariant.Inline:
    case ButtonVariant.InlineUnderlined:
      return null;
  }
};

const iconButtonSizeTokens = theme => {
  return {
    "--btn-gutter-sm-sm": theme.spacing(0.25),
    "--btn-gutter-sm-md": theme.spacing(0.75),
    "--btn-gutter-md-sm": theme.spacing(0.25),
    "--btn-gutter-md-md": theme.spacing(1),
    "--btn-gutter-lg-sm": theme.spacing(0.5),
    "--btn-gutter-lg-md": theme.spacing(1),
    "--btn-font-size-sm": "12px",
    "--btn-font-size-md": "14px",
    "--btn-font-size-lg": "22px"
  };
};
const iconButtonGeometryStyle = (theme, props) => {
  const {
    size,
    shift
  } = props;
  return [iconButtonSizeTokens(theme), theme.responsive(size, v => {
    let s;
    let g;
    if (typeof v === "object" && "base" in v) {
      s = v.base;
      g = v.gutters;
    } else {
      s = v;
      g = ButtonGutter.Md;
    }
    const padding = `var(--btn-gutter-${s}-${g})`;
    const fontSize = `var(--btn-font-size-${s})`;
    const negativePadding = `calc(-1 * ${padding})`;
    const shiftParts = shift === null || shift === void 0 ? void 0 : shift.split("-");
    return {
      padding,
      fontSize,
      lineHeight: 1,
      borderRadius: `calc(${fontSize} + ${padding})`,
      width: `calc(${fontSize} + 2* ${padding})`,
      height: `calc(${fontSize} + 2* ${padding})`,
      marginInlineStart: shiftParts !== null && shiftParts !== void 0 && shiftParts.includes("left") ? negativePadding : undefined,
      marginInlineEnd: shiftParts !== null && shiftParts !== void 0 && shiftParts.includes("right") ? negativePadding : undefined,
      marginBlockStart: shiftParts !== null && shiftParts !== void 0 && shiftParts.includes("top") ? negativePadding : undefined,
      marginBlockEnd: shiftParts !== null && shiftParts !== void 0 && shiftParts.includes("bottom") ? negativePadding : undefined
    };
  })];
};
const iconButtonColorStyle = roundedButtonColorStyle;
const iconButtonStyle = (theme, props) => {
  const {
    focusRing = FocusRing.Heavy
  } = props;
  let colorScheme;
  if (props.variant.includes("on-dark")) {
    colorScheme = ColorScheme.OnDark;
  } else if (props.variant.includes("auto")) {
    colorScheme = ColorScheme.Auto;
  } else {
    colorScheme = ColorScheme.OnLight;
  }
  return [{
    display: "inline-flex",
    fontFamily: "inherit",
    border: "none",
    appearance: "none",
    textDecoration: "none",
    cursor: "pointer",
    "&:disabled": {
      cursor: "not-allowed"
    },
    transition: "color 100ms, background 100ms, box-shadow 100ms"
  }, buttonVariantTokenStyle(theme, props), focusRingStyle(theme, {
    variant: focusRing,
    focusSelector: "&:focus-visible",
    colorScheme
  }), iconButtonGeometryStyle(theme, props), iconButtonColorStyle(theme, props)];
};

const buttonGridStyle = (_, props) => {
  const {
    leftIcon,
    rightIcon
  } = props;
  let areas = "content";
  if (leftIcon) {
    areas = `start-icon ${areas}`;
  }
  if (rightIcon) {
    areas = `${areas} end-icon`;
  }
  areas = `"${areas}"`;
  return {
    justifyContent: "center",
    gridTemplateAreas: areas
  };
};
const buttonAccessoryStyle = (theme, {
  position,
  variant
}) => {
  let isInline = false;
  switch (variant) {
    case ButtonVariant.Inline:
    case ButtonVariant.InlineUnderlined:
      isInline = true;
      break;
  }
  return [{
    display: "inline-flex",
    gridArea: position === "start" ? "start-icon" : "end-icon",
    fontSize: theme.tokens.fontSizes[TypeScale.Size_01].fontSize,
    lineHeight: 1,
    paddingRight: isInline && position === "start" ? theme.spacing(0.5) : undefined,
    paddingLeft: isInline && position === "end" ? theme.spacing(0.5) : undefined
  }];
};
const buttonStyle = (theme, props) => {
  let colorScheme;
  if (props.variant.includes("on-dark")) {
    colorScheme = ColorScheme.OnDark;
  } else if (props.variant.includes("auto")) {
    colorScheme = ColorScheme.Auto;
  } else {
    colorScheme = ColorScheme.OnLight;
  }
  const allProps = {
    colorScheme,
    ...props
  };
  switch (props.variant) {
    case ButtonVariant.PrimaryOnLight:
    case ButtonVariant.PrimaryOnDark:
    case ButtonVariant.PrimaryWhiteOnDark:
    case ButtonVariant.PrimaryAuto:
    case ButtonVariant.SecondaryOnLight:
    case ButtonVariant.SecondaryOnDark:
    case ButtonVariant.SecondaryAuto:
    case ButtonVariant.AlertOnLight:
    case ButtonVariant.AlertOnDark:
    case ButtonVariant.AlertAuto:
      return [buttonVariantTokenStyle(theme, props), buttonGridStyle(theme, props), roundedButtonStyle(theme, allProps)];
    case ButtonVariant.TextOnLight:
    case ButtonVariant.TextOnDark:
    case ButtonVariant.TextAuto:
      return [buttonVariantTokenStyle(theme, props), buttonGridStyle(theme, props), roundedButtonStyle(theme, allProps), textButtonStyle];
    case ButtonVariant.Inline:
    case ButtonVariant.InlineUnderlined:
      return [inlineButtonStyle(theme, props)];
  }
};

const contentStyle$2 = {
  gridArea: "content"
};
const Button = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    leftIcon,
    rightIcon,
    variant,
    size = ButtonSize.Md,
    layout = ButtonLayout.Inline,
    type = "button"
  } = props;
  const {
    render,
    ...rest
  } = omitButtonStyleProps(props);
  const wrappedChildren = jsxs(Fragment, {
    children: [leftIcon ? jsx("span", {
      css: buttonAccessoryStyle(theme, {
        position: "start",
        variant
      }),
      children: jsx(Icon, {
        name: leftIcon
      })
    }) : null, jsx("span", {
      css: contentStyle$2,
      children: props.children
    }), rightIcon ? jsx("span", {
      css: buttonAccessoryStyle(theme, {
        position: "end",
        variant
      }),
      children: jsx(Icon, {
        name: rightIcon
      })
    }) : null]
  });
  return jsx(ClassNames, {
    children: ({
      css,
      cx
    }) => {
      const className = cx(css(buttonStyle(theme, {
        ...props,
        size,
        layout
      })), props.className);
      const forwardedProps = {
        ...rest,
        type,
        className,
        children: wrappedChildren
      };
      return render ? render(forwardedProps) : jsx("button", {
        ref: ref,
        ...forwardedProps
      });
    }
  });
});

const IconButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    icon,
    label,
    size = ButtonSize.Md,
    variant,
    render,
    focusRing,
    type = "button",
    shift,
    ...rest
  } = props;
  const wrappedChildren = jsxs(Fragment, {
    children: [jsx(VisuallyHidden, {
      children: label
    }), jsx(Icon, {
      name: icon
    })]
  });
  return jsx(ClassNames, {
    children: ({
      css,
      cx
    }) => {
      const className = cx(css(iconButtonStyle(theme, {
        ...props,
        size
      })), props.className);
      const forwardedProps = {
        ...rest,
        type,
        className,
        children: wrappedChildren
      };
      return render ? render(forwardedProps) : jsx("button", {
        ref: ref,
        ...forwardedProps
      });
    }
  });
});

const contentStyle$1 = {
  gridArea: "content"
};
const Link = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    size = ButtonSize.Md,
    layout = ButtonLayout.Inline,
    leftIcon,
    rightIcon,
    variant
  } = props;
  const {
    render,
    ...rest
  } = omitButtonStyleProps(props);
  const wrappedChildren = jsxs(Fragment, {
    children: [leftIcon ? jsx("span", {
      css: buttonAccessoryStyle(theme, {
        position: "start",
        variant
      }),
      children: jsx(Icon, {
        name: leftIcon
      })
    }) : null, jsx("span", {
      css: contentStyle$1,
      children: props.children
    }), rightIcon ? jsx("span", {
      css: buttonAccessoryStyle(theme, {
        position: "end",
        variant
      }),
      children: jsx(Icon, {
        name: rightIcon
      })
    }) : null]
  });
  return jsx(ClassNames, {
    children: ({
      css,
      cx
    }) => {
      const className = cx(css(buttonStyle(theme, {
        ...props,
        size,
        layout
      })), props.className);
      const forwardedProps = {
        ...rest,
        className,
        children: wrappedChildren
      };
      return render ? render(forwardedProps) :
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      jsx("a", {
        ref: ref,
        ...forwardedProps
      });
    }
  });
});

const IconLink = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    icon,
    label,
    size = ButtonSize.Md,
    variant,
    render,
    ...rest
  } = props;
  const wrappedChildren = jsxs(Fragment, {
    children: [jsx(VisuallyHidden, {
      children: label
    }), jsx(Icon, {
      name: icon
    })]
  });
  return jsx(ClassNames, {
    children: ({
      css,
      cx
    }) => {
      const className = cx(css(iconButtonStyle(theme, {
        ...props,
        size
      })), props.className);
      const forwardedProps = {
        ...rest,
        className,
        children: wrappedChildren
      };
      return render ? render(forwardedProps) :
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      jsx("a", {
        ref: ref,
        ...forwardedProps
      });
    }
  });
});

const omitTypographyStyleProps = props => {
  const {
    preset,
    color,
    size,
    textAlign,
    weight,
    textWrap,
    layout,
    spaceAbove,
    spaceBelow,
    fontFamily,
    lineHeight,
    fontStyle,
    decoration,
    emptyVisibility,
    textTransform,
    ...rest
  } = props;
  return rest;
};
const resetStyle$1 = {
  padding: 0,
  margin: 0
};
/**
 * The Nudge font family, which is used as the "display" font, requires a custom
 * line height that isn't set by the typography scale. Additionally, it requires
 * a separate, custom line-height when used for non-English text to accommodate
 * diacritic marks.
 */
const nudgeLineHeightHack = {
  lineHeight: 0.9,
  "&:not(:lang(en))": {
    lineHeight: 1
  }
};
const appearanceStyle = (theme, props) => {
  const presetConf = props.preset ? theme.tokens.typePresets[props.preset] : undefined;
  const merged = {
    ...presetConf,
    ...props
  };
  const {
    layout,
    color,
    size,
    weight,
    textAlign,
    textWrap,
    spaceAbove,
    spaceBelow,
    fontFamily,
    lineHeight,
    fontStyle: style,
    decoration,
    emptyVisibility,
    textTransform
  } = merged;
  const layoutStyle = theme.responsive(layout, l => ({
    display: l
  }));
  const colorStyle = theme.responsive(color, c => ({
    color: theme.color(c)
  }));
  const sizeStyle = theme.responsive(size, s => ({
    ...theme.tokens.fontSizes[s],
    ...(fontFamily === "display" ? nudgeLineHeightHack : {})
  }));
  const weightStyle = theme.responsive(weight, fontWeight => ({
    fontWeight
  }));
  const alignStyle = theme.responsive(textAlign, value => ({
    textAlign: value
  }));
  const wrapStyle = theme.responsive(textWrap, whiteSpace => ({
    whiteSpace
  }));
  const spaceAboveStyle = theme.responsive(spaceAbove, s => ({
    marginTop: theme.spacing(s)
  }));
  const spaceBelowStyle = theme.responsive(spaceBelow, s => ({
    marginBottom: theme.spacing(s)
  }));
  const fontFamilyStyle = fontFamily ? {
    fontFamily: theme.tokens.fontFamilies[fontFamily]
  } : null;
  const lineHeightStyle = theme.responsive(lineHeight, scale => ({
    lineHeight: theme.tokens.fontSizes[scale].lineHeight
  }));
  const fontStyle = theme.responsive(style, fs => ({
    fontStyle: fs
  }));
  const decorationStyle = theme.responsive(decoration, td => ({
    textDecoration: td
  }));
  const textTransformStyle = theme.responsive(textTransform, tt => ({
    textTransform: tt
  }));
  const emptyStyle = emptyVisibility === "hidden" ? {
    "&:empty": {
      display: "none"
    }
  } : null;
  return [layoutStyle, colorStyle, sizeStyle, weightStyle, alignStyle, wrapStyle, spaceAboveStyle, spaceBelowStyle, fontFamilyStyle, lineHeightStyle, fontStyle, decorationStyle, emptyStyle, textTransformStyle];
};
const typographyStyle = (theme, props) => [resetStyle$1, appearanceStyle(theme, props)];

const plainButtonStyle = (theme, props) => {
  const {
    textDecoration,
    effect,
    ...rest
  } = props;
  return [{
    display: "inline-block",
    appearance: "none",
    padding: 0,
    margin: 0,
    background: "none",
    border: "none",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    fontWeight: "inherit",
    textAlign: "inherit",
    cursor: "pointer",
    color: "inherit",
    textDecoration: textDecoration ? textDecoration : "none"
  }, typographyStyle(theme, rest), effect === HoverEffect.Lift ? {
    transition: "filter 200ms",
    "&:hover, &:focus:focus-visible, &[data-flux-state=hover]": {
      filter: `drop-shadow(0 2px 6px ${theme.color(Color.Greystone_1400_A38)})`
    },
    "&:active, &:disabled": {
      filter: "none"
    },
    "@media (prefers-reduced-motion: reduce)": {
      "&:active, &:disabled": {
        filter: "none"
      }
    }
  } : null, effect === HoverEffect.TextDecoration ? {
    transition: "text-decoration-color 200ms",
    textDecoration: "underline",
    textDecorationColor: textDecoration === "underline" ? "currentColor" : "transparent",
    "*": {
      textDecoration: "inherit"
    },
    "&:hover, &:focus:focus-visible, &:active, &[data-flux-state=hover]": {
      textDecoration: "underline",
      textDecorationColor: textDecoration === "underline" ? "transparent" : "currentColor"
    },
    "&:disabled": {
      textDecoration: "none"
    }
  } : null, {
    "&&:disabled": {
      filter: "saturate(20%) opacity(0.6)",
      cursor: "not-allowed"
    }
  }];
};

const PlainLink = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    effect,
    render,
    children,
    ...rest
  } = props;
  return jsx(ClassNames, {
    children: ({
      css,
      cx
    }) => {
      const className = cx(css(plainButtonStyle(theme, props)), props.className);
      const forwardedProps = {
        ...omitTypographyStyleProps(rest),
        className,
        children
      };
      return render ? render(forwardedProps) : jsx("a", {
        ...forwardedProps,
        ref: ref,
        children: children
      });
    }
  });
});

const PlainButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    effect,
    children,
    render,
    type = "button",
    ...rest
  } = props;
  return jsx(ClassNames, {
    children: ({
      css,
      cx
    }) => {
      const className = cx(css(plainButtonStyle(theme, props)), props.className);
      const forwardedProps = {
        type,
        ...omitTypographyStyleProps(rest),
        className,
        children
      };
      return render ? render(forwardedProps) : jsx("button", {
        ...forwardedProps,
        ref: ref
      });
    }
  });
});

const childSelector = "& > :not([data-flux-role=spacer]) + :not([data-flux-role=spacer])";
const buttonGroupStyle = (theme, props) => {
  const {
    arrangement,
    layout,
    spacing
  } = props;
  const gapToken = "--buttongroup-gap";
  const gapV = `var(${gapToken})`;
  return [{
    flexWrap: "wrap"
  }, theme.responsive(layout, l => ({
    display: l === "inline" ? "inline-flex" : "flex"
  })), theme.responsive(spacing, s => ({
    [gapToken]: theme.spacing(s)
  })), theme.responsive(arrangement, a => {
    switch (a) {
      case "row-start":
        return {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "start",
          [childSelector]: {
            margin: `0 0 0 ${gapV}`
          }
        };
      case "row-start-reverse":
        return {
          flexDirection: "row-reverse",
          alignItems: "center",
          justifyContent: "start",
          [childSelector]: {
            margin: `0 ${gapV} 0 0`
          }
        };
      case "row-end":
        return {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "end",
          [childSelector]: {
            margin: `0 0 0 ${gapV}`
          }
        };
      case "row-end-reverse":
        return {
          flexDirection: "row-reverse",
          alignItems: "center",
          justifyContent: "end",
          [childSelector]: {
            margin: `0 ${gapV} 0 0`
          }
        };
      case "row-center":
        return {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          [childSelector]: {
            margin: `0 0 0 ${gapV}`
          }
        };
      case "row-center-reverse":
        return {
          flexDirection: "row-reverse",
          alignItems: "center",
          justifyContent: "center",
          [childSelector]: {
            margin: `0 ${gapV} 0 0`
          }
        };
      case "column-start":
        return {
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "center",
          [childSelector]: {
            margin: `${gapV} 0 0 0`
          }
        };
      case "column-start-reverse":
        return {
          flexDirection: "column-reverse",
          alignItems: "start",
          justifyContent: "center",
          [childSelector]: {
            margin: `0 0 ${gapV} 0`
          }
        };
      case "column-end":
        return {
          flexDirection: "column",
          alignItems: "end",
          justifyContent: "center",
          [childSelector]: {
            margin: `${gapV} 0 0 0`
          }
        };
      case "column-end-reverse":
        return {
          flexDirection: "column-reverse",
          alignItems: "end",
          justifyContent: "center",
          [childSelector]: {
            margin: `0 0 ${gapV} 0`
          }
        };
      case "column-center":
        return {
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          [childSelector]: {
            margin: `${gapV} 0 0 0`
          }
        };
      case "column-center-reverse":
        return {
          flexDirection: "column-reverse",
          alignItems: "center",
          justifyContent: "center",
          [childSelector]: {
            margin: `0 0 ${gapV} 0`
          }
        };
    }
  })];
};
const ButtonGroup = props => {
  const {
    theme
  } = useTheme();
  const {
    layout = "block",
    arrangement = "row-start",
    spacing = 0.5,
    ...rest
  } = props;
  return jsx("div", {
    css: buttonGroupStyle(theme, {
      layout,
      arrangement,
      spacing
    }),
    ...rest,
    children: props.children
  });
};

const RemoveAction = props => {
  const {
    label,
    onClose: onClick,
    colorScheme
  } = props;
  const btnProps = {
    label,
    onClick,
    icon: Glyph.Close,
    size: {
      base: ButtonSize.Sm,
      gutters: ButtonGutter.Sm
    }
  };
  const shift = `calc(0 * var(--btn-gutter-${btnProps.size.base}-${btnProps.size.gutters}))`;
  const margin = `${shift} ${shift} 0 0`;
  const variant = colorScheme === ColorScheme.OnDark ? ButtonVariant.TextOnLight : ButtonVariant.TextOnDark;
  return jsx(IconButton, {
    ...btnProps,
    css: /*#__PURE__*/css({
      margin
    }, process.env.NODE_ENV === "production" ? "" : ";label:RemoveAction;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlbW92ZUFjdGlvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JzQyIsImZpbGUiOiJSZW1vdmVBY3Rpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQnV0dG9uR3V0dGVyLCBCdXR0b25WYXJpYW50LCBJY29uQnV0dG9uIH0gZnJvbSBcIi4uL2J1dHRvbnNcIjtcclxuaW1wb3J0IHsgR2x5cGggfSBmcm9tIFwiLi4vaWNvbnNcIjtcclxuaW1wb3J0IHsgQnV0dG9uU2l6ZSwgQ29sb3JTY2hlbWUsIEZvY3VzUmluZyB9IGZyb20gXCIuLi90aGVtZVwiO1xyXG5jb25zdCBSZW1vdmVBY3Rpb24gPSAocHJvcHMpID0+IHtcclxuICAgIGNvbnN0IHsgbGFiZWwsIG9uQ2xvc2U6IG9uQ2xpY2ssIGNvbG9yU2NoZW1lIH0gPSBwcm9wcztcclxuICAgIGNvbnN0IGJ0blByb3BzID0ge1xyXG4gICAgICAgIGxhYmVsLFxyXG4gICAgICAgIG9uQ2xpY2ssXHJcbiAgICAgICAgaWNvbjogR2x5cGguQ2xvc2UsXHJcbiAgICAgICAgc2l6ZTogeyBiYXNlOiBCdXR0b25TaXplLlNtLCBndXR0ZXJzOiBCdXR0b25HdXR0ZXIuU20gfSxcclxuICAgIH07XHJcbiAgICBjb25zdCBzaGlmdCA9IGBjYWxjKDAgKiB2YXIoLS1idG4tZ3V0dGVyLSR7YnRuUHJvcHMuc2l6ZS5iYXNlfS0ke2J0blByb3BzLnNpemUuZ3V0dGVyc30pKWA7XHJcbiAgICBjb25zdCBtYXJnaW4gPSBgJHtzaGlmdH0gJHtzaGlmdH0gMCAwYDtcclxuICAgIGNvbnN0IHZhcmlhbnQgPSBjb2xvclNjaGVtZSA9PT0gQ29sb3JTY2hlbWUuT25EYXJrXHJcbiAgICAgICAgPyBCdXR0b25WYXJpYW50LlRleHRPbkxpZ2h0XHJcbiAgICAgICAgOiBCdXR0b25WYXJpYW50LlRleHRPbkRhcms7XHJcbiAgICByZXR1cm4gKDxJY29uQnV0dG9uIHsuLi5idG5Qcm9wc30gY3NzPXt7IG1hcmdpbiB9fSB2YXJpYW50PXt2YXJpYW50fSBmb2N1c1Jpbmc9e0ZvY3VzUmluZy5Jbm5lcn0vPik7XHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IFJlbW92ZUFjdGlvbjtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9UmVtb3ZlQWN0aW9uLmpzeC5tYXAiXX0= */"),
    variant: variant,
    focusRing: FocusRing.Inner
  });
};

var TagVariant;
(function (TagVariant) {
  TagVariant["Solid"] = "solid";
  TagVariant["Tinted"] = "tinted";
})(TagVariant || (TagVariant = {}));
var TagColor;
(function (TagColor) {
  TagColor["Primary"] = "primary";
  TagColor["Neutral"] = "neutral";
  TagColor["Success"] = "success";
  TagColor["Alert"] = "alert";
  TagColor["Warning"] = "warning";
  TagColor["Info"] = "info";
})(TagColor || (TagColor = {}));
var TagSize;
(function (TagSize) {
  TagSize["Xs"] = "xs";
  TagSize["Sm"] = "sm";
  TagSize["Md"] = "md";
  TagSize["Lg"] = "lg";
})(TagSize || (TagSize = {}));

const vars$j = {
  bg: "--tag-bg",
  color: "--tag-color",
  fontSize: "--tag-font-size",
  lineHeight: "--tag-line-height",
  gutterH: "--tag-gutterh",
  gutterV: "--tag-gutterv"
};
const tagSolidThemeTokens = (theme, tagTheme) => {
  const primaryOnLightBg = theme.color(ColorPreset.BackgroundDark_01);
  const primaryOnLightColor = theme.color(ColorPreset.TextOnDark_01);
  const primaryOnDarkBg = theme.color(ColorPreset.BackgroundLight_00);
  const primaryOnDarkColor = theme.color(ColorPreset.TextOnLight_01);
  const neutralOnLightBg = theme.color(Color.Greystone_1100);
  const neutralOnLightColor = theme.color(Color.White);
  const neutralOnDarkBg = theme.color(Color.Greystone_500);
  const neutralOnDarkColor = theme.color(Color.Greystone_DarkMatter);
  const successOnLightBg = theme.color(Color.Success_400);
  const successOnLightColor = theme.color(Color.White);
  const successOnDarkBg = theme.color(Color.Success_50);
  const successOnDarkColor = theme.color(Color.Success_500);
  const alertOnLightBg = theme.color(Color.Alert_400);
  const alertOnLightColor = theme.color(Color.White);
  const alertOnDarkBg = theme.color(Color.Alert_50);
  const alertOnDarkColor = theme.color(Color.Alert_500);
  const warningOnLightBg = theme.color(Color.Warning_400);
  const warningOnLightColor = theme.color(Color.White);
  const warningOnDarkBg = theme.color(Color.Warning_50);
  const warningOnDarkColor = theme.color(Color.Warning_500);
  const infoOnLightBg = theme.color(Color.Info_400);
  const infoOnLightColor = theme.color(Color.White);
  const infoOnDarkBg = theme.color(Color.Info_50);
  const infoOnDarkColor = theme.color(Color.Info_500);
  switch (tagTheme) {
    case "primary-on-light":
      return {
        [vars$j.bg]: primaryOnLightBg,
        [vars$j.color]: primaryOnLightColor
      };
    case "primary-on-dark":
      return {
        [vars$j.bg]: primaryOnDarkBg,
        [vars$j.color]: primaryOnDarkColor
      };
    case "primary-auto":
      return {
        [vars$j.bg]: primaryOnLightBg,
        [vars$j.color]: primaryOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: primaryOnDarkBg,
          [vars$j.color]: primaryOnDarkColor
        }
      };
    case "neutral-on-light":
      return {
        [vars$j.bg]: neutralOnLightBg,
        [vars$j.color]: neutralOnLightColor
      };
    case "neutral-on-dark":
      return {
        [vars$j.bg]: neutralOnDarkBg,
        [vars$j.color]: neutralOnDarkColor
      };
    case "neutral-auto":
      return {
        [vars$j.bg]: neutralOnLightBg,
        [vars$j.color]: neutralOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: neutralOnDarkBg,
          [vars$j.color]: neutralOnDarkColor
        }
      };
    case "success-on-light":
      return {
        [vars$j.bg]: successOnLightBg,
        [vars$j.color]: successOnLightColor
      };
    case "success-on-dark":
      return {
        [vars$j.bg]: successOnDarkBg,
        [vars$j.color]: successOnDarkColor
      };
    case "success-auto":
      return {
        [vars$j.bg]: successOnLightBg,
        [vars$j.color]: successOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: successOnDarkBg,
          [vars$j.color]: successOnDarkColor
        }
      };
    case "alert-on-light":
      return {
        [vars$j.bg]: alertOnLightBg,
        [vars$j.color]: alertOnLightColor
      };
    case "alert-on-dark":
      return {
        [vars$j.bg]: alertOnDarkBg,
        [vars$j.color]: alertOnDarkColor
      };
    case "alert-auto":
      return {
        [vars$j.bg]: alertOnLightBg,
        [vars$j.color]: alertOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: alertOnDarkBg,
          [vars$j.color]: alertOnDarkColor
        }
      };
    case "warning-on-light":
      return {
        [vars$j.bg]: warningOnLightBg,
        [vars$j.color]: warningOnLightColor
      };
    case "warning-on-dark":
      return {
        [vars$j.bg]: warningOnDarkBg,
        [vars$j.color]: warningOnDarkColor
      };
    case "warning-auto":
      return {
        [vars$j.bg]: warningOnLightBg,
        [vars$j.color]: warningOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: warningOnDarkBg,
          [vars$j.color]: warningOnDarkColor
        }
      };
    case "info-on-light":
      return {
        [vars$j.bg]: infoOnLightBg,
        [vars$j.color]: infoOnLightColor
      };
    case "info-on-dark":
      return {
        [vars$j.bg]: infoOnDarkBg,
        [vars$j.color]: infoOnDarkColor
      };
    case "info-auto":
      return {
        [vars$j.bg]: infoOnLightBg,
        [vars$j.color]: infoOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: infoOnDarkBg,
          [vars$j.color]: infoOnDarkColor
        }
      };
  }
};
const tagTintedThemeTokens = (theme, tagTheme) => {
  const primaryOnLightBg = theme.color(Color.Brownstone_Base);
  const primaryOnLightColor = theme.color(Color.Greystone_DarkMatter);
  const primaryOnDarkBg = theme.color(Color.White_A25);
  const primaryOnDarkColor = theme.color(Color.Dawn_Base);
  const neutralOnLightBg = theme.color(Color.Greystone_500);
  const neutralOnLightColor = theme.color(Color.Greystone_1200);
  const neutralOnDarkBg = theme.color(Color.White_A25);
  const neutralOnDarkColor = theme.color(Color.Brownstone_Moonstone);
  const successOnLightBg = theme.color(Color.Success_50);
  const successOnLightColor = theme.color(Color.Success_500);
  const successOnDarkBg = theme.color(Color.Success_50_A25);
  const successOnDarkColor = theme.color(Color.Success_50);
  const alertOnLightBg = theme.color(Color.Alert_50);
  const alertOnLightColor = theme.color(Color.Alert_500);
  const alertOnDarkBg = theme.color(Color.Alert_50_A25);
  const alertOnDarkColor = theme.color(Color.Alert_50);
  const warningOnLightBg = theme.color(Color.Warning_50);
  const warningOnLightColor = theme.color(Color.Warning_500);
  const warningOnDarkBg = theme.color(Color.Warning_50_A25);
  const warningOnDarkColor = theme.color(Color.Warning_50);
  const infoOnLightBg = theme.color(Color.Info_50);
  const infoOnLightColor = theme.color(Color.Info_500);
  const infoOnDarkBg = theme.color(Color.Info_50_A25);
  const infoOnDarkColor = theme.color(Color.Info_50);
  switch (tagTheme) {
    case "primary-on-light":
      return {
        [vars$j.bg]: primaryOnLightBg,
        [vars$j.color]: primaryOnLightColor
      };
    case "primary-on-dark":
      return {
        [vars$j.bg]: primaryOnDarkBg,
        [vars$j.color]: primaryOnDarkColor
      };
    case "primary-auto":
      return {
        [vars$j.bg]: primaryOnLightBg,
        [vars$j.color]: primaryOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: primaryOnDarkBg,
          [vars$j.color]: primaryOnDarkColor
        }
      };
    case "neutral-on-light":
      return {
        [vars$j.bg]: neutralOnLightBg,
        [vars$j.color]: neutralOnLightColor
      };
    case "neutral-on-dark":
      return {
        [vars$j.bg]: neutralOnDarkBg,
        [vars$j.color]: neutralOnDarkColor
      };
    case "neutral-auto":
      return {
        [vars$j.bg]: neutralOnLightBg,
        [vars$j.color]: neutralOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: neutralOnDarkBg,
          [vars$j.color]: neutralOnDarkColor
        }
      };
    case "success-on-light":
      return {
        [vars$j.bg]: successOnLightBg,
        [vars$j.color]: successOnLightColor
      };
    case "success-on-dark":
      return {
        [vars$j.bg]: successOnDarkBg,
        [vars$j.color]: successOnDarkColor
      };
    case "success-auto":
      return {
        [vars$j.bg]: successOnLightBg,
        [vars$j.color]: successOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: successOnDarkBg,
          [vars$j.color]: successOnDarkColor
        }
      };
    case "alert-on-light":
      return {
        [vars$j.bg]: alertOnLightBg,
        [vars$j.color]: alertOnLightColor
      };
    case "alert-on-dark":
      return {
        [vars$j.bg]: alertOnDarkBg,
        [vars$j.color]: alertOnDarkColor
      };
    case "alert-auto":
      return {
        [vars$j.bg]: alertOnLightBg,
        [vars$j.color]: alertOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: alertOnDarkBg,
          [vars$j.color]: alertOnDarkColor
        }
      };
    case "warning-on-light":
      return {
        [vars$j.bg]: warningOnLightBg,
        [vars$j.color]: warningOnLightColor
      };
    case "warning-on-dark":
      return {
        [vars$j.bg]: warningOnDarkBg,
        [vars$j.color]: warningOnDarkColor
      };
    case "warning-auto":
      return {
        [vars$j.bg]: warningOnLightBg,
        [vars$j.color]: warningOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: warningOnDarkBg,
          [vars$j.color]: warningOnDarkColor
        }
      };
    case "info-on-light":
      return {
        [vars$j.bg]: infoOnLightBg,
        [vars$j.color]: infoOnLightColor
      };
    case "info-on-dark":
      return {
        [vars$j.bg]: infoOnDarkBg,
        [vars$j.color]: infoOnDarkColor
      };
    case "info-auto":
      return {
        [vars$j.bg]: infoOnLightBg,
        [vars$j.color]: infoOnLightColor,
        "@media (prefers-color-scheme: dark)": {
          [vars$j.bg]: infoOnDarkBg,
          [vars$j.color]: infoOnDarkColor
        }
      };
  }
};
const tagSizeTokens = (theme, size) => {
  const smSize = theme.tokens.fontSizes[TypeScale.Size_01];
  const mdSize = theme.tokens.fontSizes[TypeScale.Size_02];
  const lgSize = theme.tokens.fontSizes[TypeScale.Size_03];
  switch (size) {
    case TagSize.Xs:
      return {
        [vars$j.fontSize]: smSize.fontSize,
        [vars$j.lineHeight]: smSize.lineHeight,
        [vars$j.gutterH]: theme.spacing(0.25),
        [vars$j.gutterV]: theme.spacing(0)
      };
    case TagSize.Sm:
      return {
        [vars$j.fontSize]: smSize.fontSize,
        [vars$j.lineHeight]: smSize.lineHeight,
        [vars$j.gutterH]: theme.spacing(0.5),
        [vars$j.gutterV]: theme.spacing(0)
      };
    case TagSize.Md:
      return {
        [vars$j.fontSize]: mdSize.fontSize,
        [vars$j.lineHeight]: mdSize.lineHeight,
        [vars$j.gutterH]: theme.spacing(0.5),
        [vars$j.gutterV]: theme.spacing(0)
      };
    case TagSize.Lg:
      return {
        [vars$j.fontSize]: lgSize.fontSize,
        [vars$j.lineHeight]: lgSize.lineHeight,
        [vars$j.gutterH]: theme.spacing(1),
        [vars$j.gutterV]: theme.spacing(0.25)
      };
  }
};
const tagStyle = (theme, props) => {
  const tagTheme = `${props.color}-${props.colorScheme}`;
  return [props.variant === TagVariant.Tinted ? tagTintedThemeTokens(theme, tagTheme) : tagSolidThemeTokens(theme, tagTheme), theme.responsive(props.size, size => tagSizeTokens(theme, size)), {
    display: "inline-grid",
    justifyItems: "center",
    gridAutoColumns: "auto",
    gridAutoFlow: "column",
    gap: theme.spacing(0.25),
    padding: `var(${vars$j.gutterV}) var(${vars$j.gutterH})`,
    alignItems: "center",
    color: `var(${vars$j.color})`,
    backgroundColor: `var(${vars$j.bg})`,
    borderRadius: theme.radius(0.25),
    fontSize: `var(${vars$j.fontSize})`,
    lineHeight: `var(${vars$j.lineHeight})`,
    fontFamily: theme.tokens.fontFamilies[props.fontFamily],
    fontWeight: props.fontFamily === "monospace" ? FontWeight.Bold : FontWeight.SemiBold
  }];
};

const Tag = props => {
  const {
    theme
  } = useTheme();
  const {
    children,
    removeAction,
    size = TagSize.Md,
    color = TagColor.Neutral,
    colorScheme = ColorScheme.OnLight,
    variant = TagVariant.Solid,
    iconAfter,
    iconBefore,
    fontFamily = "sans-serif",
    ...rest
  } = props;
  return jsxs("span", {
    css: tagStyle(theme, {
      size,
      color,
      colorScheme,
      variant,
      fontFamily
    }),
    ...rest,
    children: [iconBefore ? jsx(Icon, {
      size: "10px",
      name: iconBefore
    }) : null, jsx("span", {
      children: children
    }), iconAfter ? jsx(Icon, {
      size: "10px",
      name: iconAfter
    }) : null, removeAction ? jsx(RemoveAction, {
      colorScheme: colorScheme,
      label: removeAction === null || removeAction === void 0 ? void 0 : removeAction.label,
      onClose: removeAction === null || removeAction === void 0 ? void 0 : removeAction.onClose
    }) : null]
  });
};

const borderWidthHelper = makeCSSValueHelper(value => `${value}px`);
const boxStyle = (theme, props) => {
  const width = theme.responsive(props.width, value => ({
    width: value
  }));
  const minWidth = theme.responsive(props.minWidth, value => ({
    minWidth: value
  }));
  const maxWidth = theme.responsive(props.maxWidth, value => ({
    maxWidth: value
  }));
  const height = theme.responsive(props.height, value => ({
    height: value
  }));
  const minHeight = theme.responsive(props.minHeight, interpolatedMinHeight => ({
    minHeight: interpolatedMinHeight
  }));
  const gutterV = theme.responsive(props.gutterV, (value, themeValue) => {
    const px = themeValue.spacing(value);
    return {
      paddingTop: px,
      paddingBottom: px
    };
  });
  const gutterH = theme.responsive(props.gutterH, (value, themeValue) => {
    const px = themeValue.spacing(value);
    return {
      paddingLeft: px,
      paddingRight: px
    };
  });
  const spaceAbove = theme.responsive(props.spaceAbove, (value, themeValue) => {
    return {
      marginTop: themeValue.spacing(value)
    };
  });
  const spaceBelow = theme.responsive(props.spaceBelow, (value, themeValue) => {
    return {
      marginBottom: themeValue.spacing(value)
    };
  });
  const spaceBefore = theme.responsive(props.spaceBefore, (value, themeValue) => {
    return {
      marginLeft: themeValue.spacing(value)
    };
  });
  const spaceAfter = theme.responsive(props.spaceAfter, (value, themeValue) => {
    return {
      marginRight: themeValue.spacing(value)
    };
  });
  const flexDirection = theme.responsive(props.flexDirection, value => ({
    flexDirection: value
  }));
  const flexWrap = theme.responsive(props.flexWrap, value => ({
    flexWrap: value
  }));
  const flexGrow = theme.responsive(props.flexGrow, v => ({
    flexGrow: v
  }));
  const flexShrink = theme.responsive(props.flexShrink, v => ({
    flexShrink: v
  }));
  const flexBasis = theme.responsive(props.flexBasis, v => ({
    flexBasis: v
  }));
  const gridArea = theme.responsive(props.gridArea, v => ({
    gridArea: v
  }));
  const gridColumn = theme.responsive(props.gridColumn, v => ({
    gridColumn: v
  }));
  const gridRow = theme.responsive(props.gridRow, v => ({
    gridRow: v
  }));
  const alignItems = theme.responsive(props.alignItems, v => ({
    alignItems: v
  }));
  const justifyContent = theme.responsive(props.justifyContent, v => ({
    justifyContent: v
  }));
  const alignSelf = theme.responsive(props.alignSelf, v => ({
    alignSelf: v
  }));
  const justifySelf = theme.responsive(props.justifySelf, v => ({
    justifySelf: v
  }));
  const elevation = theme.responsive(props.elevation, (e, themeValue) => ({
    filter: themeValue.tokens.elevation[e]
  }));
  const borderRadius = theme.responsive(props.borderRadius, (r, themeValue) => ({
    borderRadius: themeValue.radius(r)
  }));
  const borderWidth = theme.responsive(props.borderWidth, v => ({
    borderWidth: borderWidthHelper(v),
    borderStyle: v ? "solid" : "none"
  }));
  const borderColor = theme.responsive(props.borderColor, c => ({
    borderColor: theme.color(c)
  }));
  const overflowX = theme.responsive(props.overflowX, v => ({
    overflowX: v
  }));
  const overflowY = theme.responsive(props.overflowY, v => ({
    overflowY: v
  }));
  const backgroundColor = theme.responsive(props.bg, c => ({
    backgroundColor: theme.color(c)
  }));
  const color = theme.responsive(props.color, c => ({
    color: theme.color(c)
  }));
  const opacity = theme.responsive(props.opacity, v => ({
    opacity: v
  }));
  const fontSize = theme.responsive(props.fontSize, v => ({
    ...theme.tokens.fontSizes[v]
  }));
  return [{
    display: props.layout || "block"
  }, width, minWidth, maxWidth, height, minHeight, backgroundColor, color, gutterH, gutterV, spaceAbove, spaceBelow, spaceBefore, spaceAfter, flexDirection, flexWrap, flexGrow, flexShrink, flexBasis, gridArea, gridRow, gridColumn, alignItems, justifyContent, alignSelf, justifySelf, elevation, borderRadius, borderWidth, borderColor, overflowX, overflowY, opacity, fontSize];
};
const omitAppearanceProps$1 = props => {
  const {
    width,
    minWidth,
    maxWidth,
    height,
    minHeight,
    bg,
    color,
    gutterH,
    gutterV,
    spaceAbove,
    spaceBelow,
    spaceBefore,
    spaceAfter,
    layout,
    justifyContent,
    flexDirection,
    flexWrap,
    flexGrow,
    flexShrink,
    flexBasis,
    alignItems,
    alignSelf,
    justifySelf,
    elevation,
    borderColor,
    borderRadius,
    borderWidth,
    overflowX,
    overflowY,
    opacity,
    gridArea,
    gridColumn,
    gridRow,
    fontSize,
    ...rest
  } = props;
  return rest;
};
const Box = /*#__PURE__*/React.forwardRef(function Box(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("div", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
`;
const shimmerStyle = (theme, props) => {
  const width = theme.responsive(props.width, value => ({
    width: value
  }));
  const minWidth = theme.responsive(props.minWidth, value => ({
    minWidth: value
  }));
  const maxWidth = theme.responsive(props.maxWidth, value => ({
    maxWidth: value
  }));
  const height = theme.responsive(props.height, value => ({
    height: value
  }));
  const minHeight = theme.responsive(props.minHeight, interpolatedMinHeight => ({
    minHeight: interpolatedMinHeight
  }));
  const spaceAbove = theme.responsive(props.spaceAbove, (value, themeValue) => {
    return {
      marginTop: themeValue.spacing(value)
    };
  });
  const spaceBelow = theme.responsive(props.spaceBelow, (value, themeValue) => {
    return {
      marginBottom: themeValue.spacing(value)
    };
  });
  const spaceBefore = theme.responsive(props.spaceBefore, (value, themeValue) => {
    return {
      marginLeft: themeValue.spacing(value)
    };
  });
  const spaceAfter = theme.responsive(props.spaceAfter, (value, themeValue) => {
    return {
      marginRight: themeValue.spacing(value)
    };
  });
  const borderRadius = theme.responsive(props.borderRadius, (r, themeValue) => ({
    borderRadius: themeValue.radius(r)
  }));
  return [{
    animation: `${shimmer} 2s ease infinite forwards`,
    border: "none",
    padding: 0,
    margin: 0,
    borderCollapse: "collapse",
    background: theme.color(Color.Greystone_300),
    backgroundImage: `linear-gradient(to right, ${theme.color(Color.Greystone_300)} 0%, ${theme.color(Color.Greystone_200)} 20%, ${theme.color(Color.Greystone_300)} 40%, ${theme.color(Color.Greystone_300)} 100%)`,
    backgroundRepeat: "no-repeat",
    ...theme.tokens.fontSizes[TypeScale.Size_02],
    borderRadius: 4,
    backgroundSize: "1000px 100%",
    width: "100%",
    height: theme.tokens.fontSizes[TypeScale.Size_02].lineHeight
  }, width, minWidth, maxWidth, height, minHeight, spaceAbove, spaceBelow, spaceBefore, spaceAfter, borderRadius];
};

const Shimmer = props => {
  const {
    theme
  } = useTheme();
  return jsx(Box, {
    css: shimmerStyle(theme, props)
  });
};

var AccordionVariant;
(function (AccordionVariant) {
  AccordionVariant["SolidOnLight"] = "solid-on-light";
  AccordionVariant["SolidOnDark"] = "solid-on-dark";
  AccordionVariant["ClearOnLight"] = "clear-on-light";
  AccordionVariant["ClearOnDark"] = "clear-on-dark";
  AccordionVariant["SolidOnLightDimmed"] = "solid-on-light-dimmed";
  AccordionVariant["SolidOnDarkDimmed"] = "solid-on-dark-dimmed";
  AccordionVariant["ClearOnLightDimmed"] = "clear-on-light-dimmed";
  AccordionVariant["ClearOnDarkDimmed"] = "clear-on-dark-dimmed";
})(AccordionVariant || (AccordionVariant = {}));
var AccordionSize;
(function (AccordionSize) {
  AccordionSize["Sm"] = "sm";
  AccordionSize["Md"] = "md";
  AccordionSize["Lg"] = "lg";
})(AccordionSize || (AccordionSize = {}));
var AccordionOutline;
(function (AccordionOutline) {
  AccordionOutline["None"] = "none";
  AccordionOutline["Solid"] = "solid";
})(AccordionOutline || (AccordionOutline = {}));
var AccordionMode;
(function (AccordionMode) {
  AccordionMode["Single"] = "single";
  AccordionMode["Multi"] = "multi";
})(AccordionMode || (AccordionMode = {}));

const useAccordionManager = (mode, initialSelected = [], options) => {
  const {
    minimumSelected
  } = options;
  const [selected, setSelected] = useState(() => {
    const source = mode === "single" ? initialSelected.slice(0, 1) : initialSelected;
    return source.reduce((acc, v) => ({
      ...acc,
      [v]: true
    }), {});
  });
  const toggleItem = itemId => {
    setSelected(current => {
      let clone = {
        [itemId]: true
      };
      if (mode === "multi") {
        clone = {
          ...clone,
          ...current
        };
      }
      if (current[itemId]) {
        delete clone[itemId];
      }
      if (Object.keys(clone).length < minimumSelected) {
        return current;
      }
      return clone;
    });
  };
  const selectedIds = React__default.useMemo(() => Object.keys(selected), [selected]);
  return [selectedIds, toggleItem];
};
const AccordionContext = /*#__PURE__*/createContext({
  autoScrollIntoView: true,
  selectedItems: [],
  toggleItem: () => {},
  mode: AccordionMode.Single,
  minimumSelected: 1,
  toggleVisibility: "visible"
});
const useAccordion = () => {
  return useContext(AccordionContext);
};

const sizeMapping = {
  [AccordionSize.Lg]: {
    headerGutterBlock: 1.5,
    headerGutterInline: 1,
    panelGutterBlock: 2,
    panelGutterInline: 1,
    borderRadius: 1.5,
    headerFontWeight: FontWeight.Normal,
    headerTypeScale: TypeScale.Size_06,
    panelTypeScale: TypeScale.Size_04
  },
  [AccordionSize.Md]: {
    headerGutterBlock: 1,
    headerGutterInline: 1,
    panelGutterBlock: 1.5,
    panelGutterInline: 1,
    borderRadius: 1,
    headerFontWeight: FontWeight.Normal,
    headerTypeScale: TypeScale.Size_05,
    panelTypeScale: TypeScale.Size_03
  },
  [AccordionSize.Sm]: {
    headerGutterBlock: 1,
    headerGutterInline: 1,
    panelGutterBlock: 1,
    panelGutterInline: 0.75,
    borderRadius: 1,
    headerFontWeight: FontWeight.Normal,
    headerTypeScale: TypeScale.Size_03,
    panelTypeScale: TypeScale.Size_03
  }
};
const solidOnLight = {
  headerColor: ColorPreset.TextOnLight_01,
  activeheaderColor: ColorPreset.TextOnLight_01,
  bodyColor: ColorPreset.TextOnLight_02,
  backgroundColor: ColorPreset.BackgroundLight_02,
  activeBackgroundColor: ColorPreset.BackgroundLight_02,
  separatorColor: ColorPreset.BorderOnLight_05
};
const solidOnDark = {
  headerColor: ColorPreset.TextOnDark_01,
  activeheaderColor: ColorPreset.TextOnDark_01,
  bodyColor: ColorPreset.TextOnDark_02,
  backgroundColor: ColorPreset.BackgroundDark_01,
  activeBackgroundColor: ColorPreset.BackgroundDark_01,
  separatorColor: Color.White_A25
};
const clearOnLight = {
  headerColor: ColorPreset.TextOnLight_01,
  activeheaderColor: ColorPreset.TextOnLight_01,
  bodyColor: ColorPreset.TextOnLight_02,
  backgroundColor: Color.Transparent,
  activeBackgroundColor: Color.Transparent,
  separatorColor: ColorPreset.BorderOnLight_05
};
const clearOnDark = {
  headerColor: ColorPreset.TextOnDark_01,
  activeheaderColor: ColorPreset.TextOnDark_01,
  bodyColor: ColorPreset.TextOnDark_02,
  backgroundColor: Color.Transparent,
  activeBackgroundColor: Color.Transparent,
  separatorColor: Color.White_A25
};
const variantMapping = {
  [AccordionVariant.SolidOnLight]: solidOnLight,
  [AccordionVariant.SolidOnDark]: solidOnDark,
  [AccordionVariant.ClearOnLight]: clearOnLight,
  [AccordionVariant.ClearOnDark]: clearOnDark,
  [AccordionVariant.SolidOnLightDimmed]: {
    ...solidOnLight,
    headerColor: ColorPreset.TextOnLight_03
  },
  [AccordionVariant.SolidOnDarkDimmed]: {
    ...solidOnDark,
    headerColor: ColorPreset.TextOnDark_03
  },
  [AccordionVariant.ClearOnLightDimmed]: {
    ...clearOnLight,
    headerColor: ColorPreset.TextOnLight_03
  },
  [AccordionVariant.ClearOnDarkDimmed]: {
    ...clearOnDark,
    headerColor: ColorPreset.TextOnDark_03
  }
};
const accordionColorTokens = (theme, props) => {
  return [theme.responsive(props.variant, v => {
    const cfg = variantMapping[v];
    return {
      "--accordion-header-color": theme.color(cfg.headerColor),
      "--accordion-active-header-color": theme.color(cfg.activeheaderColor),
      "--accordion-body-color": theme.color(cfg.bodyColor),
      "--accordion-active-bg": theme.color(cfg.activeBackgroundColor),
      "--accordion-bg": theme.color(cfg.backgroundColor),
      "--accordion-separator-color": theme.color(cfg.separatorColor)
    };
  }), {
    "--accordion-outline-color": props.outline === AccordionOutline.Solid ? "var(--accordion-separator-color)" : theme.color(Color.Transparent)
  }];
};
const accordionSizeTokens = (theme, props) => {
  return [theme.responsive(props.size, s => {
    const cfg = sizeMapping[s];
    const radius = theme.radius(cfg.borderRadius);
    const headerBlock = theme.spacing(cfg.headerGutterBlock);
    const headerInline = theme.spacing(cfg.headerGutterInline);
    const panelBlock = theme.spacing(cfg.panelGutterBlock);
    const panelInline = theme.spacing(cfg.panelGutterInline);
    const headerSize = theme.tokens.fontSizes[cfg.headerTypeScale];
    const panelSize = theme.tokens.fontSizes[cfg.panelTypeScale];
    return {
      "--accordion-border-radius": radius,
      "--accordion-header-gutter-block": headerBlock,
      "--accordion-header-gutter-inline": headerInline,
      "--accordion-header-font-size": headerSize.fontSize,
      "--accordion-header-line-height": headerSize.lineHeight,
      "--accordion-panel-gutter-block": panelBlock,
      "--accordion-panel-gutter-inline": panelInline,
      "--accordion-header-font-weight": cfg.headerFontWeight,
      "--accordion-panel-font-size": panelSize.fontSize,
      "--accordion-panel-line-height": panelSize.lineHeight
    };
  }), {
    "--accordion-left-accessory-width": "32px",
    "--accordion-header-column-gap": theme.spacing(1)
  }];
};
const focusRings = (theme, {
  variant
}) => theme.responsive(variant, v => {
  let colorScheme;
  if (v.includes("on-dark")) {
    colorScheme = ColorScheme.OnDark;
  } else {
    colorScheme = ColorScheme.Auto;
  }
  return focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme,
    focusSelector: " & [data-accordion-trigger]:focus-visible"
  });
});
const accordionStyle = (theme, props) => {
  return [accordionSizeTokens(theme, props), accordionColorTokens(theme, props), {
    backgroundColor: "var(--accordion-bg)",
    borderRadius: "var(--accordion-border-radius)",
    border: `1px solid var(--accordion-outline-color)`
  }, focusRings(theme, {
    variant: props.variant
  })];
};

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
const handleKeyDown = event => {
  var _buttons$previousInde, _buttons$nextIndex, _buttons$, _buttons$lastIndex;
  const {
    target,
    currentTarget
  } = event;
  const buttons = Array.from(currentTarget.querySelectorAll(":scope > div > button"));
  const targetIndex = buttons.findIndex(el => el === target);
  const key = event.key;
  if (!buttons.length || targetIndex < 0) {
    return;
  }
  const lastIndex = buttons.length - 1;
  const nextIndex = targetIndex === lastIndex ? 0 : targetIndex + 1;
  const previousIndex = targetIndex === 0 ? lastIndex : targetIndex - 1;
  switch (key) {
    case "ArrowUp":
    case "Up":
      (_buttons$previousInde = buttons[previousIndex]) === null || _buttons$previousInde === void 0 ? void 0 : _buttons$previousInde.focus();
      break;
    case "ArrowDown":
    case "Down":
      (_buttons$nextIndex = buttons[nextIndex]) === null || _buttons$nextIndex === void 0 ? void 0 : _buttons$nextIndex.focus();
      break;
    case "Home":
      (_buttons$ = buttons[0]) === null || _buttons$ === void 0 ? void 0 : _buttons$.focus();
      break;
    case "End":
      (_buttons$lastIndex = buttons[lastIndex]) === null || _buttons$lastIndex === void 0 ? void 0 : _buttons$lastIndex.focus();
      break;
  }
};
const Accordion = props => {
  const {
    autoScrollIntoView = true,
    children,
    initialSelected,
    minimumSelected = 1,
    mode,
    onChange,
    outline,
    size,
    toggleVisibility = "visible",
    variant,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const [selectedItems, toggleItem] = useAccordionManager(mode, initialSelected || [], {
    minimumSelected
  });
  const previousRef = React.useRef();
  React.useEffect(() => {
    // We should only call onChange after initial render and when the selected
    // items have changed. We use a previousRef to track changes between current
    // state and previous state.
    const previous = previousRef.current;
    previousRef.current = selectedItems;
    // On initial render this ref is going to be undefined.
    if (previous == null) {
      return;
    }
    if (previous === selectedItems) {
      return;
    }
    if (onChange) {
      onChange(selectedItems);
    }
  }, [previousRef, selectedItems, onChange]);
  return jsx(AccordionContext.Provider, {
    value: {
      autoScrollIntoView,
      selectedItems,
      toggleItem,
      mode,
      minimumSelected,
      toggleVisibility
    },
    children: jsx("div", {
      css: accordionStyle(theme, props),
      "data-reading-optimized": true,
      role: "presentation",
      ...rest,
      onKeyDown: handleKeyDown,
      children: props.children
    })
  });
};

const isVisibleInViewport = element => {
  if (element === null) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};

const accordionHeaderStyle = {
  width: "100%",
  display: "grid",
  textAlign: "start",
  columnGap: "var(--accordion-header-column-gap)",
  alignItems: "center",
  cursor: "pointer",
  border: "none",
  background: "none",
  padding: "var(--accordion-header-gutter-block) var(--accordion-header-gutter-inline)",
  fontFamily: "inherit",
  fontWeight: "var(--accordion-header-font-weight)",
  fontSize: "var(--accordion-header-font-size)",
  lineHeight: "var(--accordion-header-line-height)",
  color: "var(--accordion-header-color)",
  transition: "background-color 200ms",
  boxShadow: `var(${focusRingVar})`,
  "&:hover .underlineEffect, &:focus-visible:focus .underlineEffect, &:active .underlineEffect": {
    color: "var(--accordion-active-header-color)"
  },
  "&:disabled, &[aria-disabled=true]": {
    cursor: "initial"
  }
};
const leftAccessoryStyle = {
  width: "var(--accordion-left-accessory-width)",
  display: "flex",
  justifyContent: "center"
};
const rightAccessoryStyle = {
  display: "flex",
  justifyContent: "flex-end"
};
const accordionHeaderTitleStyle = {
  textDecoration: "underline",
  textDecorationColor: "transparent",
  transition: "text-decoration-color 200ms",
  "button:hover > &, button:focus-visible:focus > &, button:active > &": {
    textDecorationColor: "currentColor"
  },
  "button:disabled > &, button[aria-disabled=true] > &": {
    textDecorationColor: "transparent"
  }
};
const AccordionHeader = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    id,
    toggleItem,
    disabled,
    itemId,
    leftAccessory,
    rightAccessory,
    open,
    toggleEnabled
  } = props;
  // start with column size of title
  let gridTemplateColumns = "auto";
  if (leftAccessory) {
    gridTemplateColumns = `32px ${gridTemplateColumns}`;
  }
  if (rightAccessory) {
    gridTemplateColumns = `${gridTemplateColumns} auto`;
  }
  // finally make space for the toggle
  if (toggleEnabled) {
    gridTemplateColumns = `${gridTemplateColumns} max-content`;
  }
  return jsxs("button", {
    id: id,
    css: [accordionHeaderStyle, {
      gridTemplateColumns,
      borderRadius: theme.radius(0.25)
    }, process.env.NODE_ENV === "production" ? "" : ";label:AccordionHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
    type: "button",
    "aria-expanded": open,
    "aria-disabled": disabled,
    "aria-controls": itemId,
    "data-accordion-trigger": true,
    onClick: () => toggleItem(itemId),
    ref: ref,
    children: [leftAccessory ? jsx("span", {
      css: leftAccessoryStyle,
      children: leftAccessory
    }) : null, jsx("span", {
      css: accordionHeaderTitleStyle,
      children: props.children
    }), rightAccessory ? jsx("span", {
      css: rightAccessoryStyle,
      children: rightAccessory
    }) : null, toggleEnabled ? jsx(Icon, {
      name: props.open ? Glyph.ChevronUp : Glyph.ChevronDown
    }) : null]
  });
});

const panelBodyStyle = {
  paddingBottom: "var(--accordion-panel-gutter-block)",
  paddingRight: "calc(var(--accordion-panel-gutter-inline) +  var(--accordion-panel-pad-end))",
  paddingLeft: "calc(var(--accordion-panel-gutter-inline) + var(--accordion-panel-pad-start))",
  fontSize: "var(--accordion-panel-font-size)",
  lineHeight: "var(--accordion-panel-line-height)",
  color: "var(--accordion-body-color)"
};
const AccordionPanel = props => {
  const {
    open,
    id,
    headerId,
    children,
    onHeightAnimationEnd
  } = props;
  const [isClientSide, setIsClientSide] = React__default.useState(false);
  React__default.useEffect(() => setIsClientSide(true), []);
  const sharedProps = {
    id: id,
    role: "region",
    "aria-labelledby": headerId,
    "aria-hidden": !open
  };
  const body = jsx("div", {
    css: panelBodyStyle,
    children: children
  });
  if (!isClientSide) {
    return jsx("div", {
      ...sharedProps,
      children: body
    });
  }
  return jsx(AnimateHeight, {
    onHeightAnimationEnd: onHeightAnimationEnd,
    duration: 250,
    height: open ? "auto" : 0,
    ...sharedProps,
    children: body
  });
};

const accordionItemStyle = (theme, props) => {
  return [{
    "&+&": {
      borderTop: "1px solid var(--accordion-separator-color)"
    }
  },
  // The extra padding on the panel body is added if there is a left accessory
  // and/or the toggle is visible. However, on smaller viewports, we don't
  // want this extra padding because horizontal space is limited and we want
  // to make sure there is enough room for content.
  theme.responsive([false, false, true], enabled => {
    return {
      "--accordion-panel-pad-start": enabled && props.padStart ? "calc(var(--accordion-left-accessory-width) + var(--accordion-header-column-gap))" : "0px",
      "--accordion-panel-pad-end": enabled && props.padEnd ? "calc(var(--accordion-header-font-size) + var(--accordion-header-column-gap))" : "0px"
    };
  })];
};
const AccordionItem = props => {
  const {
    autoScrollIntoView,
    minimumSelected,
    selectedItems,
    toggleItem,
    toggleVisibility
  } = useAccordion();
  const {
    theme
  } = useTheme();
  const {
    id,
    leftAccessory,
    rightAccessory,
    title
  } = props;
  const open = !!selectedItems.find(itemId => itemId === id);
  const headerRef = React.useRef(null);
  const headerId = `${id}_header`;
  const toggleEnabled = toggleVisibility === "visible";
  const disabled = selectedItems.length <= minimumSelected && open;
  const renderProps = {
    open
  };
  const left = leftAccessory === null || leftAccessory === void 0 ? void 0 : leftAccessory(renderProps);
  const right = rightAccessory === null || rightAccessory === void 0 ? void 0 : rightAccessory(renderProps);
  const hasLeft = React.Children.count(left) > 0;
  const hasRight = React.Children.count(right) > 0;
  const onAccordionPanelHeightAnimationEnd = () => {
    if (!open) {
      return;
    }
    const headerEl = headerRef.current;
    if (autoScrollIntoView && headerEl && !isVisibleInViewport(headerEl)) {
      headerEl.scrollIntoView({
        block: "start"
      });
    }
  };
  return jsxs("div", {
    css: accordionItemStyle(theme, {
      padStart: hasLeft,
      padEnd: toggleEnabled || hasRight,
      open
    }),
    children: [jsx(AccordionHeader, {
      id: headerId,
      itemId: id,
      leftAccessory: hasLeft ? left : null,
      rightAccessory: hasRight ? right : null,
      toggleItem: toggleItem,
      open: open,
      toggleEnabled: toggleEnabled,
      disabled: disabled,
      ref: headerRef,
      children: title
    }), jsx(AccordionPanel, {
      headerId: headerId,
      id: id,
      onHeightAnimationEnd: onAccordionPanelHeightAnimationEnd,
      open: open,
      children: props.children
    })]
  });
};

const Text = /*#__PURE__*/React.forwardRef(function Text(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitTypographyStyleProps(props);
  return jsx("span", {
    css: typographyStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const createHeadingComponent = (Element, defaultSize) => {
  const Heading = /*#__PURE__*/React.forwardRef(function Heading(props, ref) {
    const {
      theme
    } = useTheme();
    // Set a default size if size or preset props are set
    const size = props.size || (props.preset ? undefined : defaultSize);
    const rest = omitTypographyStyleProps(props);
    return jsx(Element, {
      css: typographyStyle(theme, {
        ...props,
        ...(size == null ? {} : {
          size
        })
      }),
      ...rest,
      ref: ref,
      children: props.children
    });
  });
  Heading.displayName = Element.toUpperCase();
  return Heading;
};
const H1 = createHeadingComponent("h1", TypeScale.Size_11);
const H2 = createHeadingComponent("h2", TypeScale.Size_08);
const H3 = createHeadingComponent("h3", TypeScale.Size_07);
const H4 = createHeadingComponent("h4", TypeScale.Size_06);
const H5 = createHeadingComponent("h5", TypeScale.Size_05);
const H6 = createHeadingComponent("h6", TypeScale.Size_04);

const P = /*#__PURE__*/React.forwardRef(function Paragraph(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitTypographyStyleProps(props);
  return jsx("p", {
    css: typographyStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const blockQuoteStyle = (theme, props) => {
  return [typographyStyle(theme, props), {
    "--blockquote-border-width": 0,
    "--blockquote-border-spacing": 0,
    borderLeftStyle: "solid",
    "p:last-child": {
      marginBottom: 0
    }
  }, theme.responsive(props.accentPosition, v => {
    switch (v) {
      case "inside":
        return {
          marginLeft: 0
        };
      case "outside":
        return {
          marginLeft: "calc( -1 * (var(--blockquote-border-width) + var(--blockquote-border-spacing)) )"
        };
    }
  }), theme.responsive(props.borderWidth, borderWidth => ({
    borderWidth: borderWidth,
    "--blockquote-border-width": `${borderWidth}px`
  })), theme.responsive(props.borderColor, color => ({
    borderColor: theme.color(color)
  })), theme.responsive(props.borderSpacing, spacing => {
    const value = theme.spacing(spacing);
    return {
      paddingLeft: value,
      "--blockquote-border-spacing": value
    };
  })];
};
const BlockQuote = /*#__PURE__*/React.forwardRef(function BlockQuote(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    preset,
    size: inSize,
    borderWidth = 5,
    borderSpacing = 1,
    accentPosition = "inside",
    layout = "block"
  } = props;
  // Set a default size if size or preset props are set
  const size = inSize || (preset ? undefined : TypeScale.Size_07);
  const {
    borderColor,
    ...rest
  } = omitTypographyStyleProps(props);
  return jsx("blockquote", {
    css: blockQuoteStyle(theme, {
      borderWidth,
      borderSpacing,
      accentPosition,
      layout,
      ...props,
      ...(size == null ? {} : {
        size
      })
    }),
    ...rest,
    ref: ref
  });
});

const Cite = /*#__PURE__*/React.forwardRef(function Cite(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitTypographyStyleProps(props);
  return jsx("cite", {
    css: typographyStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const Code = /*#__PURE__*/React.forwardRef(function Code(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitTypographyStyleProps(props);
  const {
    fontFamily = "monospace"
  } = props;
  return jsx("code", {
    css: typographyStyle(theme, {
      fontFamily,
      ...props
    }),
    ...rest,
    ref: ref
  });
});

const containerStyle$2 = (theme, props) => {
  return [{
    margin: 0,
    maxWidth: "100%",
    overflow: props.overflow
  }, theme.responsive(props.spaceAbove, v => ({
    marginTop: theme.spacing(v)
  })), theme.responsive(props.spaceBelow, v => ({
    marginBottom: theme.spacing(v)
  }))];
};
const codeStyle = (theme, props) => {
  return typographyStyle(theme, {
    ...props,
    fontFamily: "monospace"
  });
};
const CodeBlock = props => {
  const {
    theme
  } = useTheme();
  const {
    spaceAbove,
    spaceBelow,
    overflow = Overflow.Auto,
    ...rest
  } = props;
  return jsx("pre", {
    css: containerStyle$2(theme, {
      overflow,
      ...props
    }),
    children: jsx("code", {
      css: codeStyle(theme, rest),
      children: props.children
    })
  });
};

const textSelector = ["> p", "> h1", "> h2", "> h3", "> h4", "> h5", "> h6", "> blockquote", "> cite", "> img", "> ul", "> ol", "> table", "> .gatsby-highlight", "> [data-reading-optimized]", "> pre", "> dl"].join(", ");
const readingOptimizedStyle = (theme, props) => {
  return [{
    display: "flex",
    width: "100%",
    flexDirection: "column",
    [textSelector]: {
      maxWidth: "100%"
    }
  }, theme.responsive(props.textWidth, width => ({
    [textSelector]: {
      width
    }
  })), theme.responsive(props.alignText, alignSelf => ({
    [textSelector]: {
      alignSelf
    }
  }))];
};
/**
 * The ReadingOptimized component is used to style blocks of text elements in a
 * way that creates a good reading experience. This includes setting a definite
 * width that corresponds to an optimal characters-per-line value.
 */
const ReadingOptimized = props => {
  const {
    theme
  } = useTheme();
  const {
    textWidth = ["100%", null, "41rem"],
    alignText = [AlignItems.FlexStart, null, AlignItems.Center],
    ...rest
  } = props;
  return jsx("div", {
    css: readingOptimizedStyle(theme, {
      textWidth,
      alignText,
      ...props
    }),
    ...rest,
    children: props.children
  });
};

const noClamp = () => ({
  WebkitLineClamp: "none",
  overflow: "initial"
});
const lineClampStyle = (theme, {
  lines
}) => [{
  display: "-webkit-box",
  WebkitBoxOrient: "vertical"
}, noClamp(), theme.responsive(lines, l => {
  if (l > 0) {
    return {
      WebkitLineClamp: l,
      overflow: "hidden"
    };
  } else {
    return noClamp();
  }
})];
const LineClamp = props => {
  const {
    theme
  } = useTheme();
  return jsx("span", {
    css: lineClampStyle(theme, props),
    children: props.children
  });
};

const gutterStyle$2 = (theme, props) => [theme.responsive(props.gutterV, v => ({
  paddingTop: theme.spacing(v),
  paddingBottom: theme.spacing(v)
})), theme.responsive(props.gutterH, h => ({
  paddingLeft: theme.spacing(h),
  paddingRight: theme.spacing(h)
}))];

const tableCellStyle = (theme, props) => [{
  verticalAlign: "top"
}, typographyStyle(theme, {
  ...props,
  emptyVisibility: "visible"
}), gutterStyle$2(theme, props)];
const TableCell = props => {
  const {
    theme
  } = useTheme();
  const {
    gutterV = 1,
    gutterH = 1.5,
    ...rest
  } = props;
  const {
    ...filtered
  } = omitTypographyStyleProps(props);
  const tableCellStyleProps = {
    gutterV,
    gutterH,
    ...rest
  };
  return jsx("td", {
    css: tableCellStyle(theme, tableCellStyleProps),
    ...filtered
  });
};

const tableHeadCellStyle = (theme, props) => [{
  textAlign: "start",
  verticalAlign: "top",
  fontWeight: FontWeight.SemiBold
}, typographyStyle(theme, {
  ...props,
  emptyVisibility: "visible"
}), gutterStyle$2(theme, props)];
const TableHeadCell = props => {
  const {
    theme
  } = useTheme();
  const {
    gutterV = 1,
    gutterH = 1.5,
    ...rest
  } = props;
  const {
    ...filtered
  } = omitTypographyStyleProps(props);
  const tableHeadCellStylesProps = {
    gutterV,
    gutterH,
    ...rest
  };
  return jsx("th", {
    css: tableHeadCellStyle(theme, tableHeadCellStylesProps),
    ...filtered,
    gutterH
  });
};

const tableBodyStyle = {
  "> tr + tr > td": {
    borderTop: "1px solid var(--table-border-color)"
  },
  "> tr > td + td, > tr > th + td, > tr > td + th, > tr > th + th": {
    borderLeft: "1px solid var(--table-border-color)"
  }
};
const TableBody = props => {
  return jsx("tbody", {
    css: tableBodyStyle,
    ...props
  });
};

const tableHeadStyle = {
  "> tr:last-child": {
    "> td, > th": {
      borderBottom: "1px solid var(--table-border-color)"
    }
  },
  "&:last-child > tr:last-child": {
    "> td, > th": {
      borderBottom: "none"
    }
  },
  "> tr > td + td, > tr > th + td, > tr > td + th, > tr > th + th": {
    borderLeft: "1px solid var(--table-border-color)"
  }
};
const TableHead = props => {
  return jsx("thead", {
    css: tableHeadStyle,
    ...props
  });
};

const tableContainerStyle = (theme, props) => [{
  "--table-border-color": theme.color(ColorPreset.BackgroundLight_04),
  border: "1px solid var(--table-border-color)",
  borderRadius: theme.radius(1),
  maxWidth: "100%",
  margin: "0 auto",
  overflow: "auto",
  borderSpacing: 0
}, theme.responsive(props.layout, l => ({
  width: l === "fullWidth" ? "100%" : "auto"
}))];
const TableContainer = props => {
  const {
    theme
  } = useTheme();
  const {
    layout = "contentWidth",
    ...rest
  } = props;
  const tableContainerStyleProps = {
    layout,
    ...rest
  };
  return jsx("table", {
    css: tableContainerStyle(theme, tableContainerStyleProps),
    ...rest
  });
};

const style = theme => [{
  p: typographyStyle(theme, {
    size: [TypeScale.Size_04, null, TypeScale.Size_05],
    spaceBelow: [1.5, null, 2],
    fontFamily: "serif"
  }),
  h1: typographyStyle(theme, {
    spaceAbove: 1,
    spaceBelow: 1.5
  }),
  h2: typographyStyle(theme, {
    size: [TypeScale.Size_06, null, TypeScale.Size_08],
    spaceAbove: 1,
    spaceBelow: 1.5
  }),
  h3: typographyStyle(theme, {
    size: [TypeScale.Size_05, null, TypeScale.Size_07],
    spaceAbove: 1,
    spaceBelow: 1
  }),
  h4: typographyStyle(theme, {
    size: [TypeScale.Size_04, null, TypeScale.Size_06],
    spaceAbove: 1,
    spaceBelow: 1
  }),
  h5: typographyStyle(theme, {
    size: [TypeScale.Size_03, null, TypeScale.Size_05],
    spaceAbove: 1,
    spaceBelow: 1
  }),
  h6: typographyStyle(theme, {
    size: [TypeScale.Size_02, null, TypeScale.Size_04],
    spaceAbove: 1,
    spaceBelow: 1
  }),
  a: plainButtonStyle(theme, {
    textDecoration: "underline"
  }),
  ol: {
    paddingLeft: theme.spacing(1.5),
    margin: theme.spacing([1.5, 0, 2]),
    fontFamily: theme.tokens.fontFamilies["serif"],
    ...theme.tokens.fontSizes[TypeScale.Size_05]
  },
  ul: {
    paddingLeft: theme.spacing(1.5),
    margin: theme.spacing([1.5, 0, 2]),
    fontFamily: theme.tokens.fontFamilies["serif"],
    ...theme.tokens.fontSizes[TypeScale.Size_05]
  },
  img: {
    width: "100%"
  },
  table: tableContainerStyle(theme, {
    layout: "fullWidth"
  }),
  thead: tableHeadStyle,
  tbody: tableBodyStyle,
  th: tableHeadCellStyle(theme, {
    fontFamily: "serif",
    gutterV: 0.25,
    gutterH: 1
  }),
  td: tableCellStyle(theme, {
    fontFamily: "serif",
    gutterV: 0.25,
    gutterH: 1
  }),
  "th > :last-child, td > :last-child": {
    marginBottom: 0
  },
  "th p, th ol, th ul, td p, td ol, td ul": {
    fontSize: "inherit",
    fontFamily: "inherit"
  },
  "> table img": {
    maxWidth: "100%"
  },
  ".gatsby-highlight": {
    marginBottom: theme.spacing(2)
  },
  ".wistia_responsive_padding": {
    marginBottom: theme.spacing(4),
    width: "100%"
  },
  ".youtube-embed-responsive-padding": {
    marginBottom: theme.spacing(4),
    paddingBottom: "56.25%",
    position: "relative"
  },
  ".youtube-embed-responsive-container": {
    height: "100%",
    position: "absolute",
    width: "100%"
  }
}];
/**
 * HTMLBody takes arbitrary HTML either as a raw string or React elements and
 * renders it using the Flux design system styles. This useful when working
 * with Markdown or rich text that is converted to an HTML string and then
 * passed to React using `dangerouslySetInnerHTML`.
 *
 * @example
 * // Using an arbitrary HTML string
 * function Demo() {
 *   return <HTMLContent html="<div><p>Hello World</p></div>" />;
 * }
 *
 * @example
 * // Using unstyled HTML elements
 * function Demo() {
 *   return (
 *     <HTMLContent>
 *       <div>
 *         <p>Hello World</p>
 *       </div>
 *     </HTMLContent>
 *   );
 * }
 */
const HTMLContent = ({
  html,
  children,
  ...rest
}) => {
  const {
    theme
  } = useTheme();
  const sharedProps = {
    "data-reading-optimized": true,
    css: style(theme),
    ...rest
  };
  return typeof html === "string" ? jsx("div", {
    ...sharedProps,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }) : jsx("div", {
    ...sharedProps,
    children: children
  });
};

var MoneyTextVariant;
(function (MoneyTextVariant) {
  MoneyTextVariant["Default"] = "default";
  MoneyTextVariant["Flat"] = "flat";
})(MoneyTextVariant || (MoneyTextVariant = {}));
const normalParts = new Set(["group", "integer"]);
const partStyle = (_, props) => {
  const {
    type,
    isShort
  } = props;
  if (normalParts.has(type) || isShort && type === "currency") {
    return {};
  }
  return {
    fontSize: "0.7em",
    lineHeight: 1
  };
};
const languageFromLocale = locale => locale.split("-")[0];
const CurrencySymbolMap = {
  GBP: "£",
  USD: "$",
  EUR: "€",
  DKK: "kr.",
  SEK: "kr",
  AUD: "$",
  NZD: "$",
  CAD: "$"
};
const getShortFormat = (amount, currencyCode) => {
  const currencySymbol = CurrencySymbolMap[currencyCode];
  if (!currencySymbol) {
    throw new Error(`Currency code (${currencyCode}) is not supported for short format.`);
  }
  const shortSymbol = {
    type: "currency",
    value: currencySymbol
  };
  return [shortSymbol, ...amount];
};
const getLiteralFormat = (amount, currencyCode) => {
  const literalCode = {
    type: "currency",
    value: currencyCode
  };
  return [...amount, literalCode];
};
const getAmountParts = parts => {
  return parts.filter(({
    type
  }) => type !== "currency" && type !== "literal");
};
const getFormattedParts = (parts, format, code) => {
  const amount = getAmountParts(parts);
  return format === "literal" ? getLiteralFormat(amount, code) : getShortFormat(amount, code);
};
const MoneyText = props => {
  const {
    theme
  } = useTheme();
  const {
    amount,
    currency,
    locale,
    format = "literal",
    variant = MoneyTextVariant.Default,
    ...rest
  } = props;
  const isShort = format === "short";
  const isLiteral = format === "literal";
  const formatter = Intl.NumberFormat(languageFromLocale(locale), {
    style: "currency",
    currencyDisplay: "code",
    currency
  });
  const whole = `${formatter.format(amount)}`;
  const parts = formatter.formatToParts(amount);
  const formattedParts = getFormattedParts(parts, format, currency);
  return jsx(Text, {
    textWrap: TextWrap.NoWrap,
    "aria-label": whole,
    ...rest,
    children: jsx(Text, {
      "aria-hidden": true,
      children: formattedParts.flatMap((p, index) => {
        const key = `${p.type}_${p.value}_${index}`;
        const style = variant === MoneyTextVariant.Flat ? {} : partStyle(theme, {
          ...p,
          isShort
        });
        // normalize all spaces to use literal space (" ") instead of
        // non-breaking space character where present.
        let node = jsx("span", {
          css: style,
          children: p.value.replace(/\s/g, " ")
        }, key);
        if (p.type === "currency") {
          node = jsxs(React.Fragment, {
            children: [isLiteral && jsx("span", {
              css: style,
              children: " "
            }), node, isShort && jsx("span", {
              css: style,
              children: " "
            })]
          }, key);
        }
        return node;
      })
    })
  });
};

var AvatarSize;
(function (AvatarSize) {
  AvatarSize["Xs"] = "xs";
  AvatarSize["Sm"] = "sm";
  AvatarSize["Md"] = "md";
  AvatarSize["Lg"] = "lg";
})(AvatarSize || (AvatarSize = {}));
const firstUnicodeChar = input => {
  let out = "";
  // iterate over unicode codepoints
  for (const ch of input) {
    // skip whitespace characters
    if (ch.trim() !== "") {
      out = ch;
      break;
    }
  }
  return out;
};
const sizes = {
  [AvatarSize.Xs]: "24px",
  [AvatarSize.Sm]: "32px",
  [AvatarSize.Md]: "48px",
  [AvatarSize.Lg]: "64px"
};
const fontSizes = {
  [AvatarSize.Xs]: TypeScale.Size_01,
  [AvatarSize.Sm]: TypeScale.Size_02,
  [AvatarSize.Md]: TypeScale.Size_05,
  [AvatarSize.Lg]: TypeScale.Size_07
};
const iconSizes = {
  [AvatarSize.Xs]: TypeScale.Size_01,
  [AvatarSize.Sm]: TypeScale.Size_01,
  [AvatarSize.Md]: TypeScale.Size_05,
  [AvatarSize.Lg]: TypeScale.Size_06
};
const sizeVar = "--avatar-size";
const avatarStyle = (theme, props) => {
  const {
    color,
    bg
  } = props;
  return [{
    overflow: "hidden",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: theme.tokens.fontFamilies["sans-serif"],
    backgroundColor: bg ? theme.color(bg) : undefined,
    color: color ? theme.color(color) : undefined
  }, theme.responsive(props.size, s => {
    const fs = props.icon ? iconSizes[s] : fontSizes[s];
    const sv = `var(${sizeVar})`;
    return {
      [sizeVar]: sizes[s],
      width: sv,
      height: sv,
      borderRadius: sv,
      ...theme.tokens.fontSizes[fs]
    };
  })];
};
const avatarImageStyle = {
  display: "block",
  width: `var(${sizeVar})`,
  height: `var(${sizeVar})`,
  objectFit: "cover"
};
const Avatar = props => {
  const {
    theme
  } = useTheme();
  const {
    size,
    alt,
    bg = ColorPreset.BackgroundLight_03,
    color = ColorPreset.TextOnLight_01,
    icon,
    src,
    text,
    assistiveLabel,
    ...rest
  } = props;
  let content = null;
  if (props.src) {
    content = jsx("img", {
      css: avatarImageStyle,
      src: props.src,
      alt: props.alt,
      loading: "lazy"
    });
  } else if (props.text) {
    content = jsx(Text, {
      "aria-label": props.text,
      textTransform: "uppercase",
      children: firstUnicodeChar(props.text)
    });
  } else if (props.icon) {
    content = jsxs(Fragment, {
      children: [jsx(Icon, {
        name: props.icon
      }), props.assistiveLabel ? jsx(VisuallyHidden, {
        children: props.assistiveLabel
      }) : null]
    });
  }
  return jsx("div", {
    css: avatarStyle(theme, {
      ...props,
      bg,
      color
    }),
    ...rest,
    children: content
  });
};

const gridStyle$1 = (theme, props) => {
  return [{
    display: "grid"
  }, theme.responsive(props.width, v => ({
    width: v
  })), theme.responsive(props.height, v => ({
    height: v
  })), theme.responsive(props.templateAreas, v => ({
    gridTemplateAreas: v
  })), theme.responsive(props.templateColumns, v => ({
    gridTemplateColumns: v
  })), theme.responsive(props.templateRows, v => ({
    gridTemplateRows: v
  })), theme.responsive(props.autoColumns, v => ({
    gridAutoColumns: v
  })), theme.responsive(props.autoRows, v => ({
    gridAutoRows: v
  })), theme.responsive(props.autoFlow, v => ({
    gridAutoFlow: v
  })), theme.responsive(props.columnGap, v => ({
    gridColumnGap: theme.spacing(v)
  })), theme.responsive(props.rowGap, v => ({
    rowGap: theme.spacing(v)
  })), theme.responsive(props.alignItems, v => ({
    alignItems: v
  })), theme.responsive(props.justifyItems, v => ({
    justifyItems: v
  })), theme.responsive(props.justifyContent, v => ({
    justifyContent: v
  })), theme.responsive(props.minHeight, v => ({
    minHeight: v
  }))];
};
const XYGrid = props => {
  const {
    theme
  } = useTheme();
  return jsx("div", {
    css: gridStyle$1(theme, props),
    children: props.children
  });
};

var CardLayout;
(function (CardLayout) {
  CardLayout["Vertical"] = "vertical";
  CardLayout["Horizontal"] = "horizontal";
})(CardLayout || (CardLayout = {}));
var CardVariant;
(function (CardVariant) {
  CardVariant["Default"] = "default";
  CardVariant["Gradient"] = "gradient";
  CardVariant["Outlined"] = "outlined";
})(CardVariant || (CardVariant = {}));
var CardType;
(function (CardType) {
  CardType["Plain"] = "plain";
  CardType["Button"] = "button";
})(CardType || (CardType = {}));
var CardButtonVariant;
(function (CardButtonVariant) {
  CardButtonVariant["Primary"] = "primary";
  CardButtonVariant["Secondary"] = "secondary";
  CardButtonVariant["Text"] = "text";
})(CardButtonVariant || (CardButtonVariant = {}));
var CardActionType;
(function (CardActionType) {
  CardActionType["Button"] = "button";
  CardActionType["IconButton"] = "iconButton";
  CardActionType["IconLink"] = "iconLink";
  CardActionType["Link"] = "link";
  CardActionType["PlainButton"] = "plainButton";
  CardActionType["PlainLink"] = "plainLink";
})(CardActionType || (CardActionType = {}));
var CardGradient;
(function (CardGradient) {
  CardGradient["Gradient01"] = "gradient-01";
  CardGradient["Gradient02"] = "gradient-02";
})(CardGradient || (CardGradient = {}));
var CardArea;
(function (CardArea) {
  CardArea["Media"] = "media";
  CardArea["Header"] = "header";
  CardArea["HeaderAction"] = "headerAction";
  CardArea["MainContent"] = "mainContent";
  CardArea["FooterActions"] = "footerActions";
  CardArea["Empty"] = ".";
})(CardArea || (CardArea = {}));

const initialTemplateColumns = "1fr";
const NARROW_CARD_BREAKPOINT = 425;
const defaultVerticalTemplateAreas = [`'${CardArea.Media} ${CardArea.Media}'
  '${CardArea.Header} ${CardArea.Header}'
  '${CardArea.MainContent} ${CardArea.MainContent}'
  '${CardArea.FooterActions} ${CardArea.FooterActions}'`];
const defaultHorizontalTemplateAreas = [`'${CardArea.Media} ${CardArea.Header} ${CardArea.HeaderAction}'
  '${CardArea.Media} ${CardArea.MainContent} ${CardArea.Empty}'
  '${CardArea.Media} ${CardArea.MainContent} ${CardArea.Empty}'
  '${CardArea.Media} ${CardArea.FooterActions} ${CardArea.Empty}'`];
// Rules for removing content for layouts:
// - Row: Deletes the entire row.
// - Area: Deletes only the specified area.
const verticalAreaRemovalRules = {
  row: [CardArea.Media, CardArea.Header, CardArea.MainContent, CardArea.FooterActions],
  area: [CardArea.HeaderAction]
};
const horizontalAreaRemovalRules = {
  row: [CardArea.Header, CardArea.MainContent, CardArea.FooterActions],
  area: [CardArea.Media, CardArea.HeaderAction, CardArea.Empty]
};
const generateVerticalTemplateColumns = removedAreas => {
  if (!removedAreas.includes(CardArea.HeaderAction)) {
    return `minmax(48px, 1fr) auto`;
  } else {
    return initialTemplateColumns;
  }
};
const generateHorizontalTemplateColumns = removedAreas => {
  let templateColumns = initialTemplateColumns;
  if (!removedAreas.includes(CardArea.Media)) {
    templateColumns = `minmax(48px, auto) ${templateColumns}`;
  }
  if (!removedAreas.includes(CardArea.HeaderAction)) {
    templateColumns = `${templateColumns} auto`;
  }
  return templateColumns;
};
/* Logic for generating grid areas:
   1. Include entire rows if they contain any included areas.
   2. Exclude specific areas which are not provided.
   3. Place the header action in the top-right area if it is provided.
*/
const generateVerticalGridAreas = removedAreas => {
  const newAreas = createRows(defaultVerticalTemplateAreas, verticalAreaRemovalRules.row, removedAreas);
  removeAreas(newAreas, verticalAreaRemovalRules.area, removedAreas);
  addHeaderAction(newAreas, removedAreas);
  return newAreas.join("\n");
};
const generateHorizontalGridAreas = removedAreas => {
  const newAreas = createRows(defaultHorizontalTemplateAreas, horizontalAreaRemovalRules.row, removedAreas);
  removeAreas(newAreas, horizontalAreaRemovalRules.area, removedAreas);
  addHeaderAction(newAreas, removedAreas);
  return newAreas.join("\n");
};
const createRows = (defaultAreas, rowRules, removedAreas) => {
  const newRows = [];
  defaultAreas.forEach(area => {
    area.split("\n").map(row => {
      // Don't include the row if the rules require you to remove the whole row, based on the removedAreas
      if (!row.replace("'", "").split(" ").some(a =>
      // Only consider removed areas that are included in the row rules
      removedAreas.filter(ra => rowRules.includes(ra)).includes(a))) {
        newRows.push(row.trim());
      }
    });
  });
  return newRows;
};
const removeAreas = (newAreas, defaultAreas, removedAreas) => {
  newAreas.forEach((_item, index, array) => {
    removedAreas.filter(ra => defaultAreas.includes(ra)).forEach(ar => {
      const regex = new RegExp(`\\${ar}`, "g");
      //Removes the area and deletes the spaces in quotes
      const newItem = array[index].replace(regex, "").replace(/'\s*(.*?)\s*'/, "'$1'").trim();
      array[index] = newItem;
    });
  });
};
const addHeaderAction = (newAreas, removedAreas) => {
  if (!removedAreas.includes(CardArea.HeaderAction) && newAreas.length > 0) {
    const row = newAreas[0];
    if (!row.includes(CardArea.HeaderAction)) {
      newAreas[0] = row.split(" ").map((area, index, arr) => index === arr.length - 1 ? `${CardArea.HeaderAction}'` : area).join(" ");
    }
  }
};
const useIsNarrowCard = ref => {
  const [isNarrow, setIsNarrow] = useState(false);
  useEffect(() => {
    const observable = new ResizeObserver(([entries]) => {
      const observedWidth = (entries === null || entries === void 0 ? void 0 : entries.target).offsetWidth;
      setIsNarrow(observedWidth < NARROW_CARD_BREAKPOINT);
    });
    if (ref.current) {
      observable.observe(ref.current);
    }
    return () => {
      observable.disconnect();
    };
  }, [ref, isNarrow]);
  return isNarrow;
};
const sharedButtonProps = {
  size: ButtonSize.Sm
};
const convertButtonVariant = variant => {
  switch (variant) {
    case CardButtonVariant.Primary:
      return ButtonVariant.PrimaryOnLight;
    case CardButtonVariant.Secondary:
      return ButtonVariant.SecondaryOnLight;
    case CardButtonVariant.Text:
      return ButtonVariant.TextOnLight;
    default:
      return ButtonVariant.PrimaryOnLight;
  }
};

const defaultGutter = 2;
const defaultBorderRadius = 1;
const defaultBgColor = Color.White;
const gradientColors = {
  [CardGradient.Gradient01]: [{
    layout: CardLayout.Horizontal,
    degree: 91,
    colors: [{
      color: Color.Dusk_50,
      stop: 2.96
    }, {
      color: Color.Ultraviolet_50,
      stop: 98.77
    }]
  }, {
    layout: CardLayout.Vertical,
    degree: 196,
    colors: [{
      color: Color.Dusk_50,
      stop: 11.27
    }, {
      color: Color.Ultraviolet_50,
      stop: 88.73
    }]
  }],
  [CardGradient.Gradient02]: [{
    layout: CardLayout.Horizontal,
    degree: 354,
    colors: [{
      color: Color.Sunrise_50,
      stop: 5.96
    }, {
      color: Color.Sunset_50,
      stop: 58.77
    }]
  }, {
    layout: CardLayout.Vertical,
    degree: 354,
    colors: [{
      color: Color.Sunrise_50,
      stop: 5.96
    }, {
      color: Color.Sunset_50,
      stop: 58.77
    }]
  }]
};
const cardStyle$1 = (theme, {
  props,
  isNarrow
}) => {
  var _props$borderRadius, _props$gutterV, _props$gutterH, _props$backgroundColo;
  const width = theme.responsive(props.width, value => ({
    width: value
  }));
  const minWidth = theme.responsive(props.minWidth || 300, value => ({
    minWidth: value
  }));
  const maxWidth = theme.responsive(props.maxWidth, value => ({
    maxWidth: value
  }));
  const spaceAbove = theme.responsive(props.spaceAbove, (value, themeValue) => {
    return {
      marginTop: themeValue.spacing(value)
    };
  });
  const spaceBelow = theme.responsive(props.spaceBelow, (value, themeValue) => {
    return {
      marginBottom: themeValue.spacing(value)
    };
  });
  const spaceBefore = theme.responsive(props.spaceBefore, (value, themeValue) => {
    return {
      marginLeft: themeValue.spacing(value)
    };
  });
  const spaceAfter = theme.responsive(props.spaceAfter, (value, themeValue) => {
    return {
      marginRight: themeValue.spacing(value)
    };
  });
  const borderRadius = theme.responsive((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : defaultBorderRadius, (r, themeValue) => ({
    borderRadius: themeValue.radius(r)
  }));
  const gutterV = theme.responsive((_props$gutterV = props.gutterV) !== null && _props$gutterV !== void 0 ? _props$gutterV : defaultGutter, (value, themeValue) => {
    const spacingValue = themeValue.spacing(value);
    return {
      paddingTop: spacingValue,
      paddingBottom: spacingValue
    };
  });
  const gutterH = theme.responsive((_props$gutterH = props.gutterH) !== null && _props$gutterH !== void 0 ? _props$gutterH : defaultGutter, (value, themeValue) => {
    const spacingValue = themeValue.spacing(value);
    return {
      paddingLeft: spacingValue,
      paddingRight: spacingValue
    };
  });
  const backgroundColor = theme.responsive((_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : defaultBgColor, c => ({
    backgroundColor: theme.color(c)
  }));
  const borderColor = props.variant === CardVariant.Outlined ? theme.color(ColorPreset.BorderOnLight_01) : theme.color(ColorPreset.BorderOnLight_04);
  return [gradientStyle(theme, {
    props,
    isNarrow
  }), {
    width: "100%",
    textAlign: "left",
    border: `1px solid ${borderColor}`
  }, gutterH, width, minWidth, maxWidth, gutterV, backgroundColor, borderRadius, spaceAbove, spaceAfter, spaceBefore, spaceBelow];
};
const cardButtonStyle = (theme, {
  props,
  isNarrow
}) => {
  return [cardStyle$1(theme, {
    props,
    isNarrow
  }), gradientStyle(theme, {
    props,
    isNarrow
  }), {
    fontFamily: theme.tokens.fontFamilies["sans-serif"],
    fontSize: "inherit",
    lineHeight: "inherit",
    boxShadow: `inset 0 0 0 2px transparent, ${focusRingVal}`,
    "&:hover, &:active": {
      borderColor: props.variant === CardVariant.Outlined ? theme.color(ColorPreset.BorderOnLight_04) : theme.color(ColorPreset.BorderOnLight_01),
      cursor: "pointer",
      boxShadow: `inset 0 0 0 2px transparent, ${focusRingVal}`
    }
  }, focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme: ColorScheme.OnLight,
    focusSelector: "&:focus-visible"
  })];
};
const mediaStyle = {
  display: "flex",
  alignItems: "flex-start",
  overflow: "hidden",
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "scale-down",
    flexShrink: 1,
    height: "auto"
  }
};
// Custom alignment for button `text` variant
const headerActionStyle = {
  marginTop: "-10px",
  marginRight: "-10px"
};
// Custom spacing with header for button `text` variant
const mainContentStyle = {
  marginTop: "-4px"
};
const gradientStyle = (theme, {
  props,
  isNarrow
}) => {
  if (props.variant !== CardVariant.Gradient) {
    return [];
  }
  const gradientConfig = gradientColors[props.bgGradient || CardGradient.Gradient01].find(gr => gr.layout === (isNarrow ? CardLayout.Vertical : props.layout));
  return [{
    background: generateGradientStyle(theme, gradientConfig)
  }];
};
const generateGradientStyle = (theme, config) => {
  const {
    degree,
    colors
  } = config;
  const colorStops = colors.map(stop => `${theme.color(stop.color)} ${stop.stop}%`).join(", ");
  return `linear-gradient(${degree}deg, ${colorStops})`;
};

const CardHeaderAction = props => {
  if (props == null) {
    return null;
  }
  const btnVariant = convertButtonVariant(props.variant);
  if (props.control === CardActionType.IconLink) {
    const {
      buttonVariant,
      variant,
      control,
      ...rest
    } = props;
    return jsx(IconLink, {
      ...rest,
      ...sharedButtonProps,
      variant: btnVariant
    });
  } else {
    const {
      buttonVariant,
      variant,
      control,
      ...rest
    } = props;
    return jsx(IconButton, {
      ...rest,
      ...sharedButtonProps,
      variant: btnVariant
    });
  }
};

const FooterAction = props => {
  if (props.value == null) {
    return null;
  }
  if (props.value.control === CardActionType.PlainButton || props.value.control === CardActionType.PlainLink) {
    return jsx(CardFooterAction, {
      ...props.value
    });
  } else {
    return jsx(CardFooterAction, {
      ...props.value,
      variant: props.value.buttonVariant,
      isNarrow: props.isNarrow
    });
  }
};
const CardFooterAction = props => {
  if (props == null) {
    return null;
  }
  const btnVariant = convertButtonVariant(props.variant);
  const buttonLayout = props.isNarrow ? ButtonLayout.Full : [ButtonLayout.Full, ButtonLayout.Inline];
  if (props.control === CardActionType.Link) {
    const {
      buttonVariant,
      variant,
      control,
      layout,
      isNarrow,
      ...rest
    } = props;
    return (
      // Unnecessarily noisy lint rule in this instance since we are forwarding
      // props in this components.
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      jsx(Link, {
        ...rest,
        ...sharedButtonProps,
        variant: btnVariant,
        layout: layout || buttonLayout
      })
    );
  } else if (props.control === CardActionType.IconLink) {
    const {
      buttonVariant,
      variant,
      control,
      isNarrow,
      ...rest
    } = props;
    return jsx(IconLink, {
      ...rest,
      ...sharedButtonProps,
      variant: btnVariant
    });
  } else if (props.control === CardActionType.IconButton) {
    const {
      buttonVariant,
      variant,
      control,
      isNarrow,
      ...rest
    } = props;
    return jsx(IconButton, {
      ...rest,
      ...sharedButtonProps,
      variant: btnVariant
    });
  } else if (props.control === CardActionType.PlainButton) {
    const {
      control,
      effect,
      textDecoration,
      isNarrow,
      ...rest
    } = props;
    return jsx(PlainButton, {
      ...rest,
      weight: FontWeight.SemiBold,
      size: TypeScale.Size_02,
      effect: effect || HoverEffect.TextDecoration,
      textDecoration: textDecoration || "underline"
    });
  } else if (props.control === CardActionType.PlainLink) {
    const {
      control,
      effect,
      textDecoration,
      isNarrow,
      ...rest
    } = props;
    return jsx(PlainLink, {
      ...rest,
      weight: FontWeight.SemiBold,
      size: TypeScale.Size_02,
      effect: effect || HoverEffect.TextDecoration,
      textDecoration: textDecoration || "underline"
    });
  } else {
    const {
      buttonVariant,
      variant,
      control,
      layout,
      isNarrow,
      ...rest
    } = props;
    return jsx(Button, {
      ...rest,
      ...sharedButtonProps,
      variant: btnVariant,
      layout: layout || buttonLayout
    });
  }
};

const omitCardProps = props => {
  const {
    header,
    mainContent,
    media,
    headerAction,
    primaryFooterAction,
    secondaryFooterAction,
    backgroundColor,
    borderRadius,
    bgGradient,
    gutterV,
    gutterH,
    variant,
    layout,
    width,
    minWidth,
    maxWidth,
    spaceAbove,
    spaceBelow,
    cardType,
    spaceBefore,
    spaceAfter,
    disableLayoutSwitch,
    ...rest
  } = props;
  return rest;
};
const Card = /*#__PURE__*/React.forwardRef(function Card(props, ref) {
  const {
    theme
  } = useTheme();
  const localRef = React.useRef(null);
  const {
    header,
    media,
    mainContent,
    headerAction,
    primaryFooterAction,
    secondaryFooterAction,
    cardType
  } = props;
  const footerActions = [...(primaryFooterAction ? [primaryFooterAction] : []), ...(secondaryFooterAction ? [secondaryFooterAction] : [])];
  const hasAction = footerActions.length > 0;
  const isClickable = cardType === CardType.Button;
  const isNarrow = useIsNarrowCard(localRef);
  const cardLayout = !props.disableLayoutSwitch && isNarrow ? CardLayout.Vertical : props.layout;
  const isHorizontal = cardLayout === CardLayout.Horizontal;
  const areasToBeRemoved = Object.keys(CardArea).map(key => CardArea[key]).filter(area => area !== CardArea.Empty && area !== CardArea.FooterActions ? !props[area] : false);
  if (isClickable) {
    areasToBeRemoved.push(CardArea.HeaderAction, CardArea.FooterActions, CardArea.Empty);
  } else if (areasToBeRemoved.includes(CardArea.HeaderAction) && isHorizontal) {
    areasToBeRemoved.push(CardArea.Empty);
  }
  if (!hasAction) {
    areasToBeRemoved.push(CardArea.FooterActions);
  }
  const getTemplateColumns = layout => layout === CardLayout.Horizontal ? generateHorizontalTemplateColumns(areasToBeRemoved) : generateVerticalTemplateColumns(areasToBeRemoved);
  const getTemplateAreas = layout => layout === CardLayout.Horizontal ? generateHorizontalGridAreas(areasToBeRemoved) : generateVerticalGridAreas(areasToBeRemoved);
  const cardContent = jsxs(XYGrid, {
    templateAreas: getTemplateAreas(cardLayout),
    templateColumns: getTemplateColumns(cardLayout),
    columnGap: 1.5,
    children: [media && jsx(Box, {
      gridArea: CardArea.Media,
      spaceBelow: isHorizontal ? 0 : 1.5,
      css: mediaStyle,
      children: media
    }), !isClickable && headerAction && jsx(Box, {
      gridArea: CardArea.HeaderAction,
      layout: "flex",
      justifyContent: JustifyContent.End,
      alignItems: AlignItems.FlexStart,
      css: headerAction.buttonVariant === CardButtonVariant.Text && (media || header) ? headerActionStyle : {},
      children: jsx(CardHeaderAction, {
        ...headerAction,
        variant: headerAction.buttonVariant
      })
    }), header && jsx(Box, {
      gridArea: CardArea.Header,
      layout: "flex",
      flexDirection: "column",
      justifyContent: isHorizontal ? JustifyContent.FlexStart : JustifyContent.Center,
      spaceBelow: mainContent ? 0.75 : 0,
      children: jsx(Text, {
        lineHeight: TypeScale.Size_02,
        preset: TypePreset.Heading_03,
        children: header
      })
    }), mainContent && jsx(Box, {
      gridArea: CardArea.MainContent,
      layout: "flex",
      flexDirection: "column",
      css: isHorizontal && headerAction && headerAction.buttonVariant !== CardButtonVariant.Text && header ? mainContentStyle : {},
      children: jsx(Text, {
        preset: TypePreset.Body_01,
        children: mainContent
      })
    }), !isClickable && hasAction && jsx(Box, {
      gridArea: CardArea.FooterActions,
      spaceAbove: 1.25,
      children: jsx(XYGrid, {
        rowGap: 0.5,
        columnGap: 0.5,
        justifyItems: JustifyItems.Start,
        alignItems: AlignItems.Center,
        templateColumns: isNarrow ? "1fr" : "auto 1fr",
        children: footerActions.map((fa, idx) => {
          return jsx(FooterAction, {
            value: fa,
            isNarrow: isNarrow
          }, idx);
        })
      })
    })]
  });
  // Merge the forwarded ref with the local ref
  React.useImperativeHandle(ref, () => localRef.current);
  if (isClickable) {
    return jsx("button", {
      css: cardButtonStyle(theme, {
        props,
        isNarrow
      }),
      ...omitCardProps(props),
      ref: localRef,
      children: cardContent
    });
  } else {
    return jsx("div", {
      css: cardStyle$1(theme, {
        props,
        isNarrow
      }),
      ...omitCardProps(props),
      ref: localRef,
      children: cardContent
    });
  }
});

const maxWidthStyle = (theme, {
  maxContentWidth = theme.tokens.contentMaxWidth
}) => theme.responsive(maxContentWidth, value => ({
  maxWidth: value
}));
const gutterStyle$1 = (theme, {
  contentGutters = theme.tokens.contentGutters
}) => theme.responsive(contentGutters, (value, themeValue) => ({
  padding: themeValue.spacing([0, value])
}));
const baseStyle$1 = {
  width: "100%",
  marginRight: "auto",
  marginLeft: "auto"
};
const containerStyle$1 = (theme, props) => [baseStyle$1, maxWidthStyle(theme, props), gutterStyle$1(theme, props)];
const Container = /*#__PURE__*/React.forwardRef(function Container(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    maxContentWidth,
    contentGutters,
    ...rest
  } = props;
  return jsx("div", {
    css: containerStyle$1(theme, props),
    ...rest,
    ref: ref
  });
});

const inlineStyle = {
  flexBasis: "auto",
  display: "inline-block"
};
const blockStyle = {
  flexBasis: "100%",
  display: "block"
};
const spaceStyle = (theme, props) => [theme.responsive(props.layout, l => {
  if (l === "block") {
    return blockStyle;
  } else if (l === "inline") {
    return inlineStyle;
  } else {
    return null;
  }
}),
// Hide any sibling Space elements to avoid them stacking their margins and
// creating undesirably large empty spaces. This can happen when using with
// Interpose and some children may be null.
//
// ```jsx
// const PotentiallyEmptyComponent = () => (
//   Math.random() > 0.5 ? <span>yay</span> : null
// )
// ```
// ```jsx
// <Box>
//   <Interpose node={<Space v={1} />}>
//     <PotentiallyEmptyComponent />
//     <PotentiallyEmptyComponent />
//     <P>Hello</P>
//   </Interpose>
// </Box>
// ```
{
  "&+&": {
    display: "none"
  }
}, theme.responsive(props.h, h => ({
  paddingRight: theme.spacing(h)
})), theme.responsive(props.v, v => ({
  paddingBottom: theme.spacing(v)
}))];
const Space = props => {
  const {
    theme
  } = useTheme();
  const {
    v = 0,
    h = 0,
    layout = "block",
    ...rest
  } = props;
  return jsx("span", {
    "aria-hidden": true,
    "data-flux-role": "spacer",
    css: spaceStyle(theme, {
      v,
      h,
      layout
    }),
    ...rest
  });
};

var GridSemantics;
(function (GridSemantics) {
  GridSemantics["Default"] = "default";
  GridSemantics["UnorderedList"] = "unordered-list";
  GridSemantics["OrderedList"] = "ordered-list";
})(GridSemantics || (GridSemantics = {}));
const GridContext = /*#__PURE__*/React.createContext({
  semantics: GridSemantics.Default
});
const gutterStyle = (theme, {
  gutterH
}) => theme.responsive(gutterH == null ? theme.tokens.gridGutters : gutterH, value => ({
  margin: `0 calc(-1 * ${theme.spacing(value)} / 2)`,
  "> *": {
    padding: `0 calc(${theme.spacing(value)} / 2)`
  }
}));
const spacingStyle = (theme, props) => theme.responsive(props.gutterV, v => ({
  marginBottom: `calc(-1 * ${theme.spacing(v)})`,
  "> *": {
    marginBottom: theme.spacing(v)
  }
}));
const layoutStyle = (theme, props) => [{
  display: "flex"
}, theme.responsive(props.direction, v => ({
  flexDirection: v
})), theme.responsive(props.justifyContent, v => ({
  justifyContent: v
})), theme.responsive(props.alignItems, v => ({
  alignItems: v
})), theme.responsive(props.flexWrap || "wrap", v => ({
  flexWrap: v
}))];
const semanticsStyle = (_, props) => {
  switch (props.semantics) {
    case GridSemantics.OrderedList:
    case GridSemantics.UnorderedList:
      return {
        listStyle: "none",
        padding: 0
      };
    default:
      return null;
  }
};
const gridStyle = (theme, props) => [layoutStyle(theme, props), gutterStyle(theme, props), spacingStyle(theme, props), semanticsStyle(theme, props)];
const tags$1 = {
  [GridSemantics.Default]: "div",
  [GridSemantics.OrderedList]: "ol",
  [GridSemantics.UnorderedList]: "ul"
};
const Grid = /*#__PURE__*/React.forwardRef(function Grid(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    direction,
    justifyContent,
    alignItems,
    gutterH,
    gutterV,
    flexWrap,
    semantics = GridSemantics.Default,
    ...rest
  } = props;
  const Tag = tags$1[semantics];
  return jsx(GridContext.Provider, {
    value: {
      semantics
    },
    children: jsx(Tag, {
      css: gridStyle(theme, props),
      ...rest,
      ref: ref,
      children: props.children
    })
  });
});

const bgStyle = (theme, props) => theme.responsive(props.bg, bg => ({
  backgroundColor: theme.color(bg)
}));
const widthStyle = (theme, size) => theme.responsive(size, value => {
  if (value === "auto") {
    return {
      flexGrow: 1,
      width: "auto",
      flexBasis: 0
    };
  }
  if (value === 0) {
    return {
      display: "none"
    };
  }
  const width = `${100 * value / 12}%`;
  return {
    flexGrow: 0,
    minWidth: 0,
    display: "block",
    width: width,
    flexBasis: width
  };
});
const offsetStyle = (theme, size) => theme.responsive(size, value => {
  const width = `${100 * value / 12}%`;
  return {
    marginLeft: width
  };
});
const baseStyle = {
  flex: "0 1 0"
};
const columnStyle = (theme, props) => [baseStyle, widthStyle(theme, props.size || "auto"), props.offset ? offsetStyle(theme, props.offset) : null, bgStyle(theme, props)];
const tags = {
  [GridSemantics.Default]: "div",
  [GridSemantics.OrderedList]: "li",
  [GridSemantics.UnorderedList]: "li"
};
const Column = /*#__PURE__*/React.forwardRef(function Column(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    size,
    offset,
    bg,
    ...rest
  } = props;
  const {
    semantics
  } = React.useContext(GridContext);
  const Tag = tags[semantics];
  return jsx(Tag, {
    css: columnStyle(theme, props),
    ...rest,
    ref: ref,
    children: props.children
  });
});

const visibilityStyle = (theme, props) => theme.responsive(props.visible, display => ({
  display
}));
const Visibility = /*#__PURE__*/React.forwardRef(function Visibility(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    visible,
    ...rest
  } = props;
  return jsx("span", {
    css: visibilityStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const Interpose = props => {
  const {
    children,
    node,
    trailing
  } = props;
  const filtered = React.Children.toArray(children).filter(c => /*#__PURE__*/React.isValidElement(c));
  if (trailing) {
    filtered.push(null);
  }
  return jsx(Fragment, {
    children: filtered.map((c, i, arr) => {
      const key = `Interpose_${i}`;
      if (i === arr.length - 1) {
        return jsx(React.Fragment, {
          children: c
        }, key);
      }
      const n = node instanceof Function ? node(c, i, arr) : node;
      return jsxs(React.Fragment, {
        children: [c, n]
      }, key);
    })
  });
};

const flexItemStyle = (theme, props) => {
  return [{
    display: "block"
  }, theme.responsive(props.grow, v => ({
    flexGrow: v
  })), theme.responsive(props.shrink, v => ({
    flexShrink: v
  })), theme.responsive(props.basis, v => ({
    flexBasis: v
  }))];
};
const FlexItem = props => {
  const {
    theme
  } = useTheme();
  return jsx("span", {
    css: flexItemStyle(theme, props),
    children: props.children
  });
};

const bound = (min, max, input) => Math.max(min, Math.min(max, input));
const direction = {
  horizontal: "row",
  horizontalReverse: "row-reverse",
  vertical: "column",
  verticalReverse: "column-reverse"
};
const cardStyle = (theme, props) => [{
  display: "flex",
  flexWrap: "nowrap",
  position: "relative"
}, theme.responsive(props.layout, l => ({
  flexDirection: direction[l]
})), theme.responsive(props.width, width => ({
  width
})), theme.responsive(props.height, height => ({
  height
})), theme.responsive(props.alignItems, alignItems => ({
  alignItems
})), theme.responsive(props.bg, colorProp => ({
  backgroundColor: theme.color(colorProp)
})), theme.responsive(props.color, colorProp => ({
  color: theme.color(colorProp)
}))];
const subjectStyle = (theme, props) => {
  return [{
    img: {
      display: "block"
    }
  }, theme.responsive(props.subjectBasis, b => {
    const basis = bound(0, 1, b) * 100;
    return {
      flexBasis: `${basis}%`
    };
  })];
};
const contentStyle = (theme, props) => {
  return [{
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column"
  }, theme.responsive(props.subjectBasis, b => {
    const basis = bound(0, 1, 1 - b) * 100;
    return {
      flexBasis: `${basis}%`
    };
  })];
};
/**
 * @deprecated This component will be deprecated and removed in a later version.
 * Please use `<Card />` instead
 */
const LegacyCard = props => {
  const {
    theme
  } = useTheme();
  const {
    width = "100%",
    height,
    subject,
    layout = "vertical",
    gutter = 0.5,
    subjectBasis = 0.5,
    alignItems,
    color,
    bg,
    footer,
    ...rest
  } = props;
  return jsxs("div", {
    css: cardStyle(theme, {
      width,
      layout,
      ...props
    }),
    role: "group",
    ...rest,
    children: [jsx("div", {
      css: subjectStyle(theme, {
        subjectBasis,
        ...props
      }),
      children: subject
    }), subject && props.children ? jsx(Space, {
      layout: "inline",
      v: gutter,
      h: gutter
    }) : null, jsxs("div", {
      css: contentStyle(theme, {
        ...props,
        subjectBasis
      }),
      children: [props.children, footer]
    })]
  });
};

/* eslint-disable deprecation/deprecation */
const directionStyle = (theme, props) => {
  if (props.direction === "inline-vertical") {
    return [{
      display: "inline-block",
      width: "1px",
      height: "auto",
      minHeight: "1.4em",
      flex: "0 0 auto"
    }, theme.responsive(props.thickness, width => ({
      height: "auto",
      width
    })), theme.responsive(props.length, length => ({
      height: length
    })), theme.responsive(props.align, alignment => {
      switch (alignment) {
        case "center":
          return {
            marginTop: "auto",
            marginBottom: "auto"
          };
        case "top":
          return {
            marginBottom: "auto"
          };
        case "bottom":
          return {
            marginTop: "auto"
          };
        default:
          return null;
      }
    })];
  } else {
    return [{
      display: "block",
      height: "1px"
    }, theme.responsive(props.thickness, height => ({
      width: "auto",
      height
    })), theme.responsive(props.length, length => ({
      width: length
    })), theme.responsive(props.align, alignment => {
      switch (alignment) {
        case "center":
          return {
            marginLeft: "auto",
            marginRight: "auto"
          };
        case "left":
          return {
            marginRight: "auto"
          };
        case "right":
          return {
            marginLeft: "auto"
          };
        default:
          return null;
      }
    })];
  }
};
const separatorStyle = (theme, props) => {
  return [{
    lineHeight: 1,
    verticalAlign: "middle"
  }, theme.responsive(props.spacing, space => ({
    margin: theme.spacing(space)
  })), directionStyle(theme, props), theme.responsive(props.color, color => ({
    backgroundColor: theme.color(color)
  })), theme.responsive(props.opacity, opacity => ({
    opacity: opacity
  }))];
};
const Separator = props => {
  const {
    theme
  } = useTheme();
  const {
    direction,
    thickness,
    color = ColorPreset.BorderOnLight_04,
    spacing,
    opacity,
    length,
    align,
    ...rest
  } = props;
  return jsx("span", {
    "aria-hidden": true,
    "data-flux-role": "spacer",
    css: separatorStyle(theme, {
      direction,
      thickness,
      color,
      spacing,
      opacity,
      length,
      align
    }),
    ...rest
  });
};

const vars$i = {
  gutterV: "--labelledpanel-gutterv",
  gutterH: "--labelledpanel-gutterh",
  headerBg: "--labelledpanel-header-bg",
  headerColor: "--labelledpanel-header-fg",
  headerBorder: "--labelledpanel-header-border",
  bodyBg: "--labelledpanel-body-bg",
  bodyColor: "--labelledpanel-body-fg",
  bodyBorder: "--labelledpanel-body-border",
  borderRadius: "--labelledpanel-borderradius"
};
const labelledPanelHeaderStyle = (theme, props) => {
  const gh = `var(${vars$i.gutterH})`;
  const gv = `var(${vars$i.gutterV})`;
  const r = `var(${vars$i.borderRadius})`;
  const backgroundColor = `var(${vars$i.headerBg})`;
  const color = `var(${vars$i.headerColor})`;
  const borderColor = `var(${vars$i.headerBorder})`;
  const padding = props.separator === "hidden" ? `${gv} ${gh} 0` : `${gv} ${gh}`;
  const borderWidth = props.separator === "hidden" ? "1px 1px 0" : "1px";
  return {
    display: "grid",
    alignItems: "start",
    gap: theme.spacing([1, 1]),
    padding,
    borderRadius: `${r} ${r} 0 0`,
    backgroundColor,
    color,
    borderWidth,
    borderStyle: "solid",
    borderColor
  };
};
const defaultHeaderLayout = ["stack", null, "inline"];
const labelledPanelHeaderLayoutStyle = (theme, {
  hasPrimaryAccessory,
  hasSecondaryAccessory
}) => {
  /**
   * This tedious interpolation builds two versions of grid-template-areas:
   * - A stack layout where accessories are one line and the heading is on the
   *   next line
   * - An inline layout with a heading surrounded by accessories
   *
   * The complicated bit is that we need to omit the areas that don't content
   * in them so the css grid does not allocate an empty column for them.
   */
  const heading = "heading heading";
  const l = hasPrimaryAccessory ? "primary" : "";
  const r = hasSecondaryAccessory ? "secondary" : "";
  const inlineLayout = `"${[l, heading, r].filter(Boolean).join(" ")}"`;
  let inlineTemplateColumns = "auto auto";
  if (hasPrimaryAccessory) {
    inlineTemplateColumns = `max-content ${inlineTemplateColumns}`;
  }
  if (hasSecondaryAccessory) {
    inlineTemplateColumns = `${inlineTemplateColumns} max-content`;
  }
  // the following line will result in one of the following:
  // "primary primary", "secondary secondary", "primary secondary" or ""
  const slots = [l || r, r || l].join(" ").trim();
  const stackLine1 = slots ? `"${slots}" ` : "";
  const stackLayout = `${stackLine1}"${heading}"`;
  const stackTemplateColumns = "1fr 1fr";
  return theme.responsive(defaultHeaderLayout, layout => {
    switch (layout) {
      case "inline":
        return {
          gridTemplateAreas: inlineLayout,
          gridTemplateColumns: inlineTemplateColumns
        };
      default:
        return {
          gridTemplateAreas: stackLayout,
          gridTemplateColumns: stackTemplateColumns
        };
    }
  });
};
const labelledPanelHeadingStyle = theme => ({
  display: "grid",
  rowGap: theme.spacing(0.25)
});
const labelledPanelBodyStyle = (_, {
  hasHeader
}) => {
  const gh = `var(${vars$i.gutterH})`;
  const gv = `var(${vars$i.gutterV})`;
  const r = `var(${vars$i.borderRadius})`;
  const backgroundColor = `var(${vars$i.bodyBg})`;
  const color = `var(${vars$i.bodyColor})`;
  const borderColor = `var(${vars$i.bodyBorder})`;
  return {
    padding: `${gv} ${gh}`,
    borderRadius: hasHeader ? `0 0 ${r} ${r}` : r,
    borderWidth: hasHeader ? "0 1px 1px" : "1px",
    borderStyle: "solid",
    borderColor,
    backgroundColor,
    color
  };
};
const labelledPanelStyle = (theme, props) => {
  return [theme.responsive(props.gutterV, v => ({
    [vars$i.gutterV]: theme.spacing(v)
  })), theme.responsive(props.gutterH, v => ({
    [vars$i.gutterH]: theme.spacing(v)
  })), typographyStyle(theme, {
    ...(props.fontSize ? {
      size: props.fontSize
    } : {}),
    ...(props.typePreset ? {
      preset: props.typePreset
    } : {})
  }), {
    [vars$i.headerBg]: theme.color(props.headerBg),
    [vars$i.headerColor]: theme.color(props.headerColor),
    [vars$i.headerBorder]: theme.color(props.headerBorder),
    [vars$i.bodyBg]: theme.color(props.bodyBg),
    [vars$i.bodyColor]: theme.color(props.bodyColor),
    [vars$i.bodyBorder]: theme.color(props.bodyBorder),
    [vars$i.borderRadius]: theme.radius(1)
  }];
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$5 = process.env.NODE_ENV === "production" ? {
  name: "1grcuem",
  styles: "grid-area:primary"
} : {
  name: "15usuo6-LabelledPanel",
  styles: "grid-area:primary;label:LabelledPanel;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};
const LabelledPanel = props => {
  const {
    heading,
    description,
    primaryAccessory,
    secondaryAccessory,
    headerBg = ColorPreset.BackgroundLight_01,
    headerColor = ColorPreset.TextOnLight_01,
    headerBorder = props.headerBg || ColorPreset.BorderOnLight_04,
    bodyBg = ColorPreset.BackgroundLight_01,
    bodyColor = ColorPreset.TextOnLight_01,
    bodyBorder = ColorPreset.BorderOnLight_04,
    gutterV = [1, null, 1.5],
    gutterH = [1, null, 1.5],
    fontSize,
    typePreset,
    separator = "visible",
    children,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const hasHeader = !!(heading || description);
  const styleProps = {
    headerBg,
    headerColor,
    headerBorder,
    bodyBg,
    bodyColor,
    bodyBorder,
    gutterV,
    gutterH,
    fontSize,
    typePreset,
    separator,
    hasHeader
  };
  return jsxs("div", {
    css: labelledPanelStyle(theme, styleProps),
    ...rest,
    children: [hasHeader ? jsxs("div", {
      css: [labelledPanelHeaderStyle(theme, styleProps), labelledPanelHeaderLayoutStyle(theme, {
        hasPrimaryAccessory: !!primaryAccessory,
        hasSecondaryAccessory: !!secondaryAccessory
      }), process.env.NODE_ENV === "production" ? "" : ";label:LabelledPanel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      children: [primaryAccessory ? jsx("div", {
        css: _ref$5,
        children: primaryAccessory
      }) : null, jsxs("div", {
        css: [labelledPanelHeadingStyle(theme), "grid-area:heading;" + (process.env.NODE_ENV === "production" ? "" : ";label:LabelledPanel;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
        children: [heading ? jsx("div", {
          children: heading
        }) : null, description ? jsx("div", {
          children: description
        }) : null]
      }), secondaryAccessory ? jsx("div", {
        css: /*#__PURE__*/css({
          gridArea: "secondary",
          justifySelf: primaryAccessory ? "end" : undefined
        }, process.env.NODE_ENV === "production" ? "" : ";label:LabelledPanel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
        children: secondaryAccessory
      }) : null]
    }) : null, jsx("div", {
      css: labelledPanelBodyStyle(theme, styleProps),
      children: children
    })]
  });
};

const layerStyle = (theme, props) => [theme.responsive(props.mode, mode => ({
  position: mode
})), theme.responsive(props.top, top => ({
  top
})), theme.responsive(props.bottom, bottom => ({
  bottom
})), theme.responsive(props.left, left => ({
  left
})), theme.responsive(props.right, right => ({
  right
})), theme.responsive(props.zIndex, z => ({
  zIndex: z
}))];
const Layer = props => {
  const {
    theme
  } = useTheme();
  const {
    mode,
    top,
    bottom,
    left,
    right,
    zIndex,
    ...rest
  } = props;
  return jsx("div", {
    css: layerStyle(theme, props),
    ...rest,
    children: props.children
  });
};

const fullWidthStyle = (theme, props) => [{
  marginLeft: "calc(50% - 50vw)",
  marginRight: "calc(50% - 50vw)",
  maxWidth: "unset",
  width: "auto"
}, theme.responsive(props.bg, bg => ({
  backgroundColor: theme.color(bg)
}))];
const FullWidth = /*#__PURE__*/React.forwardRef(function FullWidth(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    bg,
    ...rest
  } = props;
  return jsx("div", {
    css: fullWidthStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const vars$h = {
  itemSpacing: "--carousel-item-spacing"
};
const visuallyHidden = {
  pointerEvents: "none",
  opacity: 0
};
const visuallyVisible = {
  pointerEvents: "initial",
  opacity: 1
};
const controlStyle$1 = {
  position: "absolute",
  top: "50%",
  transform: "translate3d(0, -50%, 0)",
  zIndex: 1,
  transition: "opacity 200ms 50ms",
  "@media(prefers-reduced-motion: reduce)": {
    transition: "opacity 50ms"
  }
};
const previousButtonStyle = [controlStyle$1, {
  left: 0
}];
const nextButtonStyle = [controlStyle$1, {
  right: 0
}];
const carouselListStyle = {
  display: "grid",
  gap: `var(${vars$h.itemSpacing})`,
  gridAutoFlow: "column",
  gridAutoColumns: "max-content",
  width: "100%",
  overflow: "auto",
  padding: 0,
  margin: 0,
  listStyleType: "none",
  scrollSnapType: "x mandatory",
  overscrollBehaviorX: "contain",
  scrollPaddingLeft: 0,
  "> li": {
    scrollSnapAlign: "center"
  },
  "@media (min-width: 480px)": {
    scrollPaddingLeft: `calc(2 * var(${vars$h.itemSpacing}))`,
    "> li": {
      scrollSnapAlign: "start"
    }
  },
  scrollBehavior: "smooth",
  "@media (prefers-reduced-motion: reduce)": {
    scrollBehavior: "auto"
  },
  // Only hide the scroll bars if the browser supports the snapping
  // carousel scrolling
  "@supports (scroll-snap-type: x mandatory)": {
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  }
};
const carouselStyle = (theme, props) => {
  return [theme.responsive(props.itemSpacing, v => {
    return {
      [vars$h.itemSpacing]: theme.spacing(v)
    };
  }), {
    position: "relative",
    "> [data-carousel-control]": visuallyHidden,
    "&:hover > [data-carousel-control]": visuallyVisible,
    "> [data-carousel-control][data-disabled=true]": visuallyHidden
  }];
};
const Carousel = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    nextLabel,
    previousLabel,
    itemSpacing = [1, null, 3],
    onPreviousClick,
    onNextClick,
    children,
    ...rest
  } = props;
  const listRef = React.useRef(null);
  // We want to visually hide next/previous buttons when they are not
  // applicable. For example, when at the start of the carousel, we don't need
  // to show the previous button. Likewise when at the end, we don't need to
  // show the next button. We're also visually hiding them because we want to
  // avoid popping them in and out of the accessibility tree and disrupting
  // the user journey for assistive tech users.
  const [disabledControls, setDisabledControls] = React.useState({
    next: false,
    previous: false
  });
  const updateDisabledControls = React.useCallback(() => {
    const listEl = listRef.current;
    if (!(listEl instanceof HTMLElement)) {
      return;
    }
    setDisabledControls({
      previous: listEl.scrollLeft === 0,
      next: listEl.scrollLeft >= listEl.scrollWidth - listEl.clientWidth
    });
  }, [listRef, setDisabledControls]);
  // Update the disabled state of next/previous controls when browser resizes
  React.useEffect(() => {
    const el = listRef.current;
    if (!(el instanceof HTMLElement)) {
      return;
    }
    if (typeof window === "undefined") {
      return;
    }
    // If ResizeObserver is not available for a browser then use a traditional
    // window resize event listener
    if (typeof window.ResizeObserver === "undefined") {
      document.addEventListener("resize", updateDisabledControls, false);
      return () => {
        document.removeEventListener("resize", updateDisabledControls, false);
      };
    } else {
      const ro = new ResizeObserver(entries => {
        if (!entries.length) {
          return;
        }
        updateDisabledControls();
      });
      ro.observe(el);
      return () => {
        if (!el) {
          return;
        }
        ro.unobserve(el);
      };
    }
  }, [listRef, updateDisabledControls]);
  // Update the disabled state of next/previous controls when the carousel
  // list is scrolled.
  React.useEffect(() => {
    const el = listRef.current;
    if (!(el instanceof HTMLElement)) {
      return;
    }
    el.addEventListener("scroll", updateDisabledControls, false);
    return () => el.removeEventListener("scroll", updateDisabledControls, false);
  }, [listRef, updateDisabledControls]);
  const handlePrevious = e => {
    onPreviousClick === null || onPreviousClick === void 0 ? void 0 : onPreviousClick(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    const listEl = listRef.current;
    if (!listEl) {
      return;
    }
    listEl.scrollBy(-1 * listEl.clientWidth, 0);
  };
  const handleNext = e => {
    onNextClick === null || onNextClick === void 0 ? void 0 : onNextClick(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    const listEl = listRef.current;
    if (!listEl) {
      return;
    }
    listEl.scrollBy(listEl.clientWidth, 0);
  };
  const nodes = React.Children.map(children, c => {
    return jsx("li", {
      children: c
    });
  });
  return jsxs("div", {
    ref: ref,
    css: carouselStyle(theme, {
      itemSpacing
    }),
    ...rest,
    children: [jsx("div", {
      css: previousButtonStyle,
      "data-carousel-control": true,
      "data-disabled": disabledControls.previous,
      children: jsx(IconButton, {
        icon: Glyph.ArrowBack,
        variant: ButtonVariant.PrimaryOnLight,
        size: ButtonSize.Lg,
        label: previousLabel,
        onClick: handlePrevious,
        disabled: disabledControls.previous
      })
    }), jsx("ul", {
      ref: listRef,
      css: carouselListStyle
      // See note 1 above
      ,
      "data-snap-disabled": disabledControls.next,
      children: nodes
    }), jsx("div", {
      css: nextButtonStyle,
      "data-carousel-control": true,
      "data-disabled": disabledControls.next,
      children: jsx(IconButton, {
        icon: Glyph.ArrowForward,
        variant: ButtonVariant.PrimaryOnLight,
        size: ButtonSize.Lg,
        label: nextLabel,
        onClick: handleNext,
        disabled: disabledControls.next
      })
    })]
  });
});

const isInBrowser = () => {
  return typeof window !== "undefined" && typeof window.document !== "undefined";
};
/**
 * When React.useLayoutEffect is invoked during server-side rendering or static
 * generation, it causes a warning to be printed out. This can get noisy so
 * let's instead use React.useEffect when React is running on the server and
 * React.useLayoutEffect on the browser.
 */
const useIsomorphicLayoutEffect = isInBrowser() ? React__default.useLayoutEffect : React__default.useEffect;

var SidebarLayout;
(function (SidebarLayout) {
  SidebarLayout["FloatingLeft"] = "floating-left";
  SidebarLayout["FloatingRight"] = "floating-right";
  SidebarLayout["StaticLeft"] = "static-left";
})(SidebarLayout || (SidebarLayout = {}));
const vars$g = {
  contentWidth: "--sidebar-content-width",
  defaultDisplay: "--sidebar-default-display",
  bg: "--sidebar-bg",
  color: "--sidebar-color",
  borderColor: "--sidebar-border-color",
  enterTransitions: "--sidebar-enter-transitions",
  exitTransitions: "--sidebar-exit-transitions",
  enterTransform: "--sidebar-enter-transform",
  exitTransform: "--sidebar-exit-transform",
  closeSpacing: "--sidebar-close-spacing",
  closeDisplay: "--sidebar-close-display",
  backdropDisplay: "--sidebar-backdrop-display",
  backdropBg: "--sidebar-backdrop-bg",
  borderLeftRadius: "--border-left-radius",
  borderRightRadius: "--border-right-radius"
};
const sidebarColorSchemeTokens = (theme, colorScheme) => {
  const light = {
    [vars$g.bg]: theme.color(ColorPreset.BackgroundLight_01),
    [vars$g.color]: theme.color(ColorPreset.TextOnLight_01),
    [vars$g.borderColor]: theme.color(ColorPreset.BorderOnLight_02),
    [vars$g.backdropBg]: theme.color(Color.Greystone_1400_A50)
  };
  const dark = {
    [vars$g.bg]: theme.color(ColorPreset.BackgroundDark_02),
    [vars$g.color]: theme.color(ColorPreset.TextOnDark_01),
    [vars$g.borderColor]: theme.color(ColorPreset.BorderOnDark_02),
    [vars$g.backdropBg]: theme.color(Color.Greystone_1400_A50)
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const sidebarLayoutStyle = (theme, {
  layout = SidebarLayout.StaticLeft,
  borderRadius = 0
}) => {
  return theme.responsive(layout, v => {
    switch (v) {
      case SidebarLayout.FloatingLeft:
        return {
          minHeight: "auto",
          height: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          [vars$g.borderLeftRadius]: "0px",
          [vars$g.borderRightRadius]: theme.radius(borderRadius),
          [vars$g.closeSpacing]: theme.spacing([1, 0, 0, 1]),
          [vars$g.closeDisplay]: "block",
          [vars$g.backdropDisplay]: "block",
          [vars$g.enterTransform]: "translate3d(0, 0, 0)",
          [vars$g.exitTransform]: "translate3d(-100%, 0, 0)",
          [vars$g.enterTransitions]: "transform 200ms, filter 200ms, opacity 200ms 200ms",
          [vars$g.exitTransitions]: "transform 200ms, filter 200ms, opacity 100ms",
          "@media (prefers-reduced-motion: reduce)": {
            [vars$g.enterTransitions]: "transform 50ms, filter 50ms, opacity 50ms",
            [vars$g.exitTransitions]: "transform 50ms, filter 50ms, opacity 50ms"
          },
          "&.slide-enter, &.slide-enter-done": {
            display: "grid"
          },
          "&.slide-exit, &.slide-exit-active": {
            display: "grid"
          },
          "&.slide-exit-done": {
            display: `var(${vars$g.defaultDisplay})`
          }
        };
      case SidebarLayout.FloatingRight:
        return {
          minHeight: "auto",
          height: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          [vars$g.borderLeftRadius]: theme.radius(borderRadius),
          [vars$g.borderRightRadius]: "0px",
          justifyContent: "end",
          [vars$g.closeSpacing]: theme.spacing([1, 1, 0, 0]),
          [vars$g.closeDisplay]: "block",
          [vars$g.backdropDisplay]: "block",
          [vars$g.enterTransform]: "translate3d(0, 0, 0)",
          [vars$g.exitTransform]: "translate3d(100%, 0, 0)",
          [vars$g.enterTransitions]: "transform 200ms, filter 200ms, opacity 200ms 200ms",
          [vars$g.exitTransitions]: "transform 200ms, filter 200ms, opacity 100ms",
          "@media (prefers-reduced-motion: reduce)": {
            [vars$g.enterTransitions]: "transform 50ms, filter 50ms, opacity 50ms",
            [vars$g.exitTransitions]: "transform 50ms, filter 50ms, opacity 50ms"
          },
          "&.slide-enter, &.slide-enter-done": {
            display: "grid"
          },
          "&.slide-exit, &.slide-exit-active": {
            display: "grid"
          },
          "&.slide-exit-done": {
            display: `var(${vars$g.defaultDisplay})`
          }
        };
      case SidebarLayout.StaticLeft:
        return {
          minHeight: "100vh",
          height: "100%",
          position: "relative",
          top: 0,
          left: 0,
          [vars$g.borderLeftRadius]: "0px",
          [vars$g.borderRightRadius]: theme.radius(borderRadius),
          filter: "none",
          [vars$g.closeSpacing]: theme.spacing([1, 0, 0, 1]),
          [vars$g.closeDisplay]: "none",
          [vars$g.backdropDisplay]: "none",
          [vars$g.enterTransform]: "none",
          [vars$g.exitTransform]: "none",
          [vars$g.enterTransitions]: "none",
          [vars$g.exitTransitions]: "none",
          "@media (prefers-reduced-motion: reduce)": {
            [vars$g.enterTransitions]: "none",
            [vars$g.exitTransitions]: "none"
          },
          display: "grid",
          "&.slide-enter, &.slide-enter-done": {
            display: "grid"
          },
          "&.slide-exit, &.slide-exit-active": {
            display: "grid"
          },
          "&.slide-exit-done": {
            display: "grid"
          }
        };
    }
  });
};
const sidebarContentStyle = {
  width: `var(${vars$g.contentWidth})`,
  overflow: "auto",
  backgroundColor: `var(${vars$g.bg})`,
  color: `var(${vars$g.color})`,
  borderBottomLeftRadius: `var(${vars$g.borderLeftRadius})`,
  borderTopLeftRadius: `var(${vars$g.borderLeftRadius})`,
  borderBottomRightRadius: `var(${vars$g.borderRightRadius})`,
  borderTopRightRadius: `var(${vars$g.borderRightRadius})`,
  transform: `var(${vars$g.enterTransform})`,
  ".slide-enter > &": {
    transition: `var(${vars$g.enterTransitions})`,
    transform: `var(${vars$g.exitTransform})`
  },
  ".slide-enter-active > &, .slide-enter-done > &": {
    transition: `var(${vars$g.enterTransitions})`,
    transform: `var(${vars$g.enterTransform})`
  },
  ".slide-exit > &": {
    transition: `var(${vars$g.exitTransitions})`,
    transform: `var(${vars$g.enterTransform})`
  },
  ".slide-exit-active > &, .slide-exit-done > &": {
    transition: `var(${vars$g.exitTransitions})`,
    transform: `var(${vars$g.exitTransform})`
  }
};
const sidebarCloseStyle = layout => ({
  margin: `var(${vars$g.closeSpacing})`,
  display: `var(${vars$g.closeDisplay})`,
  alignSelf: "start",
  order: layout === SidebarLayout.FloatingRight ? -1 : 1,
  opacity: 1,
  ".slide-enter > &": {
    transition: `var(${vars$g.enterTransitions})`,
    opacity: 0
  },
  ".slide-enter-active > &, .slide-enter-done > &": {
    transition: `var(${vars$g.enterTransitions})`,
    opacity: 1
  },
  ".slide-exit > &": {
    transition: `var(${vars$g.exitTransitions})`,
    opacity: 1
  },
  ".slide-exit-active > &, .slide-exit-done > &": {
    transition: `var(${vars$g.exitTransitions})`,
    opacity: 0
  }
});
const sidebarBackdropStyle = {
  zIndex: -1,
  display: `var(${vars$g.backdropDisplay})`,
  background: `var(${vars$g.backdropBg})`,
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  ".slide-enter > &": {
    transition: `var(${vars$g.enterTransitions})`,
    filter: "opacity(0)"
  },
  ".slide-enter-active > &, .slide-enter-done > &": {
    transition: `var(${vars$g.enterTransitions})`,
    filter: "opacity(1)"
  },
  ".slide-exit > &": {
    transition: `var(${vars$g.exitTransitions})`,
    filter: "opacity(1)"
  },
  ".slide-exit-active > &, .slide-exit-done > &": {
    transition: `var(${vars$g.exitTransitions})`,
    filter: "opacity(0)"
  }
};
const sidebarStyle = (theme, props) => {
  return [sidebarColorSchemeTokens(theme, props.colorScheme), {
    [vars$g.defaultDisplay]: props.open ? "grid" : "none",
    width: "100%",
    zIndex: ZIndex.Sidebar,
    display: `var(${vars$g.defaultDisplay})`,
    gridAutoColumns: "auto",
    gridAutoFlow: "column",
    justifyContent: "start"
  }, theme.responsive(props.contentWidth, cw => ({
    [vars$g.contentWidth]: cw
  })), sidebarLayoutStyle(theme, props)];
};

const Sidebar = props => {
  const {
    open,
    colorScheme = ColorScheme.OnLight,
    closeAction,
    borderRadius,
    layout = [SidebarLayout.FloatingLeft, null, null, SidebarLayout.StaticLeft],
    contentWidth = ["248px", "256px", null, "208px", "256px"],
    ...rest
  } = props;
  const sidebarRef = React.useRef(null);
  const {
    theme
  } = useTheme();
  // If the sidebar is changing state to become open then use that as a trigger
  // to focus it. `openRef` tracks the previous open state and the layout effect
  // compares it to the current open state
  const openRef = React.useRef(!!open);
  useIsomorphicLayoutEffect(() => {
    const wasOpen = openRef.current;
    const isOpen = !!open;
    openRef.current = isOpen;
    if (isOpen === wasOpen) {
      return;
    }
    if (isOpen) {
      var _sidebarRef$current;
      (_sidebarRef$current = sidebarRef.current) === null || _sidebarRef$current === void 0 ? void 0 : _sidebarRef$current.focus();
    }
  }, [openRef, open]);
  let closeVariant = ButtonVariant.PrimaryAuto;
  switch (colorScheme) {
    case ColorScheme.OnLight:
      closeVariant = ButtonVariant.PrimaryOnLight;
      break;
    case ColorScheme.OnDark:
      closeVariant = ButtonVariant.PrimaryOnDark;
      break;
  }
  const handleClose = () => {
    var _closeAction$onClose;
    closeAction === null || closeAction === void 0 ? void 0 : (_closeAction$onClose = closeAction.onClose) === null || _closeAction$onClose === void 0 ? void 0 : _closeAction$onClose.call(closeAction);
  };
  return jsx(CSSTransition, {
    in: open,
    timeout: 200,
    classNames: "slide",
    appear: true,
    children: jsxs("div", {
      css: sidebarStyle(theme, {
        layout,
        colorScheme,
        open,
        contentWidth,
        borderRadius
      }),
      ...rest,
      ref: sidebarRef,
      tabIndex: -1,
      role: "presentation",
      children: [jsx("div", {
        css: sidebarBackdropStyle,
        role: "presentation",
        onClick: handleClose
      }), jsx("div", {
        css: sidebarContentStyle,
        children: props.children
      }), closeAction ? jsx("div", {
        css: sidebarCloseStyle(layout),
        children: jsx(IconButton, {
          icon: Glyph.Close,
          variant: closeVariant,
          size: ButtonSize.Sm,
          label: closeAction.label,
          onClick: handleClose
        })
      }) : null]
    })
  });
};

const mainAreaStyle = (theme, props) => [boxStyle(theme, props), {
  "&:focus": {
    boxShadow: "none",
    outline: 0
  }
}];
const MainArea = props => {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("main", {
    css: mainAreaStyle(theme, props),
    tabIndex: -1,
    ...rest,
    children: props.children
  });
};
const Article = /*#__PURE__*/React.forwardRef(function Article(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("article", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});
const Section = /*#__PURE__*/React.forwardRef(function Section(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("section", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});
const Footer = /*#__PURE__*/React.forwardRef(function Footer(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("footer", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});
const Aside = /*#__PURE__*/React.forwardRef(function Aside(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("aside", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});
const Nav = /*#__PURE__*/React.forwardRef(function Nav(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("nav", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});
const Header = /*#__PURE__*/React.forwardRef(function Header(props, ref) {
  const {
    theme
  } = useTheme();
  const rest = omitAppearanceProps$1(props);
  return jsx("header", {
    css: boxStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const TabItemRole = /*#__PURE__*/React.createContext("trigger");

const vars$f = {
  triggersSpacing: "--tabs-triggers-spacing",
  triggersGap: "--tabs-triggers-gap",
  triggersTrackSize: "--tabs-triggers-track-size",
  triggersTrackBg: "--tabs-triggers-track-bg",
  triggerGutterV: "--tabs-trigger-gutterv",
  triggerGutterH: "--tabs-trigger-gutterh",
  triggerFontSize: "--tabs-trigger-font-size",
  triggerLineHeight: "--tabs-trigger-line-height",
  triggerColor: "--tabs-trigger-color",
  triggerHoverColor: "--tabs-trigger-hover-color",
  triggerSelectedColor: "--tabs-trigger-selected-color"
};
const tabsColorSchemeTokens = (theme, cs) => {
  const lightScheme = {
    [vars$f.triggersTrackBg]: theme.color(ColorPreset.BorderOnLight_05),
    [vars$f.triggerColor]: theme.color(ColorPreset.TextOnLight_03),
    [vars$f.triggerHoverColor]: theme.color(ColorPreset.TextOnLight_01),
    [vars$f.triggerSelectedColor]: theme.color(ColorPreset.TextOnLight_01)
  };
  const darkScheme = {
    [vars$f.triggersTrackBg]: theme.color(ColorPreset.BorderOnDark_05),
    [vars$f.triggerColor]: theme.color(ColorPreset.TextOnDark_03),
    [vars$f.triggerHoverColor]: theme.color(ColorPreset.TextOnDark_01),
    [vars$f.triggerSelectedColor]: theme.color(ColorPreset.TextOnDark_01)
  };
  switch (cs) {
    case ColorScheme.OnLight:
      return lightScheme;
    case ColorScheme.OnDark:
      return darkScheme;
    case ColorScheme.Auto:
      return [lightScheme, {
        "@media (prefers-color-scheme: dark)": darkScheme
      }];
  }
};
const tabsScrollerStyle = (theme, orientation) => {
  return [{
    overflow: "auto",
    flex: "0 0 auto"
  }, theme.responsive(orientation, o => {
    switch (o) {
      case "horizontal":
        return {
          boxShadow: `inset 0 calc(-1 * var(${vars$f.triggersTrackSize})) 0 0 var(${vars$f.triggersTrackBg})`,
          margin: `0 0 var(${vars$f.triggersSpacing})`
        };
      case "vertical":
        return {
          boxShadow: "none",
          margin: `0 var(${vars$f.triggersSpacing}) 0 0`
        };
    }
  })];
};
const tabsScrollIndicator = (theme, orientation) => {
  return [{
    height: `var(${vars$f.triggersTrackSize})`,
    width: 0,
    backgroundColor: `var(${vars$f.triggerSelectedColor})`,
    transition: "transform 200ms, width 200ms",
    "@media (prefers-reduced-motion: reduce)": {
      transitionDuration: "50ms, 50ms"
    }
  }, theme.responsive(orientation, o => {
    switch (o) {
      case "horizontal":
        return {
          display: "block"
        };
      case "vertical":
        return {
          display: "none"
        };
    }
  })];
};
const tabsListStyle = (theme, {
  orientation,
  colorScheme
}) => {
  return [focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme,
    focusSelector: "& [role='tab']:focus-visible"
  }), {
    position: "relative",
    display: "grid",
    gap: `var(${vars$f.triggersGap})`
  }, theme.responsive(orientation, o => {
    switch (o) {
      case "horizontal":
        return {
          gridAutoFlow: "column",
          gridAutoColumns: "max-content",
          marginBottom: `calc(${theme.spacing(0.75)} - var(${activeFocusWidth}))`
        };
      case "vertical":
        return {
          gridAutoFlow: "row",
          gridAutoRows: "max-content",
          marginBottom: 0
        };
    }
  })];
};
const tabsStyle = (theme, props) => {
  const o = props.orientation;
  return [tabsColorSchemeTokens(theme, props.colorScheme), focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme: props.colorScheme,
    focusSelector: "& [role='tabpanel']:focus-visible"
  }), {
    [vars$f.triggersTrackSize]: "3px",
    [vars$f.triggersGap]: theme.spacing(1),
    [vars$f.triggerGutterV]: theme.spacing(0.75),
    [vars$f.triggerGutterH]: 0,
    [vars$f.triggerFontSize]: "inherit",
    [vars$f.triggerLineHeight]: "inherit",
    display: "flex",
    flexDirection: o === "vertical" ? "row" : "column",
    overflow: o === "vertical" ? "auto" : "initial"
  }, theme.responsive(props.triggerFontSize, fs => {
    const value = theme.tokens.fontSizes[fs];
    return {
      [vars$f.triggerFontSize]: value.fontSize,
      [vars$f.triggerLineHeight]: value.lineHeight
    };
  }), theme.responsive(props.spacing, s => {
    return {
      [vars$f.triggersSpacing]: theme.spacing(s)
    };
  })];
};

const noop$8 = () => {};
const Tabs = props => {
  const {
    colorScheme = ColorScheme.OnLight,
    orientation = "horizontal",
    triggerFontSize,
    spacing = [1, null, 2],
    selected,
    onSelected = noop$8,
    initialSelected,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  // @ts-expect-error - Component effectively handles when both selected and initialSelected are undefined; it selects the first tab in this case
  const [selectedKey, setSelectedKey] = useControlledState(selected, initialSelected, onSelected);
  const [focused, setFocused] = React.useState(0);
  const [indicatorEnabled, setIndicatorEnabled] = React.useState(false);
  const tabScrollerRef = React.useRef(null);
  const indicatorRef = React.useRef(null);
  /**
   * Disable the selection indicator until font loading is complete. Otherwise,
   * the width and positon of the indicator will be incorrect when the desired
   * font loads in.
   */
  React.useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    const cb = () => setIndicatorEnabled(true);
    document.fonts.ready.then(cb, cb);
  }, []);
  /**
   * The selection indicators position must be computed by using the position
   * and width of the selected tab.
   */
  useIsomorphicLayoutEffect(() => {
    const updateIndicator = () => {
      var _tabScrollerRef$curre;
      const selectedTab = (_tabScrollerRef$curre = tabScrollerRef.current) === null || _tabScrollerRef$curre === void 0 ? void 0 : _tabScrollerRef$curre.querySelector(":scope > [role=tablist] > [role=tab][aria-selected=true]");
      if (!(selectedTab instanceof HTMLElement) || !indicatorRef.current) {
        return;
      }
      indicatorRef.current.style.width = `${selectedTab.offsetWidth}px`;
      indicatorRef.current.style.transform = `translateX(${selectedTab.offsetLeft}px)`;
    };
    if (!indicatorRef.current || !tabScrollerRef.current) {
      return;
    }
    updateIndicator();
    const resizeObserver = new ResizeObserver(updateIndicator);
    const tabs = tabScrollerRef.current.querySelectorAll(":scope > [role=tablist] > [role=tab]");
    tabs.forEach(tab => resizeObserver.observe(tab));
    return () => {
      tabs.forEach(tab => resizeObserver.unobserve(tab));
      resizeObserver.disconnect();
    };
  }, [selectedKey, indicatorEnabled, triggerFontSize, orientation]);
  /**
   * Sets up keyboard shortcuts for this component based on its orientation.
   * The focused tab can be changed using the arrow keys as specified by the
   * aria `tab` role docs: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
   */
  const handleKeyDown = e => {
    let backKey = ["Left", "ArrowLeft"];
    let forwardKey = ["Right", "ArrowRight"];
    if (orientation === "vertical") {
      backKey = ["Up", "ArrowUp"];
      forwardKey = ["Down", "ArrowDown"];
    }
    const goingBack = backKey.indexOf(e.key) >= 0;
    const goingForward = forwardKey.indexOf(e.key) >= 0;
    if (!goingBack && !goingForward) {
      return;
    }
    e.preventDefault();
    const tabs = Array.from(e.currentTarget.querySelectorAll(":scope > [role=tab]"));
    let nextIndex = tabs.findIndex(tab => tab.getAttribute("tabindex") === "0");
    if (goingBack) {
      nextIndex = nextIndex > 0 ? nextIndex - 1 : tabs.length - 1;
    } else if (goingForward) {
      nextIndex = nextIndex < tabs.length - 1 ? nextIndex + 1 : 0;
    }
    setFocused(nextIndex);
    const nextTab = tabs[nextIndex];
    if (nextTab instanceof HTMLElement) {
      nextTab.focus();
    }
  };
  // We are going to be rendering `TabItem`s twice as this component:
  // Under one part of the `Tab`s tree, they will be rendered as tab
  // triggers (buttons). Under another, part of the tree they will be rendered
  // as panels with content.
  //
  // Using `TabItemRole.Provider` is a neat little trick to change the render
  // output of `TabItem`s. It means we can keep the API of this component simple
  // and maintain strong accessibility by tightly association a trigger and
  // panel using one component - the `TabItem`.
  const items = React.Children.map(props.children, (item, index) => {
    if (! /*#__PURE__*/React.isValidElement(item)) {
      return null;
    }
    const itemProps = {
      focused: index === focused,
      selected: selectedKey,
      onClick: key => setSelectedKey(key)
    };
    return /*#__PURE__*/React.cloneElement(item, itemProps);
  });
  return jsxs("div", {
    css: tabsStyle(theme, {
      colorScheme,
      triggerFontSize,
      orientation,
      spacing
    }),
    ...rest,
    children: [jsxs("div", {
      ref: tabScrollerRef,
      css: tabsScrollerStyle(theme, orientation),
      role: "presentation",
      children: [jsx("div", {
        css: tabsListStyle(theme, {
          orientation,
          colorScheme
        }),
        role: "tablist",
        onKeyDown: handleKeyDown,
        "aria-orientation": orientation,
        children: jsx(TabItemRole.Provider, {
          value: "trigger",
          children: items
        })
      }), jsx("div", {
        ref: indicatorRef,
        css: tabsScrollIndicator(theme, orientation),
        role: "presentation",
        "data-tabs-indicator-ready": indicatorEnabled
      })]
    }), jsx(TabItemRole.Provider, {
      value: "panel",
      children: items
    })]
  });
};

const tabPanelStyle = {
  flex: "1 1 100%",
  boxShadow: `var(${focusRingVar})`
};
const TabPanel = props => {
  const {
    theme
  } = useTheme();
  return jsx("div", {
    css: [tabPanelStyle, {
      borderRadius: theme.radius(0.25)
    }, process.env.NODE_ENV === "production" ? "" : ";label:TabPanel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYlBhbmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRaUIiLCJmaWxlIjoiVGFiUGFuZWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlVGhlbWUgfSBmcm9tIFwiLi4vdGhlbWVcIjtcclxuaW1wb3J0IHsgZm9jdXNSaW5nVmFyIH0gZnJvbSBcIi4uL3RoZW1lL2Nzc3ZhcmlhYmxlc1wiO1xyXG5jb25zdCB0YWJQYW5lbFN0eWxlID0ge1xyXG4gICAgZmxleDogXCIxIDEgMTAwJVwiLFxyXG4gICAgYm94U2hhZG93OiBgdmFyKCR7Zm9jdXNSaW5nVmFyfSlgLFxyXG59O1xyXG5jb25zdCBUYWJQYW5lbCA9IChwcm9wcykgPT4ge1xyXG4gICAgY29uc3QgeyB0aGVtZSB9ID0gdXNlVGhlbWUoKTtcclxuICAgIHJldHVybiAoPGRpdiBjc3M9e1t0YWJQYW5lbFN0eWxlLCB7IGJvcmRlclJhZGl1czogdGhlbWUucmFkaXVzKDAuMjUpIH1dfSBpZD17cHJvcHMuaWR9IHJvbGU9XCJ0YWJwYW5lbFwiIGFyaWEtbGFiZWxsZWRieT17cHJvcHMubGFiZWxJZH0gdGFiSW5kZXg9ezB9IGhpZGRlbj17IXByb3BzLnNlbGVjdGVkIHx8IHVuZGVmaW5lZH0+XG4gICAgICB7cHJvcHMuY2hpbGRyZW59XG4gICAgPC9kaXY+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgVGFiUGFuZWw7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVRhYlBhbmVsLmpzeC5tYXAiXX0= */"],
    id: props.id,
    role: "tabpanel",
    "aria-labelledby": props.labelId,
    tabIndex: 0,
    hidden: !props.selected || undefined,
    children: props.children
  });
};

const tabTriggerStyle = {
  scrollSnapAlign: "start",
  fontFamily: "inherit",
  border: "none",
  background: "none",
  textAlign: "start",
  margin: 0,
  padding: `var(${activeFocusWidth})`,
  fontSize: `var(${vars$f.triggerFontSize})`,
  lineHeight: `var(${vars$f.triggerLineHeight})`,
  fontWeight: FontWeight.SemiBold,
  cursor: "pointer",
  transition: "color 200ms",
  color: `var(${vars$f.triggerColor})`,
  "&:hover": {
    color: `var(${vars$f.triggerHoverColor})`
  },
  "&[aria-selected=true]": {
    color: `var(${vars$f.triggerSelectedColor})`
  },
  "&:disabled": {
    color: `var(${vars$f.triggerColor})`,
    cursor: "unset",
    opacity: 0.5
  }
};
const TabTrigger = props => {
  const {
    theme
  } = useTheme();
  const {
    id,
    panelId,
    focused,
    selected = false,
    onClick,
    disabled,
    children
  } = props;
  return jsx("button", {
    css: tabTriggerStyle,
    id: id,
    type: "button",
    role: "tab",
    "aria-controls": panelId,
    "aria-selected": selected,
    tabIndex: focused ? 0 : -1,
    onClick: onClick,
    disabled: disabled,
    children: jsx("span", {
      css: /*#__PURE__*/css({
        boxShadow: `var(${focusRingVar})`,
        borderRadius: theme.radius(0.25)
      }, process.env.NODE_ENV === "production" ? "" : ";label:TabTrigger;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: children
    })
  });
};

const TabItem = props => {
  const {
    focused,
    selected,
    onClick,
    disabled
  } = props;
  const renderRole = React.useContext(TabItemRole);
  const panelId = props.id;
  const triggerId = `${props.id}-trigger`;
  if (renderRole === "trigger") {
    return jsx(TabTrigger, {
      id: triggerId,
      panelId: panelId,
      focused: focused,
      selected: selected === props.id,
      onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(props.id),
      disabled: disabled,
      children: props.label
    });
  } else {
    return jsx(TabPanel, {
      id: panelId,
      labelId: triggerId,
      selected: selected === props.id,
      children: props.children
    });
  }
};

const vars$e = {
  spaceBefore: "--breadcrumbs-spacebefore",
  spaceAfter: "--breadcrumbs-spaceafter",
  staggered: "--breadcrumbs-staggered",
  color: "--breadcrumbs-color",
  separatorColor: "--breadcrumbs-separator-color",
  activeColor: "--breadcrumbs-active-color"
};
const breadcrumbsSeparatorStyle = {
  margin: `0 var(${vars$e.spaceAfter}) 0 var(${vars$e.spaceBefore})`,
  alignSelf: "center",
  userSelect: "none",
  color: `var(${vars$e.separatorColor})`,
  "li:first-of-type > &": {
    display: "none"
  }
};
const breadcrumbsLinkStyle = {
  color: "inherit",
  textDecoration: "none",
  boxShadow: `var(${focusRingVar})`,
  "&:hover": {
    textDecoration: "underline"
  }
};
const breadcrumbsItemStyle = (theme, props) => {
  const {
    level
  } = props;
  const s = theme.spacing(1);
  const ml = `calc(var(--breadcrumbs-staggered) * ${level} * ${s})`;
  return [typographyStyle(theme, props), {
    display: "inline-flex",
    alignItems: "baseline",
    marginLeft: ml,
    "&:last-of-type": {
      color: `var(${vars$e.activeColor})`
    }
  }];
};
const breadcrumbsColorSchemeTokens = (theme, colorScheme) => {
  const light = {
    [vars$e.color]: theme.color(ColorPreset.TextOnLight_02),
    [vars$e.separatorColor]: theme.color(ColorPreset.IconOnLight_03),
    [vars$e.activeColor]: theme.color(ColorPreset.TextOnLight_01)
  };
  const dark = {
    [vars$e.color]: theme.color(ColorPreset.TextOnDark_02),
    [vars$e.separatorColor]: theme.color(ColorPreset.IconOnDark_03),
    [vars$e.activeColor]: theme.color(ColorPreset.TextOnDark_01)
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const breadcrumbsStyle = (theme, props) => {
  const {
    layout,
    colorScheme,
    ...rest
  } = props;
  return [typographyStyle(theme, rest), breadcrumbsColorSchemeTokens(theme, colorScheme), focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme,
    focusSelector: "& li a:focus-visible"
  }), {
    [vars$e.spaceBefore]: theme.spacing(1),
    [vars$e.spaceAfter]: theme.spacing(1),
    display: "flex",
    flexWrap: "nowrap",
    margin: 0,
    padding: 0,
    listStyleType: "none",
    color: `var(${vars$e.color})`
  }, theme.responsive(layout, v => {
    switch (v) {
      case "column":
        return {
          [vars$e.staggered]: 1,
          [vars$e.spaceBefore]: 0,
          whiteSpace: "normal",
          flexDirection: v,
          alignItems: "start"
        };
      case "row":
        return {
          [vars$e.staggered]: 0,
          [vars$e.spaceBefore]: theme.spacing(1),
          whiteSpace: "nowrap",
          flexDirection: v,
          alignItems: "center"
        };
    }
  })];
};

const BreadcrumbsSeparatorContext = /*#__PURE__*/React.createContext(null);
const BreadcrumbsSeparator = () => {
  const node = React.useContext(BreadcrumbsSeparatorContext);
  return /*#__PURE__*/React.isValidElement(node) ? node : null;
};
const BreadcrumbsItem = ({
  level = 0,
  href,
  children,
  ...rest
}) => {
  const {
    theme
  } = useTheme();
  return jsxs("li", {
    css: breadcrumbsItemStyle(theme, {
      level,
      ...rest
    }),
    ...omitTypographyStyleProps(rest),
    children: [jsx(BreadcrumbsSeparator, {}), href ? jsx("a", {
      css: [breadcrumbsLinkStyle, {
        borderRadius: theme.radius(0.25)
      }, process.env.NODE_ENV === "production" ? "" : ";label:BreadcrumbsItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      href: href,
      children: children
    }) : jsx("span", {
      children: children
    })]
  });
};
const Breadcrumbs = props => {
  const {
    separator = Glyph.ArrowForwardLong,
    colorScheme = ColorScheme.OnLight,
    layout = ["column", null, "row"],
    children,
    color,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const sepNode = React.useMemo(() => separator === "/" ? jsx("span", {
    css: breadcrumbsSeparatorStyle,
    "aria-hidden": true,
    children: "/"
  }) : jsx(Icon, {
    css: breadcrumbsSeparatorStyle,
    name: separator
  }), [separator, breadcrumbsSeparatorStyle]);
  let level = 0;
  const nodes = React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return;
    }
    const childProps = {
      level
    };
    const clone = /*#__PURE__*/React.cloneElement(child, childProps);
    level += 1;
    return clone;
  });
  return jsx("ol", {
    css: breadcrumbsStyle(theme, {
      colorScheme,
      layout,
      ...rest
    }),
    ...omitTypographyStyleProps(rest),
    children: jsx(BreadcrumbsSeparatorContext.Provider, {
      value: sepNode,
      children: nodes
    })
  });
};

const codePanelStyle = {
  overflow: "auto"
};
const CodeSnippet = props => {
  const {
    language,
    ...rest
  } = props;
  return jsx(TabItem, {
    ...rest,
    label: language,
    children: jsx("div", {
      css: codePanelStyle,
      children: rest.children
    })
  });
};
const codeSnippetsStyle = (theme, colorScheme) => {
  const lightScheme = {
    color: theme.color(ColorPreset.TextOnLight_01),
    backgroundColor: theme.color(ColorPreset.BackgroundLight_01)
  };
  const darkScheme = {
    color: theme.color(ColorPreset.TextOnDark_01),
    backgroundColor: theme.color(ColorPreset.BackgroundDark_01)
  };
  // Your eyes aren't tricking you. They are flipped around intentionally
  // except for Auto.
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return darkScheme;
    case ColorScheme.OnDark:
      return lightScheme;
    case ColorScheme.Auto:
      return [lightScheme, {
        "@media (prefers-color-scheme: dark)": darkScheme
      }];
  }
};
const CodeSnippets = props => {
  const {
    theme
  } = useTheme();
  const {
    triggerFontSize = TypeScale.Size_03,
    footer,
    colorScheme = ColorScheme.OnLight,
    ...rest
  } = props;
  let flipped = ColorScheme.Auto;
  switch (colorScheme) {
    case ColorScheme.OnLight:
      flipped = ColorScheme.OnDark;
      break;
    case ColorScheme.OnDark:
      flipped = ColorScheme.OnLight;
      break;
  }
  return jsxs(Box, {
    gutterV: 2,
    gutterH: [1.5, null, 2],
    css: codeSnippetsStyle(theme, colorScheme),
    borderRadius: 1,
    children: [jsx(Tabs, {
      ...rest,
      triggerFontSize: triggerFontSize,
      colorScheme: flipped,
      spacing: 1.5
    }), footer ? jsx(Box, {
      spaceAbove: 1,
      children: footer
    }) : null]
  });
};

const BodyPortal = ({
  children
}) => {
  const [portalEl, setPortalEl] = React.useState();
  React.useEffect(() => {
    if (!portalEl) {
      const newPortalEl = document.createElement("div");
      document.body.appendChild(newPortalEl);
      setPortalEl(newPortalEl);
    }
    return () => {
      portalEl && document.body.removeChild(portalEl);
    };
  }, [portalEl]);
  return portalEl ? /*#__PURE__*/createPortal(children, portalEl) : null;
};

const hasListboxParent = target => {
  let parent = target.parentElement;
  while (parent) {
    // list and children nodes that clicked within a dialog should not close the dialog
    if (parent.getAttribute("role") === "list") {
      var _parent, _parent$parentElement;
      // checking that this list is sitting directly in the body portal
      return ((_parent = parent) === null || _parent === void 0 ? void 0 : (_parent$parentElement = _parent.parentElement) === null || _parent$parentElement === void 0 ? void 0 : _parent$parentElement.parentElement) === document.body;
    }
    parent = parent.parentElement;
  }
  return false;
};
const tappedOut = (ref, target) => {
  if (hasListboxParent(target)) {
    return false;
  }
  const refs = Array.isArray(ref) ? ref : [ref];
  const hit = refs.some(r => {
    const refEl = r.current;
    if (!refEl) {
      return;
    }
    return refEl.contains(target);
  });
  return !hit;
};
/**
 * @param ref One or more refs to element that should be excluded from tap out
 * detection. For example, this could be a dropdown's trigger AND its panel.
 * @param callback The callback to call when a tap outside the target element
 * occurs.
 */
const useTapOut = (ref, callback) => {
  React__default.useEffect(() => {
    if (typeof window === "undefined" || typeof window.document === "undefined") {
      return;
    }
    const handleMouse = e => {
      const target = e.target;
      if (!target || !(target instanceof Element)) {
        return;
      }
      if (tappedOut(ref, target)) {
        callback();
      }
    };
    const handleKey = e => {
      if (e.key !== "Tab" || !document.activeElement) {
        return;
      }
      if (tappedOut(ref, document.activeElement)) {
        callback();
      }
    };
    document.addEventListener("mouseup", handleMouse, true);
    document.addEventListener("keydown", handleKey, true);
    return () => {
      document.removeEventListener("mouseup", handleMouse, true);
      document.removeEventListener("keydown", handleKey, true);
    };
  }, [ref, callback]);
};

const overlayStyle = theme => {
  return {
    overflow: "auto",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: theme.color(Color.Greystone_1400_A90),
    zIndex: ZIndex.Dialog,
    transition: "opacity 250ms",
    opacity: 1,
    ".slide-enter &": {
      display: "block",
      opacity: 0
    },
    ".slide-enter-active &": {
      opacity: 1
    },
    ".slide-enter-done &": {
      opacity: 1,
      display: "block"
    },
    ".slide-exit &": {
      display: "block",
      opacity: 1
    },
    ".slide-exit-active &": {
      opacity: 0
    },
    ".slide-exit-done &": {
      opacity: 0,
      display: "none"
    }
  };
};
const Overlay = () => {
  const {
    theme
  } = useTheme();
  return jsx("div", {
    css: overlayStyle(theme),
    "aria-hidden": true
  });
};

const styleVars = {
  // the top and right absolute position of the close button
  closePull: "--dialog-close-pull",
  // the amount of right padding to add to the header so it clears the close
  // button
  closeClearing: "--dialog-close-clearing",
  // dialogs padding
  headerGutterV: "--dialog-header-gutterv",
  headerGutterH: "--dialog-header-gutterh",
  headerGridGap: "--dialog-header-grid-gap",
  footerGutterV: "--dialog-footer-gutterv",
  footerGutterH: "--dialog-footer-gutterh",
  bodyGutterV: "--dialog-body-gutterv",
  bodyGutterH: "--dialog-body-gutterh",
  // dialogs main content scroll shadow
  topShadowOpacity: "--dialog-top-shadow-opacity",
  bottomShadowOpacity: "--dialog-bottom-shadow-opacity",
  width: "--dialog-width",
  height: "--dialog-height",
  borderRadius: "--dialog-border-radius"
};
const dialogSizeTokens = (theme, {
  header,
  footer,
  bodyGutterH,
  bodyGutterV
}) => {
  const headerGutterV = (header === null || header === void 0 ? void 0 : header.gutterV) !== undefined ? header.gutterV : [1.5];
  const headerGutterH = (header === null || header === void 0 ? void 0 : header.gutterH) !== undefined ? header.gutterH : bodyGutterH;
  const footerGutterV = (footer === null || footer === void 0 ? void 0 : footer.gutterV) !== undefined ? footer.gutterV : [1, null, 1.5];
  const footerGutterH = (footer === null || footer === void 0 ? void 0 : footer.gutterH) !== undefined ? footer.gutterH : bodyGutterH;
  return [{
    [styleVars.headerGridGap]: theme.spacing(1),
    [styleVars.closePull]: theme.spacing(0.5),
    [styleVars.closeClearing]: theme.spacing(4)
  }, theme.responsive(headerGutterV, v => {
    return {
      [styleVars.headerGutterV]: theme.spacing(v)
    };
  }), theme.responsive(headerGutterH, h => {
    return {
      [styleVars.headerGutterH]: theme.spacing(h)
    };
  }), theme.responsive(bodyGutterV, v => {
    return {
      [styleVars.bodyGutterV]: theme.spacing(v)
    };
  }), theme.responsive(bodyGutterH, h => {
    return {
      [styleVars.bodyGutterH]: theme.spacing(h)
    };
  }), theme.responsive(footerGutterV, v => {
    return {
      [styleVars.footerGutterV]: theme.spacing(v)
    };
  }), theme.responsive(footerGutterH, h => {
    return {
      [styleVars.footerGutterH]: theme.spacing(h)
    };
  })];
};
const dialogHostStyle = (theme, {
  hostGutterH,
  hostGutterV
}) => {
  return [theme.responsive(hostGutterV, pad => ({
    paddingTop: theme.spacing(pad),
    paddingBottom: theme.spacing(pad)
  })), theme.responsive(hostGutterH, pad => ({
    paddingLeft: theme.spacing(pad),
    paddingRight: theme.spacing(pad)
  })), {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: ZIndex.Dialog,
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  }];
};
const dialogStyle = (theme, props) => {
  const tv = "--dialog-transform";
  const tvar = `var(${tv})`;
  const ov = "--dialog-opacity";
  const ovar = `var(${ov})`;
  return [dialogSizeTokens(theme, props), {
    margin: "auto",
    position: "relative",
    backgroundColor: theme.color(Color.Brownstone_100),
    webkitOverflowScrolling: "touch",
    maxHeight: "100%",
    outline: "none",
    overflow: "hidden"
  }, theme.responsive(props.width, w => {
    return {
      width: w
    };
  }), theme.responsive(props.height, h => {
    return {
      height: h
    };
  }), theme.responsive(props.borderRadius, (r, th) => ({
    borderRadius: th.radius(r)
  })), {
    [tv]: "translate3d(0, 48px, 0)",
    [ov]: 0,
    transition: "transform 250ms, opacity 250ms",
    transform: tvar,
    opacity: ovar,
    ".slide-enter &": {
      [tv]: "translate3d(0, 48px, 0)",
      [ov]: 0
    },
    ".slide-enter-active &": {
      [tv]: "translate3d(0, 0, 0)",
      [ov]: 1
    },
    ".slide-enter-done &": {
      [tv]: "translate3d(0, 0, 0)",
      [ov]: 1
    },
    ".slide-exit &": {
      [tv]: "translate3d(0, 0, 0)",
      [ov]: 1
    },
    ".slide-exit-active &": {
      [tv]: "translate3d(0, -48px, 0)",
      [ov]: 0
    },
    ".slide-exit-done &": {
      [tv]: "translate3d(0, -48px, 0)",
      [ov]: 0
    },
    "@media (prefers-reduced-motion: reduce)": {
      ".slide-enter &": {
        [tv]: "translate3d(0, 8px, 0)",
        [ov]: 0
      },
      ".slide-enter-active &": {
        [tv]: "translate3d(0, 0, 0)",
        [ov]: 1
      },
      ".slide-enter-done &": {
        [tv]: "translate3d(0, 0, 0)",
        [ov]: 1
      },
      ".slide-exit &": {
        [tv]: "translate3d(0, 0, 0)",
        [ov]: 1
      },
      ".slide-exit-active &": {
        [tv]: "translate3d(0, -8px, 0)",
        [ov]: 0
      },
      ".slide-exit-done &": {
        [tv]: "translate3d(0, -8px, 0)",
        [ov]: 0
      }
    }
  }];
};
const dialogMainWrapperStyle = {
  height: "100%",
  maxHeight: "100%",
  display: "grid"
};
const headerFooterSeparator = theme => `1px solid ${theme.color(ColorPreset.BorderOnLight_04)}`;
const dialogHeaderStyle = (theme, {
  closePadding,
  separator = true
}) => ({
  paddingTop: `var(${styleVars.headerGutterV})`,
  paddingBottom: `var(${styleVars.headerGutterV})`,
  paddingRight: closePadding ? `max(var(${styleVars.closeClearing}), var(${styleVars.headerGutterH}))` : `var(${styleVars.headerGutterH})`,
  paddingLeft: `var(${styleVars.headerGutterH})`,
  borderBottom: separator ? headerFooterSeparator(theme) : undefined,
  display: "grid",
  gap: `var(${styleVars.headerGridGap})`
});
const dialogFooterStyle = (theme, {
  separator = true
}) => ({
  borderTop: separator ? headerFooterSeparator(theme) : undefined,
  padding: `var(${styleVars.footerGutterV}) var(${styleVars.footerGutterH})`
});
const scrollShadowVal = (theme, pos) => `0 ${pos === "top" ? "-" : ""}8px 18px 1px ${theme.color(Color.Brownstone_1400)}`;
const contentScrollShadows = ({
  top,
  bottom
}) => {
  return {
    [styleVars.topShadowOpacity]: top ? "1" : "0",
    [styleVars.bottomShadowOpacity]: bottom ? "1" : "0"
  };
};
const dialogBodyStyle = theme => ({
  position: "relative",
  overflowY: "auto",
  "::before": {
    content: '""',
    display: "block",
    position: "sticky",
    top: "-1px",
    left: 0,
    right: 0,
    height: "1px",
    opacity: `var(${styleVars.topShadowOpacity})`,
    boxShadow: `${scrollShadowVal(theme, "top")}`
  },
  "::after": {
    content: '""',
    display: "block",
    position: "sticky",
    bottom: "-1px",
    left: 0,
    right: 0,
    height: "1px",
    opacity: `var(${styleVars.bottomShadowOpacity})`,
    boxShadow: `${scrollShadowVal(theme, "bottom")}`
  },
  "::before, ::after": {
    transition: "opacity 0.25s"
  }
});
const bodyContentStyle = {
  padding: `var(${styleVars.bodyGutterV}) var(${styleVars.bodyGutterH})`
};
const closeStyle = ({
  position,
  onHeader
}) => {
  const closePosition = position ? position : onHeader ? "absolute" : "static";
  return {
    position: closePosition,
    top: `var(${styleVars.closePull})`,
    right: `var(${styleVars.closePull})`,
    marginBottom: `calc(-1 * var(${styleVars.closePull}))`,
    button: closePosition === "static" ? {
      float: "right",
      margin: `var(${styleVars.closePull}) var(${styleVars.closePull}) 0 0`
    } : undefined
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CloseTrigger = props => {
  const {
    onClose,
    label,
    ...rest
  } = props;
  return jsx("div", {
    css: closeStyle(rest),
    children: jsx(IconButton, {
      icon: Glyph.Close,
      label: label,
      variant: ButtonVariant.TextOnLight,
      onClick: onClose
    })
  });
};
const overFlowScrollShadow = wrapper => {
  const child = wrapper.children[0];
  if (!child || child.children.length < 1) return {
    top: false,
    bottom: false
  };
  const top = wrapper.scrollTop > 4;
  const heightDiff = child.clientHeight - wrapper.clientHeight;
  const bottom = heightDiff > 0 && wrapper.scrollTop < heightDiff;
  return {
    top,
    bottom
  };
};
const destructureHeaderFooter = item => {
  const itemIsObject = !!item && typeof item === "object" && "content" in item;
  const enableItem = itemIsObject || !!item && React.Children.count(item) > 0;
  const {
    content,
    ...styles
  } = itemIsObject ? item : {
    content: item
  };
  return {
    enableItem,
    content,
    styles
  };
};
var _ref$4 = process.env.NODE_ENV === "production" ? {
  name: "1quw0ni",
  styles: "pointer-events:auto"
} : {
  name: "1rdygna-Dialog",
  styles: "pointer-events:auto;label:Dialog;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
const Dialog = ({
  open,
  closeAction,
  header,
  footer,
  children,
  bodyGutterH = [2, null, 3],
  bodyGutterV = [1.5, null, 2],
  hostGutterH = 1,
  hostGutterV = [1, null, null, 2, 3],
  width = ["100%", null, "600px"],
  height = undefined,
  borderRadius = 1.5,
  ...rest
}) => {
  const {
    theme
  } = useTheme();
  const [scrollShadows, setScrollShadows] = React.useState({
    top: false,
    bottom: false
  });
  const mainDialogRef = React.useRef(null);
  const contentDivRef = React.useCallback(node => {
    if (!node) return;
    setScrollShadows(overFlowScrollShadow(node));
  }, [children]);
  useTapOut(mainDialogRef, () => {
    if (!open || !closeAction) return;
    closeAction.onClose();
  });
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "revert";
    }
    return () => {
      document.body.style.overflow = "revert";
    };
  }, [open]);
  const handleKeyDown = event => {
    if (event.key !== "Escape" || !(closeAction !== null && closeAction !== void 0 && closeAction.onClose)) return;
    // We don't want the event to propagate up in case anyone is listening to
    // the Escape key on the body.
    event.stopPropagation();
    closeAction.onClose();
  };
  const {
    enableItem: enableHeader,
    content: headerContent,
    styles: headerStyles
  } = destructureHeaderFooter(header);
  const {
    enableItem: enableFooter,
    content: footerContent,
    styles: footerStyles
  } = destructureHeaderFooter(footer);
  const sharedProps = {
    as: undefined
  };
  const content = jsxs(Fragment, {
    children: [" ", closeAction ? jsx(CloseTrigger, {
      ...closeAction,
      onHeader: !!enableHeader
    }) : null, enableHeader ? jsx("div", {
      css: dialogHeaderStyle(theme, {
        ...headerStyles,
        closePadding: !!closeAction && !closeAction.position
      }),
      children: headerContent
    }) : null, jsx("div", {
      ref: contentDivRef,
      onScroll: event => {
        const node = event.currentTarget;
        const {
          top,
          bottom
        } = overFlowScrollShadow(node);
        if (top === scrollShadows.top && bottom === scrollShadows.bottom) return;
        setScrollShadows({
          top,
          bottom
        });
      },
      style: {
        ...contentScrollShadows(scrollShadows)
      },
      css: dialogBodyStyle(theme),
      children: jsx("div", {
        css: bodyContentStyle,
        children: children
      })
    }), enableFooter ? jsx("div", {
      css: dialogFooterStyle(theme, footerStyles),
      children: footerContent
    }) : null]
  });
  return jsx(BodyPortal, {
    children: jsx(CSSTransition, {
      in: open,
      timeout: 250,
      classNames: "slide",
      mountOnEnter: true,
      unmountOnExit: true,
      appear: true,
      children: jsx("div", {
        css: _ref$4,
        onKeyDown: handleKeyDown,
        role: "presentation",
        tabIndex: -1,
        children: jsxs(FocusScope, {
          contain: true,
          autoFocus: true,
          restoreFocus: true,
          children: [jsx(Overlay, {}), jsx("div", {
            css: dialogHostStyle(theme, {
              hostGutterH,
              hostGutterV
            }),
            children: jsx("div", {
              ref: mainDialogRef,
              css: dialogStyle(theme, {
                header: headerStyles,
                footer: footerStyles,
                bodyGutterH,
                bodyGutterV,
                width,
                height,
                borderRadius
              }),
              role: "dialog",
              "aria-modal": true,
              tabIndex: -1,
              children: rest.as === "form" ? jsx("form", {
                css: dialogMainWrapperStyle,
                ...rest,
                ...sharedProps,
                children: content
              }) : jsx("div", {
                css: dialogMainWrapperStyle,
                ...rest,
                ...sharedProps,
                children: content
              })
            })
          })]
        })
      })
    })
  });
};

const Form = props => {
  return jsx("form", {
    ...props
  });
};

const fieldStyle = theme => ({
  "&& > *": {
    marginBottom: theme.spacing(0.25)
  },
  "&& > input, && > select, && > [data-field-control]": {
    margin: theme.spacing([0.5, 0])
  },
  "&& > :last-child": {
    marginBottom: theme.spacing(0)
  }
});
const Field = props => {
  const {
    theme
  } = useTheme();
  return jsx("div", {
    css: fieldStyle(theme),
    ...props,
    "data-field-control": true
  });
};

/* eslint-disable deprecation/deprecation */
const labelStyle$1 = {
  fontWeight: FontWeight.SemiBold,
  display: "block"
};
const Label = props => {
  return jsx("label", {
    css: labelStyle$1,
    ...props,
    children: props.children
  });
};

var FormFieldStatus;
(function (FormFieldStatus) {
  FormFieldStatus["Success"] = "success";
  FormFieldStatus["Danger"] = "danger";
})(FormFieldStatus || (FormFieldStatus = {}));
const defaultStatusColor = {
  border: ColorPreset.BorderOnLight_02,
  focusBorder: ColorPreset.BorderOnLight_01,
  background: ColorPreset.BackgroundLight_01,
  icon: ColorPreset.IconOnLight_01,
  text: ColorPreset.TextOnLight_01
};
const disabledStatusColor = {
  border: Color.Greystone_700_A38,
  focusBorder: Color.Greystone_700_A38,
  text: Color.Greystone_1400_A38,
  background: Color.Greystone_1400_A8,
  icon: Color.Greystone_1400_A38
};
const statusColors = {
  [FormFieldStatus.Danger]: {
    border: ColorPreset.AlertBorderOnLight,
    focusBorder: ColorPreset.AlertBorderOnLight,
    background: ColorPreset.BackgroundLight_01,
    icon: ColorPreset.AlertIconOnLight
  },
  [FormFieldStatus.Success]: {
    ...defaultStatusColor,
    border: Color.Success_Base,
    focusBorder: Color.Success_300,
    icon: Color.Success_Base
  }
};
const resolveStatusColors = (theme, options) => {
  const {
    status,
    disabled
  } = options;
  let config = status ? statusColors[status] : defaultStatusColor;
  if (disabled) {
    config = disabledStatusColor;
  }
  const baseBorderColor = theme.color(config.border);
  const selectedBorderColor = theme.color(config.focusBorder);
  const focusBorderColor = selectedBorderColor;
  const textColor = config.text ? theme.color(config.text) : undefined;
  const iconColor = config.icon ? theme.color(config.icon) : undefined;
  const backgroundColor = config.background ? theme.color(config.background) : undefined;
  return {
    baseBorderColor,
    selectedBorderColor,
    focusBorderColor,
    textColor,
    backgroundColor,
    iconColor
  };
};

const searchStyle$1 = {
  display: "none"
};
const searchReset$1 = {
  "&[type='search']::-ms-clear": searchStyle$1,
  "&[type='search']::-ms-reveal": searchStyle$1,
  "&[type='search']::-webkit-search-decoration": searchStyle$1,
  "&[type='search']::-webkit-search-cancel-button": searchStyle$1,
  "&[type='search']::-webkit-search-results-button": searchStyle$1,
  "&[type='search']::-webkit-search-results-decoration": searchStyle$1
};
// Autofill styling by browsers and password managers involves setting a custom
// background on filled inputs. Since the input container uses an inset shadow
// to simulate a solid border, this background color will overlap the inset
// shadow and hide it which disrupts this components appearance. We can overcome
// this by setting a transparent border on the underlying input that will shrink
// it and the impact of the custom background. The border radius will smooth out
// the input's corners since it will match its parents border radius.
const autoFillSupport$1 = {
  border: "var(--input-border-width) solid transparent",
  borderRadius: "inherit"
};
const inputStyle$1 = (theme, props) => {
  const padding = inputGutterStyle(theme, {
    size: props.gutter,
    adjustmentVar: "--input-border-width"
  });
  const typePreset = theme.tokens.typePresets[TypePreset.Body_02];
  const fontFamily = props.fontFamily ? theme.tokens.fontFamilies[props.fontFamily] : "inherit";
  return [autoFillSupport$1, {
    display: "block",
    width: "100%",
    margin: 0,
    background: "none",
    cursor: props.disabled ? "not-allowed" : "auto",
    fontFamily,
    color: "inherit",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    }
  }, padding, theme.responsive(typePreset.size, fs => {
    const size = theme.tokens.fontSizes[fs];
    const minHeight = `calc(${size.lineHeight} + ${padding} * 2)`;
    return {
      ...size,
      minHeight
    };
  }), searchReset$1];
};
const inputContainerStyle = (theme, props) => {
  const {
    status,
    focused,
    disabled
  } = props;
  const colors = resolveStatusColors(theme, {
    status,
    disabled
  });
  const {
    baseBorderColor,
    focusBorderColor,
    textColor,
    backgroundColor
  } = colors;
  let borderWidth = "1px";
  let boxShadowColor = baseBorderColor;
  if (focused) {
    borderWidth = "2px";
    boxShadowColor = focusBorderColor;
  }
  return {
    "--input-border-width": borderWidth,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    backgroundColor,
    color: textColor,
    borderRadius: theme.radius(0.5),
    boxShadow: `0 0 0 var(--input-border-width) ${boxShadowColor}`,
    transition: "box-shadow 150ms"
  };
};
const inputAccessoryStyle = {
  display: "flex",
  alignItems: "center"
};
const leftInputAccessoryStyle = theme => {
  return [inputAccessoryStyle, {
    "> svg": {
      margin: theme.spacing([0, 0, 0, 1])
    }
  }];
};
const rightInputAccessoryStyle = theme => {
  return [inputAccessoryStyle, {
    "> svg": {
      margin: theme.spacing([0, 1, 0, 0])
    }
  }];
};
const inputStatusIconStyle = (theme, props) => {
  const {
    iconColor
  } = resolveStatusColors(theme, {
    status: props.status,
    disabled: props.disabled
  });
  if (props.disabled) {
    return {
      display: "none"
    };
  }
  return {
    display: "flex",
    alignItems: "center",
    padding: `0 ${theme.spacing(1)}`,
    color: iconColor
  };
};
const Input = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    status,
    leftAccessory,
    rightAccessory,
    type,
    gutter,
    ...rest
  } = props;
  const {
    onFocus,
    onBlur,
    disabled
  } = props;
  const [focused, setFocused] = React.useState(false);
  const handleFocus = React.useCallback(e => {
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  }, [onFocus]);
  const handleBlur = React.useCallback(e => {
    setFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  }, [onBlur]);
  const styleProps = {
    ...props,
    focused,
    disabled
  };
  const statusIconCSS = inputStatusIconStyle(theme, styleProps);
  return jsxs("div", {
    css: inputContainerStyle(theme, styleProps),
    "data-field-control": true,
    children: [React.Children.count(leftAccessory) ? jsx("div", {
      css: leftInputAccessoryStyle(theme),
      children: leftAccessory
    }) : null, jsx("input", {
      css: inputStyle$1(theme, styleProps),
      type: type,
      ...rest,
      onFocus: handleFocus,
      onBlur: handleBlur,
      ref: ref
    }), status === FormFieldStatus.Success && jsx("div", {
      css: statusIconCSS,
      "aria-hidden": true,
      children: jsx(Icon, {
        size: "10px",
        name: Glyph.Tick
      })
    }), status === FormFieldStatus.Danger && jsx("div", {
      css: statusIconCSS,
      "aria-hidden": true,
      children: jsx(Icon, {
        size: "10px",
        name: Glyph.Close
      })
    }), React.Children.count(rightAccessory) ? jsx("div", {
      css: rightInputAccessoryStyle(theme),
      children: rightAccessory
    }) : null]
  });
});

const PasswordInput = /*#__PURE__*/React.forwardRef(function PasswordInput(props, ref) {
  const [showPassword, setShowPassword] = React.useState(false);
  const type = showPassword ? "text" : "password";
  const {
    showButtonLabel,
    hideButtonLabel,
    ...rest
  } = props;
  return jsx(Input, {
    ref: ref,
    ...rest,
    type: type,
    rightAccessory: jsx(IconButton, {
      variant: ButtonVariant.TextOnLight,
      icon: showPassword ? Glyph.ViewHidden : Glyph.View,
      label: showPassword ? hideButtonLabel : showButtonLabel,
      onClick: () => setShowPassword(v => !v),
      size: ButtonSize.Md
    })
  });
});

const vars$d = {
  neutralColor: "--hint-neutral-color",
  dangerColor: "--hint-danger-color",
  accentColor: "--hint-accent-color",
  color: "--hint-color",
  titleColor: "--hint-title-color"
};
const hintColorVars = (theme, cs) => {
  const light = {
    [vars$d.neutralColor]: theme.color(ColorPreset.TextOnLight_01),
    [vars$d.dangerColor]: theme.color(ColorPreset.AlertTextOnLight),
    [vars$d.accentColor]: theme.color(ColorPreset.AlertBorderOnLight),
    [vars$d.titleColor]: theme.color(ColorPreset.TextOnLight_01)
  };
  const dark = {
    [vars$d.neutralColor]: theme.color(ColorPreset.TextOnDark_01),
    [vars$d.dangerColor]: theme.color(ColorPreset.AlertTextOnDark),
    [vars$d.accentColor]: theme.color(Color.Alert_100),
    [vars$d.titleColor]: theme.color(ColorPreset.TextOnDark_01)
  };
  switch (cs) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const hintStyle = (theme, props) => {
  return [hintColorVars(theme, props.colorScheme || ColorScheme.OnLight), {
    color: props.status === FormFieldStatus.Danger ? `var(${vars$d.dangerColor})` : `var(${vars$d.neutralColor})`,
    display: "flex",
    alignItems: "center"
  }];
};
const hintLeftAccessoryStyle = theme => {
  return {
    marginRight: theme.spacing(0.75)
  };
};
const hintBodyStyle = (theme, props) => {
  const {
    status,
    summaryTitle
  } = props;
  const fontWeight = status === FormFieldStatus.Danger ? FontWeight.SemiBold : FontWeight.Normal;
  const customSpacing = summaryTitle ? theme.spacing([1, 1]) : theme.spacing([0, 1]);
  return {
    padding: status ? customSpacing : undefined,
    position: "relative",
    margin: 0,
    fontWeight,
    ...theme.tokens.fontSizes[TypeScale.Size_02],
    "&:before": {
      content: '""',
      display: status ? "inline" : "none",
      position: "absolute",
      width: "2px",
      height: "100%",
      top: "50%",
      left: 0,
      transform: "translateY(-50%)",
      borderRadius: theme.radius(3),
      backgroundColor: `var(${vars$d.accentColor})`
    }
  };
};
const hintTitleStyle = {
  color: `var(${vars$d.titleColor})`,
  marginTop: "0"
};
const Hint = props => {
  const {
    children,
    leftAccessory,
    status,
    summaryTitle,
    colorScheme = ColorScheme.OnLight,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  return jsxs("div", {
    css: hintStyle(theme, {
      ...props,
      colorScheme
    }),
    children: [leftAccessory ? jsx("div", {
      css: hintLeftAccessoryStyle(theme),
      children: leftAccessory
    }) : null, jsxs("div", {
      css: hintBodyStyle(theme, props),
      ...rest,
      children: [summaryTitle && jsx("p", {
        css: hintTitleStyle,
        children: summaryTitle
      }), jsx("div", {
        children: children
      })]
    })]
  });
};

var ToggleControl;
(function (ToggleControl) {
  ToggleControl["Check"] = "check";
  ToggleControl["Radio"] = "radio";
  ToggleControl["Switch"] = "switch";
})(ToggleControl || (ToggleControl = {}));
var ToggleVariant;
(function (ToggleVariant) {
  ToggleVariant["Emphasized"] = "emphasized";
  ToggleVariant["Compact"] = "compact";
  ToggleVariant["ControlOnly"] = "control-only";
})(ToggleVariant || (ToggleVariant = {}));
var ToggleControlPosition;
(function (ToggleControlPosition) {
  ToggleControlPosition["Start"] = "start";
  ToggleControlPosition["End"] = "end";
})(ToggleControlPosition || (ToggleControlPosition = {}));
var ControlVar;
(function (ControlVar) {
  ControlVar["On"] = "--toggle-control-on";
  ControlVar["Bg"] = "--toggle-control-bg";
  ControlVar["Fg"] = "--toggle-control-fg";
  ControlVar["OutlineOn"] = "--toggle-control-outline-on";
  ControlVar["OutlineColor"] = "--toggle-control-outline-color";
  ControlVar["BorderColor"] = "--toggle-control-border-color";
})(ControlVar || (ControlVar = {}));

const outlineWidth$1 = `calc(var(${ControlVar.OutlineOn}) * 1px)`;
const toggleCheckStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
  borderRadius: "4px",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: `
  inset 0 0 0 1px var(${ControlVar.BorderColor}),
  0 0 0 ${outlineWidth$1} var(${ControlVar.OutlineColor})
  `,
  color: `var(${ControlVar.Fg})`,
  backgroundColor: `var(${ControlVar.Bg})`,
  transition: "box-shadow 100ms, background 100ms, color 100ms",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "box-shadow 50ms, background 50ms, color 50ms"
  },
  "> svg": {
    opacity: `var(${ControlVar.On})`,
    transition: "opacity 100ms",
    "@media (prefers-reduced-motion: reduce)": {
      transition: "opacity 50ms"
    }
  }
};
const ToggleCheck = ({
  indeterminate
}) => {
  return jsx("span", {
    css: toggleCheckStyle,
    role: "presentation",
    children: jsx(Icon, {
      size: "12px",
      name: indeterminate ? Glyph.Subtract : Glyph.Tick
    })
  });
};

const outlineWidth = `calc(var(${ControlVar.OutlineOn}) * 1px)`;
const toggleRadioStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
  borderRadius: "24px",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: `
  inset 0 0 0 ${outlineWidth} var(${ControlVar.BorderColor})
  `,
  color: `var(${ControlVar.Fg})`,
  transition: "box-shadow 100ms, background 100ms, color 100ms",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "box-shadow 50ms, background 50ms, color 50ms"
  }
};
const ToggleRadio = () => {
  return jsx("span", {
    css: toggleRadioStyle,
    role: "presentation"
  });
};

const controlStyle = (theme, props) => {
  const {
    control,
    colorScheme,
    focusSelector,
    focusSelectedSelector,
    disabledSelector,
    disabledUnselectedSelector,
    hoverSelectedSelector,
    hoverUnselectedSelector,
    selectedSelector
  } = props;
  const isSwitch = control === ToggleControl.Switch;
  const isRadio = control === ToggleControl.Radio;
  const isCheck = control === ToggleControl.Check;
  const light = {
    [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_Base) : "transparent",
    [ControlVar.Fg]: theme.color(Color.Brownstone_50),
    [ControlVar.OutlineColor]: isSwitch ? theme.color(Color.Brownstone_1400) : "transparent",
    [ControlVar.BorderColor]: isSwitch ? theme.color(Color.Brownstone_1400) : theme.color(Color.Greystone_DarkMatter),
    [selectedSelector]: {
      [ControlVar.Bg]: theme.color(Color.Greystone_DarkMatter),
      [ControlVar.Fg]: theme.color(Color.Brownstone_50),
      [ControlVar.BorderColor]: theme.color(Color.Greystone_DarkMatter)
    },
    [focusSelector]: {
      [ControlVar.BorderColor]: isSwitch ? theme.color(Color.Brownstone_1400) : theme.color(Color.Greystone_DarkMatter),
      [ControlVar.OutlineColor]: theme.color(Color.White)
    },
    [hoverUnselectedSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_500) : "transparent",
      [ControlVar.OutlineColor]: isRadio ? "transparent" : theme.color(Color.Greystone_1200),
      [ControlVar.BorderColor]: theme.color(Color.Greystone_1200)
    },
    [hoverSelectedSelector]: {
      [ControlVar.Bg]: theme.color(Color.Greystone_1200),
      [ControlVar.OutlineColor]: theme.color(Color.Greystone_1200),
      [ControlVar.BorderColor]: theme.color(Color.Greystone_1200)
    },
    [disabledSelector]: {
      [ControlVar.Fg]: theme.color(isCheck ? Color.Greystone_1400_A38 : isRadio ? Color.Greystone_1400_A16 : Color.White),
      [ControlVar.Bg]: theme.color(Color.Greystone_1400_A8),
      [ControlVar.BorderColor]: isRadio ? theme.color(Color.Greystone_1400_A8) : "transparent"
    },
    [disabledUnselectedSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_1400_A8) : "transparent",
      [ControlVar.BorderColor]: isSwitch ? "transparent" : theme.color(Color.Greystone_1400_A8)
    }
  };
  const dark = {
    [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_1100) : isRadio ? "transparent" : theme.color(Color.Slate_900),
    [ControlVar.Fg]: theme.color(Color.Greystone_DarkMatter),
    [ControlVar.BorderColor]: theme.color(Color.Greystone_50),
    [ControlVar.OutlineColor]: "transparent",
    [selectedSelector]: {
      [ControlVar.Bg]: theme.color(Color.Greystone_50),
      [ControlVar.Fg]: theme.color(Color.Greystone_DarkMatter),
      [ControlVar.BorderColor]: isCheck ? theme.color(Color.Greystone_DarkMatter) : theme.color(Color.Greystone_50)
    },
    [focusSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_1100) : "transparent",
      [ControlVar.BorderColor]: theme.color(Color.Greystone_50),
      [ControlVar.OutlineColor]: theme.color(Color.Slate_1100)
    },
    [focusSelectedSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.White) : isRadio ? "transparent" : theme.color(Color.Greystone_50),
      [ControlVar.BorderColor]: theme.color(Color.Greystone_50),
      [ControlVar.OutlineColor]: theme.color(Color.Slate_1100)
    },
    [hoverUnselectedSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_1300) : theme.color(Color.Slate_900),
      [ControlVar.OutlineColor]: isRadio ? "transparent" : theme.color(Color.Brownstone_400),
      [ControlVar.BorderColor]: theme.color(Color.Brownstone_400)
    },
    [hoverSelectedSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.Brownstone_700) : theme.color(Color.Brownstone_400),
      [ControlVar.OutlineColor]: theme.color(Color.Brownstone_400),
      [ControlVar.BorderColor]: theme.color(Color.Brownstone_400)
    },
    [disabledSelector]: {
      [ControlVar.Fg]: theme.color(Color.Greystone_700_A38),
      [ControlVar.Bg]: theme.color(Color.Greystone_700_A16),
      [ControlVar.BorderColor]: isRadio ? theme.color(Color.Greystone_700_A16) : "transparent"
    },
    [disabledUnselectedSelector]: {
      [ControlVar.Bg]: isSwitch ? theme.color(Color.Greystone_700_A16) : "transparent",
      [ControlVar.BorderColor]: isSwitch ? "transparent" : theme.color(Color.Greystone_700_A16)
    }
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};

var GeometryVar;
(function (GeometryVar) {
  GeometryVar["gutterV"] = "--toggle-gutterv";
  GeometryVar["gutterH"] = "--toggle-gutterh";
  GeometryVar["itemSpacing"] = "--toggle-item-spacing";
  GeometryVar["defaultBorderWidth"] = "--toggle-default-border-width";
  GeometryVar["hoverBorderWidth"] = "--toggle-hover-border-width";
  GeometryVar["focusedBorderWidth"] = "--toggle-focused-border-width";
  GeometryVar["borderRadius"] = "--toggle-border-radius";
})(GeometryVar || (GeometryVar = {}));
var ColorVar;
(function (ColorVar) {
  ColorVar["defaultBg"] = "--toggle-default-bg";
  ColorVar["disabledBg"] = "--toggle-disabled-bg";
  ColorVar["labelColor"] = "--toggle-label-color";
  ColorVar["descriptionColor"] = "--toggle-description-color";
  ColorVar["borderDefaultColor"] = "--toggle-border-default-color";
  ColorVar["borderFocusColor"] = "--toggle-border-focus-color";
  ColorVar["borderHoverColor"] = "--toggle-border-hover-color";
  ColorVar["borderCheckedColor"] = "--toggle-border-checked-color";
  ColorVar["borderDisabledColor"] = "--toggle-border-disabled-color";
})(ColorVar || (ColorVar = {}));
var Var;
(function (Var) {
  Var["bg"] = "--toggle-bg";
  Var["borderWidth"] = "--toggle-border-width";
  Var["borderColor"] = "--toggle-border-color";
  Var["boxShadow"] = "--toggle-box-shadow";
})(Var || (Var = {}));
const toggleGeometryStyle = (theme, variant) => {
  const compact = {
    [GeometryVar.gutterV]: 0,
    [GeometryVar.gutterH]: 0,
    [GeometryVar.itemSpacing]: theme.spacing(1.5),
    [GeometryVar.borderRadius]: theme.radius(1),
    [GeometryVar.defaultBorderWidth]: 0,
    [GeometryVar.hoverBorderWidth]: 0,
    [GeometryVar.focusedBorderWidth]: 0
  };
  const emphasized = {
    [GeometryVar.gutterV]: theme.spacing(1.5),
    [GeometryVar.gutterH]: theme.spacing(1.5),
    [GeometryVar.itemSpacing]: theme.spacing(1.5),
    [GeometryVar.borderRadius]: theme.radius(1),
    [GeometryVar.defaultBorderWidth]: "1px",
    [GeometryVar.hoverBorderWidth]: "2px",
    [GeometryVar.focusedBorderWidth]: "2px"
  };
  switch (variant) {
    case ToggleVariant.ControlOnly:
    case ToggleVariant.Compact:
      return compact;
    case ToggleVariant.Emphasized:
      return emphasized;
  }
};
/**
 * Utility function that lazily evaluates color scheme values for each toggle
 * variant.
 *
 * @param light A function that returns a config config for light color scheme
 * @param dark A function that returns a config config for dark color scheme
 * @returns A CSS rules function to generate the necessary color scheme style
 * rules
 */
const configureColors = (light, dark) => {
  return (theme, cs) => {
    switch (cs) {
      case ColorScheme.OnLight:
        return light(theme);
      case ColorScheme.OnDark:
        return dark(theme);
      case ColorScheme.Auto:
        return [light(theme), {
          "@media (prefers-color-scheme: dark)": dark(theme)
        }];
    }
  };
};
const toggleColorStyle = (theme, props) => {
  switch (props.variant) {
    case ToggleVariant.Emphasized:
      return configureColors(t => ({
        [ColorVar.defaultBg]: t.color(ColorPreset.BackgroundLight_03),
        [ColorVar.disabledBg]: t.color(Color.Greystone_700_A38),
        [ColorVar.labelColor]: t.color(ColorPreset.TextOnLight_01),
        [ColorVar.descriptionColor]: t.color(ColorPreset.TextOnLight_02),
        [ColorVar.borderDefaultColor]: t.color(ColorPreset.BorderOnLight_03),
        [ColorVar.borderFocusColor]: t.color(Color.Greystone_DarkMatter),
        [ColorVar.borderCheckedColor]: t.color(Color.Greystone_DarkMatter),
        [ColorVar.borderHoverColor]: t.color(ColorPreset.BorderOnLight_01),
        [ColorVar.borderHoverColor]: t.color(Color.Greystone_1200),
        [ColorVar.borderDisabledColor]: t.color(Color.Greystone_1400_A38)
      }), t => ({
        [ColorVar.defaultBg]: t.color(ColorPreset.BackgroundDark_03),
        [ColorVar.disabledBg]: t.color(Color.Greystone_700_A16),
        [ColorVar.labelColor]: t.color(ColorPreset.TextOnDark_01),
        [ColorVar.descriptionColor]: t.color(ColorPreset.TextOnDark_02),
        [ColorVar.borderDefaultColor]: t.color(ColorPreset.BorderOnDark_03),
        [ColorVar.borderFocusColor]: t.color(Color.Greystone_50),
        [ColorVar.borderCheckedColor]: t.color(Color.Greystone_50),
        [ColorVar.borderHoverColor]: t.color(Color.Brownstone_400),
        [ColorVar.borderDisabledColor]: t.color(Color.Greystone_700_A38)
      }))(theme, props.colorScheme);
    case ToggleVariant.ControlOnly:
    case ToggleVariant.Compact:
      return configureColors(t => ({
        [ColorVar.defaultBg]: "transparent",
        [ColorVar.disabledBg]: "transparent",
        [ColorVar.labelColor]: t.color(ColorPreset.TextOnLight_01),
        [ColorVar.descriptionColor]: t.color(ColorPreset.TextOnLight_02),
        [ColorVar.borderDefaultColor]: "transparent",
        [ColorVar.borderFocusColor]: "transparent",
        [ColorVar.borderCheckedColor]: "transparent",
        [ColorVar.borderHoverColor]: "transparent",
        [ColorVar.borderDisabledColor]: "transparent"
      }), t => ({
        [ColorVar.defaultBg]: "transparent",
        [ColorVar.disabledBg]: "transparent",
        [ColorVar.labelColor]: t.color(ColorPreset.TextOnDark_01),
        [ColorVar.descriptionColor]: t.color(ColorPreset.TextOnDark_02),
        [ColorVar.borderDefaultColor]: "transparent",
        [ColorVar.borderFocusColor]: "transparent",
        [ColorVar.borderCheckedColor]: "transparent",
        [ColorVar.borderHoverColor]: "transparent",
        [ColorVar.borderDisabledColor]: "transparent"
      }))(theme, props.colorScheme);
  }
};
const toggleBodyStyle = (theme, props) => {
  // We need to dynamically set up the grid areas and template columns based on
  // whether or not there is media being shown and the position of the control.
  const {
    controlPosition,
    hasMedia,
    control
  } = props;
  const outlineWidth = `calc(var(${ControlVar.OutlineOn}) * 1px)`;
  // For predictable styling, ensure these selectors have the same specificity.
  //
  // Use a tool like Specificity Calculator (https://specificity.keegan.st/) to
  // calculate the specificity of each selector. Replace every instance of '&'
  // with '.blah' e.g. '&&' becomes '.blah.blah' to get a correct calculation.
  const selectors = {
    selectedSelector: "input:checked ~ &&",
    hoverUnselectedSelector: "input:not(:checked) ~ &:hover",
    hoverSelectedSelector: "input:checked ~ &:hover",
    focusSelector: "input:focus-visible ~ &&",
    focusSelectedSelector: "input:checked:focus-visible ~ &&",
    disabledSelector: "input:disabled ~ &&",
    disabledUnselectedSelector: "input:not(:checked):disabled ~ &&",
    // additional selectors to accommodate styling the toggles from the parent
    hoverUnselectedToggleSelector: "input:not(:checked) ~ &:hover > div > span[role=presentation]",
    hoverUnselectedDisabledToggleSelector: "input:disabled:not(:checked) ~ &:hover > div > span[role=presentation]",
    focusUnselectedToggleSelector: "input:focus-visible ~ && > div > span[role=presentation]",
    focusSelectedToggleSelector: "input:checked:focus-visible ~ && > div > span[role=presentation]",
    focusUnselectedToggleKnobSelector: "input:focus-visible ~ && > div > span[role=presentation]:after",
    focusSelectedToggleKnobSelector: "input:checked:focus-visible ~ && > div > span[role=presentation]:after"
  };
  const alignItems = hasMedia || controlPosition === ToggleControlPosition.End || control === "switch" ? "center" : "baseline";
  const areas = [hasMedia ? "media" : null, "content"];
  if (controlPosition === ToggleControlPosition.End) {
    areas.push("control");
  } else {
    areas.unshift("control");
  }
  const gridTemplateAreas = `'${areas.filter(Boolean).join(" ")}'`;
  const templateCols = [hasMedia ? "max-content" : null, "auto"];
  if (controlPosition === ToggleControlPosition.End) {
    templateCols.push("max-content");
  } else {
    templateCols.unshift("max-content");
  }
  const gridTemplateColumns = templateCols.filter(Boolean).join(" ");
  const isSwitch = props.control === ToggleControl.Switch;
  const isRadio = props.control === ToggleControl.Radio;
  return [controlStyle(theme, {
    colorScheme: props.colorScheme,
    control: props.control,
    ...selectors
  }), {
    [Var.bg]: `var(${ColorVar.defaultBg})`,
    [Var.borderWidth]: `var(${GeometryVar.defaultBorderWidth})`,
    [Var.borderColor]: `var(${ColorVar.borderDefaultColor})`,
    [ControlVar.On]: 0,
    [ControlVar.OutlineOn]: isRadio ? 1 : 0,
    [selectors.focusSelector]: {
      [Var.borderColor]: `var(${ColorVar.borderFocusColor})`,
      [Var.borderWidth]: `var(${GeometryVar.focusedBorderWidth})`,
      [ControlVar.OutlineOn]: 1
    },
    [selectors.selectedSelector]: {
      [Var.borderColor]: `var(${ColorVar.borderCheckedColor})`,
      [ControlVar.On]: 1,
      [ControlVar.OutlineOn]: isRadio ? 6 : 0
    },
    [`${selectors.hoverSelectedSelector}, ${selectors.hoverUnselectedSelector}`]: {
      [Var.borderColor]: `var(${ColorVar.borderHoverColor})`,
      [Var.borderWidth]: `var(${GeometryVar.hoverBorderWidth})`
    },
    [selectors.disabledSelector]: {
      [Var.bg]: `var(${ColorVar.disabledBg})`,
      [Var.borderWidth]: `var(${GeometryVar.defaultBorderWidth})`,
      [Var.borderColor]: `var(${ColorVar.borderDisabledColor})`
    },
    // Only show focus indicators when use keyboard (Tab) for navigation
    ".js-focus-visible input:focus:not(.focus-visible) ~ &": isRadio ? {
      [Var.borderWidth]: `var(${GeometryVar.defaultBorderWidth})`
    } : {
      [Var.borderWidth]: `var(${GeometryVar.defaultBorderWidth})`,
      [ControlVar.OutlineOn]: 0
    },
    "input:focus:not(:focus-visible) ~ &": isRadio ? {
      [Var.borderWidth]: `var(${GeometryVar.defaultBorderWidth})`
    } : {
      [Var.borderWidth]: `var(${GeometryVar.defaultBorderWidth})`,
      [ControlVar.OutlineOn]: 0
    }
  }, isSwitch ? {
    [selectors.focusUnselectedToggleSelector]: {
      [Var.boxShadow]: `
              0px 0px 0px 1px var(${ControlVar.OutlineColor}), 
              0px 0px 0px 5px var(${ControlVar.BorderColor})
            `
    },
    [selectors.focusUnselectedToggleKnobSelector]: {
      [Var.boxShadow]: `
              0px 0px 0px 2px var(${ControlVar.BorderColor})
            `
    },
    [selectors.focusSelectedToggleKnobSelector]: {
      [Var.boxShadow]: `
              inset 0px 0px 0px 2px var(${ControlVar.BorderColor})
            `
    }
  } : {
    [selectors.hoverUnselectedToggleSelector]: {
      [Var.boxShadow]: `
              inset 0 0 0 2px var(${ControlVar.BorderColor}),
              0 0 0 ${outlineWidth} var(${ControlVar.OutlineColor})
            `
    },
    [selectors.hoverUnselectedDisabledToggleSelector]: {
      [Var.boxShadow]: `
              inset 0 0 0 1px var(${ControlVar.BorderColor}),
              0 0 0 ${outlineWidth} var(${ControlVar.OutlineColor})
            `
    },
    [selectors.focusUnselectedToggleSelector]: {
      [Var.boxShadow]: `
            0px 0px 0px 1px var(${ControlVar.OutlineColor}), 
            0px 0px 0px 5px var(${ControlVar.BorderColor}), 
            inset 0px 0px 0px 1px var(${ControlVar.BorderColor});
          `
    },
    [selectors.focusSelectedToggleSelector]: {
      [Var.boxShadow]: `
            0px 0px 0px 1px var(${ControlVar.OutlineColor}), 
            0px 0px 0px 5px var(${ControlVar.BorderColor}), 
            inset 0px 0px 0px 1px var(${ControlVar.BorderColor});
          `
    }
  }, isRadio && {
    [selectors.focusSelectedToggleSelector]: {
      [Var.boxShadow]: `
            0px 0px 0px 1px var(${ControlVar.OutlineColor}), 
            0px 0px 0px 4px var(${ControlVar.BorderColor}), 
            inset 0px 0px 0px 5px var(${ControlVar.BorderColor});
          `
    }
  }, {
    padding: `var(${GeometryVar.gutterV}) var(${GeometryVar.gutterH})`,
    borderRadius: `var(${GeometryVar.borderRadius})`,
    width: "100%",
    display: "inline-grid",
    alignItems,
    gap: `var(${GeometryVar.itemSpacing})`,
    gridTemplateAreas,
    gridTemplateColumns,
    boxShadow: `inset 0 0 0 var(${Var.borderWidth}) var(${Var.borderColor})`,
    backgroundColor: `var(${Var.bg})`,
    cursor: "pointer",
    color: `var(${ColorVar.labelColor})`,
    transition: "box-shadow 200ms",
    "input:disabled ~ &": {
      cursor: "not-allowed"
    },
    [`${selectors.focusUnselectedToggleSelector}, ${selectors.focusSelectedToggleSelector}`]: {
      boxShadow: `var(${Var.boxShadow})`
    },
    [selectors.hoverUnselectedToggleSelector]: {
      boxShadow: `var(${Var.boxShadow})`
    },
    [selectors.focusUnselectedToggleKnobSelector]: {
      boxShadow: `var(${Var.boxShadow})`
    },
    [selectors.focusSelectedToggleKnobSelector]: {
      boxShadow: `var(${Var.boxShadow})`
    }
  }, props.variant === ToggleVariant.ControlOnly ? {
    gap: 0,
    width: "auto"
  } : null];
};
const toggleInputStyle = {
  width: "1px",
  height: "1px",
  opacity: 0,
  position: "absolute",
  top: 0,
  left: 0
};
const toggleLabelStyle = {
  fontWeight: FontWeight.SemiBold
};
const toggleDescriptionStyle = {
  color: `var(${ColorVar.descriptionColor})`
};
const toggleStyle = (theme, props) => {
  return [toggleGeometryStyle(theme, props.variant), toggleColorStyle(theme, props), {
    display: props.variant === ToggleVariant.ControlOnly ? "inline-block" : "block",
    position: "relative"
  }];
};
const checkboxesToggleStyle = (theme, props) => {
  const selectors = {
    focusSelector: "&:focus-visible",
    selectedSelector: "&[aria-checked=true], &[aria-checked=mixed]",
    disabledSelector: "&:disabled",
    disabledUnselectedSelector: "&:not(:checked):disabled",
    hoverUnselectedSelector: "&:hover[aria-checked=false]",
    hoverSelectedSelector: "&:hover[aria-checked=true], &:hover[aria-checked=mixed]",
    focusSelectedSelector: "input:checked:focus ~ &:hover",
    // additional selectors to accommodate styling the toggles from the parent
    focusSelectedToggleSelector: "&:focus[aria-checked=true] > div > span[role=presentation], &:focus[aria-checked=mixed] > div > span[role=presentation]",
    focusUnselectedToggleSelector: "&:focus > div > span[role=presentation]"
  };
  return [toggleGeometryStyle(theme, props.variant), toggleColorStyle(theme, props), controlStyle(theme, {
    colorScheme: props.colorScheme,
    control: ToggleControl.Check,
    ...selectors
  }), {
    padding: 0,
    background: "none",
    border: "none",
    display: "inline-grid",
    alignItems: "baseline",
    gridAutoFlow: "column",
    gridTemplate: "max-content auto",
    columnGap: `var(${GeometryVar.itemSpacing})`,
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    fontWeight: FontWeight.SemiBold,
    cursor: "pointer",
    color: `var(${ColorVar.labelColor})`,
    [ControlVar.On]: 0,
    [ControlVar.OutlineOn]: 0,
    [selectors.focusSelector]: {
      [ControlVar.OutlineOn]: 1,
      outline: "none"
    },
    [selectors.selectedSelector]: {
      [ControlVar.On]: 1
    },
    [selectors.disabledSelector]: {
      cursor: "not-allowed"
    },
    [selectors.focusUnselectedToggleSelector]: {
      [Var.boxShadow]: `
        0px 0px 0px 1px var(${ControlVar.OutlineColor}), 
        0px 0px 0px 5px var(${ControlVar.BorderColor}), 
        inset 0px 0px 0px 1px var(${ControlVar.BorderColor});
      `
    },
    [selectors.focusSelectedToggleSelector]: {
      [Var.boxShadow]: `
        0px 0px 0px 1px var(${ControlVar.OutlineColor}), 
        0px 0px 0px 5px var(${ControlVar.BorderColor}), 
        inset 0px 0px 0px 1px var(${ControlVar.BorderColor});
      `
    },
    // Only show focus indicators when use keyboard (Tab) for navigation
    ".js-focus-visible input:focus:not(.focus) ~ &": {
      [ControlVar.OutlineOn]: 0
    },
    "input:focus-visible:not(:focus) ~ &": {
      [ControlVar.OutlineOn]: 0
    },
    "&:focus-visible[aria-checked=true] > div > span, &:focus-visible[aria-checked=mixed] > div > span, &:focus-visible > div > span": {
      boxShadow: `var(${Var.boxShadow})`,
      backgroundColor: props.colorScheme === ColorScheme.OnDark ? theme.color(Color.Brownstone_50) : theme.color(Color.Greystone_1400)
    },
    "&:focus-visible > div > span[role=presentation]": {
      backgroundColor: "transparent"
    }
  }];
};

const trackWidth = "36px";
const trackHeight = "20px";
const knobSize = "16px";
const outlineSize = "2px";
const offOffset = outlineSize;
const onOffset = `${trackWidth} - ${knobSize} - ${outlineSize} - calc(var(${ControlVar.On}) * ${outlineSize})`;
const offset = `calc(var(${ControlVar.On}) * (${onOffset}) + ${offOffset})`;
const toggleSwitchStyle = {
  width: trackWidth,
  height: trackHeight,
  borderRadius: trackWidth,
  display: "flex",
  alignItems: "center",
  backgroundColor: `var(${ControlVar.Bg})`,
  boxShadow: `0 0 0 calc(var(${ControlVar.OutlineOn}) * ${outlineSize}) var(${ControlVar.OutlineColor})`,
  transition: "box-shadow 100ms",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "box-shadow 50ms"
  },
  "&:after": {
    content: '""',
    width: knobSize,
    height: knobSize,
    borderRadius: knobSize,
    backgroundColor: `var(${ControlVar.Fg})`,
    transform: `translate3d(${offset}, 0, 0)`,
    transition: "transform 100ms ease-out",
    boxShadow: `0 0 0 ${outlineSize} var(${ControlVar.BorderColor})`,
    "@media (prefers-reduced-motion: reduce)": {
      transition: "transform 50ms ease-out"
    }
  },
  "&:focus-visible:after": {
    boxShadow: `inset 0 0 0 ${outlineSize} var(${ControlVar.BorderColor})`
  }
};
const ToggleSwitch = () => {
  return jsx("span", {
    css: toggleSwitchStyle,
    role: "presentation"
  });
};

const controlArea = {
  gridArea: "control"
};
const mediaArea = {
  gridArea: "media"
};
const contentArea = {
  gridArea: "content",
  alignSelf: "center"
};
const Control = ({
  type
}) => {
  switch (type) {
    case ToggleControl.Check:
      return jsx(ToggleCheck, {});
    case ToggleControl.Radio:
      return jsx(ToggleRadio, {});
    case ToggleControl.Switch:
      return jsx(ToggleSwitch, {});
  }
};
const Toggle = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    description,
    media,
    control = ToggleControl.Check,
    colorScheme = ColorScheme.OnLight,
    controlPosition = ToggleControlPosition.Start,
    variant = ToggleVariant.Emphasized,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const styleProps = {
    control,
    controlPosition,
    colorScheme,
    variant
  };
  let contents = jsxs(Fragment, {
    children: [media ? jsx("div", {
      css: mediaArea,
      children: media
    }) : null, jsxs("div", {
      css: contentArea,
      children: [jsx("div", {
        css: toggleLabelStyle,
        children: children
      }), description ? jsx("div", {
        css: toggleDescriptionStyle,
        children: description
      }) : null]
    })]
  });
  if (styleProps.variant === ToggleVariant.ControlOnly) {
    contents = jsx(VisuallyHidden, {
      children: contents
    });
  }
  return jsxs("label", {
    css: toggleStyle(theme, styleProps),
    "data-field-control": true,
    children: [jsx("input", {
      css: toggleInputStyle,
      ...rest,
      ref: ref
    }), jsxs("div", {
      css: toggleBodyStyle(theme, {
        ...styleProps,
        hasMedia: !!media
      }),
      children: [jsx("div", {
        css: controlArea,
        role: "presentation",
        children: jsx(Control, {
          type: control
        })
      }), contents]
    })]
  });
});

const ariaCheckedMapping = {
  all: "true",
  none: "false",
  mixed: "mixed"
};
const nextStates = {
  all: "none",
  none: "all",
  mixed: "none"
};
const CheckboxesToggle = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    value,
    onChange,
    colorScheme = ColorScheme.OnLight,
    variant = ToggleVariant.Compact,
    children,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const styleProps = {
    colorScheme,
    variant,
    control: ToggleControl.Check,
    controlPosition: ToggleControlPosition.Start
  };
  return jsxs("button", {
    css: checkboxesToggleStyle(theme, styleProps),
    ...rest,
    type: "button",
    role: "checkbox",
    "aria-checked": ariaCheckedMapping[value],
    onClick: e => {
      var _rest$onClick;
      onChange(nextStates[value]);
      (_rest$onClick = rest.onClick) === null || _rest$onClick === void 0 ? void 0 : _rest$onClick.call(rest, e);
    },
    "data-field-control": true,
    ref: ref,
    children: [jsx("div", {
      children: jsx(ToggleCheck, {
        indeterminate: value === "mixed"
      })
    }), variant === ToggleVariant.ControlOnly ? jsx(VisuallyHidden, {
      children: children
    }) : jsx("div", {
      children: children
    })]
  });
});

const Radio = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
  const {
    variant = ToggleVariant.Compact,
    colorScheme = ColorScheme.OnLight,
    controlPosition = ToggleControlPosition.Start,
    ...rest
  } = props;
  const radioStyleProps = {
    variant,
    colorScheme,
    controlPosition,
    ...rest
  };
  return jsx(Toggle, {
    ...radioStyleProps,
    control: ToggleControl.Radio,
    type: "radio",
    ref: ref
  });
});

const Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
  const {
    variant = ToggleVariant.Compact,
    colorScheme = ColorScheme.OnLight,
    controlPosition = ToggleControlPosition.Start,
    ...rest
  } = props;
  const checkboxStyleProps = {
    variant,
    colorScheme,
    controlPosition,
    ...rest
  };
  return jsx(Toggle, {
    ...checkboxStyleProps,
    control: ToggleControl.Check,
    type: "checkbox",
    ref: ref
  });
});

const leftAccessorySizeTokens = size => {
  switch (size) {
    case AccessorySize.Sm:
      return {
        dimension: "14px",
        paddingLeft: "32px"
      };
    case AccessorySize.Lg:
      return {
        dimension: "24px",
        paddingLeft: "40px"
      };
    default:
      return {
        dimension: "20px",
        paddingLeft: "36px"
      };
  }
};
const selectContainerStyle = {
  position: "relative"
};
const selectStyle = (theme, props) => {
  const {
    gutter,
    status,
    disabled,
    leftAccessory,
    leftAccessorySize
  } = props;
  const padding = inputGutterStyle(theme, {
    size: gutter
  });
  const statusColors = resolveStatusColors(theme, {
    status: status,
    disabled: disabled
  });
  const {
    baseBorderColor,
    textColor,
    backgroundColor,
    focusBorderColor
  } = statusColors;
  return [padding, {
    display: "block",
    width: "100%",
    border: "none",
    borderRadius: theme.radius(0.5),
    appearance: "none",
    // make room for the icon
    paddingRight: `calc(${theme.spacing(0.75)} + 24px)`,
    ...(leftAccessory ? {
      paddingLeft: `calc(${theme.spacing(0.75)} + ${leftAccessorySizeTokens(leftAccessorySize).paddingLeft})`
    } : {}),
    boxShadow: `inset 0 0 0 1px ${baseBorderColor}`,
    color: textColor,
    fontFamily: "inherit",
    backgroundColor,
    ...theme.tokens.fontSizes[TypeScale.Size_03],
    "&:focus": {
      outline: "none",
      boxShadow: `inset 0 0 0 2px ${focusBorderColor}`
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: "unset"
    }
  }];
};
const iconStyle = (theme, {
  status,
  disabled
}) => {
  const {
    iconColor
  } = resolveStatusColors(theme, {
    status,
    disabled
  });
  return {
    position: "absolute",
    right: theme.spacing(0.75),
    top: "50%",
    transform: `translate3d(-6px, -50%, 0)`,
    color: iconColor,
    pointerEvents: "none"
  };
};
const leftSelectAccessoryStyle = (theme, {
  leftAccessorySize
}) => {
  const {
    dimension
  } = leftAccessorySizeTokens(leftAccessorySize);
  return {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    left: theme.spacing(1.5),
    top: "50%",
    transform: `translate3d(-6px, -50%, 0)`,
    pointerEvents: "none",
    maxHeight: dimension,
    maxWidth: dimension,
    overflow: Overflow.Hidden
  };
};
const Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    status,
    gutter,
    leftAccessory,
    leftAccessorySize,
    ...rest
  } = props;
  return jsxs("div", {
    css: selectContainerStyle,
    "data-field-control": true,
    children: [React.Children.count(leftAccessory) ? jsx("div", {
      css: leftSelectAccessoryStyle(theme, props),
      children: leftAccessory
    }) : null, jsx("select", {
      css: selectStyle(theme, props),
      ref: ref,
      ...rest
    }), jsx(Icon, {
      name: Glyph.ChevronDown,
      size: "12px",
      css: iconStyle(theme, props)
    })]
  });
});

const useResizeObserver = (/** The element to observe. */
elementRef, /** A callback to call on resize. */
callback,
/**
 * An optional list of dependencies to track in the underlying use effect.
 *
 * For example, if a tooltip element is conditionally rendered then elementRef
 * will contain a null reference until some `open` prop is true. Adding the
 * `open` prop to the deps list will setup the resize observer when the
 * tooltip is rendered.
 */
deps = []) => {
  React__default.useEffect(() => {
    if (typeof window === "undefined" || window.document == null) {
      return;
    }
    const el = elementRef.current;
    if (!el) {
      return;
    }
    // If ResizeObserver is not available for a browser then use a traditional
    // window resize event listener
    const handleResize = () => {
      callback();
    };
    if (typeof window.ResizeObserver === "undefined") {
      window.addEventListener("resize", handleResize, false);
      return () => window.removeEventListener("resize", handleResize, false);
    } else {
      const ro = new ResizeObserver(entries => {
        if (!entries.length) {
          return;
        }
        handleResize();
      });
      ro.observe(el);
      return () => {
        if (!el) {
          return;
        }
        ro.unobserve(el);
      };
    }
  }, [elementRef, callback, ...deps]);
};
/**
 * A hook that triggers a callback when the page, or a reference, scrollable
 * element, are scrolled.
 */
const useScrollObserver = options => {
  const {
    scrollReference,
    callback,
    enabled
  } = options;
  React__default.useEffect(() => {
    if (!enabled) {
      return;
    }
    let reference;
    if (scrollReference === "document") {
      reference = document;
    } else {
      reference = scrollReference.current;
    }
    if (!reference) {
      return;
    }
    const handler = () => {
      callback();
    };
    reference.addEventListener("scroll", handler, {
      passive: true
    });
    return () => {
      if (!reference) {
        return;
      }
      reference.removeEventListener("scroll", handler);
    };
  }, [scrollReference, callback, enabled]);
};

const getDocumentBody$1 = () => {
  if (typeof document === "undefined" || typeof document.body === "undefined") {
    return null;
  }
  return document.body;
};
const placementMiddleware$1 = options => {
  const {
    placementStrategy,
    initialPlacement
  } = options;
  if (placementStrategy === "static") {
    return [];
  }
  if (initialPlacement || placementStrategy === "flip") {
    // When deciding the set of allowed placements for a tooltip using flip
    // strategy, we will bias this based on the initial placement. For example,
    // if the initial placement is "top-start" then we will assume we can
    // reposition the tooltip above and below its trigger. This is a sensible
    // default behaviour that tries to avoid having the tooltip cover content to
    // the left or right of its trigger. A similar assumption is made if the
    // initial placement is left-* or right-*.
    const majorEdge = initialPlacement ? initialPlacement.split("-")[0] : "top";
    const fallbackPlacements = [];
    if (majorEdge === "left" || majorEdge === "right") {
      fallbackPlacements.push("left", "left-start", "left-end", "right", "right-start", "right-end");
    } else {
      fallbackPlacements.push("top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end");
    }
    return [flip({
      fallbackStrategy: "bestFit",
      fallbackPlacements
    })];
  }
  return [autoPlacement()];
};
const useTooltip = options => {
  const {
    open = false,
    arrowRef,
    initialPlacement,
    placementStrategy,
    offsetPadding,
    positionStrategy = "fixed",
    sameWidth
  } = options;
  const placement = placementStrategy === "auto" ? initialPlacement : initialPlacement || "top";
  const result = useFloating$1({
    strategy: positionStrategy,
    placement,
    middleware: [...placementMiddleware$1({
      initialPlacement: placement,
      placementStrategy
    }), ...(arrowRef ? [arrow({
      element: arrowRef,
      padding: offsetPadding
    })] : []),
    // This is the pixel offset of the tooltip from its reference and needs to
    // be adjust to account for the arrow.
    offset$1(8), ...(sameWidth ? [size({
      apply({
        rects,
        elements
      }) {
        Object.assign(elements.floating.style, {
          width: `${rects.reference.width}px`
        });
      }
    })] : [])]
  });
  const {
    update
  } = result;
  // // We need to track the size of the document so we can reposition the tooltip
  // // if it changes.
  const documentRef = useRef(getDocumentBody$1());
  useResizeObserver(documentRef, update, [open]);
  useResizeObserver(result.refs.floating, update, [open]);
  // // We also need to track the browser scroll position to flip the tooltip
  // // reposition if needed.
  useScrollObserver({
    scrollReference: "document",
    callback: update,
    enabled: open && placementStrategy === "flip"
  });
  return result;
};

const useKeyDown = (key, callback) => {
  const callbackRef = useRef(callback);
  if (callback !== callbackRef.current) {
    callbackRef.current = callback;
  }
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === key) {
        callbackRef.current(event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [callbackRef, key]);
};

function usePrevious(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const escapeRegExpString = input =>
// eslint-disable-next-line no-useless-escape
(input !== null && input !== void 0 ? input : "").replace(/([\[\\\^\$\.\|\?\*\+\(\)\]])/g, "\\$1");
const getHighlightedText = (text, highlight) => {
  var _text$toString;
  const parsedText = text === undefined ? "" : (_text$toString = text === null || text === void 0 ? void 0 : text.toString()) !== null && _text$toString !== void 0 ? _text$toString : "";
  if (!parsedText.trim() || !(highlight !== null && highlight !== void 0 && highlight.trim())) {
    return parsedText;
  }
  const rx = escapeRegExpString(highlight);
  // Split on highlight term and include term into parts, ignore case
  const parts = parsedText.split(new RegExp(`(${rx})`, "gi"));
  return parts.map((part, i) => {
    const isHighlighted = part.toLowerCase() === highlight.toLowerCase();
    return jsx(Text, {
      weight: isHighlighted ? FontWeight.SemiBold : FontWeight.Normal,
      color: ColorPreset.TextOnLight_01,
      children: part
    }, i.toString());
  });
};
const ListItem = /*#__PURE__*/forwardRef(({
  children,
  leftAccessory,
  rightAccessory,
  description,
  highlightText = "",
  isSelected,
  isHighlighted,
  ...rest
}, ref) => jsxs(Box, {
  bg: isHighlighted ? ColorPreset.BackgroundLight_03 : Color.Transparent,
  ref: ref,
  gutterH: 1,
  gutterV: 0.5,
  borderRadius: 0.25,
  style: {
    width: "100%"
  },
  ...rest,
  children: [jsx(Box, {
    layout: "flex",
    alignItems: AlignItems.Center,
    justifyContent: JustifyContent.SpaceBetween,
    children: jsxs(Box, {
      layout: "flex",
      alignItems: AlignItems.Center,
      justifyContent: JustifyContent.Center,
      width: "100%",
      children: [jsx(Box, {
        layout: "flex",
        alignItems: AlignItems.FlexStart,
        children: leftAccessory
      }), jsx(Box, {
        layout: "inline-block",
        flexGrow: 1,
        spaceBefore: leftAccessory ? 0.5 : 0,
        spaceAfter: leftAccessory ? 0.5 : 0,
        maxWidth: "100%",
        minWidth: 6,
        children: typeof children === "string" ? jsx(Text, {
          children: getHighlightedText(children, highlightText)
        }) : children
      }), isSelected ? jsx(Icon, {
        name: Glyph.TickSmall,
        color: ColorPreset.TextOnLight_01
      }) : null, jsx(Box, {
        layout: "flex",
        alignItems: AlignItems.FlexStart,
        children: rightAccessory
      })]
    })
  }), description ? jsx(Box, {
    width: "100%",
    children: typeof description === "string" ? jsx(Text, {
      preset: TypePreset.Body_01,
      children: getHighlightedText(description, highlightText)
    }) : description
  }) : null]
}));

const noop$7 = () => {};
const getListHeight = listRef => {
  var _listRef$current;
  return Math.round(((_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.clientHeight) || 0);
};
const getRowHeight = element => Math.round((element === null || element === void 0 ? void 0 : element.clientHeight) || 0);
const useObserveElementHeight = ref => {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (ref.current) {
      const {
        offsetHeight
      } = ref.current;
      if (offsetHeight !== height) {
        setHeight(offsetHeight);
      }
      const observable = new ResizeObserver(([entries]) => {
        const observedHeight = (entries === null || entries === void 0 ? void 0 : entries.target).offsetHeight;
        if (observedHeight !== height) {
          setHeight(observedHeight);
        }
      });
      observable.observe(ref.current);
      return () => {
        observable.disconnect();
      };
    }
    setHeight(0);
    return noop$7;
  }, [ref.current, height]);
  return height;
};
// Calculate the actual height of the list based on various parameters
const calcActualListHeight = ({
  heightRestriction,
  minListHeight,
  maxListHeight,
  verticalListPadding,
  screenPadding,
  headerHeight,
  footerHeight
}) => {
  if (!heightRestriction) {
    return maxListHeight - verticalListPadding;
  }
  const staticElementsTotalHeight = (headerHeight !== null && headerHeight !== void 0 ? headerHeight : 0) + (footerHeight !== null && footerHeight !== void 0 ? footerHeight : 0);
  // there is no header nor footer
  // Check if the total height of static elements is zero
  if (staticElementsTotalHeight === 0) {
    // If the minimum list height exceeds the height restriction
    if (minListHeight > heightRestriction) {
      // Return the adjusted minimum list height by subtracting vertical padding
      return minListHeight - verticalListPadding;
    }
    // If the maximum list height exceeds the height restriction
    if (maxListHeight > heightRestriction) {
      // Return the adjusted height restriction by subtracting vertical list padding and screen padding
      return heightRestriction - verticalListPadding - screenPadding;
    }
    // If neither the minimum nor maximum list height exceeds the height restriction
    // Return the adjusted maximum list height by subtracting vertical padding
    return maxListHeight - verticalListPadding;
  }
  // else there is header and/or a footer
  // Calculate the modified minimum list height by subtracting the total height of static elements
  const minListHeightModified = minListHeight - staticElementsTotalHeight;
  // Calculate the modified maximum list height by subtracting the total height of static elements
  const maxListHeightModified = maxListHeight - staticElementsTotalHeight;
  // If the modified minimum list height exceeds the height restriction
  if (minListHeightModified > heightRestriction) {
    // Return the adjusted modified minimum list height by subtracting vertical padding
    return minListHeightModified - verticalListPadding;
  }
  // If the modified maximum list height exceeds the adjusted height restriction with static elements taken into account
  if (maxListHeightModified > heightRestriction - staticElementsTotalHeight) {
    // Return the adjusted height restriction with static elements taken into account
    // by subtracting static elements total height, vertical list padding, and screen padding
    return heightRestriction - staticElementsTotalHeight - verticalListPadding - screenPadding;
  }
  // If neither the modified minimum nor modified maximum list height exceeds the height restriction
  // Return the adjusted modified maximum list height by subtracting vertical padding
  return maxListHeightModified - verticalListPadding;
};
const calcListHeight = ({
  scrollableAreaHeight,
  ...args
}) => {
  const calculatedListHeight = calcActualListHeight(args);
  if (calculatedListHeight > scrollableAreaHeight) {
    return scrollableAreaHeight;
  }
  return calculatedListHeight;
};

var Direction;
(function (Direction) {
  Direction[Direction["Up"] = -1] = "Up";
  Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
const inactiveIndex = -1;
const firstItemIndex = 0;
const useListKeyboardNav = ({
  items = [],
  onChange,
  searchInput,
  searchable,
  focusListOnMount,
  innerVirtualizeListRef,
  ...rest
}) => {
  // the ref is applied to the container of the search input
  const searchInputRef = useRef(null);
  // this ref is applied to very outer the list wrapper
  const listRef = useRef(null);
  // ref for the header element
  const headerRef = useRef(null);
  const footerRef = useRef(null);
  // create 2 refs that are assigned to the virtual list
  const virtualListRef = useRef((innerVirtualizeListRef === null || innerVirtualizeListRef === void 0 ? void 0 : innerVirtualizeListRef.current) || null);
  const innerListRef = useRef(null);
  // the focussed index is the index of the item that we have highlighted using
  // keyboard or mouse navigation.
  const [focussedIndex, setFocussedIndex] = useState(rest.focussedIndex !== undefined && rest.focussedIndex >= 0 ? rest.focussedIndex : inactiveIndex);
  // search input value
  const [searchInputVal, setSearchInputVal] = useState((searchInput === null || searchInput === void 0 ? void 0 : searchInput.value) || "");
  // store the total calculated height of all rendered items in the list
  const [listTotalHeight, setListTotalHeight] = useState(0);
  // determine the index of the last item
  const lastItemIndex = items.length;
  useEffect(() => {
    const height = getListHeight(innerListRef);
    if (height !== listTotalHeight) {
      setListTotalHeight(height);
    }
  }, [items, listTotalHeight]);
  useEffect(() => {
    if (focusListOnMount && !searchable) {
      var _listRef$current;
      listRef === null || listRef === void 0 ? void 0 : (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.focus({
        preventScroll: true
      });
    }
    if (focusListOnMount && !!searchable && (searchInput === null || searchInput === void 0 ? void 0 : searchInput.autoFocus) !== false) {
      var _searchInputRef$curre;
      searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus({
        preventScroll: true
      });
    }
  }, [focusListOnMount, searchInput === null || searchInput === void 0 ? void 0 : searchInput.autoFocus, searchable]);
  /**
   * bring the list item with the given index into the viewport incase it's not.
   */
  const bringListItemIntoView = useCallback(index => {
    var _virtualListRef$curre;
    if ((_virtualListRef$curre = virtualListRef.current) !== null && _virtualListRef$curre !== void 0 && _virtualListRef$curre.scrollToItem) {
      var _virtualListRef$curre2;
      (_virtualListRef$curre2 = virtualListRef.current) === null || _virtualListRef$curre2 === void 0 ? void 0 : _virtualListRef$curre2.scrollToItem(index, "smart");
    } else {
      var _innerListRef$current;
      ((_innerListRef$current = innerListRef.current) === null || _innerListRef$current === void 0 ? void 0 : _innerListRef$current.children[index]).scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
    }
  }, []);
  /**
   * get the index of the next active item based on the direction
   * we've passed in
   */
  const getNextActiveIndex = useCallback(direction => {
    const newActiveIndex = focussedIndex + direction;
    if (newActiveIndex < firstItemIndex) {
      return focussedIndex;
    }
    if (newActiveIndex + 1 > lastItemIndex) {
      return focussedIndex;
    }
    return newActiveIndex;
  }, [focussedIndex, lastItemIndex]);
  // handle keyboard navigation
  const handleArrowKeys = useCallback(e => {
    const isModified = e.metaKey || e.ctrlKey;
    let newActiveIndex = focussedIndex;
    if (e.key === "ArrowUp") {
      e.preventDefault();
      newActiveIndex = isModified ? firstItemIndex : getNextActiveIndex(Direction.Up);
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      newActiveIndex = isModified ? lastItemIndex - 1 : getNextActiveIndex(Direction.Down);
    }
    if (e.key === "Home") {
      e.preventDefault();
      newActiveIndex = firstItemIndex;
    }
    if (e.key === "End") {
      e.preventDefault();
      newActiveIndex = lastItemIndex - 1;
    }
    if (newActiveIndex !== focussedIndex) {
      setFocussedIndex(newActiveIndex);
      bringListItemIntoView(newActiveIndex);
    }
  }, [focussedIndex, getNextActiveIndex, lastItemIndex, bringListItemIntoView]);
  // handle selection of item using ENTER
  const handleSelect = useCallback(e => {
    if (e.key === "Enter") {
      e.preventDefault();
      const useItemIndex = focussedIndex;
      const value = items[useItemIndex];
      if (value && onChange) {
        onChange(value);
      }
    }
  }, [focussedIndex, items, onChange]);
  /**
   * All the props that are applied to the search input when the user wants one
   */
  const searchInputProps = useMemo(() => ({
    ...searchInput,
    ref: searchInputRef,
    onKeyDown: e => {
      var _searchInput$onKeyDow;
      handleArrowKeys(e);
      handleSelect(e);
      searchInput === null || searchInput === void 0 ? void 0 : (_searchInput$onKeyDow = searchInput.onKeyDown) === null || _searchInput$onKeyDow === void 0 ? void 0 : _searchInput$onKeyDow.call(searchInput, e);
    },
    value: typeof (searchInput === null || searchInput === void 0 ? void 0 : searchInput.value) === "undefined" ? searchInputVal : searchInput === null || searchInput === void 0 ? void 0 : searchInput.value,
    onFocus: () => {
      setFocussedIndex(firstItemIndex);
    },
    onChange: e => {
      var _searchInput$onChange, _virtualListRef$curre3;
      setFocussedIndex(firstItemIndex);
      setSearchInputVal(e.target.value);
      searchInput === null || searchInput === void 0 ? void 0 : (_searchInput$onChange = searchInput.onChange) === null || _searchInput$onChange === void 0 ? void 0 : _searchInput$onChange.call(searchInput, e);
      (_virtualListRef$curre3 = virtualListRef.current) === null || _virtualListRef$curre3 === void 0 ? void 0 : _virtualListRef$curre3.scrollTo(0);
    }
  }), [searchInputVal, handleArrowKeys, handleSelect, searchInput]);
  /**
   * All the list props are assigned to the list element that contains
   * the items we want to navigate through
   */
  const listProps = useMemo(() => {
    const activeDescendant = focussedIndex !== inactiveIndex ? `item-${focussedIndex + 1}` : undefined;
    return {
      tabIndex: 0,
      ref: listRef,
      role: "listbox",
      "aria-activedescendant": activeDescendant,
      onMouseEnter: () => {
        if (listRef.current) {
          // Only focus on the list itself to activate keyboard navigation
          // if there is no search input in this list.
          if (!searchInputRef.current) {
            listRef.current.focus();
          }
          // if the search input is in the document but not focussed, we
          // focus it, so the user can easily type as well as use keyboard navigation
          if (searchInputRef.current && document.activeElement !== searchInputRef.current) {
            searchInputRef.current.focus();
          }
        }
        // if no list item is highlighted at the moment, highlight the first one
        if (focussedIndex === inactiveIndex) {
          setFocussedIndex(firstItemIndex);
        }
      },
      onFocus: () => {
        if (focussedIndex === inactiveIndex) {
          setFocussedIndex(firstItemIndex);
        }
      },
      onKeyDown: e => {
        // prevent the list from scrolling when pressing space
        if (e.key === "Space") {
          e.preventDefault();
        }
        handleArrowKeys(e);
        handleSelect(e);
      }
    };
  }, [focussedIndex, handleArrowKeys, handleSelect, searchInputRef]);
  /**
   * All the item props are assigned to an individual list item
   */
  const getItemProps = useCallback(({
    index,
    ...userProps
  }) => {
    const id = userProps.id || `item-${index + 1}`;
    const recalculatedIndex = index;
    return {
      id,
      role: "option",
      "aria-selected": index === focussedIndex,
      onMouseMove: () => {
        if (index !== focussedIndex) {
          setFocussedIndex(index);
        }
      },
      onClick: e => {
        e.preventDefault();
        onChange === null || onChange === void 0 ? void 0 : onChange(items[recalculatedIndex]);
        if (userProps.onClick) {
          userProps.onClick(items[recalculatedIndex]);
        }
        // if there is a search input and the user clicks on a list item
        // focus on the search input
        if (searchInputRef.current) {
          if (document.activeElement !== searchInputRef.current) {
            searchInputRef.current.focus();
          }
        }
      }
    };
  }, [items, focussedIndex, onChange]);
  return {
    listTotalHeight,
    focussedIndex,
    searchInputProps,
    listProps,
    getItemProps,
    listRef,
    searchInputVal: typeof (searchInput === null || searchInput === void 0 ? void 0 : searchInput.value) === "undefined" ? searchInputVal : searchInput === null || searchInput === void 0 ? void 0 : searchInput.value,
    virtualListRef,
    innerListRef,
    headerRef,
    footerRef
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$3 = process.env.NODE_ENV === "production" ? {
  name: "rn0o1g",
  styles: "&:focus-visible{outline:none;}"
} : {
  name: "1nwqdbx-ListItemsContainer",
  styles: "&:focus-visible{outline:none;};label:ListItemsContainer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RJdGVtQ29udGFpbmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHMkIiLCJmaWxlIjoiTGlzdEl0ZW1Db250YWluZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gXCJyZWFjdFwiO1xyXG5pbXBvcnQgeyBCb3ggfSBmcm9tIFwiLi4vLi4vbGF5b3V0XCI7XHJcbmV4cG9ydCBjb25zdCBMaXN0SXRlbXNDb250YWluZXIgPSBmb3J3YXJkUmVmKCh7IGNoaWxkcmVuLCAuLi5yZXN0IH0sIHJlZikgPT4ge1xyXG4gICAgcmV0dXJuICg8Qm94IHJlZj17cmVmfSBjc3M9e3tcclxuICAgICAgICAgICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xyXG4gICAgICAgICAgICAgICAgb3V0bGluZTogXCJub25lXCIsXHJcbiAgICAgICAgICAgIH0sXHJcbiAgICAgICAgfX0gey4uLnJlc3R9PlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvQm94Pik7XHJcbn0pO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1MaXN0SXRlbUNvbnRhaW5lci5qc3gubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
const ListItemsContainer = /*#__PURE__*/forwardRef(({
  children,
  ...rest
}, ref) => {
  return jsx(Box, {
    ref: ref,
    css: _ref$3,
    ...rest,
    children: children
  });
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "1hs1hlf",
  styles: "max-height:100%"
} : {
  name: "mealr4-ListWrapper",
  styles: "max-height:100%;label:ListWrapper;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RXcmFwcGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHb1QiLCJmaWxlIjoiTGlzdFdyYXBwZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gXCJyZWFjdFwiO1xyXG5pbXBvcnQgeyBCb3ggfSBmcm9tIFwiLi4vLi4vbGF5b3V0XCI7XHJcbmltcG9ydCB7IENvbG9yLCBDb2xvclByZXNldCwgT3ZlcmZsb3cgfSBmcm9tIFwiLi4vLi4vdGhlbWVcIjtcclxuZXhwb3J0IGNvbnN0IExpc3RXcmFwcGVyID0gZm9yd2FyZFJlZigoeyBmbGlwLCBjaGlsZHJlbiwgLi4ucmVzdCB9LCByZWYpID0+ICg8Qm94IHJlZj17cmVmfSBsYXlvdXQ9XCJmbGV4XCIgZmxleERpcmVjdGlvbj17ZmxpcCA/IFwiY29sdW1uLXJldmVyc2VcIiA6IFwiY29sdW1uXCJ9IGJnPXtDb2xvci5XaGl0ZX0gYm9yZGVyUmFkaXVzPXswLjV9IGJvcmRlcldpZHRoPXsxfSBib3JkZXJDb2xvcj17Q29sb3JQcmVzZXQuQm9yZGVyT25MaWdodF8wMn0gb3ZlcmZsb3dZPXtPdmVyZmxvdy5IaWRkZW59IG92ZXJmbG93WD17T3ZlcmZsb3cuSGlkZGVufSBjc3M9e3sgbWF4SGVpZ2h0OiBcIjEwMCVcIiB9fSB7Li4ucmVzdH0+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9Cb3g+KSk7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUxpc3RXcmFwcGVyLmpzeC5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
const ListWrapper = /*#__PURE__*/forwardRef(({
  flip,
  children,
  ...rest
}, ref) => jsx(Box, {
  ref: ref,
  layout: "flex",
  flexDirection: flip ? "column-reverse" : "column",
  bg: Color.White,
  borderRadius: 0.5,
  borderWidth: 1,
  borderColor: ColorPreset.BorderOnLight_02,
  overflowY: Overflow.Hidden,
  overflowX: Overflow.Hidden,
  css: _ref$2,
  ...rest,
  children: children
}));

const listItemStyle = (_, props) => ({
  listStyleType: props.marker
});
const LI = /*#__PURE__*/React.forwardRef(function LI(props, ref) {
  const {
    theme
  } = useTheme();
  const {
    marker,
    ...rest
  } = props;
  return jsx("li", {
    css: listItemStyle(theme, props),
    ...rest,
    ref: ref
  });
});

const omitAppearanceProps = props => {
  const {
    marker,
    spaceAbove,
    spaceBelow,
    spaceBetween,
    gutterH,
    ...rest
  } = props;
  return rest;
};
const listStyle = (theme, props) => {
  const {
    gutterH,
    marker,
    spaceAbove,
    spaceBelow,
    spaceBetween
  } = props;
  return [{
    margin: 0,
    listStyleType: marker
  }, theme.responsive(gutterH, v => ({
    paddingLeft: theme.spacing(v)
  })), theme.responsive(spaceAbove, v => ({
    marginTop: theme.spacing(v)
  })), theme.responsive(spaceBelow, v => ({
    marginBottom: theme.spacing(v)
  })), theme.responsive(spaceBetween, v => ({
    "li+li": {
      marginTop: theme.spacing(v)
    }
  }))];
};

const UL = /*#__PURE__*/React.forwardRef(function UL(props, ref) {
  const {
    theme
  } = useTheme();
  const filtered = omitTypographyStyleProps(omitAppearanceProps(props));
  const {
    marker = "disc",
    gutterH = 1.5
  } = props;
  return jsx("ul", {
    css: [typographyStyle(theme, props), listStyle(theme, {
      ...props,
      marker,
      gutterH
    }), process.env.NODE_ENV === "production" ? "" : ";label:UL;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVMLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRZ0IiLCJmaWxlIjoiVUwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgUmVhY3QgZnJvbSBcInJlYWN0XCI7XHJcbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSBcIi4uL3RoZW1lXCI7XHJcbmltcG9ydCB7IHR5cG9ncmFwaHlTdHlsZSwgb21pdFR5cG9ncmFwaHlTdHlsZVByb3BzLCB9IGZyb20gXCIuLi90eXBvZ3JhcGh5L2FwcGVhcmFuY2VcIjtcclxuaW1wb3J0IHsgbGlzdFN0eWxlLCBvbWl0QXBwZWFyYW5jZVByb3BzIH0gZnJvbSBcIi4vYXBwZWFyYW5jZVwiO1xyXG5jb25zdCBVTCA9IFJlYWN0LmZvcndhcmRSZWYoZnVuY3Rpb24gVUwocHJvcHMsIHJlZikge1xyXG4gICAgY29uc3QgeyB0aGVtZSB9ID0gdXNlVGhlbWUoKTtcclxuICAgIGNvbnN0IGZpbHRlcmVkID0gb21pdFR5cG9ncmFwaHlTdHlsZVByb3BzKG9taXRBcHBlYXJhbmNlUHJvcHMocHJvcHMpKTtcclxuICAgIGNvbnN0IHsgbWFya2VyID0gXCJkaXNjXCIsIGd1dHRlckggPSAxLjUgfSA9IHByb3BzO1xyXG4gICAgcmV0dXJuICg8dWwgY3NzPXtbXHJcbiAgICAgICAgICAgIHR5cG9ncmFwaHlTdHlsZSh0aGVtZSwgcHJvcHMpLFxyXG4gICAgICAgICAgICBsaXN0U3R5bGUodGhlbWUsIHsgLi4ucHJvcHMsIG1hcmtlciwgZ3V0dGVySCB9KSxcclxuICAgICAgICBdfSB7Li4uZmlsdGVyZWR9IHJlZj17cmVmfS8+KTtcclxufSk7XHJcbmV4cG9ydCBkZWZhdWx0IFVMO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1VTC5qc3gubWFwIl19 */"],
    ...filtered,
    ref: ref
  });
});

const OL = /*#__PURE__*/React.forwardRef(function OL(props, ref) {
  const {
    theme
  } = useTheme();
  const filtered = omitTypographyStyleProps(omitAppearanceProps(props));
  const {
    marker = "decimal",
    gutterH = 1.5
  } = props;
  return jsx("ol", {
    css: [typographyStyle(theme, props), listStyle(theme, {
      ...props,
      marker,
      gutterH
    }), process.env.NODE_ENV === "production" ? "" : ";label:OL;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk9MLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRZ0IiLCJmaWxlIjoiT0wudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgUmVhY3QgZnJvbSBcInJlYWN0XCI7XHJcbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSBcIi4uL3RoZW1lXCI7XHJcbmltcG9ydCB7IHR5cG9ncmFwaHlTdHlsZSwgb21pdFR5cG9ncmFwaHlTdHlsZVByb3BzLCB9IGZyb20gXCIuLi90eXBvZ3JhcGh5L2FwcGVhcmFuY2VcIjtcclxuaW1wb3J0IHsgbGlzdFN0eWxlLCBvbWl0QXBwZWFyYW5jZVByb3BzIH0gZnJvbSBcIi4vYXBwZWFyYW5jZVwiO1xyXG5jb25zdCBPTCA9IFJlYWN0LmZvcndhcmRSZWYoZnVuY3Rpb24gT0wocHJvcHMsIHJlZikge1xyXG4gICAgY29uc3QgeyB0aGVtZSB9ID0gdXNlVGhlbWUoKTtcclxuICAgIGNvbnN0IGZpbHRlcmVkID0gb21pdFR5cG9ncmFwaHlTdHlsZVByb3BzKG9taXRBcHBlYXJhbmNlUHJvcHMocHJvcHMpKTtcclxuICAgIGNvbnN0IHsgbWFya2VyID0gXCJkZWNpbWFsXCIsIGd1dHRlckggPSAxLjUgfSA9IHByb3BzO1xyXG4gICAgcmV0dXJuICg8b2wgY3NzPXtbXHJcbiAgICAgICAgICAgIHR5cG9ncmFwaHlTdHlsZSh0aGVtZSwgcHJvcHMpLFxyXG4gICAgICAgICAgICBsaXN0U3R5bGUodGhlbWUsIHsgLi4ucHJvcHMsIG1hcmtlciwgZ3V0dGVySCB9KSxcclxuICAgICAgICBdfSB7Li4uZmlsdGVyZWR9IHJlZj17cmVmfS8+KTtcclxufSk7XHJcbmV4cG9ydCBkZWZhdWx0IE9MO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1PTC5qc3gubWFwIl19 */"],
    ...filtered,
    ref: ref
  });
});

var DLLayout;
(function (DLLayout) {
  DLLayout["Stack"] = "stack";
  DLLayout["Row"] = "row";
  DLLayout["RowFixedTerm"] = "row-fixed-term";
})(DLLayout || (DLLayout = {}));

const vars$c = {
  templateColumns: "--dl-template-cols",
  rowGap: "--dl-row-gap",
  dtGridColumn: "--dl-dt-grid-col",
  ddGridColumn: "--dl-dd-grid-col",
  dtSpaceBelow: "--dl-dt-space-below",
  ddSpaceBelow: "--dl-dd-space-below"
};
const dlStackLayout = theme => ({
  [vars$c.templateColumns]: "1fr",
  [vars$c.rowGap]: 0,
  [vars$c.dtGridColumn]: "auto",
  [vars$c.ddGridColumn]: "auto",
  [vars$c.dtSpaceBelow]: theme.spacing(0.25),
  [vars$c.ddSpaceBelow]: theme.spacing(1.5)
});
const dlRowLayout = theme => ({
  [vars$c.templateColumns]: `1fr ${theme.spacing(1.5)} 1fr`,
  [vars$c.rowGap]: theme.spacing(1),
  [vars$c.dtGridColumn]: 1,
  [vars$c.ddGridColumn]: 3,
  [vars$c.ddSpaceBelow]: 0,
  [vars$c.dtSpaceBelow]: 0
});
const dlRowFixedTermLayout = theme => ({
  [vars$c.templateColumns]: `max-content ${theme.spacing(1.5)} 1fr`,
  [vars$c.rowGap]: theme.spacing(1),
  [vars$c.dtGridColumn]: 1,
  [vars$c.ddGridColumn]: 3,
  [vars$c.ddSpaceBelow]: 0,
  [vars$c.dtSpaceBelow]: 0
});
const dlStyle = (theme, props) => {
  return [theme.responsive(props.layout, layout => {
    switch (layout) {
      case DLLayout.Row:
        return dlRowLayout(theme);
      case DLLayout.RowFixedTerm:
        return dlRowFixedTermLayout(theme);
      default:
        return dlStackLayout(theme);
    }
  }), {
    display: "grid",
    alignItems: "baseline",
    overflow: "auto",
    margin: 0,
    gridTemplateColumns: `var(${vars$c.templateColumns})`,
    rowGap: `var(${vars$c.rowGap})`,
    "> dt": {
      gridColumn: `var(${vars$c.dtGridColumn})`,
      marginBottom: `var(${vars$c.dtSpaceBelow})`
    },
    "> dd": {
      gridColumn: `var(${vars$c.ddGridColumn})`,
      marginBottom: `var(${vars$c.ddSpaceBelow})`
    },
    "> dd:last-of-type": {
      marginBottom: 0
    }
  }, theme.responsive(props.spaceAbove, v => ({
    marginTop: theme.spacing(v)
  })), theme.responsive(props.spaceBelow, v => ({
    marginBottom: theme.spacing(v)
  }))];
};
const dtStyle = (theme, props) => {
  return typographyStyle(theme, props);
};
const ddStyle = (theme, props) => {
  return [{
    margin: 0
  }, typographyStyle(theme, props)];
};
const dlAccessoryStyle = (theme, position) => ({
  marginLeft: position === "right" ? theme.spacing(0.5) : undefined,
  marginRight: position === "left" ? theme.spacing(0.5) : undefined
});

const DL = props => {
  const {
    theme
  } = useTheme();
  const {
    layout = DLLayout.Row,
    spaceAbove = 0,
    spaceBelow = 0,
    ...rest
  } = props;
  return jsx("dl", {
    css: dlStyle(theme, {
      layout,
      spaceAbove,
      spaceBelow
    }),
    ...rest,
    children: props.children
  });
};

const DT = props => {
  const {
    theme
  } = useTheme();
  const {
    leftAccessory,
    children,
    ...rest
  } = omitTypographyStyleProps(props);
  return jsxs("dt", {
    css: dtStyle(theme, props),
    ...rest,
    children: [leftAccessory && React.Children.count(leftAccessory) > 0 ? jsx("span", {
      css: dlAccessoryStyle(theme, "left"),
      children: leftAccessory
    }) : null, jsx("span", {
      children: children
    })]
  });
};

const DD = props => {
  const {
    theme
  } = useTheme();
  const {
    weight = FontWeight.SemiBold
  } = props;
  const {
    rightAccessory,
    children,
    ...rest
  } = omitTypographyStyleProps(props);
  return jsxs("dd", {
    css: ddStyle(theme, {
      ...props,
      weight
    }),
    ...rest,
    children: [jsx("span", {
      children: children
    }), rightAccessory && React.Children.count(rightAccessory) > 0 ? jsx("span", {
      css: dlAccessoryStyle(theme, "right"),
      children: rightAccessory
    }) : null]
  });
};

const dynamicListItemStyle = theme => ({
  width: "100%",
  padding: `${theme.spacing(1)} 0px`,
  borderTop: "1px solid",
  borderColor: theme.color(ColorPreset.BorderOnLight_05),
  ":first-of-type": {
    borderTop: "unset"
  }
});
const plainActionStyle = {
  borderRadius: "4px",
  boxShadow: `var(${focusRingVar})`,
  maxWidth: "100%"
};
const dynamicListStyle = (theme, props) => {
  const borderWidth = props.border === "top-bottom" ? "1px" : "0px";
  return [{
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderColor: theme.color(ColorPreset.BorderOnLight_05),
    borderStyle: "solid",
    borderWidth: `${borderWidth} 0px`
  }, focusRingStyle(theme, {
    colorScheme: props.colorScheme || ColorScheme.OnLight,
    variant: FocusRing.Heavy,
    focusSelector: "& li [data-dynamiclist-item-primary]:focus-visible"
  })];
};

const Action = ({
  action
}) => {
  const styleProps = {
    effect: HoverEffect.TextDecoration,
    textDecoration: "underline",
    weight: FontWeight.Bold
  };
  return "href" in action ? jsx(PlainLink, {
    "data-dynamiclist-item-primary": true,
    ...action,
    ...styleProps,
    css: plainActionStyle
  }) : jsx(PlainButton, {
    "data-dynamiclist-item-primary": true,
    ...action,
    ...styleProps,
    css: plainActionStyle
  });
};
const DynamicListItem = props => {
  const {
    theme
  } = useTheme();
  const {
    leadingElement,
    moreActions,
    trailingElement
  } = props;
  const actionsArea = moreActions ? "actions" : "";
  const headerArea = `'lead ${actionsArea || "lead"}'`;
  const leadArea = leadingElement ? "lead" : "";
  const gridAreas = [`
      ${leadingElement ? headerArea : ""}
      'body ${!leadingElement && !!actionsArea ? actionsArea : "body"}'
      ${trailingElement ? "'trail trail'" : ""}
    `, null, `
      '${leadArea} body ${trailingElement ? "trail" : ""} ${actionsArea}'
    `];
  const leadColumn = leadArea ? "max-content" : "";
  const trailingColumn = trailingElement ? "auto" : "";
  const actionsColumn = actionsArea ? "auto" : "";
  const gridColumns = ["1fr auto", null, `${leadColumn} minmax(0, 1fr) ${trailingColumn} ${actionsColumn}`];
  const actionsAlign = leadingElement ? AlignItems.Center : [AlignItems.Start, null, AlignItems.Center];
  return jsx(LI, {
    id: props.id,
    marker: "none",
    css: [dynamicListItemStyle(theme), process.env.NODE_ENV === "production" ? "" : ";label:DynamicListItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
    children: jsxs(XYGrid, {
      templateAreas: gridAreas,
      templateColumns: gridColumns,
      columnGap: 1,
      rowGap: 1,
      children: [!!leadingElement && jsx(Box, {
        gridArea: "lead",
        layout: "flex",
        alignItems: AlignItems.Center,
        children: leadingElement
      }), jsxs(Box, {
        gridArea: "body",
        layout: "flex",
        flexDirection: "column",
        justifyContent: JustifyContent.Center,
        css: /*#__PURE__*/css({
          gap: theme.spacing(0.25)
        }, process.env.NODE_ENV === "production" ? "" : ";label:DynamicListItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR5bmFtaWNMaXN0SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0N5RyIsImZpbGUiOiJEeW5hbWljTGlzdEl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUGxhaW5CdXR0b24sIFBsYWluTGluayB9IGZyb20gXCIuLi8uLi9idXR0b25zXCI7XHJcbmltcG9ydCB7IEJveCwgWFlHcmlkIH0gZnJvbSBcIi4uLy4uL2xheW91dFwiO1xyXG5pbXBvcnQgeyBBbGlnbkl0ZW1zLCBDb2xvclByZXNldCwgRm9udFdlaWdodCwgSG92ZXJFZmZlY3QsIEp1c3RpZnlDb250ZW50LCBUeXBlU2NhbGUsIHVzZVRoZW1lLCB9IGZyb20gXCIuLi8uLi90aGVtZVwiO1xyXG5pbXBvcnQgTEkgZnJvbSBcIi4uL0xJXCI7XHJcbmltcG9ydCB7IGR5bmFtaWNMaXN0SXRlbVN0eWxlLCBwbGFpbkFjdGlvblN0eWxlIH0gZnJvbSBcIi4vc3R5bGVzXCI7XHJcbmV4cG9ydCBjb25zdCBBY3Rpb24gPSAoeyBhY3Rpb24gfSkgPT4ge1xyXG4gICAgY29uc3Qgc3R5bGVQcm9wcyA9IHtcclxuICAgICAgICBlZmZlY3Q6IEhvdmVyRWZmZWN0LlRleHREZWNvcmF0aW9uLFxyXG4gICAgICAgIHRleHREZWNvcmF0aW9uOiBcInVuZGVybGluZVwiLFxyXG4gICAgICAgIHdlaWdodDogRm9udFdlaWdodC5Cb2xkLFxyXG4gICAgfTtcclxuICAgIHJldHVybiBcImhyZWZcIiBpbiBhY3Rpb24gPyAoPFBsYWluTGluayBkYXRhLWR5bmFtaWNsaXN0LWl0ZW0tcHJpbWFyeSB7Li4uYWN0aW9ufSB7Li4uc3R5bGVQcm9wc30gY3NzPXtwbGFpbkFjdGlvblN0eWxlfS8+KSA6ICg8UGxhaW5CdXR0b24gZGF0YS1keW5hbWljbGlzdC1pdGVtLXByaW1hcnkgey4uLmFjdGlvbn0gey4uLnN0eWxlUHJvcHN9IGNzcz17cGxhaW5BY3Rpb25TdHlsZX0vPik7XHJcbn07XHJcbmNvbnN0IER5bmFtaWNMaXN0SXRlbSA9IChwcm9wcykgPT4ge1xyXG4gICAgY29uc3QgeyB0aGVtZSB9ID0gdXNlVGhlbWUoKTtcclxuICAgIGNvbnN0IHsgbGVhZGluZ0VsZW1lbnQsIG1vcmVBY3Rpb25zLCB0cmFpbGluZ0VsZW1lbnQgfSA9IHByb3BzO1xyXG4gICAgY29uc3QgYWN0aW9uc0FyZWEgPSBtb3JlQWN0aW9ucyA/IFwiYWN0aW9uc1wiIDogXCJcIjtcclxuICAgIGNvbnN0IGhlYWRlckFyZWEgPSBgJ2xlYWQgJHthY3Rpb25zQXJlYSB8fCBcImxlYWRcIn0nYDtcclxuICAgIGNvbnN0IGxlYWRBcmVhID0gbGVhZGluZ0VsZW1lbnQgPyBcImxlYWRcIiA6IFwiXCI7XHJcbiAgICBjb25zdCBncmlkQXJlYXMgPSBbXHJcbiAgICAgICAgYFxuICAgICAgJHtsZWFkaW5nRWxlbWVudCA/IGhlYWRlckFyZWEgOiBcIlwifVxuICAgICAgJ2JvZHkgJHshbGVhZGluZ0VsZW1lbnQgJiYgISFhY3Rpb25zQXJlYSA/IGFjdGlvbnNBcmVhIDogXCJib2R5XCJ9J1xuICAgICAgJHt0cmFpbGluZ0VsZW1lbnQgPyBcIid0cmFpbCB0cmFpbCdcIiA6IFwiXCJ9XG4gICAgYCxcclxuICAgICAgICBudWxsLFxyXG4gICAgICAgIGBcbiAgICAgICcke2xlYWRBcmVhfSBib2R5ICR7dHJhaWxpbmdFbGVtZW50ID8gXCJ0cmFpbFwiIDogXCJcIn0gJHthY3Rpb25zQXJlYX0nXG4gICAgYCxcclxuICAgIF07XHJcbiAgICBjb25zdCBsZWFkQ29sdW1uID0gbGVhZEFyZWEgPyBcIm1heC1jb250ZW50XCIgOiBcIlwiO1xyXG4gICAgY29uc3QgdHJhaWxpbmdDb2x1bW4gPSB0cmFpbGluZ0VsZW1lbnQgPyBcImF1dG9cIiA6IFwiXCI7XHJcbiAgICBjb25zdCBhY3Rpb25zQ29sdW1uID0gYWN0aW9uc0FyZWEgPyBcImF1dG9cIiA6IFwiXCI7XHJcbiAgICBjb25zdCBncmlkQ29sdW1ucyA9IFtcclxuICAgICAgICBcIjFmciBhdXRvXCIsXHJcbiAgICAgICAgbnVsbCxcclxuICAgICAgICBgJHtsZWFkQ29sdW1ufSBtaW5tYXgoMCwgMWZyKSAke3RyYWlsaW5nQ29sdW1ufSAke2FjdGlvbnNDb2x1bW59YCxcclxuICAgIF07XHJcbiAgICBjb25zdCBhY3Rpb25zQWxpZ24gPSBsZWFkaW5nRWxlbWVudFxyXG4gICAgICAgID8gQWxpZ25JdGVtcy5DZW50ZXJcclxuICAgICAgICA6IFtBbGlnbkl0ZW1zLlN0YXJ0LCBudWxsLCBBbGlnbkl0ZW1zLkNlbnRlcl07XHJcbiAgICByZXR1cm4gKDxMSSBpZD17cHJvcHMuaWR9IG1hcmtlcj1cIm5vbmVcIiBjc3M9e1tkeW5hbWljTGlzdEl0ZW1TdHlsZSh0aGVtZSldfT5cbiAgICAgIDxYWUdyaWQgdGVtcGxhdGVBcmVhcz17Z3JpZEFyZWFzfSB0ZW1wbGF0ZUNvbHVtbnM9e2dyaWRDb2x1bW5zfSBjb2x1bW5HYXA9ezF9IHJvd0dhcD17MX0+XG4gICAgICAgIHshIWxlYWRpbmdFbGVtZW50ICYmICg8Qm94IGdyaWRBcmVhPVwibGVhZFwiIGxheW91dD1cImZsZXhcIiBhbGlnbkl0ZW1zPXtBbGlnbkl0ZW1zLkNlbnRlcn0+XG4gICAgICAgICAgICB7bGVhZGluZ0VsZW1lbnR9XG4gICAgICAgICAgPC9Cb3g+KX1cblxuICAgICAgICA8Qm94IGdyaWRBcmVhPVwiYm9keVwiIGxheW91dD1cImZsZXhcIiBmbGV4RGlyZWN0aW9uPVwiY29sdW1uXCIganVzdGlmeUNvbnRlbnQ9e0p1c3RpZnlDb250ZW50LkNlbnRlcn0gY3NzPXt7IGdhcDogdGhlbWUuc3BhY2luZygwLjI1KSB9fT5cbiAgICAgICAgICA8Qm94IGxheW91dD1cImZsZXhcIiBmbGV4RGlyZWN0aW9uPVwicm93XCIgZmxleFdyYXA9XCJ3cmFwXCIgYWxpZ25JdGVtcz17QWxpZ25JdGVtcy5CYXNlbGluZX0gY3NzPXt7IGdhcDogdGhlbWUuc3BhY2luZygwLjUpIH19PlxuICAgICAgICAgICAgPEFjdGlvbiBhY3Rpb249e3Byb3BzLnByaW1hcnlBY3Rpb259Lz5cbiAgICAgICAgICAgIHshIXByb3BzLnRhZ3MgJiZcclxuICAgICAgICAgICAgcHJvcHMudGFncy5tYXAoKHRhZywgaSkgPT4ge1xyXG4gICAgICAgICAgICAgICAgcmV0dXJuIDxzcGFuIGtleT17YCR7cHJvcHMuaWR9X3RhZ18ke2l9YH0+e3RhZ308L3NwYW4+O1xyXG4gICAgICAgICAgICB9KX1cbiAgICAgICAgICA8L0JveD5cbiAgICAgICAgICB7ISFwcm9wcy5jaGlsZHJlbiAmJiAoPEJveCBmb250U2l6ZT17VHlwZVNjYWxlLlNpemVfMDJ9IGNvbG9yPXtDb2xvclByZXNldC5UZXh0T25MaWdodF8wM30+XG4gICAgICAgICAgICAgIHtwcm9wcy5jaGlsZHJlbn1cbiAgICAgICAgICAgIDwvQm94Pil9XG4gICAgICAgIDwvQm94PlxuXG4gICAgICAgIHshIXRyYWlsaW5nRWxlbWVudCAmJiAoPEJveCBncmlkQXJlYT1cInRyYWlsXCIgbGF5b3V0PVwiZmxleFwiIGFsaWduSXRlbXM9e1tBbGlnbkl0ZW1zLlN0YXJ0LCBudWxsLCBBbGlnbkl0ZW1zLkNlbnRlcl19IGZvbnRTaXplPXtUeXBlU2NhbGUuU2l6ZV8wMn0gY29sb3I9e0NvbG9yUHJlc2V0LlRleHRPbkxpZ2h0XzAzfT5cbiAgICAgICAgICAgIHt0cmFpbGluZ0VsZW1lbnR9XG4gICAgICAgICAgPC9Cb3g+KX1cblxuICAgICAgICB7ISFtb3JlQWN0aW9ucyAmJiAoPEJveCBncmlkQXJlYT1cImFjdGlvbnNcIiBqdXN0aWZ5U2VsZj17SnVzdGlmeUNvbnRlbnQuRW5kfSBsYXlvdXQ9XCJmbGV4XCIgYWxpZ25JdGVtcz17YWN0aW9uc0FsaWdufT5cbiAgICAgICAgICAgIHttb3JlQWN0aW9uc31cbiAgICAgICAgICA8L0JveD4pfVxuICAgICAgPC9YWUdyaWQ+XG4gICAgPC9MST4pO1xyXG59O1xyXG5leHBvcnQgZGVmYXVsdCBEeW5hbWljTGlzdEl0ZW07XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUR5bmFtaWNMaXN0SXRlbS5qc3gubWFwIl19 */"),
        children: [jsxs(Box, {
          layout: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: AlignItems.Baseline,
          css: /*#__PURE__*/css({
            gap: theme.spacing(0.5)
          }, process.env.NODE_ENV === "production" ? "" : ";label:DynamicListItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
          children: [jsx(Action, {
            action: props.primaryAction
          }), !!props.tags && props.tags.map((tag, i) => {
            return jsx("span", {
              children: tag
            }, `${props.id}_tag_${i}`);
          })]
        }), !!props.children && jsx(Box, {
          fontSize: TypeScale.Size_02,
          color: ColorPreset.TextOnLight_03,
          children: props.children
        })]
      }), !!trailingElement && jsx(Box, {
        gridArea: "trail",
        layout: "flex",
        alignItems: [AlignItems.Start, null, AlignItems.Center],
        fontSize: TypeScale.Size_02,
        color: ColorPreset.TextOnLight_03,
        children: trailingElement
      }), !!moreActions && jsx(Box, {
        gridArea: "actions",
        justifySelf: JustifyContent.End,
        layout: "flex",
        alignItems: actionsAlign,
        children: moreActions
      })]
    })
  });
};

const DynamicList = props => {
  const {
    theme
  } = useTheme();
  const {
    border = "top-bottom",
    placeholderCount,
    loading
  } = props;
  const shimmers = Array(placeholderCount || 5).fill(jsx(LI, {
    marker: "none",
    css: [dynamicListItemStyle(theme), process.env.NODE_ENV === "production" ? "" : ";label:shimmers;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR5bmFtaWNMaXN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFReUUiLCJmaWxlIjoiRHluYW1pY0xpc3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU2hpbW1lciB9IGZyb20gXCIuLi8uLi9hbmltYXRpb25zXCI7XHJcbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSBcIi4uLy4uL3RoZW1lXCI7XHJcbmltcG9ydCBVTCBmcm9tIFwiLi4vVUxcIjtcclxuaW1wb3J0IExJIGZyb20gXCIuLi9MSVwiO1xyXG5pbXBvcnQgeyBkeW5hbWljTGlzdEl0ZW1TdHlsZSwgZHluYW1pY0xpc3RTdHlsZSB9IGZyb20gXCIuL3N0eWxlc1wiO1xyXG5jb25zdCBEeW5hbWljTGlzdCA9IChwcm9wcykgPT4ge1xyXG4gICAgY29uc3QgeyB0aGVtZSB9ID0gdXNlVGhlbWUoKTtcclxuICAgIGNvbnN0IHsgYm9yZGVyID0gXCJ0b3AtYm90dG9tXCIsIHBsYWNlaG9sZGVyQ291bnQsIGxvYWRpbmcgfSA9IHByb3BzO1xyXG4gICAgY29uc3Qgc2hpbW1lcnMgPSBBcnJheShwbGFjZWhvbGRlckNvdW50IHx8IDUpLmZpbGwoPExJIG1hcmtlcj1cIm5vbmVcIiBjc3M9e1tkeW5hbWljTGlzdEl0ZW1TdHlsZSh0aGVtZSldfT5cbiAgICAgIDxTaGltbWVyIC8+XG4gICAgPC9MST4pO1xyXG4gICAgcmV0dXJuICg8VUwgbWFya2VyPVwibm9uZVwiIGd1dHRlckg9ezB9IGNzcz17ZHluYW1pY0xpc3RTdHlsZSh0aGVtZSwgeyBib3JkZXIgfSl9PlxuICAgICAge2xvYWRpbmcgPyBzaGltbWVycyA6IHByb3BzLmNoaWxkcmVufVxuICAgIDwvVUw+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRHluYW1pY0xpc3Q7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUR5bmFtaWNMaXN0LmpzeC5tYXAiXX0= */"],
    children: jsx(Shimmer, {})
  }));
  return jsx(UL, {
    marker: "none",
    gutterH: 0,
    css: dynamicListStyle(theme, {
      border
    }),
    children: loading ? shimmers : props.children
  });
};

const ListItemWrapper = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, ref) => {
  const {
    theme
  } = useTheme();
  return jsx(Box, {
    ref: ref,
    css: /*#__PURE__*/css({
      "&:first-of-type": {
        paddingTop: theme.spacing(0.5)
      },
      "&:last-of-type": {
        paddingBottom: theme.spacing(1)
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:ListItemWrapper;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RJdGVtV3JhcHBlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzJCIiwiZmlsZSI6Ikxpc3RJdGVtV3JhcHBlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmb3J3YXJkUmVmIH0gZnJvbSBcInJlYWN0XCI7XHJcbmltcG9ydCB7IEJveCB9IGZyb20gXCIuLi8uLi9sYXlvdXRcIjtcclxuaW1wb3J0IHsgdXNlVGhlbWUgfSBmcm9tIFwiLi4vLi4vdGhlbWVcIjtcclxuZXhwb3J0IGNvbnN0IExpc3RJdGVtV3JhcHBlciA9IGZvcndhcmRSZWYoKHsgY2hpbGRyZW4sIC4uLnByb3BzIH0sIHJlZikgPT4ge1xyXG4gICAgY29uc3QgeyB0aGVtZSB9ID0gdXNlVGhlbWUoKTtcclxuICAgIHJldHVybiAoPEJveCByZWY9e3JlZn0gY3NzPXt7XHJcbiAgICAgICAgICAgIFwiJjpmaXJzdC1vZi10eXBlXCI6IHtcclxuICAgICAgICAgICAgICAgIHBhZGRpbmdUb3A6IHRoZW1lLnNwYWNpbmcoMC41KSxcclxuICAgICAgICAgICAgfSxcclxuICAgICAgICAgICAgXCImOmxhc3Qtb2YtdHlwZVwiOiB7XHJcbiAgICAgICAgICAgICAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zcGFjaW5nKDEpLFxyXG4gICAgICAgICAgICB9LFxyXG4gICAgICAgIH19IHsuLi5wcm9wc30+XG4gICAgICAgIHtjaGlsZHJlbn1cbiAgICAgIDwvQm94Pik7XHJcbn0pO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1MaXN0SXRlbVdyYXBwZXIuanN4Lm1hcCJdfQ== */"),
    ...props,
    children: children
  });
});

const ListRowUnmemo = ({
  items,
  index,
  renderItem,
  focussedIndex,
  searchInputValue,
  getItemProps,
  style,
  onSize,
  getSize
}) => {
  const item = items[index];
  const rowRef = useRef(null);
  useEffect(() => {
    if (rowRef.current && onSize && getSize) {
      const height = getRowHeight(rowRef.current.childNodes[0]);
      if (height !== getSize(index) && height !== 0) {
        onSize(index, height);
      }
      const observable = new ResizeObserver(([rowEl]) => {
        var _rowEl$contentRect;
        const observedHeight = rowEl === null || rowEl === void 0 ? void 0 : (_rowEl$contentRect = rowEl.contentRect) === null || _rowEl$contentRect === void 0 ? void 0 : _rowEl$contentRect.height;
        if (observedHeight && observedHeight !== getSize(index) && observedHeight > 0) {
          onSize(index, observedHeight);
        }
      });
      observable.observe(rowRef.current);
      return () => observable.disconnect();
    }
    return noop$7;
  }, [index, getSize, onSize, rowRef.current]);
  // render custom item
  if (renderItem) {
    return jsx(Box, {
      style: style,
      ref: rowRef,
      children: renderItem({
        item,
        index,
        highlightText: searchInputValue,
        isHighlighted: index === focussedIndex,
        ...getItemProps({
          index
        })
      })
    });
  }
  const {
    onClick,
    ...itemProps
  } = getItemProps({
    index
  });
  return jsx(ListItemWrapper, {
    ref: rowRef,
    gutterH: 0.25,
    gutterV: 0.5,
    bg: index === focussedIndex ? Color.Brownstone_100 : Color.White,
    style: style,
    children: jsx(DynamicListItem, {
      primaryAction: {
        children: item.label || "",
        onClick
      },
      ...itemProps
    })
  }, item.value || index);
};
const ListRow = /*#__PURE__*/memo(ListRowUnmemo);

const autoFillSupport = {
  border: "var(--input-border-width) solid transparent",
  borderRadius: "inherit"
};
const searchStyle = {
  display: "none"
};
const searchReset = {
  "&[type='search']::-ms-clear": searchStyle,
  "&[type='search']::-ms-reveal": searchStyle,
  "&[type='search']::-webkit-search-decoration": searchStyle,
  "&[type='search']::-webkit-search-cancel-button": searchStyle,
  "&[type='search']::-webkit-search-results-button": searchStyle,
  "&[type='search']::-webkit-search-results-decoration": searchStyle
};

const BASE_SIZE = 16;
const MIN_LIST_HEIGHT = 10;
const MAX_LIST_HEIGHT = 25;
// start trying to load more items when the items.length - x comes into view
const LAZY_LOAD_LOOKAHEAD = 2;
const inputStyle = (theme, props) => {
  const padding = inputGutterStyle(theme, {
    size: props.gutter,
    adjustmentVar: "--input-border-width"
  });
  const typePreset = theme.tokens.typePresets[TypePreset.Body_02];
  const fontFamily = props.fontFamily ? theme.tokens.fontFamilies[props.fontFamily] : "inherit";
  return [autoFillSupport, {
    display: "block",
    width: "100%",
    margin: 0,
    background: "none",
    cursor: props.disabled ? "not-allowed" : "auto",
    fontFamily,
    color: "inherit",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    }
  }, padding, theme.responsive(typePreset.size, fs => {
    const size = theme.tokens.fontSizes[fs];
    const minHeight = `calc(${size.lineHeight} + ${padding} * 2)`;
    return {
      ...size,
      minHeight
    };
  }), searchReset];
};
const searchInputContainerStyle = (theme, props) => {
  const {
    status,
    focused,
    disabled,
    flip
  } = props;
  const colors = resolveStatusColors(theme, {
    status,
    disabled
  });
  const {
    textColor,
    backgroundColor
  } = colors;
  const borderWidth = focused ? "2px" : "1px";
  return {
    "--input-border-width": borderWidth,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    backgroundColor,
    color: textColor,
    transition: "box-shadow 150ms",
    borderBottom: flip ? "none" : `1px solid ${theme.color(ColorPreset.BorderOnLight_02)}`,
    borderTop: !flip ? "none" : `1px solid ${theme.color(ColorPreset.BorderOnLight_02)}`,
    borderRadius: 0,
    boxShadow: "none"
  };
};
const List = ({
  flip,
  items,
  virtualize,
  renderItem,
  maxHeight,
  loading,
  loadingCount,
  emptyMessage,
  searchInputProps: userSearchInputProps,
  onChange,
  focussedIndex: defaultFocussedIndex,
  innerRef,
  focusListOnMount,
  onLoadNextPage,
  loadingNextPage,
  status,
  footer
}) => {
  const prevLoading = usePrevious(loadingNextPage);
  const prevItems = usePrevious(items);
  const searchable = !!Object.keys(userSearchInputProps || {}).length;
  const {
    theme
  } = useTheme();
  const {
    listTotalHeight,
    searchInputVal,
    focussedIndex,
    listProps,
    getItemProps,
    searchInputProps,
    virtualListRef,
    innerListRef,
    headerRef,
    footerRef
  } = useListKeyboardNav({
    items,
    onChange,
    focussedIndex: defaultFocussedIndex,
    focusListOnMount,
    searchable,
    searchInput: {
      ...userSearchInputProps,
      value: userSearchInputProps === null || userSearchInputProps === void 0 ? void 0 : userSearchInputProps.value
    }
  });
  // store sizing variables in a ref so they don't get re-calculated
  const listAttributes = useRef({
    minHeight: BASE_SIZE * MIN_LIST_HEIGHT,
    maxHeight: BASE_SIZE * MAX_LIST_HEIGHT,
    verticalPadding: BASE_SIZE,
    screenPadding: BASE_SIZE
  });
  // get the observed height for the footer and header element
  const headerHeight = useObserveElementHeight(headerRef);
  const footerHeight = useObserveElementHeight(footerRef);
  // calculate the height for the virtualised list
  const calculatedListHeight = calcListHeight({
    heightRestriction: maxHeight,
    scrollableAreaHeight: listTotalHeight,
    minListHeight: listAttributes.current.minHeight,
    maxListHeight: listAttributes.current.maxHeight,
    verticalListPadding: listAttributes.current.verticalPadding,
    screenPadding: listAttributes.current.screenPadding,
    headerHeight,
    footerHeight
  });
  const inputCssProps = inputStyle(theme, {});
  const inputContainerCssProps = searchInputContainerStyle(theme, {
    flip: flip !== null && flip !== void 0 ? flip : false
  });
  // store the height of the list items in a map so the virtual list
  // can calculate the total height and render correctly
  // needs to be in a useCallback so that ListRow React.memo can be effectively memoizing the component
  const sizeMap = useRef({});
  const updateSizeMap = useCallback((index, size) => {
    if (sizeMap.current[`${index}`] !== Math.round(size)) {
      var _virtualListRef$curre;
      (_virtualListRef$curre = virtualListRef.current) === null || _virtualListRef$curre === void 0 ? void 0 : _virtualListRef$curre.resetAfterIndex(index);
      sizeMap.current = {
        ...sizeMap.current,
        [index]: Math.round(size)
      };
    }
  }, [sizeMap.current, virtualListRef.current]);
  // get the size for a list item by index.
  // if there's no calculated height yet we take the very first height and assume that
  // all items have the same height. If no height has been calculated yet we go with 64px
  // which is slightly higher than the standard list item with description.
  const getSize = useCallback(index => {
    return sizeMap.current[`${index}`] || sizeMap.current["0"] || BASE_SIZE * 4;
  }, [sizeMap.current]);
  useEffect(() => {
    if (onLoadNextPage && prevLoading && !loadingNextPage && prevItems !== null && prevItems !== void 0 && prevItems.length) {
      var _virtualListRef$curre2;
      const index = prevItems.length;
      if ((_virtualListRef$curre2 = virtualListRef.current) !== null && _virtualListRef$curre2 !== void 0 && _virtualListRef$curre2.scrollToItem) {
        var _virtualListRef$curre3;
        (_virtualListRef$curre3 = virtualListRef.current) === null || _virtualListRef$curre3 === void 0 ? void 0 : _virtualListRef$curre3.scrollToItem(index, "smart");
      }
    }
  }, [onLoadNextPage, loadingNextPage, prevLoading, items, prevItems]);
  return jsxs(ListWrapper, {
    flip: flip,
    ref: innerRef,
    children: [searchable ? jsxs(Box, {
      borderRadius: 0,
      borderWidth: 0,
      css: inputContainerCssProps,
      ref: headerRef,
      gutterH: 0.5,
      children: [jsx(Box, {
        layout: "flex",
        alignItems: AlignItems.Center,
        spaceBefore: 0.5,
        children: jsx(Icon, {
          name: Glyph.Search
        })
      }), jsx("input", {
        ...searchInputProps,
        css: inputCssProps
      })]
    }) : null, loading && loadingCount && !items.length ? jsx(ListItemsContainer, {
      children: Array.from({
        length: loadingCount !== null && loadingCount !== void 0 ? loadingCount : 0
      }).map((_, i) => jsx(ListItemWrapper, {
        children: jsx(ListItem, {
          children: jsx(Shimmer, {})
        })
      }, i.toString()))
    }) : null, !loading && !items.length && emptyMessage ? jsx(ListItemsContainer, {
      children: jsx(Box, {
        gutterH: 1,
        gutterV: 1,
        children: emptyMessage
      })
    }) : null, items.length ? jsx(ListItemsContainer, {
      ...listProps,
      "aria-label": "listbox",
      children: virtualize ? jsx(VariableSizeList, {
        height: calculatedListHeight,
        width: "100%",
        ref: virtualListRef,
        innerRef: innerListRef,
        itemCount: items.length,
        itemSize: getSize,
        style: {
          padding: theme.spacing(0.5),
          position: "relative"
        },
        onItemsRendered: ({
          visibleStopIndex
        }) => {
          const thresholdMet = visibleStopIndex >= items.length - LAZY_LOAD_LOOKAHEAD;
          if (onLoadNextPage && !loadingNextPage && thresholdMet) {
            onLoadNextPage();
          }
        },
        children: ({
          index,
          style
        }) => {
          var _items$index;
          return jsx(ListRow, {
            style: style,
            onSize: updateSizeMap,
            getSize: getSize,
            index: index,
            renderItem: renderItem,
            focussedIndex: focussedIndex,
            searchInputValue: searchInputVal,
            items: items,
            getItemProps: getItemProps
          }, (_items$index = items[index]) === null || _items$index === void 0 ? void 0 : _items$index.value.toString());
        }
      }) : jsx(Box, {
        height: calculatedListHeight,
        overflowY: Overflow.Auto,
        children: jsx(Box, {
          ref: innerListRef,
          children: items.map((_, index) => jsx(ListRow, {
            index: index,
            renderItem: renderItem,
            focussedIndex: focussedIndex,
            searchInputValue: searchInputVal,
            items: items,
            getItemProps: getItemProps,
            style: {
              paddingBottom: !loadingNextPage && index === items.length - 1 ? theme.spacing(0.5) : 0
            }
          }, index.toString()))
        })
      })
    }) : null, loadingNextPage ? jsx(Box, {
      ref: footerRef,
      gutterV: 0.75,
      gutterH: 0.75,
      spaceBelow: 0.5,
      children: jsx(ListItem, {
        leftAccessory: jsxs(Fragment, {
          children: [jsx(Icon, {
            name: Glyph.Spinner,
            size: "16px"
          }), jsx(Space, {
            h: 0.25
          })]
        }),
        children: jsx(Shimmer, {
          height: 12
        })
      })
    }) : null, footer && !loadingNextPage ? jsx(Box, {
      ref: footerRef,
      children: footer({
        flip,
        status
      })
    }) : null]
  });
};

const triggerContainerStyle = (theme, props) => {
  const {
    status,
    focused,
    disabled
  } = props;
  const colors = resolveStatusColors(theme, {
    status,
    disabled
  });
  const {
    baseBorderColor,
    focusBorderColor,
    textColor,
    backgroundColor
  } = colors;
  let borderWidth = "1px";
  let boxShadowColor = baseBorderColor;
  if (focused) {
    borderWidth = "2px";
    boxShadowColor = focusBorderColor;
  }
  return {
    "--input-border-width": borderWidth,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    backgroundColor,
    color: textColor,
    borderRadius: theme.radius(0.5),
    boxShadow: `0 0 0 var(--input-border-width) ${boxShadowColor}`,
    transition: "box-shadow 150ms",
    overflow: "hidden",
    position: "relative",
    width: "100%",
    "&:focus-visible": {
      outline: "none"
    }
  };
};
const Trigger = ({
  clearable,
  placeholder,
  value,
  isOpen,
  loading,
  renderValue,
  onClear,
  leftAccessory,
  setReferenceElement,
  status,
  id,
  ...props
}) => {
  const {
    theme
  } = useTheme();
  const [isHovering, setIsHovering] = useState(false);
  const renderValueText = useMemo(() => () => {
    if (value) {
      if (renderValue) {
        return renderValue({
          value,
          disabled: props.disabled
        });
      }
      return jsx(ListItem, {
        disabled: props.disabled,
        children: value.label
      });
    }
    return jsx(ListItem, {
      leftAccessory: leftAccessory,
      children: placeholder
    });
  }, [loading, value, leftAccessory, placeholder, renderValue, props.disabled]);
  const renderAction = useMemo(() => () => {
    if (loading) {
      return jsx(Icon, {
        name: Glyph.Spinner
      });
    }
    const emptyvalue = !value;
    if (!emptyvalue && isHovering && clearable) {
      return jsx(IconButton, {
        icon: Glyph.Close,
        size: ButtonSize.Sm,
        label: "clear",
        variant: ButtonVariant.TextOnLight,
        "data-cy": "clear-btn",
        onClick: e => {
          e.stopPropagation();
          onClear();
        }
      });
    }
    return jsx(IconButton, {
      icon: isOpen ? Glyph.ChevronUp : Glyph.ChevronDown,
      label: isOpen ? "close" : "open",
      variant: ButtonVariant.TextOnLight,
      "data-cy": "clear-btn"
    });
  }, [loading, value, isHovering, clearable, isOpen, onClear]);
  const statusCss = triggerContainerStyle(theme, {
    status,
    focused: isOpen,
    disabled: props.disabled
  });
  return jsx(PlainButton, {
    effect: HoverEffect.TextDecoration,
    ref: setReferenceElement,
    onMouseEnter: () => setIsHovering(true),
    onMouseLeave: () => setIsHovering(false),
    css: statusCss,
    id: id,
    ...props,
    children: jsxs(Box, {
      bg: Color.White,
      layout: "flex",
      justifyContent: JustifyContent.SpaceBetween,
      alignItems: AlignItems.Center,
      "aria-haspopup": "listbox",
      width: "100%",
      minHeight: theme.spacing(3),
      children: [jsx(Box, {
        width: "100%",
        maxWidth: "calc(100% - 64px)",
        children: renderValueText()
      }), jsx(Box, {
        width: "64px",
        gutterH: 1,
        layout: "flex",
        justifyContent: JustifyContent.Center,
        children: renderAction()
      })]
    })
  });
};

const SelectInput = ({
  loading,
  placeholder,
  disabled,
  clearable = true,
  renderValue,
  items = [],
  value: inValue,
  defaultValue: inDefault,
  loadingCount,
  emptyMessage,
  onChange: inOnChange = noop$7,
  searchInputProps,
  renderItem,
  onClose,
  usePortal,
  leftAccessory,
  status,
  id,
  ...props
}) => {
  const {
    theme
  } = useTheme();
  const [value, setValue] = useControlledState(inValue, inDefault || null, inOnChange);
  const [isOpen, setIsOpen] = useState(false);
  const prevIsOpen = usePrevious(isOpen);
  const {
    floatingStyles,
    refs,
    placement: finalPlacement
  } = useTooltip({
    open: isOpen,
    initialPlacement: "bottom",
    placementStrategy: "flip",
    positionStrategy: "absolute",
    sameWidth: true
  });
  const closeCallout = useCallback(() => {
    setIsOpen(false);
  }, []);
  useTapOut(refs.floating, closeCallout);
  useKeyDown("Escape", closeCallout);
  useKeyDown("Tab", closeCallout);
  useEffect(() => {
    // was open but now is closed
    if (prevIsOpen && !isOpen) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
      if (refs.reference.current) {
        // preventing from scrolling when the dropdown is open
        refs.reference.current.focus({
          preventScroll: true
        });
      }
    }
  }, [prevIsOpen, isOpen, refs.reference, onClose]);
  const Portal = useMemo(() => usePortal ? BodyPortal : Fragment$1, [usePortal]);
  return jsxs(Fragment, {
    children: [jsx(Trigger, {
      clearable: clearable,
      value: value,
      placeholder: placeholder,
      disabled: disabled,
      loading: !!loading,
      isOpen: isOpen,
      setReferenceElement: refs.setReference,
      renderValue: renderValue,
      onClear: () => {
        setValue(null);
        closeCallout();
      },
      onClick: () => {
        setIsOpen(!isOpen);
      },
      leftAccessory: leftAccessory,
      status: status,
      id: id
    }), isOpen ? jsx(Portal, {
      children: jsx(ListWrapper, {
        role: "list",
        ref: refs.setFloating,
        style: {
          ...floatingStyles,
          zIndex: usePortal ? ZIndex.Dialog + 1 : 1,
          border: "none"
        },
        children: jsx(List, {
          focusListOnMount: true,
          loadingCount: loadingCount || 5,
          emptyMessage: emptyMessage,
          flip: finalPlacement === "top",
          items: items,
          loading: loading,
          onChange: item => {
            setValue(item);
            closeCallout();
          },
          status: status,
          searchInputProps: searchInputProps,
          renderItem: listItemProps => {
            const itemProps = {
              ...listItemProps,
              isSelected: (value === null || value === void 0 ? void 0 : value.value) === listItemProps.item.value
            };
            if (renderItem) {
              return renderItem(itemProps);
            }
            const isFirstItem = listItemProps.index === 0;
            return jsx(Box, {
              css: /*#__PURE__*/css({
                paddingTop: isFirstItem ? theme.spacing(0.5) : 0
              }, process.env.NODE_ENV === "production" ? "" : ";label:SelectInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
              gutterH: 0.5,
              children: jsx(ListItem, {
                ...itemProps,
                children: listItemProps.item.label
              })
            }, listItemProps.item.value);
          },
          ...props
        })
      })
    }) : null]
  });
};

const fieldSetStyle = theme => ({
  display: "block",
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  "&& > *": {
    marginBottom: theme.spacing(0.25)
  },
  "&& > input, && > select, && > [data-field-control]": {
    margin: theme.spacing([1.5, 0])
  },
  "&& > :last-child": {
    marginBottom: theme.spacing(0)
  }
});
const FieldSet = props => {
  const {
    theme
  } = useTheme();
  return jsx("fieldset", {
    css: fieldSetStyle(theme),
    role: "group",
    ...props
  });
};

const legendStyle$1 = (theme, props) => {
  return [{
    fontWeight: FontWeight.SemiBold,
    display: "block",
    padding: 0,
    margin: 0
  }, typographyStyle(theme, props)];
};
const Legend = props => {
  const {
    theme
  } = useTheme();
  return jsx("legend", {
    css: legendStyle$1(theme, props),
    ...omitTypographyStyleProps(props),
    children: props.children
  });
};

const vars$b = {
  ratio: "--slider-ratio",
  zeroRatio: "--slider-zero-ratio",
  knobBaseSize: "--slider-knob-base-size",
  knobSize: "--slider-knob-size",
  knobScale: "--slider-knob-scale",
  knobActiveScale: "--slider-knob-active-scale",
  // This is the total possible fill for the track. We need to take into
  // account that the knob's center isn't at 0 when the input value is 0. This
  // is why the total range (100%) is augmented by the knob size. If we don't do
  // this then the knob and track fill will not be in phase.
  trackRange: "--slider-track-range",
  // Theming vars
  knobDefaultBg: "--slider-knob-default-bg",
  knobActiveBg: "--slider-knob-active-bg",
  knobDefaultOutline: "--slider-knob-default-outline",
  knobDisabledOutline: "--slider-knob-disabled-outline",
  trackActiveDefaultFill: "--slider-track-active-default-fill",
  trackInactiveDefaultFill: "--slider-track-inactive-default-fill",
  trackDisabledActiveFill: "--slider-track-disabled-active-fill",
  trackDisabledInactiveFill: "--slider-track-disabled-inactive-fill",
  labelDefaultColor: "--slider-label-default-color",
  labelDisabledColor: "--slider-label-disabled-color",
  // Derived theming vars
  knobBg: "--slider-knob-bg",
  knobOutline: "--slider-knob-outline",
  trackActiveFill: "--slider-track-active-fill",
  trackInactiveFill: "--slider-track-inactive-fill",
  labelColor: "--slider-label-color"
};
const sliderColorTokens = (theme, colorScheme) => {
  const light = {
    [vars$b.knobDefaultBg]: theme.color(Color.Transparent),
    [vars$b.knobActiveBg]: theme.color(Color.Greystone_DarkMatter),
    [vars$b.knobDefaultOutline]: `
      inset 0 0 0 4px ${theme.color(Color.Greystone_DarkMatter)}
    `,
    [vars$b.knobDisabledOutline]: `
      inset 0 0 0 4px ${theme.color(Color.Greystone_1400_A38)}
    `,
    [vars$b.trackActiveDefaultFill]: theme.color(Color.Greystone_1200),
    [vars$b.trackInactiveDefaultFill]: theme.color(Color.Greystone_1400_A16),
    [vars$b.trackDisabledActiveFill]: theme.color(Color.Greystone_1400_A38),
    [vars$b.trackDisabledInactiveFill]: theme.color(Color.Greystone_1400_A8),
    [vars$b.labelDefaultColor]: theme.color(ColorPreset.TextOnLight_03),
    [vars$b.labelDisabledColor]: theme.color(Color.Greystone_1400_A38)
  };
  const dark = {
    [vars$b.knobDefaultBg]: theme.color(Color.Transparent),
    [vars$b.knobActiveBg]: theme.color(Color.Brownstone_Moonstone),
    [vars$b.knobDefaultOutline]: `
      inset 0 0 0 4px ${theme.color(Color.Brownstone_Moonstone)}
    `,
    [vars$b.knobDisabledOutline]: `
      inset 0 0 0 4px ${theme.color(Color.Greystone_700_A38)}
    `,
    [vars$b.trackActiveDefaultFill]: theme.color(Color.Dawn_400),
    [vars$b.trackInactiveDefaultFill]: theme.color(Color.White_A25),
    [vars$b.trackDisabledActiveFill]: theme.color(Color.Greystone_700_A38),
    [vars$b.trackDisabledInactiveFill]: theme.color(Color.Greystone_700_A16),
    [vars$b.labelDefaultColor]: theme.color(ColorPreset.TextOnDark_03),
    [vars$b.labelDisabledColor]: theme.color(Color.Greystone_700_A38)
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const sliderStyle = (theme, props) => {
  const {
    labelPlacement
  } = props;
  return [sliderColorTokens(theme, props.colorScheme), {
    display: "grid",
    alignItems: "center",
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(1)
  }, theme.responsive(labelPlacement, lp => {
    switch (lp) {
      case "block":
        return {
          gridTemplateAreas: "'control control' 'minLabel maxLabel'",
          gridTemplateColumns: "1fr 1fr"
        };
      case "inline":
        return {
          gridTemplateAreas: "'minLabel control maxLabel'",
          gridTemplateColumns: "auto 1fr auto"
        };
    }
  })];
};
const sliderLabelStyle = {
  display: "flex",
  alignItems: "center",
  [vars$b.labelColor]: `var(${vars$b.labelDefaultColor})`,
  color: `var(${vars$b.labelColor})`,
  "input:disabled ~ &": {
    [vars$b.labelColor]: `var(${vars$b.labelDisabledColor})`
  }
};
const sliderControlStyle = (theme, colorScheme) => {
  return [{
    // Whereas `vars.ratio` is from 0 to 1, zero ratio is from -0.5 to 0.5.
    // That is, it is centered at 0. This scale helps us perform later
    // calculations relating to the before and after track fills.
    [vars$b.zeroRatio]: `calc((var(${vars$b.ratio}) - 0.5))`,
    [vars$b.knobBaseSize]: "24px",
    [vars$b.knobSize]: `calc(var(${vars$b.knobBaseSize}) * var(${vars$b.knobScale}, 1))`,
    [vars$b.knobScale]: "1",
    [vars$b.knobActiveScale]: "calc(28/24)",
    // The maximum width of either parts of the track fill is 100 percent
    // minus the size of the knob.
    [vars$b.trackRange]: `calc(100% - var(${vars$b.knobSize}))`,
    [vars$b.knobBg]: `var(${vars$b.knobDefaultBg})`,
    [vars$b.knobOutline]: `var(${vars$b.knobDefaultOutline})`,
    [vars$b.trackActiveFill]: `var(${vars$b.trackActiveDefaultFill})`,
    [vars$b.trackInactiveFill]: `var(${vars$b.trackInactiveDefaultFill})`
  }, {
    "&[data-active], &[data-focused], &[data-hovered], &:active, &:hover, &:focus-visible": {
      [vars$b.knobBg]: `var(${vars$b.knobActiveBg})`
    },
    "&[data-active], &:active": {
      [vars$b.knobScale]: `var(${vars$b.knobActiveScale})`
    },
    "&:disabled": {
      [vars$b.knobScale]: "1",
      [vars$b.knobBg]: `var(${vars$b.knobDefaultBg})`,
      [vars$b.trackActiveFill]: `var(${vars$b.trackDisabledActiveFill})`,
      [vars$b.trackInactiveFill]: `var(${vars$b.trackDisabledInactiveFill})`,
      [vars$b.knobOutline]: `var(${vars$b.knobDisabledOutline})`,
      cursor: "not-allowed"
    }
  }, focusRingStyle(theme, {
    variant: FocusRing.Heavy,
    colorScheme,
    focusSelector: "&:focus-visible, &[data-focused]"
  }), {
    appearance: "none",
    cursor: "pointer",
    display: "block",
    width: "100%",
    background: "none",
    margin: 0,
    padding: 0,
    gridArea: "control",
    "&::-webkit-slider-thumb": knobStyle,
    "&::-moz-range-thumb": knobStyle,
    "&::-webkit-slider-runnable-track": trackStyle,
    "&::-moz-range-track": trackStyle
  }];
};
const knobStyle = {
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  appearance: "none",
  width: `var(${vars$b.knobBaseSize})`,
  height: `var(${vars$b.knobBaseSize})`,
  borderRadius: `var(${vars$b.knobBaseSize})`,
  border: "none",
  backgroundColor: `var(${vars$b.knobBg})`,
  boxShadow: `var(${vars$b.knobOutline}), ${focusRingVal}`,
  transform: `scale(var(${vars$b.knobScale}, 1))`,
  transformOrigin: "50% 50%",
  transition: "transform 150ms, box-shadow 150ms, background-color 150ms"
};
const trackStyle = {
  // When the knob is scaled up, i.e. when it is actively pressed, we need to
  // adjust the track fill to account for its new size. Unfortunately, scaling
  // up the knob requires some finer calculations. This would not be needed if
  // we could have changed the width and height of the knob but that results in
  // an unpleasant interaction and layout shift. Scaling with a transform and
  // transform-origin mitigates this but requires this bit of maths.
  //
  // Regardless of scaling, the knob physically occupies its base size, that is
  // defined as its width and height, on the slider. The total we need to adjust
  // for is the "scaled size - base size" or "base size * (scale factor - 1)".
  // This adjustment then needs to be translated along the slider such that at
  // the 50% mark we need 0 adjustment and as we move to either ends of the
  // slider we apply adjustments linearly. This is where the zero ratio comes in
  // to help.
  //
  // Frankly, the best way to understand this maths is to set this variable to
  // 0, see the effect of that change and then work backwards from this code.
  "--adjustment": `calc(
    var(${vars$b.knobBaseSize})
    * (var(${vars$b.knobScale}) - 1)
    * var(${vars$b.zeroRatio})
  )`,
  // The following two variables determine the widths of the track fill before
  // and after the knob.
  //
  // The 1px adjustments in the following two rules will create a nice little
  // gap between the track fills and the knob.
  "--before": `calc(
    var(${vars$b.trackRange}) * var(${vars$b.ratio})
    + var(--adjustment)
    - 1px
  )`,
  "--after": `calc(
    var(${vars$b.trackRange}) * var(${vars$b.ratio})
    + var(${vars$b.knobSize})
    + var(--adjustment)
    + 1px
  )`,
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  appearance: "none",
  width: "100%",
  backgroundSize: "100% 4px",
  backgroundPosition: "left center",
  backgroundRepeat: "no-repeat",
  // The gradient represents the fill that is applied to the track. The middle
  // color stop is transparent and is effectively creating a space for the knob
  // to sit in.
  backgroundImage: `linear-gradient(
    to right,
    var(${vars$b.trackActiveFill}) 0% var(--before),
    transparent var(--before) var(--after),
    var(${vars$b.trackInactiveFill}) var(--after) 100%
  )`
};
const noop$6 = () => {};
const Slider = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    colorScheme = ColorScheme.OnLight,
    labelPlacement = "block",
    value: inValue,
    defaultValue: inDefaultValue,
    onChange,
    min = 0,
    max = 100,
    minLabel,
    maxLabel,
    ...rest
  } = props;
  const styleProps = {
    colorScheme,
    labelPlacement
  };
  const defaultValue = typeof inDefaultValue === "number" ? inDefaultValue : Math.trunc((max - min) / 2);
  const [value, setValue] = useControlledState(inValue, defaultValue, noop$6);
  const range = max - min;
  const ratio = range && value ? (value - min) / range : 0;
  const hasMinLabel = React.Children.count(minLabel) > 0;
  const hasMaxLabel = React.Children.count(maxLabel) > 0;
  return jsxs("div", {
    css: sliderStyle(theme, styleProps),
    "data-field-control": true,
    children: [jsx("input", {
      css: sliderControlStyle(theme, colorScheme),
      type: "range",
      ...rest,
      min: min,
      max: max,
      value: value,
      onChange: e => {
        const parsed = parseInt(e.target.value);
        if (Number.isNaN(parsed)) {
          return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        setValue(parsed);
      },
      ref: ref,
      style: {
        [vars$b.ratio]: `${ratio}`
      }
    }), hasMinLabel ? jsx("div", {
      css: [sliderLabelStyle, "grid-area:minLabel;" + (process.env.NODE_ENV === "production" ? "" : ";label:Slider;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      children: minLabel
    }) : null, hasMaxLabel ? jsx("div", {
      css: [sliderLabelStyle, "grid-area:maxLabel;text-align:end;justify-content:end;" + (process.env.NODE_ENV === "production" ? "" : ";label:Slider;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      children: maxLabel
    }) : null]
  });
});

const Switch = /*#__PURE__*/React.forwardRef(function Switch(props, ref) {
  const {
    variant = ToggleVariant.Compact,
    colorScheme = ColorScheme.OnLight,
    controlPosition = ToggleControlPosition.Start,
    ...rest
  } = props;
  const switchStyleProps = {
    variant,
    colorScheme,
    controlPosition,
    ...rest
  };
  return jsx(Toggle, {
    ...switchStyleProps,
    control: ToggleControl.Switch,
    type: "checkbox",
    ref: ref
  });
});

/* eslint-disable react/forbid-elements */
const Option = props => {
  return jsx("option", {
    ...props
  });
};

var TextAreaResize;
(function (TextAreaResize) {
  TextAreaResize["Auto"] = "auto";
  TextAreaResize["None"] = "none";
})(TextAreaResize || (TextAreaResize = {}));
const textAreaStatusColors = theme => {
  const vs = FormFieldStatus.Success;
  const vd = FormFieldStatus.Danger;
  return {
    [`--textarea-${vs}`]: theme.color(Color.Success_300),
    [`--textarea-${vd}`]: theme.color(ColorPreset.AlertBorderOnLight)
  };
};
const textAreaContainerStyle = (theme, props) => {
  const {
    status,
    focused,
    disabled
  } = props;
  const borderWidth = focused ? "2px" : "1px";
  let boxShadow = `inset 0 0 0 ${borderWidth} ${theme.color(ColorPreset.BorderOnLight_02)}`;
  let backgroundColor = theme.color(ColorPreset.BackgroundLight_01);
  let color = theme.color(ColorPreset.TextOnLight_01);
  if (status) {
    boxShadow = `inset 0 0 0 ${borderWidth} var(--textarea-${status})`;
  }
  if (focused && !status) {
    boxShadow = `inset 0 0 0 ${borderWidth} ${theme.color(ColorPreset.BorderOnLight_01)}`;
  }
  if (disabled) {
    boxShadow = `inset 0 0 0 ${borderWidth} ${theme.color(Color.Greystone_700_A38)}`;
    backgroundColor = theme.color(Color.Greystone_1400_A8);
    color = theme.color(Color.Greystone_1400_A38);
  }
  return [{
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "stretch",
    padding: `${borderWidth} 0`,
    fontFamily: theme.tokens.fontFamilies["sans-serif"],
    color,
    boxShadow,
    borderRadius: theme.spacing(0.5),
    backgroundColor
  }];
};
const textAreaStyle = (theme, props) => {
  const padding = inputGutterStyle(theme, {
    size: props.gutter
  });
  const typePreset = theme.tokens.typePresets[TypePreset.Body_02];
  const {
    disabled,
    fontFamily,
    resize
  } = props;
  const fontFamilyProp = fontFamily ? theme.tokens.fontFamilies[fontFamily] : "inherit";
  return [padding, theme.responsive(typePreset.size, fs => {
    return theme.tokens.fontSizes[fs];
  }), {
    display: "block",
    width: "100%",
    margin: 0,
    background: "none",
    paddingRight: theme.spacing(1.5),
    cursor: disabled ? "not-allowed" : "auto",
    borderWidth: 0,
    fontFamily: fontFamilyProp,
    color: "inherit",
    resize: resize ? "none" : "vertical",
    maxHeight: "450px",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    }
  }];
};
const rightStatusIconCSS = (theme, props) => {
  const {
    status,
    disabled
  } = props;
  let color = status ? `var(--textarea-${status})` : "inherit";
  if (disabled) {
    color = theme.color(Color.Greystone_700_A38);
  }
  return {
    color,
    display: "inline-block",
    position: "absolute",
    right: theme.spacing(1),
    marginTop: theme.spacing(0.5)
  };
};
const TextArea = /*#__PURE__*/React.forwardRef(function TextArea(props, ref) {
  const {
    theme
  } = useTheme();
  const [focused, setFocused] = React.useState(false);
  const {
    status,
    onBlur,
    onFocus,
    resize,
    gutter,
    ...rest
  } = props;
  const {
    disabled
  } = props;
  const styleProps = {
    ...props,
    disabled,
    focused
  };
  const textAreaCSS = [textAreaStatusColors(theme), textAreaStyle(theme, styleProps)];
  const rightStatusCSS = [textAreaStatusColors(theme), rightStatusIconCSS(theme, styleProps)];
  const textAreaContainerCSS = [textAreaStatusColors(theme), textAreaContainerStyle(theme, styleProps)];
  function handleOnInput(e) {
    var _props$onInput;
    // we need this to measure the initial scroll height of the element
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
    (_props$onInput = props.onInput) === null || _props$onInput === void 0 ? void 0 : _props$onInput.call(props, e);
  }
  const handleFocus = React.useCallback(e => {
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  }, [onFocus]);
  const handleBlur = React.useCallback(e => {
    setFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  }, [onBlur]);
  return jsxs("div", {
    css: textAreaContainerCSS,
    "data-field-control": true,
    children: [jsx("textarea", {
      css: textAreaCSS,
      onFocus: handleFocus,
      onBlur: handleBlur,
      rows: 4,
      ref: ref,
      ...rest,
      onInput: resize === "auto" ? handleOnInput : rest.onInput
    }), status === FormFieldStatus.Success && jsx("div", {
      css: rightStatusCSS,
      "aria-hidden": true,
      children: jsx(Icon, {
        size: "10px",
        name: Glyph.Tick
      })
    }), status === FormFieldStatus.Danger && jsx("div", {
      css: rightStatusCSS,
      "aria-hidden": true,
      children: jsx(Icon, {
        size: "10px",
        name: Glyph.Close
      })
    })]
  });
});

const vars$a = {
  containerBg: "--upload-container-bg",
  containerBorder: "--upload-container-border"
};
const uploadColorVars = (theme, props) => {
  var _props$bg, _props$bg2;
  const isDisabled = props.status === "disabled" || props.status === "uploading";
  const light = {
    [vars$a.containerBg]: isDisabled ? theme.color(Color.Greystone_700_A38) : theme.color((_props$bg = props.bg) !== null && _props$bg !== void 0 ? _props$bg : ColorPreset.BackgroundLight_03),
    [vars$a.containerBorder]: isDisabled ? theme.color(Color.Greystone_700_A38) : theme.color(ColorPreset.BorderOnLight_04)
  };
  const dark = {
    [vars$a.containerBg]: isDisabled ? theme.color(Color.Greystone_700_A16) : theme.color((_props$bg2 = props.bg) !== null && _props$bg2 !== void 0 ? _props$bg2 : ColorPreset.BackgroundDark_04),
    [vars$a.containerBorder]: isDisabled ? theme.color(Color.Greystone_700_A16) : theme.color(ColorPreset.BorderOnLight_04)
  };
  switch (props.colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const uploadStyle = (theme, props) => {
  return [uploadColorVars(theme, props), {
    position: "relative",
    border: `1px solid var(${vars$a.containerBorder})`,
    borderRadius: theme.radius(1),
    backgroundColor: `var(${vars$a.containerBg})`
  }];
};
const wrapperStyle = {
  opacity: 0,
  zIndex: "-1",
  position: "absolute"
};

var UploadStatus;
(function (UploadStatus) {
  UploadStatus["Initial"] = "initial";
  UploadStatus["Disabled"] = "disabled";
  UploadStatus["Uploading"] = "uploading";
})(UploadStatus || (UploadStatus = {}));
var UploadSelectionMode;
(function (UploadSelectionMode) {
  UploadSelectionMode["Single"] = "single";
  UploadSelectionMode["Multiple"] = "multiple";
})(UploadSelectionMode || (UploadSelectionMode = {}));

const Upload = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _selectedFiles$, _selectedFiles$2;
  const {
    theme
  } = useTheme();
  const {
    colorScheme,
    buttonLayout,
    accept,
    description,
    selectionMode,
    status,
    errors,
    translations,
    onSelectFiles,
    uploadDescribeby,
    ...rest
  } = props;
  const emptyFile = new File([], "");
  const [selectedFiles, setSelectedFiles] = React.useState([emptyFile]);
  const onChangeInput = event => {
    const files = event.currentTarget.files && event.currentTarget.files[0] ? Array.from(event.currentTarget.files) : [];
    onChangeFile(files);
  };
  const removeFile = file => {
    const files = selectedFiles.filter(x => x !== file);
    setSelectedFiles(files);
    onSelectFiles(files);
  };
  const onChangeFile = files => {
    const newFiles = files.filter(({
      name,
      lastModified
    }) => !selectedFiles.some(({
      name: selectedName,
      lastModified: selectedLastModified
    }) => name === selectedName && lastModified === selectedLastModified));
    let updatedFiles;
    if (isMultiple) {
      updatedFiles = isFileSelected ? selectedFiles.concat(newFiles) : newFiles;
    } else {
      updatedFiles = files;
    }
    setSelectedFiles(updatedFiles);
    onSelectFiles(updatedFiles);
  };
  const isFileSelected = selectedFiles.length > 0 && ((_selectedFiles$ = selectedFiles[0]) === null || _selectedFiles$ === void 0 ? void 0 : _selectedFiles$.size) != null && ((_selectedFiles$2 = selectedFiles[0]) === null || _selectedFiles$2 === void 0 ? void 0 : _selectedFiles$2.size) > 0;
  React.useEffect(() => {
    if (status === UploadStatus.Initial) {
      setSelectedFiles([emptyFile]);
    }
  }, [status]);
  const inputRef = React.useRef(null);
  const onClick = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  };
  let color;
  let descriptionColor;
  let uploadFileButtonVariant;
  let removeFileButtonVariant;
  const isDisabledStatus = status === UploadStatus.Disabled;
  const isUploading = status === UploadStatus.Uploading;
  const isDisabledColours = status === UploadStatus.Disabled || status === UploadStatus.Uploading;
  const isMultiple = selectionMode === UploadSelectionMode.Multiple;
  switch (colorScheme) {
    case ColorScheme.OnLight:
      color = isDisabledColours ? ColorPreset.TextOnLight_03 : ColorPreset.TextOnLight_01;
      descriptionColor = ColorPreset.TextOnLight_03;
      uploadFileButtonVariant = ButtonVariant.TextOnLight;
      removeFileButtonVariant = ButtonVariant.TextOnLight;
      break;
    case ColorScheme.OnDark:
      color = isDisabledColours ? ColorPreset.TextOnDark_01 : ColorPreset.TextOnDark_01;
      descriptionColor = ColorPreset.TextOnDark_01;
      uploadFileButtonVariant = ButtonVariant.TextOnDark;
      removeFileButtonVariant = ButtonVariant.TextOnDark;
      break;
    default:
      color = ColorPreset.TextOnDark_01;
      descriptionColor = ColorPreset.TextOnDark_01;
      uploadFileButtonVariant = ButtonVariant.TextAuto;
      removeFileButtonVariant = ButtonVariant.TextOnLight;
  }
  const chooseFileLabel = `${(translations === null || translations === void 0 ? void 0 : translations.chooseFile) || (isMultiple ? "Choose files" : "Choose file")}`;
  const chooseButtonLabel = `${isUploading ? (translations === null || translations === void 0 ? void 0 : translations.uploadingLabel) || "Uploading" : chooseFileLabel}`;
  return jsxs("div", {
    ref: ref,
    children: [jsxs(Box, {
      layout: "flex",
      flexDirection: "column",
      alignItems: AlignItems.Center,
      css: uploadStyle(theme, props),
      gutterV: 1.5,
      gutterH: 2,
      spaceBelow: 1,
      children: [jsx(Box, {
        layout: "flex",
        alignItems: AlignItems.Center,
        children: jsx(Button, {
          disabled: isDisabledStatus || isUploading,
          rightIcon: status === UploadStatus.Uploading ? Glyph.Spinner : Glyph.PaperClip,
          variant: uploadFileButtonVariant,
          onClick: onClick,
          size: ButtonSize.Sm,
          "aria-label": chooseButtonLabel,
          "aria-describedby": uploadDescribeby,
          children: chooseButtonLabel
        })
      }), description && jsx(Box, {
        spaceAbove: 0.75,
        children: jsx(P, {
          color: descriptionColor,
          size: 2,
          textAlign: TextAlign.Center,
          children: description
        })
      }), jsx(Box, {
        css: wrapperStyle,
        children: jsx(Input, {
          type: "file",
          multiple: isMultiple,
          onChange: onChangeInput,
          ...rest,
          ref: inputRef,
          accept: accept,
          tabIndex: -1
        })
      })]
    }), isFileSelected && jsx(Box, {
      spaceAbove: 1.5,
      children: selectedFiles.map((file, index) => jsxs(Box, {
        layout: "flex",
        flexDirection: "row",
        spaceBelow: index === selectedFiles.length - 1 ? 0 : 0.5,
        children: [jsx(IconButton, {
          label: translations !== null && translations !== void 0 && translations.removeFile ? `${translations === null || translations === void 0 ? void 0 : translations.removeFile} ${file.name}` : "Remove file",
          size: {
            base: ButtonSize.Sm,
            gutters: ButtonGutter.Sm
          },
          variant: removeFileButtonVariant,
          icon: Glyph.Close,
          onClick: () => removeFile(file)
        }), jsx(Space, {
          h: 0.75,
          layout: "inline"
        }), jsx(P, {
          color: color,
          size: 2,
          children: file.name
        })]
      }, `${index}_${file.name}`))
    }), errors && errors.map(error => jsx(Box, {
      spaceBelow: 1,
      children: jsx(Hint, {
        status: FormFieldStatus.Danger,
        children: error
      })
    }, error))]
  });
});

/**
 * Returns the string representation of a calendar date.
 */
const asString = d => {
  const pm = `${d.month}`.padStart(2, "0");
  const pd = `${d.day}`.padStart(2, "0");
  return `${d.year}-${pm}-${pd}`;
};
/**
 * Converts a JavaScript `Date` object into a calendar date.
 */
const toCalendarDate = d => {
  return {
    year: d.getFullYear(),
    month: d.getMonth() + 1,
    day: d.getDate()
  };
};
/**
 * Returns a JavaScript `Date` object given a calendar date.
 */
const fromCalendarDate = d => {
  return new Date(d.year, d.month - 1, d.day);
};
/**
 * Compares two dates and returns 0 if they are equal, -1 if the first date is
 * before than the second date and 1 if the first date is after than the second
 * date.
 */
const compare = (a, b) => {
  const dy = a.year - b.year;
  const dm = a.month - b.month;
  const dd = a.day - b.day;
  return dy || dm || dd;
};
/**
 * Adds (or subtracts) a delta value from a given calendar date.
 */
const add = (d, delta) => {
  const {
    year: dy = 0,
    month: dm = 0,
    day: dd = 0
  } = delta;
  return toCalendarDate(new Date(d.year + dy, d.month + dm - 1, d.day + dd));
};
/**
 * Returns the first day of the week where the given date falls.
 */
const startOfWeek = d => {
  const offset = dayInMondayWeek(d);
  return toCalendarDate(new Date(d.year, d.month - 1, d.day - offset));
};
/**
 * Returns the last day of the week where the given date falls.
 */
const endOfWeek = d => {
  const offset = 6 - dayInMondayWeek(d);
  return toCalendarDate(new Date(d.year, d.month - 1, d.day + offset));
};
/**
 * Subtracts one month to the given date and accounts for overflow such that
 * moving back one month from 2020-03-31 results in 2020-02-29.
 */
const backOneMonth = d => {
  return toCalendarDate(addMonths(fromCalendarDate(d), -1));
};
/**
 * Adds one month to the given date and accounts for overflow such that
 * advancing one month from 2020-01-31 results in 2020-02-28.
 */
const forwardOneMonth = d => {
  return toCalendarDate(addMonths(fromCalendarDate(d), 1));
};
/**
 * Subtracts one year to the given date and accounts for overflow such that
 * moving back one year from 2020-02-29 results in 2019-02-28.
 */
const backOneYear = d => {
  return toCalendarDate(addYears(fromCalendarDate(d), -1));
};
/**
 * Adds one year to the given date and accounts for overflow such that advancing
 * one year from 2020-02-29 results in 2021-02-28.
 */
const forwardOneYear = d => {
  return toCalendarDate(addYears(fromCalendarDate(d), 1));
};
/**
 * Calculates the index of a day in a calendar week that starts on Monday.
 */
const dayInMondayWeek = d => {
  const dayInSundayWeek = fromCalendarDate(d).getDay();
  return dayInSundayWeek === 0 ? 6 : dayInSundayWeek - 1;
};
/**
 * Checks that a CalendarDate is valid and doesn't contain overflowing
 * day/month/year combos such as 2022-02-31.
 */
const validate = d => {
  const result = fromCalendarDate(d);
  const isValid = result.getFullYear() === d.year && result.getMonth() + 1 === d.month && result.getDate() === d.day;
  return isValid ? d : null;
};
/**
 * Checks that a partial CalendarDate is valid and doesn't contain overflowing
 * day/month/year combos such as 2022-02-31.
 */
const validatePartial = d => {
  if (!d) return null;
  const {
    day,
    month,
    year
  } = d;
  if (day == null || month == null || year == null) {
    return null;
  }
  return validate({
    day,
    month,
    year
  });
};
/**
 * Checks if the date is within range of min and max date.
 */
const dateInRange = ({
  min,
  max,
  dt
}) => {
  if (!min && !max) return true;
  // Return false if date is before min date or after max date
  if (min && compare(dt, min) < 0 || max && compare(dt, max) > 0) {
    return false;
  }
  return true;
};

var dateHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  add: add,
  asString: asString,
  backOneMonth: backOneMonth,
  backOneYear: backOneYear,
  compare: compare,
  dateInRange: dateInRange,
  dayInMondayWeek: dayInMondayWeek,
  endOfWeek: endOfWeek,
  forwardOneMonth: forwardOneMonth,
  forwardOneYear: forwardOneYear,
  fromCalendarDate: fromCalendarDate,
  startOfWeek: startOfWeek,
  toCalendarDate: toCalendarDate,
  validate: validate,
  validatePartial: validatePartial
});

const calendarSize$2 = ["sm", "md"];
const vars$9 = {
  maxWidth: "--datepickercalendar-max-width",
  gutterV: "--datepickercalendar-gutterv",
  gutterH: "--datepickercalendar-gutterh",
  spacing: "--datepickercalendar-spacing",
  bg: "--datepickercalendar-bg",
  weekColor: "--datepickercalendar-week-color",
  cellGutterV: "--datepickercalendar-cell-gutterv",
  cellGutterH: "--datepickercalendar-cell-gutterh",
  buttonSize: "--datepickercalendar-button-size",
  buttonColor: "--datepickercalendar-button-color",
  buttonDisabledColor: "--datepickercalendar-button-disabled-color",
  buttonOutline: "--datepickercalendar-button-outline-color",
  buttonHoverBg: "--datepickercalendar-button-hover-bg",
  buttonSelectedBg: "--datepickercalendar-button-selected-bg",
  buttonSelectedDisabledBg: "--datepickercalendar-button-selected-disabled-bg",
  buttonSelectedColor: "--datepickercalendar-button-selected-color"
};
const calendarStyle$1 = theme => {
  return [{
    [vars$9.spacing]: theme.spacing(1),
    [vars$9.bg]: theme.color(ColorPreset.BackgroundLight_01),
    [vars$9.weekColor]: theme.color(ColorPreset.TextOnLight_03),
    [vars$9.buttonColor]: theme.color(ColorPreset.TextOnLight_01),
    [vars$9.buttonDisabledColor]: theme.color(Color.Greystone_1400_A38),
    [vars$9.buttonOutline]: theme.color(ColorPreset.BorderOnLight_01),
    [vars$9.buttonHoverBg]: theme.color(Color.Greystone_900_A21),
    [vars$9.buttonSelectedBg]: theme.color(Color.Greystone_DarkMatter),
    [vars$9.buttonSelectedDisabledBg]: theme.color(Color.Greystone_1400_A8),
    [vars$9.buttonSelectedColor]: theme.color(ColorPreset.TextOnDark_01),
    [vars$9.cellGutterV]: theme.spacing(0.25),
    [vars$9.cellGutterH]: theme.spacing(0.25)
  }, theme.responsive(calendarSize$2, s => {
    switch (s) {
      case "sm":
        return {
          [vars$9.maxWidth]: "none",
          [vars$9.buttonSize]: "32px",
          [vars$9.gutterV]: theme.spacing(0.5),
          [vars$9.gutterH]: theme.spacing(0.5)
        };
      case "md":
        return {
          [vars$9.maxWidth]: "412px",
          [vars$9.buttonSize]: "40px",
          [vars$9.gutterV]: theme.spacing(2),
          [vars$9.gutterH]: theme.spacing(2)
        };
    }
  }), {
    background: `var(${vars$9.bg})`,
    borderRadius: theme.radius(1),
    filter: theme.tokens.elevation[4],
    padding: `var(${vars$9.gutterV}) var(${vars$9.gutterH})`,
    maxWidth: `var(${vars$9.maxWidth})`,
    flex: "1 1 auto"
  }];
};
const calendarHeaderStyle = {
  display: "grid",
  gridTemplateColumns: "max-content auto max-content",
  alignItems: "center",
  marginBottom: `var(${vars$9.spacing})`
};
const calendarGridStyle$1 = {
  textAlign: "center",
  borderCollapse: "collapse",
  width: "100%",
  th: {
    padding: `0 0 var(${vars$9.spacing})`
  },
  td: {
    padding: `var(${vars$9.cellGutterV}) var(${vars$9.cellGutterH})`
  },
  "td,th": {
    "&:first-of-type": {
      paddingLeft: 0
    },
    "&:last-of-type": {
      paddingRight: 0
    }
  },
  "tr:first-of-type > td": {
    paddingTop: 0
  },
  "tr:last-of-type > td": {
    paddingBottom: 0
  }
};
const calendarWeekHeaderStyle = {
  textDecoration: "none",
  fontWeight: FontWeight.SemiBold,
  color: `var(${vars$9.weekColor})`
};
const calendarButtonStyle = {
  width: `var(${vars$9.buttonSize})`,
  height: `var(${vars$9.buttonSize})`,
  borderRadius: `var(${vars$9.buttonSize})`,
  background: "none",
  margin: 0,
  padding: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  border: "none",
  fontFamily: "inherit",
  lineHeight: "inherit",
  fontWeight: FontWeight.SemiBold,
  color: `var(${vars$9.buttonColor})`,
  "&:hover": {
    background: `var(${vars$9.buttonHoverBg})`,
    color: `var(${vars$9.buttonColor})`
  },
  "&:focus": {
    background: "none",
    color: `var(${vars$9.buttonColor})`
  },
  "&[data-selected=true]": {
    background: `var(${vars$9.buttonSelectedBg})`,
    color: `var(${vars$9.buttonSelectedColor})`
  },
  "&[data-highlighted=true]": {
    "&:focus, &:hover": {
      background: "none"
    }
  },
  "&:disabled": {
    color: `var(${vars$9.buttonDisabledColor})`,
    background: "none",
    "&:focus, &:hover": {
      background: "none"
    },
    "&[data-selected=true]": {
      background: `var(${vars$9.buttonSelectedDisabledBg})`
    }
  }
};
const hideButton = {
  visibility: "hidden"
};
const highlightCalendarButton = (theme, props) => {
  return {
    background: props ? theme.color(props) : "none",
    border: props ? `2px solid ${theme.color(props)}` : "none",
    color: `var(${vars$9.buttonSelectedColor})`
  };
};

const CalendarHeader = props => {
  const {
    i18n,
    focusedDate,
    minDate,
    maxDate
  } = props;
  // Disable previous button of current date is less than min date
  const disablePrev = !dateInRange({
    min: minDate,
    dt: {
      ...focusedDate,
      day: 1
    }
  });
  // Disable next button of current date is less than max date
  const disableNext = !dateInRange({
    max: maxDate,
    dt: {
      ...focusedDate,
      day: 31
    }
  });
  return jsxs("div", {
    css: calendarHeaderStyle,
    children: [jsx(IconButton, {
      icon: Glyph.ChevronLeft,
      variant: ButtonVariant.TextOnLight,
      size: ButtonSize.Sm,
      label: i18n.previousMonthButtonLabel,
      onClick: props.onPrevious,
      disabled: disablePrev
    }), jsx(Text, {
      textAlign: TextAlign.Center,
      weight: FontWeight.SemiBold,
      "aria-live": "polite",
      children: i18n.getMonthYearLabel(focusedDate)
    }), jsx(IconButton, {
      icon: Glyph.ChevronRight,
      variant: ButtonVariant.TextOnLight,
      size: ButtonSize.Sm,
      label: i18n.nextMonthButtonLabel,
      onClick: props.onNext,
      disabled: disableNext
    })]
  });
};

const calendarSize$1 = ["sm", "md"];
const vars$8 = {
  maxWidth: "--daterangepickercalendar-max-width",
  gutterV: "--daterangepickercalendar-gutterv",
  gutterH: "--daterangepickercalendar-gutterh",
  spacing: "--daterangepickercalendar-spacing",
  bg: "--daterangepickercalendar-bg",
  weekColor: "--daterangepickercalendar-week-color",
  cellGutterV: "--daterangepickercalendar-cell-gutterv",
  cellGutterH: "--daterangepickercalendar-cell-gutterh",
  buttonSize: "--daterangepickercalendar-button-size",
  buttonColor: "--daterangepickercalendar-button-color",
  buttonDisabledColor: "--daterangepickercalendar-button-disabled-color",
  buttonHoverBg: "--daterangepickercalendar-button-hover-bg",
  buttonRangeHoverBg: "--daterangepickercalendar-button-range-hover-bg",
  buttonSelectedBg: "--daterangepickercalendar-button-selected-bg",
  buttonSelectedDisabledBg: "--daterangepickercalendar-button-selected-disabled-bg",
  buttonSelectedColor: "--daterangepickercalendar-button-selected-color"
};
const calendarStyle = theme => {
  return [{
    [vars$8.spacing]: theme.spacing(1),
    [vars$8.bg]: theme.color(ColorPreset.BackgroundLight_01),
    [vars$8.weekColor]: theme.color(ColorPreset.TextOnLight_03),
    [vars$8.buttonColor]: theme.color(ColorPreset.TextOnLight_01),
    [vars$8.buttonDisabledColor]: theme.color(Color.Greystone_1400_A38),
    [vars$8.buttonHoverBg]: theme.color(ColorPreset.BackgroundLight_03),
    [vars$8.buttonRangeHoverBg]: theme.color(ColorPreset.BackgroundLight_03),
    [vars$8.buttonSelectedBg]: theme.color(Color.Greystone_DarkMatter),
    [vars$8.buttonSelectedDisabledBg]: theme.color(Color.Greystone_1400_A8),
    [vars$8.buttonSelectedColor]: theme.color(ColorPreset.TextOnDark_01),
    [vars$8.cellGutterV]: theme.spacing(0.5),
    [vars$8.cellGutterH]: theme.spacing(0.5)
  }, theme.responsive(calendarSize$1, s => {
    switch (s) {
      case "sm":
        return {
          [vars$8.maxWidth]: "280px",
          [vars$8.buttonSize]: "32px",
          [vars$8.gutterV]: theme.spacing(1),
          [vars$8.gutterH]: theme.spacing(1.5)
        };
      case "md":
        return {
          [vars$8.maxWidth]: "354px",
          [vars$8.buttonSize]: "40px",
          [vars$8.gutterV]: theme.spacing(1.5),
          [vars$8.gutterH]: theme.spacing(2)
        };
    }
  }), {
    background: `var(${vars$8.bg})`,
    borderRadius: theme.radius(1),
    filter: theme.tokens.elevation[4],
    maxWidth: `var(${vars$8.maxWidth})`,
    flex: "1 1 auto"
  }];
};
const calendarPaddingStyle = {
  padding: `var(${vars$8.gutterV}) var(${vars$8.gutterH})`
};
const calendarFooterButtonStyle = theme => {
  return [{
    borderTop: `1px solid ${theme.color(Color.Greystone_500)}`,
    textAlign: "right"
  }, calendarPaddingStyle];
};
const calendarRangeStyle = ({
  hightlightOnSelection,
  isFromDate,
  isToDate,
  isHoverDate
}) => {
  return [isFromDate ? {
    borderTopLeftRadius: "100%",
    borderBottomLeftRadius: "100%"
  } : {}, !hightlightOnSelection && isHoverDate || isToDate ? {
    borderTopRightRadius: "100%",
    borderBottomRightRadius: "100%"
  } : {}];
};
const calendarGridStyle = {
  textAlign: "center",
  borderCollapse: "separate",
  borderSpacing: `0 var(${vars$8.cellGutterV})`,
  th: {
    padding: `0 0 var(${vars$8.spacing})`
  },
  td: {
    "&[data-highlighted=true]": {
      background: `var(${vars$8.buttonRangeHoverBg})`
    }
  },
  width: `var(${vars$8.buttonSize})`,
  height: `var(${vars$8.buttonSize})`,
  "td,th": {
    "&:first-of-type": {
      paddingLeft: 0
    },
    "&:last-of-type": {
      paddingRight: 0
    }
  },
  "tr:first-of-type > td": {
    paddingTop: 0
  },
  "tr:last-of-type > td": {
    paddingBottom: 0
  }
};
({
  textDecoration: "none",
  fontWeight: FontWeight.SemiBold,
  color: `var(${vars$8.weekColor})`
});
const calendarRangeButtonStyle = {
  width: `var(${vars$8.buttonSize})`,
  height: `var(${vars$8.buttonSize})`,
  borderRadius: `var(${vars$8.buttonSize})`,
  background: "none",
  margin: 0,
  padding: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  border: "none",
  fontFamily: "inherit",
  lineHeight: "inherit",
  fontWeight: FontWeight.SemiBold,
  color: `var(${vars$8.buttonColor})`,
  "&:hover": {
    background: `var(${vars$8.buttonHoverBg})`,
    color: `var(${vars$8.buttonColor})`
  },
  "&[data-selected=true]": {
    background: `var(${vars$8.buttonSelectedBg})`,
    color: `var(${vars$8.buttonSelectedColor})`
  },
  "&[data-highlighted=true]": {
    "&:focus, &:hover": {
      background: "none"
    }
  },
  "&:disabled": {
    color: `var(${vars$8.buttonDisabledColor})`,
    background: "none",
    "&:focus, &:hover": {
      background: "none"
    },
    "&[data-selected=true]": {
      background: `var(${vars$8.buttonSelectedDisabledBg})`
    }
  }
};
const highlightCalendarRangeButton = (theme, props) => {
  return {
    background: props ? theme.color(props) : "none",
    border: props ? `2px solid ${theme.color(props)}` : "none",
    color: `var(${vars$8.buttonSelectedColor})`
  };
};

const CalendarButton = props => {
  const {
    children,
    hidden,
    isHighlighted,
    bg,
    date,
    isRangePicker,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  return jsx("button", {
    css: isRangePicker ? [calendarRangeButtonStyle, hidden && hideButton, isHighlighted && highlightCalendarRangeButton(theme, bg)] : [calendarButtonStyle, hidden && hideButton, isHighlighted && highlightCalendarButton(theme, bg)],
    type: "button",
    "data-date": asString(date),
    ...rest,
    children: jsx("span", {
      children: children
    })
  });
};

const CalendarWeekHeader = ({
  i18n
}) => {
  const daysOfWeek = i18n.getDaysOfWeek();
  return jsx("thead", {
    "aria-hidden": true,
    children: jsxs("tr", {
      children: [jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["mon"].full,
          children: daysOfWeek["mon"].short
        })
      }), jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["tue"].full,
          children: daysOfWeek["tue"].short
        })
      }), jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["wed"].full,
          children: daysOfWeek["wed"].short
        })
      }), jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["thu"].full,
          children: daysOfWeek["thu"].short
        })
      }), jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["fri"].full,
          children: daysOfWeek["fri"].short
        })
      }), jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["sat"].full,
          children: daysOfWeek["sat"].short
        })
      }), jsx("th", {
        children: jsx("abbr", {
          css: calendarWeekHeaderStyle,
          title: daysOfWeek["sun"].full,
          children: daysOfWeek["sun"].short
        })
      })]
    })
  });
};

const getFocusedDate = (key, curr, e) => {
  switch (key) {
    case "ArrowRight":
      return add(curr, {
        day: 1
      });
    case "ArrowLeft":
      return add(curr, {
        day: -1
      });
    case "ArrowUp":
      return add(curr, {
        day: -7
      });
    case "ArrowDown":
      return add(curr, {
        day: 7
      });
    case "Home":
      return startOfWeek(curr);
    case "End":
      return endOfWeek(curr);
    case "PageUp":
      if (e.shiftKey) {
        return backOneYear(curr);
      } else {
        return backOneMonth(curr);
      }
    case "PageDown":
      if (e.shiftKey) {
        return forwardOneYear(curr);
      } else {
        return forwardOneMonth(curr);
      }
  }
  return curr;
};
const areEqual = (d1, d2) => {
  if (!d1 || !d2) return false;
  return compare(d1, d2) === 0;
};
const isSmaller = (d1, d2) => {
  if (!d1 || !d2) return false;
  return compare(d1, d2) < 0;
};
const flattenHighlightedDates = dt => {
  const dates = [];
  const labels = [];
  if (!dt) return {
    dates,
    labels
  };
  dt.forEach(item => {
    if (item.label) {
      labels.push({
        color: item.color,
        label: item.label
      });
    }
    item.dates.forEach(dateObj => {
      dates.push({
        date: dateObj.date,
        disabled: dateObj.disabled,
        color: item.color,
        label: item.label
      });
    });
  });
  return {
    dates,
    labels
  };
};

const vars$7 = {
  spacing: "--calendarlegend-input-spacing",
  fontSize: "--calendarlegend-font-size",
  labelSpacing: "--calendarlegend-label-spacing"
};
const legendStyle = (theme, color) => {
  return {
    width: theme.spacing(0.5),
    height: theme.spacing(0.25),
    borderRadius: theme.radius(1),
    paddingRight: theme.spacing(0.75),
    paddingLeft: theme.spacing(0.75),
    margin: theme.spacing(0.5),
    backgroundColor: `${theme.color(color)}`
  };
};
const legendWrapperStyle = theme => {
  return [{
    [vars$7.spacing]: theme.spacing(1),
    [vars$7.labelSpacing]: theme.spacing(0.25),
    [vars$7.fontSize]: theme.tokens.fontSizes[TypeScale.Size_02].fontSize
  }, {
    display: "flex",
    marginRight: theme.spacing(0.5),
    alignItems: AlignItems.Center,
    fontSize: `var(${vars$7.fontSize})`,
    marginTop: theme.spacing(0.25)
  }];
};
const legendSectionStyle = theme => {
  return {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(1)
  };
};

const CalendarLegend = props => {
  const {
    theme
  } = useTheme();
  const {
    color,
    label
  } = props;
  return jsxs("div", {
    css: legendWrapperStyle(theme),
    children: [jsx("div", {
      css: legendStyle(theme, color)
    }), jsx("div", {
      children: label
    })]
  });
};

const Calendar = props => {
  const {
    i18n,
    defaultDate = toCalendarDate(new Date()),
    onSelect,
    onClose,
    minDate,
    maxDate,
    highlightedDates
  } = props;
  const {
    theme
  } = useTheme();
  const tableRef = React.useRef(null);
  // When interacting with previous/next month buttons we don't want to
  // automatically move focus to any day buttons in the calendar's grid.
  // Otherwise, users will have tab back to those buttons after they click each
  // one. This ref is used track when users interact with buttons other than the
  // day buttons in the grid and we can skip the focus management logic in the
  // hook below.
  const gridFocusFlagRef = React.useRef(true);
  const [focusedDate, setFocusedDate] = React.useState(defaultDate);
  const focusedStr = asString(focusedDate);
  const {
    dates,
    labels
  } = flattenHighlightedDates(highlightedDates);
  const hasLabel = labels.length > 0;
  // Every time we change the focused date using the state hook above, we should
  // focus the corresponding date button.
  useIsomorphicLayoutEffect(() => {
    if (!gridFocusFlagRef.current) {
      gridFocusFlagRef.current = true;
      return;
    }
    const table = tableRef.current;
    if (!table) {
      return;
    }
    const el = table.querySelector(`:scope  [data-date="${focusedStr}"]`);
    if (!(el instanceof HTMLElement)) {
      return;
    }
    el.focus();
  }, [tableRef, focusedStr, gridFocusFlagRef]);
  const first = fromCalendarDate({
    ...focusedDate,
    day: 1
  });
  const last = fromCalendarDate({
    ...focusedDate,
    month: focusedDate.month + 1,
    day: 0
  });
  const firstDateInMonth = toCalendarDate(first);
  const lastDateInMonth = toCalendarDate(last);
  let targetWeek = [];
  const visibleWeeks = [targetWeek];
  for (let i = 0; i < lastDateInMonth.day; i++) {
    const d = {
      ...firstDateInMonth,
      day: firstDateInMonth.day + i
    };
    if (i !== 0 && dayInMondayWeek(d) === 0) {
      targetWeek = [];
      visibleWeeks.push(targetWeek);
    }
    const isFocused = compare(d, focusedDate) === 0;
    const isSelected = compare(d, defaultDate) === 0;
    const isDateWithinRange = dateInRange({
      min: minDate,
      max: maxDate,
      dt: d
    });
    const highlighted = dates.find(hd => areEqual(d, hd.date));
    targetWeek.push(jsx("td", {
      role: "gridcell",
      children: jsx(CalendarButton, {
        date: d,
        isHighlighted: !!highlighted,
        bg: highlighted === null || highlighted === void 0 ? void 0 : highlighted.color,
        tabIndex: isFocused ? 0 : -1,
        "data-autofocus": isFocused,
        "data-selected": isSelected,
        "aria-label": i18n.getDateLabel(d),
        onClick: () => {
          onSelect(d);
          setFocusedDate(d);
        },
        disabled: (highlighted === null || highlighted === void 0 ? void 0 : highlighted.disabled) || !isDateWithinRange,
        children: i18n.getDayLabel(d.day)
      })
    }, asString(d)));
  }
  // Pad the first week if there are not enough days in to fill it in the given
  // month
  for (let i = 0; i < dayInMondayWeek(firstDateInMonth); i++) {
    var _visibleWeeks$;
    const d = add(firstDateInMonth, {
      day: -1 * (i + 1)
    });
    (_visibleWeeks$ = visibleWeeks[0]) === null || _visibleWeeks$ === void 0 ? void 0 : _visibleWeeks$.unshift(jsx("td", {
      role: "gridcell",
      "aria-hidden": true,
      children: jsx(CalendarButton, {
        date: d,
        hidden: true,
        "aria-label": i18n.getDateLabel(d),
        onClick: () => {},
        children: i18n.getDayLabel(d.day)
      })
    }, `startpad-${asString(d)}`));
  }
  // Pad the last week if there are not enough days in to fill it in the given
  // month
  for (let i = 0; i < 6 - dayInMondayWeek(lastDateInMonth); i++) {
    var _visibleWeeks;
    const d = add(lastDateInMonth, {
      day: i + 1
    });
    (_visibleWeeks = visibleWeeks[visibleWeeks.length - 1]) === null || _visibleWeeks === void 0 ? void 0 : _visibleWeeks.push(jsx("td", {
      role: "gridcell",
      "aria-hidden": true,
      children: jsx(CalendarButton, {
        date: d,
        hidden: true,
        "aria-label": i18n.getDateLabel(d),
        onClick: () => {},
        children: i18n.getDayLabel(d.day)
      })
    }, `endpad-${asString(d)}`));
  }
  // The reference for the required keyboard shortcuts can be found on the
  // W3C APG reference for date pickers:
  // https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/datepicker-dialog.html
  const handleRootKeyDown = e => {
    if (e.key === "Escape") {
      onClose();
      return;
    }
  };
  // The reference for the required keyboard shortcuts can be found on the
  // W3C APG reference for date pickers:
  // https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/datepicker-dialog.html
  const handleGridKeyDown = e => {
    const key = e.key;
    setFocusedDate(curr => getFocusedDate(key, curr, e));
  };
  return (
    // We need to handle keyboard shortcuts as outline in the W3C APG guidelines
    // https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/datepicker-dialog.html
    //
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsxs("div", {
      css: calendarStyle$1(theme),
      role: "dialog",
      "aria-modal": true,
      onKeyDown: handleRootKeyDown,
      tabIndex: -1,
      children: [jsx(VisuallyHidden, {
        children: i18n.instructionsText
      }), jsx(CalendarHeader, {
        i18n: i18n,
        onPrevious: () => {
          setFocusedDate(d => backOneMonth(d));
          gridFocusFlagRef.current = false;
        },
        onNext: () => {
          setFocusedDate(d => forwardOneMonth(d));
          gridFocusFlagRef.current = false;
        },
        focusedDate: focusedDate,
        minDate: minDate,
        maxDate: maxDate
      }), jsxs("table", {
        ref: tableRef,
        css: calendarGridStyle$1,
        onKeyDown: handleGridKeyDown,
        role: "grid",
        children: [jsx(CalendarWeekHeader, {
          i18n: i18n
        }), jsx("tbody", {
          children: visibleWeeks.map((week, i) => {
            return jsx("tr", {
              children: week
            }, `${asString(firstDateInMonth)}-${i}`);
          })
        })]
      }), hasLabel && jsx("div", {
        css: legendSectionStyle(theme),
        children: labels.map(hd => {
          return jsx(CalendarLegend, {
            color: hd.color,
            label: hd.label
          }, hd.label);
        })
      })]
    })
  );
};

const inputSize = ["sm", "md"];
const vars$6 = {
  bg: "--dateinput-bg",
  color: "--dateinput-color",
  borderColor: "--dateinput-border-color",
  borderWidth: "--dateinput-border-width",
  gutterH: "--dateinput-gutterh",
  gutterV: "--dateinput-gutterv",
  segmentFocusBg: "--dateinput-segment-focus-bg",
  segmentBorderRadius: "--dateinput-segment-border-radius",
  accessorySpacing: "--dateinput-accessory-spacing"
};
const dateInputStyle = (theme, props) => {
  return [theme.responsive(inputSize, s => {
    switch (s) {
      case "sm":
        return {
          [vars$6.gutterV]: props.compact ? theme.spacing(0.5) : theme.spacing(1)
        };
      case "md":
        return {
          [vars$6.gutterV]: props.compact ? theme.spacing(0.75) : theme.spacing(1)
        };
    }
  }), {
    [vars$6.gutterH]: props.compact ? theme.spacing(0.25) : theme.spacing(1),
    [vars$6.color]: theme.color(ColorPreset.TextOnLight_01),
    [vars$6.bg]: theme.color(ColorPreset.BackgroundLight_01),
    [vars$6.borderColor]: props.status === FormFieldStatus.Danger ? theme.color(ColorPreset.AlertBorderOnLight) : theme.color(ColorPreset.BorderOnLight_02),
    [vars$6.borderWidth]: "1px",
    "&:focus-within": {
      [vars$6.borderWidth]: "2px",
      [vars$6.borderColor]: props.status === FormFieldStatus.Danger ? theme.color(ColorPreset.AlertBorderOnLight) : theme.color(ColorPreset.BorderOnLight_01)
    },
    [vars$6.segmentFocusBg]: theme.color(ColorPreset.BackgroundLight_03),
    [vars$6.segmentBorderRadius]: theme.radius(0.25),
    "&[aria-disabled=true]": {
      [vars$6.color]: theme.color(Color.Greystone_1400_A38),
      [vars$6.bg]: theme.color(Color.Greystone_1400_A8),
      [vars$6.borderColor]: theme.color(Color.Greystone_700_A38)
    }
  }, {
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "center",
    color: `var(${vars$6.color})`,
    backgroundColor: `var(${vars$6.bg})`,
    borderRadius: theme.radius(0.5),
    boxShadow: `inset 0 0 0 var(${vars$6.borderWidth}) var(${vars$6.borderColor})`,
    "&[aria-disabled=true]": {
      cursor: "not-allowed"
    }
  }];
};
const dateInputGroupStyle = {
  display: "inline-flex",
  flexWrap: "nowrap",
  alignItems: "baseline",
  padding: `var(${vars$6.gutterV}) var(${vars$6.gutterH})`
};
const dateInputAccessoriesStyle = {
  display: "inline-flex",
  flexWrap: "nowrap",
  alignItems: "center",
  padding: `0 var(${vars$6.gutterH})`,
  "> * + *": {
    marginLeft: `var(${vars$6.accessorySpacing})`
  }
};
const dateInputSegmentStyle = {
  border: "none",
  padding: 0,
  background: "none",
  fontFamily: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  textAlign: "inherit",
  color: `var(${vars$6.color})`,
  borderRadius: `var(${vars$6.segmentBorderRadius})`,
  "&:focus": {
    outline: "none",
    background: `var(${vars$6.segmentFocusBg})`
  },
  "&:disabled": {
    cursor: "not-allowed"
  }
};

const noop$5 = () => {};
const ch4 = {
  width: "4ch"
};
const ch6 = {
  width: "6ch"
};
const dayRE = /^[0-9]{0,2}$/;
const monthRE = /^[0-9]{0,2}$/;
const yearRE = /^[0-9]{0,4}$/;
const reForMode = mode => {
  switch (mode) {
    case "day":
      return dayRE;
    case "month":
      return monthRE;
    case "year":
      return yearRE;
  }
};
const DateInputSegment = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const genid = React__default.useId();
  const id = props.id || genid;
  const {
    onFinished
  } = props;
  const inValue = props.value;
  const inDefault = props.defaultValue || "";
  const onChange = props.onChange || noop$5;
  const [value, setValue] = useControlledState(inValue, inDefault, onChange);
  const modeRE = reForMode(props.mode);
  const internalLabelId = `${genid}-label`;
  return jsxs("div", {
    children: [jsx(VisuallyHidden, {
      children: jsx("label", {
        id: internalLabelId,
        htmlFor: id,
        children: props.label
      })
    }), jsx("input", {
      id: id,
      ref: ref,
      css: [dateInputSegmentStyle, props.mode === "year" ? ch6 : ch4, props.compact ? {
        fontSize: theme.tokens.fontSizes[TypeScale.Size_02].fontSize
      } : {}, process.env.NODE_ENV === "production" ? "" : ";label:DateInputSegment;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
      disabled: props.disabled,
      type: "text",
      inputMode: "numeric",
      "data-name": props.mode,
      "data-focustarget": true,
      value: value,
      "aria-labelledby": `${props["aria-labelledby"] || ""} ${internalLabelId} ${id}`,
      "aria-invalid": props["aria-invalid"],
      "aria-describedby": props["aria-describedby"],
      placeholder: props.placeholder,
      onChange: e => {
        const val = e.target.value;
        if (!modeRE.test(val)) {
          e.preventDefault();
          e.stopPropagation();
          onFinished === null || onFinished === void 0 ? void 0 : onFinished();
          return;
        }
        setValue(val);
        // Check if we have entered the last character by adding another
        // character and seeing if it breaks the regex checks
        if (!modeRE.test(`${val}0`)) {
          onFinished === null || onFinished === void 0 ? void 0 : onFinished();
        }
      }
    })]
  });
});

var DateInputError;
(function (DateInputError) {
  DateInputError["InvalidDate"] = "invalid-date";
  DateInputError["DateNotInRange"] = "date-not-in-range";
  DateInputError["FromDateGreaterThanToDate"] = "from-date-greater-than-to-date";
})(DateInputError || (DateInputError = {}));
const noop$4 = () => {};
const caps = {
  day: {
    min: 0,
    max: 31
  },
  month: {
    min: 0,
    max: 12
  },
  year: {
    min: 0,
    max: 9999
  }
};
const DateInput = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    id,
    i18n,
    disabled,
    format,
    status,
    rightAccessory,
    value: inValue,
    defaultValue: inDefault = {
      day: undefined,
      month: undefined,
      year: undefined
    },
    minDate,
    maxDate,
    compact,
    onError,
    onChange: inOnChange = noop$4,
    "aria-labelledby": labelIds,
    "aria-describedby": externalDescriptionIds,
    ...rest
  } = props;
  const [errorStatus, setErrorStatus] = React.useState(status);
  const separator = i18n.separator || "/";
  const descriptionId = React.useId();
  const {
    theme
  } = useTheme();
  const [value, setValue] = useControlledState(inValue, inDefault, inOnChange);
  const groupRef = React.useRef(null);
  const cd = value && value.day != null ? `${value.day}` : "";
  const cm = value && value.month != null ? `${value.month}` : "";
  const cy = value && value.year != null ? `${value.year}` : "";
  React.useEffect(() => {
    const error = validateDate(value);
    /**
     * Set the input status to danger if,
     * 1. there is error
     * 2. or user has explicitly asked for it
     **/
    setErrorStatus((error || status) && FormFieldStatus.Danger);
    if (onError) onError(error);
  }, [value, status, minDate, maxDate]);
  const validateDate = dt => {
    if (dt !== null && dt !== void 0 && dt.year && dt !== null && dt !== void 0 && dt.day && dt !== null && dt !== void 0 && dt.month) {
      const isDateWithinRange = dateInRange({
        min: minDate,
        max: maxDate,
        dt: {
          ...dt
        }
      });
      if (!isDateWithinRange) return DateInputError.DateNotInRange;
    } else if (dt !== null && dt !== void 0 && dt.year || dt !== null && dt !== void 0 && dt.day || dt !== null && dt !== void 0 && dt.month) {
      return DateInputError.InvalidDate;
    }
    return;
  };
  const changeHandler = field => v => {
    if (v == null) {
      return;
    }
    const parsed = v ? parseInt(v, 10) : undefined;
    if (v != null && Number.isNaN(parsed)) {
      return;
    }
    const next = value ? {
      ...value
    } : {};
    const cap = caps[field];
    const capped = parsed == null ? undefined : Math.min(cap.max, Math.max(cap.min, parsed));
    next[field] = capped;
    const error = validateDate(next);
    setValue(next, {
      error
    });
  };
  const handleFinish = () => {
    const group = groupRef.current;
    if (group == null || typeof document === "undefined") {
      return;
    }
    if (document.activeElement == null) {
      return;
    }
    const inputs = Array.from(group.querySelectorAll(":scope input"));
    const activeIndex = inputs.indexOf(document.activeElement);
    if (activeIndex < 0) {
      return;
    }
    const nextIndex = activeIndex === inputs.length - 1 ? -1 : activeIndex + 1;
    const nextEl = inputs[nextIndex];
    if (!(nextEl instanceof HTMLElement)) {
      return;
    }
    nextEl.focus();
  };
  const dayInput = jsx(DateInputSegment, {
    value: cd,
    onChange: changeHandler("day"),
    onFinished: handleFinish,
    mode: "day",
    disabled: disabled,
    placeholder: i18n.dayInputPlaceholder,
    label: i18n.dayInputLabel,
    "aria-labelledby": labelIds,
    "aria-invalid": errorStatus === FormFieldStatus.Danger,
    "aria-describedby": `${descriptionId} ${externalDescriptionIds}`,
    compact: compact
  }, "day");
  const monthInput = jsx(DateInputSegment, {
    value: cm,
    onChange: changeHandler("month"),
    onFinished: handleFinish,
    mode: "month",
    disabled: disabled,
    placeholder: i18n.monthInputPlaceholder,
    label: i18n.monthInputLabel,
    "aria-labelledby": labelIds,
    "aria-invalid": errorStatus === FormFieldStatus.Danger,
    "aria-describedby": `${descriptionId} ${externalDescriptionIds}`,
    compact: compact
  }, "month");
  const yearInput = jsx(DateInputSegment, {
    value: cy,
    onChange: changeHandler("year"),
    onFinished: handleFinish,
    mode: "year",
    disabled: disabled,
    placeholder: i18n.yearInputPlaceholder,
    label: i18n.yearInputLabel,
    "aria-labelledby": labelIds,
    "aria-invalid": errorStatus === FormFieldStatus.Danger,
    "aria-describedby": `${descriptionId} ${externalDescriptionIds}`,
    compact: compact
  }, "year");
  const sep1 = jsx("span", {
    "aria-hidden": true,
    children: separator
  }, "sep1");
  const sep2 = jsx("span", {
    "aria-hidden": true,
    children: separator
  }, "sep2");
  let nodes = [];
  switch (format) {
    case "dd-mm-yyyy":
      nodes = [dayInput, sep1, monthInput, sep2, yearInput];
      break;
    case "mm-dd-yyyy":
      nodes = [monthInput, sep1, dayInput, sep2, yearInput];
      break;
    case "yyyy-mm-dd":
      nodes = [yearInput, sep1, monthInput, sep2, dayInput];
      break;
  }
  // Add the id prop to the first input in this component. That way if there
  // is a label with htmlFor set to that id, it can be clicked to focus the
  // first input.
  const first = nodes[0];
  const attrs = {
    id
  };
  if (/*#__PURE__*/React.isValidElement(first)) {
    nodes[0] = /*#__PURE__*/React.cloneElement(first, attrs);
  }
  const isDanger = errorStatus === FormFieldStatus.Danger;
  const validated = value ? validatePartial(value) : null;
  return jsxs("label", {
    ref: ref,
    "data-field-control": true,
    role: "group",
    "aria-disabled": disabled,
    css: dateInputStyle(theme, {
      disabled,
      status: errorStatus,
      compact
    }),
    "aria-describedby": externalDescriptionIds,
    ...rest,
    children: [validated ? jsx(VisuallyHidden, {
      id: descriptionId,
      role: "presentation",
      "aria-live": "polite",
      "aria-labelledby": labelIds,
      children: i18n.getSelectedDateLabel(validated)
    }) : null, jsx("div", {
      css: dateInputGroupStyle,
      ref: groupRef,
      children: nodes
    }), !compact ? jsxs("div", {
      css: dateInputAccessoriesStyle,
      children: [isDanger ? jsx(Icon, {
        name: Glyph.Close,
        color: ColorPreset.AlertIconOnLight,
        size: "12px"
      }) : null, rightAccessory]
    }) : null]
  });
});

const vars$5 = {
  spacing: "--datepicker-range-input-spacing",
  fontSize: "--datepicker-range-input-font-size",
  labelSpacing: "--datepicker-range-input-label-spacing"
};
const calendarSize = ["sm", "md"];
const dataRangeInputsStyle = theme => {
  return [{
    [vars$5.spacing]: theme.spacing(1),
    [vars$5.labelSpacing]: theme.spacing(0.25),
    [vars$5.fontSize]: theme.tokens.fontSizes[TypeScale.Size_02].fontSize
  }, theme.responsive(calendarSize, s => {
    switch (s) {
      case "sm":
        return {
          display: "flex",
          flexDirection: "column",
          ">div:first-of-type": {
            marginBottom: theme.spacing(0.5),
            marginRight: 0,
            marginLeft: 0
          }
        };
      case "md":
        return {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          ">div:first-of-type": {
            marginRight: theme.spacing(0.5),
            marginLeft: `-${theme.spacing(0.25)}`,
            marginBottom: 0
          }
        };
    }
  }), {
    borderBottom: `1px solid ${theme.color(Color.Greystone_500)}`,
    paddingBottom: theme.spacing(1.5)
  }];
};
const labelStyle = {
  fontWeight: FontWeight.SemiBold,
  fontSize: `var(${vars$5.fontSize})`,
  marginBottom: `var(${vars$5.labelSpacing})`,
  display: "block"
};

const DateRangeInputs = ({
  fromDate,
  toDate,
  i18n
}) => {
  const {
    theme
  } = useTheme();
  const genid = React__default.useId();
  const fromInputId = `from-input-${genid}`;
  const fromLabelId = `from-label-${genid}`;
  const toInputId = `to-input-${genid}`;
  const toLabelId = `to-label-${genid}`;
  return jsxs("div", {
    css: [dataRangeInputsStyle(theme), calendarPaddingStyle, process.env.NODE_ENV === "production" ? "" : ";label:DateRangeInputs;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRhdGVSYW5nZUlucHV0cy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWWlCIiwiZmlsZSI6IkRhdGVSYW5nZUlucHV0cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XHJcbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSBcIi4uLy4uL3RoZW1lXCI7XHJcbmltcG9ydCB7IGRhdGFSYW5nZUlucHV0c1N0eWxlLCBsYWJlbFN0eWxlIH0gZnJvbSBcIi4vZGF0ZVJhbmdlSW5wdXRzU3R5bGVzXCI7XHJcbmltcG9ydCB7IGNhbGVuZGFyUGFkZGluZ1N0eWxlIH0gZnJvbSBcIi4vY2FsZW5kYXJSYW5nZVN0eWxlc1wiO1xyXG5pbXBvcnQgRGF0ZUlucHV0IGZyb20gXCIuL0RhdGVJbnB1dFwiO1xyXG5jb25zdCBEYXRlUmFuZ2VJbnB1dHMgPSAoeyBmcm9tRGF0ZSwgdG9EYXRlLCBpMThuIH0pID0+IHtcclxuICAgIGNvbnN0IHsgdGhlbWUgfSA9IHVzZVRoZW1lKCk7XHJcbiAgICBjb25zdCBnZW5pZCA9IFJlYWN0LnVzZUlkKCk7XHJcbiAgICBjb25zdCBmcm9tSW5wdXRJZCA9IGBmcm9tLWlucHV0LSR7Z2VuaWR9YDtcclxuICAgIGNvbnN0IGZyb21MYWJlbElkID0gYGZyb20tbGFiZWwtJHtnZW5pZH1gO1xyXG4gICAgY29uc3QgdG9JbnB1dElkID0gYHRvLWlucHV0LSR7Z2VuaWR9YDtcclxuICAgIGNvbnN0IHRvTGFiZWxJZCA9IGB0by1sYWJlbC0ke2dlbmlkfWA7XHJcbiAgICByZXR1cm4gKDxkaXYgY3NzPXtbZGF0YVJhbmdlSW5wdXRzU3R5bGUodGhlbWUpLCBjYWxlbmRhclBhZGRpbmdTdHlsZV19PlxuICAgICAgPGRpdj5cbiAgICAgICAgPGxhYmVsIGlkPXtmcm9tTGFiZWxJZH0gaHRtbEZvcj17ZnJvbUlucHV0SWR9IGNzcz17bGFiZWxTdHlsZX0+XG4gICAgICAgICAge2kxOG4uZnJvbURhdGVMYWJlbCB8fCBcIkZyb21cIn1cbiAgICAgICAgPC9sYWJlbD5cbiAgICAgICAgPERhdGVJbnB1dCB7Li4uZnJvbURhdGV9IGlkPXtmcm9tSW5wdXRJZH0gY29tcGFjdC8+XG4gICAgICA8L2Rpdj5cbiAgICAgIDxkaXY+XG4gICAgICAgIDxsYWJlbCBpZD17dG9MYWJlbElkfSBodG1sRm9yPXt0b0lucHV0SWR9IGNzcz17bGFiZWxTdHlsZX0+XG4gICAgICAgICAge2kxOG4udG9EYXRlTGFiZWwgfHwgXCJUb1wifVxuICAgICAgICA8L2xhYmVsPlxuICAgICAgICA8RGF0ZUlucHV0IHsuLi50b0RhdGV9IGlkPXt0b0lucHV0SWR9IGNvbXBhY3QvPlxuICAgICAgPC9kaXY+XG4gICAgPC9kaXY+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgRGF0ZVJhbmdlSW5wdXRzO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1EYXRlUmFuZ2VJbnB1dHMuanN4Lm1hcCJdfQ== */"],
    children: [jsxs("div", {
      children: [jsx("label", {
        id: fromLabelId,
        htmlFor: fromInputId,
        css: labelStyle,
        children: i18n.fromDateLabel || "From"
      }), jsx(DateInput, {
        ...fromDate,
        id: fromInputId,
        compact: true
      })]
    }), jsxs("div", {
      children: [jsx("label", {
        id: toLabelId,
        htmlFor: toInputId,
        css: labelStyle,
        children: i18n.toDateLabel || "To"
      }), jsx(DateInput, {
        ...toDate,
        id: toInputId,
        compact: true
      })]
    })]
  });
};

const CalendarRangeFooter = ({
  onChange,
  setFromDate,
  setToDate,
  validFromDate,
  validToDate,
  i18n,
  canApply,
  onClose
}) => {
  const {
    theme
  } = useTheme();
  return jsxs("div", {
    css: calendarFooterButtonStyle(theme),
    children: [jsx(Button, {
      variant: ButtonVariant.TextOnLight,
      layout: ButtonLayout.Inline,
      onClick: () => {
        onChange && onChange([]);
        setFromDate(undefined);
        setToDate(undefined);
      },
      size: ButtonSize.Sm,
      css: /*#__PURE__*/css({
        marginRight: theme.spacing(0.5)
      }, process.env.NODE_ENV === "production" ? "" : ";label:CalendarRangeFooter;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhbGVuZGFyUmFuZ2VGb290ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVnQyIsImZpbGUiOiJDYWxlbmRhclJhbmdlRm9vdGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJ1dHRvbiwgQnV0dG9uTGF5b3V0LCBCdXR0b25WYXJpYW50IH0gZnJvbSBcIi4uLy4uL2J1dHRvbnNcIjtcclxuaW1wb3J0IHsgQnV0dG9uU2l6ZSwgdXNlVGhlbWUgfSBmcm9tIFwiLi4vLi4vdGhlbWVcIjtcclxuaW1wb3J0IHsgY2FsZW5kYXJGb290ZXJCdXR0b25TdHlsZSB9IGZyb20gXCIuL2NhbGVuZGFyUmFuZ2VTdHlsZXNcIjtcclxuY29uc3QgQ2FsZW5kYXJSYW5nZUZvb3RlciA9ICh7IG9uQ2hhbmdlLCBzZXRGcm9tRGF0ZSwgc2V0VG9EYXRlLCB2YWxpZEZyb21EYXRlLCB2YWxpZFRvRGF0ZSwgaTE4biwgY2FuQXBwbHksIG9uQ2xvc2UsIH0pID0+IHtcclxuICAgIGNvbnN0IHsgdGhlbWUgfSA9IHVzZVRoZW1lKCk7XHJcbiAgICByZXR1cm4gKDxkaXYgY3NzPXtjYWxlbmRhckZvb3RlckJ1dHRvblN0eWxlKHRoZW1lKX0+XG4gICAgICA8QnV0dG9uIHZhcmlhbnQ9e0J1dHRvblZhcmlhbnQuVGV4dE9uTGlnaHR9IGxheW91dD17QnV0dG9uTGF5b3V0LklubGluZX0gb25DbGljaz17KCkgPT4ge1xyXG4gICAgICAgICAgICBvbkNoYW5nZSAmJiBvbkNoYW5nZShbXSk7XHJcbiAgICAgICAgICAgIHNldEZyb21EYXRlKHVuZGVmaW5lZCk7XHJcbiAgICAgICAgICAgIHNldFRvRGF0ZSh1bmRlZmluZWQpO1xyXG4gICAgICAgIH19IHNpemU9e0J1dHRvblNpemUuU219IGNzcz17eyBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZygwLjUpIH19PlxuICAgICAgICB7aTE4bi5jbGVhckJ1dHRvbkxhYmVsIHx8IFwiQ2xlYXJcIn1cbiAgICAgIDwvQnV0dG9uPlxuICAgICAgPEJ1dHRvbiB2YXJpYW50PXtCdXR0b25WYXJpYW50LlByaW1hcnlPbkxpZ2h0fSBsYXlvdXQ9e0J1dHRvbkxheW91dC5JbmxpbmV9IGRpc2FibGVkPXshY2FuQXBwbHl9IG9uQ2xpY2s9eygpID0+IHtcclxuICAgICAgICAgICAgaWYgKG9uQ2hhbmdlICYmIGNhbkFwcGx5KSB7XHJcbiAgICAgICAgICAgICAgICBvbkNoYW5nZShbdmFsaWRGcm9tRGF0ZSwgdmFsaWRUb0RhdGVdKTtcclxuICAgICAgICAgICAgICAgIG9uQ2xvc2UgJiYgb25DbG9zZSgpO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfX0gc2l6ZT17QnV0dG9uU2l6ZS5TbX0+XG4gICAgICAgIHtpMThuLmFwcGx5QnV0dG9uTGFiZWwgfHwgXCJBcHBseVwifVxuICAgICAgPC9CdXR0b24+XG4gICAgPC9kaXY+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgQ2FsZW5kYXJSYW5nZUZvb3RlcjtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2FsZW5kYXJSYW5nZUZvb3Rlci5qc3gubWFwIl19 */"),
      children: i18n.clearButtonLabel || "Clear"
    }), jsx(Button, {
      variant: ButtonVariant.PrimaryOnLight,
      layout: ButtonLayout.Inline,
      disabled: !canApply,
      onClick: () => {
        if (onChange && canApply) {
          onChange([validFromDate, validToDate]);
          onClose && onClose();
        }
      },
      size: ButtonSize.Sm,
      children: i18n.applyButtonLabel || "Apply"
    })]
  });
};

const CalendarRange = props => {
  const {
    defaultValue,
    value,
    highlightedDates,
    onClose,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const [defaultFromDate, defaultToDate] = value || [];
  const {
    dates,
    labels
  } = flattenHighlightedDates(highlightedDates);
  const hasLabel = labels.length > 0;
  const tableRef = React.useRef(null);
  // When interacting with previous/next month buttons we don't want to
  // automatically move focus to any day buttons in the calendar's grid.
  // Otherwise, users will have tab back to those buttons after they click each
  // one. This ref is used track when users interact with buttons other than the
  // day buttons in the grid and we can skip the focus management logic in the
  // hook below.
  const gridFocusFlagRef = React.useRef(true);
  const todaysDate = toCalendarDate(new Date());
  const [focusedDate, setFocusedDate] = React.useState(defaultFromDate || todaysDate);
  const [hoverDate, setHoverDate] = React.useState(null);
  const [fromDate, setFromDate] = React.useState(defaultFromDate);
  const [toDate, setToDate] = React.useState(defaultToDate);
  const validFromDate = validatePartial(fromDate);
  const validToDate = validatePartial(toDate);
  const isToDateBeforeFrom = isSmaller(validToDate, validFromDate);
  const isToDateAfterMax = isSmaller(rest.maxDate, validToDate);
  const isFromDateBeforeMin = isSmaller(validFromDate, rest.minDate);
  const isHoverDateAfterMaxDate = isSmaller(rest.maxDate, hoverDate);
  const canApply = validFromDate && validToDate && !isToDateBeforeFrom && !isFromDateBeforeMin && !isToDateAfterMax;
  if (isToDateBeforeFrom && rest.onError) {
    rest.onError(DateInputError.FromDateGreaterThanToDate);
  }
  const focusedStr = asString(focusedDate);
  // Every time we change the focused date using the state hook above, we should
  // focus the corresponding date button.
  useIsomorphicLayoutEffect(() => {
    if (!gridFocusFlagRef.current) {
      gridFocusFlagRef.current = true;
      return;
    }
    const table = tableRef.current;
    if (!table) {
      return;
    }
    const el = table.querySelector(`:scope  [data-date="${focusedStr}"]`);
    if (!(el instanceof HTMLElement)) {
      return;
    }
    el.focus();
  }, [tableRef, focusedStr, gridFocusFlagRef]);
  const first = fromCalendarDate({
    ...focusedDate,
    day: 1
  });
  const last = fromCalendarDate({
    ...focusedDate,
    month: focusedDate.month + 1,
    day: 0
  });
  const firstDateInMonth = toCalendarDate(first);
  const lastDateInMonth = toCalendarDate(last);
  let targetWeek = [];
  const visibleWeeks = [targetWeek];
  for (let i = 0; i < lastDateInMonth.day; i++) {
    const d = {
      ...firstDateInMonth,
      day: firstDateInMonth.day + i
    };
    if (i !== 0 && dayInMondayWeek(d) === 0) {
      targetWeek = [];
      visibleWeeks.push(targetWeek);
    }
    const isFocused = areEqual(d, focusedDate);
    const highlighted = dates.find(hd => areEqual(d, hd.date));
    // Checks for setting border radius for
    // start and end date on hover and selection
    const isFromDate = areEqual(d, validFromDate);
    const isToDate = areEqual(d, validToDate);
    // Checks for highlighting range on hover and selection
    const isHoverDate = areEqual(d, hoverDate);
    const isHoverDateBeforeFrom = !toDate && isSmaller(hoverDate, validFromDate);
    const isSelected = isFromDate || isToDate;
    const hightlightOnHover = hoverDate && validFromDate && !validToDate && dateInRange({
      min: validFromDate,
      max: isHoverDateAfterMaxDate ? rest.maxDate : hoverDate,
      dt: d
    });
    const hightlightOnSelection = validFromDate && validToDate && dateInRange({
      min: isFromDateBeforeMin ? rest.minDate : validFromDate,
      max: isToDateAfterMax ? rest.maxDate : validToDate,
      dt: d
    });
    const isDateWithinRange = dateInRange({
      min: rest.minDate,
      max: rest.maxDate,
      dt: d
    });
    targetWeek.push(jsx("td", {
      role: "gridcell",
      onMouseEnter: () => setHoverDate(d),
      onMouseLeave: () => setHoverDate(null),
      "data-highlighted": hightlightOnHover || hightlightOnSelection,
      css: calendarRangeStyle({
        hightlightOnSelection,
        isFromDate,
        isToDate,
        isHoverDate
      }),
      children: jsx(CalendarButton, {
        date: d,
        isHighlighted: !!highlighted,
        bg: highlighted === null || highlighted === void 0 ? void 0 : highlighted.color,
        tabIndex: isFocused ? 0 : -1,
        "data-autofocus": isFocused,
        "data-selected": isSelected,
        "data-highlighted": hightlightOnSelection && !isFromDate && !isToDate,
        "aria-label": rest.i18n.getDateLabel(d),
        onClick: () => {
          if (!validFromDate || isHoverDateBeforeFrom || validFromDate && validToDate) {
            setFromDate(d);
            setToDate(undefined);
          } else {
            setToDate(d);
          }
          setFocusedDate(d);
        },
        disabled: (highlighted === null || highlighted === void 0 ? void 0 : highlighted.disabled) || !isDateWithinRange,
        isRangePicker: true,
        children: rest.i18n.getDayLabel(d.day)
      })
    }, asString(d)));
  }
  // Pad the first week if there are not enough days in to fill it in the given
  // month
  for (let i = 0; i < dayInMondayWeek(firstDateInMonth); i++) {
    var _visibleWeeks$;
    const d = add(firstDateInMonth, {
      day: -1 * (i + 1)
    });
    (_visibleWeeks$ = visibleWeeks[0]) === null || _visibleWeeks$ === void 0 ? void 0 : _visibleWeeks$.unshift(jsx("td", {
      role: "gridcell",
      "aria-hidden": true,
      children: jsx(CalendarButton, {
        date: d,
        hidden: true,
        "aria-label": rest.i18n.getDateLabel(d),
        onClick: () => {},
        isRangePicker: true,
        children: rest.i18n.getDayLabel(d.day)
      })
    }, `startpad-${asString(d)}`));
  }
  // Pad the last week if there are not enough days in to fill it in the given
  // month
  for (let i = 0; i < 6 - dayInMondayWeek(lastDateInMonth); i++) {
    var _visibleWeeks;
    const d = add(lastDateInMonth, {
      day: i + 1
    });
    (_visibleWeeks = visibleWeeks[visibleWeeks.length - 1]) === null || _visibleWeeks === void 0 ? void 0 : _visibleWeeks.push(jsx("td", {
      role: "gridcell",
      "aria-hidden": true,
      children: jsx(CalendarButton, {
        date: d,
        hidden: true,
        "aria-label": rest.i18n.getDateLabel(d),
        onClick: () => {},
        isRangePicker: true,
        children: rest.i18n.getDayLabel(d.day)
      })
    }, `endpad-${asString(d)}`));
  }
  // The reference for the required keyboard shortcuts can be found on the
  // W3C APG reference for date pickers:
  // https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/datepicker-dialog.html
  const handleRootKeyDown = e => {
    if (e.key === "Escape") {
      onClose && onClose();
      return;
    }
  };
  // The reference for the required keyboard shortcuts can be found on the
  // W3C APG reference for date pickers:
  // https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/datepicker-dialog.html
  const handleGridKeyDown = e => {
    const key = e.key;
    setFocusedDate(curr => getFocusedDate(key, curr, e));
  };
  return (
    // We need to handle keyboard shortcuts as outline in the W3C APG guidelines
    // https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/datepicker-dialog.html
    //
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsxs("div", {
      css: calendarStyle(theme),
      role: "dialog",
      "aria-modal": true,
      onKeyDown: handleRootKeyDown,
      tabIndex: -1,
      children: [jsx(VisuallyHidden, {
        children: rest.i18n.instructionsText
      }), jsx(DateRangeInputs, {
        fromDate: {
          ...rest,
          status: isToDateBeforeFrom ? FormFieldStatus.Danger : rest.status,
          value: fromDate || {},
          onChange: nfd => setFromDate(nfd)
        },
        toDate: {
          ...rest,
          status: isToDateBeforeFrom ? FormFieldStatus.Danger : rest.status,
          value: toDate || {},
          onChange: ntd => setToDate(ntd)
        },
        i18n: rest.i18n
      }), jsxs("div", {
        css: calendarPaddingStyle,
        children: [jsx(CalendarHeader, {
          i18n: rest.i18n,
          onPrevious: () => {
            setFocusedDate(d => backOneMonth(d));
            gridFocusFlagRef.current = false;
          },
          onNext: () => {
            setFocusedDate(d => forwardOneMonth(d));
            gridFocusFlagRef.current = false;
          },
          focusedDate: focusedDate,
          minDate: rest.minDate,
          maxDate: rest.maxDate
        }), jsxs("table", {
          ref: tableRef,
          css: calendarGridStyle,
          onKeyDown: handleGridKeyDown,
          role: "grid",
          children: [jsx(CalendarWeekHeader, {
            i18n: rest.i18n
          }), jsx("tbody", {
            children: visibleWeeks.map((week, i) => {
              return jsx("tr", {
                children: week
              }, `${asString(firstDateInMonth)}-${i}`);
            })
          })]
        }), hasLabel && jsx("div", {
          css: legendSectionStyle(theme),
          children: labels.map(hd => {
            return jsx(CalendarLegend, {
              color: hd.color,
              label: hd.label
            }, hd.label);
          })
        })]
      }), jsx(CalendarRangeFooter, {
        onChange: props.onChange,
        setFromDate: setFromDate,
        setToDate: setToDate,
        validFromDate: validFromDate,
        validToDate: validToDate,
        i18n: props.i18n,
        canApply: canApply,
        onClose: props.onClose
      })]
    })
  );
};

const getDocumentBody = () => {
  if (typeof document === "undefined" || typeof document.body === "undefined") {
    return null;
  }
  return document.body;
};
const placementMiddleware = options => {
  const {
    placementStrategy,
    initialPlacement
  } = options;
  if (placementStrategy === "static") {
    return [];
  }
  // When deciding the set of allowed placements for a tooltip using flip
  // strategy, we will bias this based on the initial placement. For example,
  // if the initial placement is "top-start" then we will assume we can
  // reposition the tooltip above and below its trigger. This is a sensible
  // default behaviour that tries to avoid having the tooltip cover content to
  // the left or right of its trigger. A similar assumption is made if the
  // initial placement is left-* or right-*.
  const majorEdge = initialPlacement.split("-")[0];
  const fallbackPlacements = [];
  if (majorEdge === "left" || majorEdge === "right") {
    fallbackPlacements.push("left", "left-start", "left-end", "right", "right-start", "right-end");
  } else {
    fallbackPlacements.push("top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end");
  }
  return [flip({
    fallbackStrategy: "bestFit",
    fallbackPlacements
  })];
};
const useFloating = options => {
  const {
    open = false,
    arrowRef,
    initialPlacement,
    placementStrategy,
    arrowPadding,
    offset: offsetScale = 0.5,
    shouldUpdate,
    positionStrategy = "fixed"
  } = options;
  const offsetAmount = offsetScale * 16;
  const arrowMiddleware = arrowRef ? [arrow({
    element: arrowRef,
    padding: arrowPadding
  })] : [];
  const result = useFloating$1({
    strategy: positionStrategy,
    placement: initialPlacement,
    middleware: [...placementMiddleware({
      initialPlacement,
      placementStrategy
    }), ...arrowMiddleware,
    // This is the pixel offset of the tooltip from its reference and needs to
    // be adjust to account for the arrow.
    offset$1(offsetAmount)],
    whileElementsMounted: shouldUpdate ? autoUpdate : undefined
  });
  const {
    update
  } = result;
  // We need to track the size of the document so we can reposition the tooltip
  // if it changes.
  const documentRef = React__default.useRef(getDocumentBody());
  useResizeObserver(documentRef, update, [open]);
  // We also need to track the browser scroll position to flip the tooltip
  // reposition if needed.
  useScrollObserver({
    scrollReference: "document",
    callback: update,
    enabled: open && placementStrategy === "flip"
  });
  return result;
};

const datePickerCalendarStyle = (theme, {
  position,
  top,
  left
}) => {
  return {
    position,
    top,
    left,
    zIndex: ZIndex.Dropdown,
    marginTop: theme.spacing(0.5),
    display: "flex",
    justifyContent: "end",
    "&.fade-enter": {
      opacity: 0,
      transform: "translate3d(0, -8px, 0)"
    },
    "&.fade-enter-active": {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
      transition: "opacity 250ms, transform 250ms"
    },
    "&.fade-enter-done": {
      opacity: 1,
      transform: "translate3d(0, 0, 0)"
    },
    "&.fade-exit": {
      opacity: 1,
      transform: "translate3d(0, 0, 0)"
    },
    "&.fade-exit-active": {
      opacity: 0,
      transform: "translate3d(0, -8px, 0)",
      transition: "opacity 250ms, transform 250ms"
    }
  };
};
const datePickerTriggerStyle = (theme, props) => {
  var _props$triggerButton;
  return [{
    marginRight: `calc(-1 * ${theme.spacing(0.75)})`,
    padding: theme.spacing(0.75),
    display: "inline-flex",
    alignItems: "center",
    borderRadius: theme.radius(2),
    "&:focus, &:hover": {
      outline: "none",
      background: theme.color(Color.Greystone_700_A38)
    },
    "&:disabled": {
      background: "none"
    }
  }, (_props$triggerButton = props.triggerButton) === null || _props$triggerButton === void 0 ? void 0 : _props$triggerButton.style];
};
const datePickerTriggerLayoutStyle = _theme => {
  return {
    width: "42px",
    height: "30px",
    position: "absolute",
    zIndex: -1
  };
};

const DatePickerTrigger = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    onClick,
    label,
    triggerButton
  } = props;
  return jsx(PlainButton, {
    ref: ref,
    onClick: onClick,
    disabled: props.disabled,
    css: datePickerTriggerStyle(theme, props),
    children: triggerButton !== null && triggerButton !== void 0 && triggerButton.children ? triggerButton === null || triggerButton === void 0 ? void 0 : triggerButton.children : jsxs(Fragment, {
      children: [jsx(Icon, {
        name: Glyph.Calendar,
        size: "14px"
      }), jsx(VisuallyHidden, {
        children: label
      })]
    })
  });
});

const DatePickerAccessory = ({
  i18n,
  value,
  setValue,
  disabled,
  position = "absolute",
  initialPlacement = "bottom-end",
  placementStrategy = "static",
  minDate,
  maxDate,
  highlightedDates
}) => {
  const {
    theme
  } = useTheme();
  const [calendarOpen, toggleCalendar] = React.useState(false);
  const {
    x,
    y,
    refs,
    update
  } = useFloating({
    open: calendarOpen,
    placementStrategy,
    initialPlacement,
    shouldUpdate: position === "fixed"
  });
  const hitAreaRef = React.useRef(null);
  const floatingRef = refs.floating;
  const tapoutRefs = React.useMemo(() => [floatingRef, hitAreaRef], [floatingRef, hitAreaRef]);
  const onTapOut = React.useCallback(() => {
    toggleCalendar(false);
  }, [toggleCalendar]);
  useTapOut(tapoutRefs, onTapOut);
  const validated = value ? validatePartial(value) : null;
  const calendarTop = y == null ? "" : `${y}px`;
  const calendarLeft = x == null ? "" : `${x}px`;
  return jsxs(Fragment, {
    children: [jsx("div", {
      ref: refs.setReference,
      css: datePickerTriggerLayoutStyle()
    }), jsxs("div", {
      children: [jsx(DatePickerTrigger, {
        ref: hitAreaRef,
        label: i18n.changeDateButtonLabel,
        onClick: () => toggleCalendar(v => !v),
        disabled: disabled,
        "aria-expanded": calendarOpen,
        "aria-haspopup": "dialog"
      }), jsx(CSSTransition, {
        in: calendarOpen,
        timeout: 250,
        classNames: "fade",
        unmountOnExit: true,
        mountOnEnter: true,
        onEnter: update,
        children: jsx("div", {
          ref: refs.setFloating,
          css: datePickerCalendarStyle(theme, {
            position,
            top: calendarTop,
            left: calendarLeft
          }),
          children: jsx(FocusScope, {
            contain: true,
            restoreFocus: true,
            children: jsx(Calendar, {
              defaultDate: validated || undefined,
              i18n: i18n,
              onClose: () => toggleCalendar(false),
              minDate: minDate,
              highlightedDates: highlightedDates,
              maxDate: maxDate,
              onSelect: v => {
                setValue(v);
                toggleCalendar(false);
              }
            })
          })
        })
      })]
    })]
  });
};

const noop$3 = () => {};
const DatePicker = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    calendar = "enabled",
    minDate,
    maxDate,
    highlightedDates,
    ...rest
  } = props;
  const [value, setValue] = useControlledState(props.value, props.defaultValue || {
    day: undefined,
    month: undefined,
    year: undefined
  }, props.onChange || noop$3);
  const calendarOptions = !!calendar && typeof calendar === "object";
  return jsx(DateInput, {
    ...rest,
    minDate: minDate,
    maxDate: maxDate,
    value: value,
    onChange: setValue,
    ref: ref,
    css: /*#__PURE__*/css({
      transform: calendarOptions && calendar.position === "fixed" ? "initial" : undefined
    }, process.env.NODE_ENV === "production" ? "" : ";label:DatePicker;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    rightAccessory: calendar === "enabled" || calendarOptions ? jsx(DatePickerAccessory, {
      disabled: props.disabled,
      i18n: props.i18n,
      setValue: setValue,
      highlightedDates: highlightedDates,
      value: value,
      position: calendarOptions ? calendar.position : undefined,
      minDate: minDate,
      maxDate: maxDate,
      placementStrategy: calendarOptions ? calendar.placementStrategy : undefined,
      initialPlacement: calendarOptions ? calendar.placement : undefined
    }) : null
  });
});

const noop$2 = () => {};
const DateRangePicker = ({
  value = [],
  defaultValue = [],
  highlightedDates,
  onChange,
  triggerButton,
  position = "absolute",
  placement = "bottom-start",
  placementStrategy = "static",
  disabled,
  ...rest
}) => {
  const [propsStartDate, propsEndDate] = value;
  const [propsDefaultStartDate, propsDefaultEndDate] = defaultValue;
  const [startDate, setStartDate] = useControlledState(propsStartDate, propsDefaultStartDate || {
    day: undefined,
    month: undefined,
    year: undefined
  }, noop$2);
  const [endDate, setEndDate] = useControlledState(propsEndDate, propsDefaultEndDate || {
    day: undefined,
    month: undefined,
    year: undefined
  }, noop$2);
  const {
    theme
  } = useTheme();
  const [calendarOpen, toggleCalendar] = React.useState(false);
  const {
    x,
    y,
    refs,
    update
  } = useFloating({
    open: calendarOpen,
    placementStrategy,
    initialPlacement: placement,
    shouldUpdate: position === "fixed"
  });
  const hitAreaRef = React.useRef(null);
  const floatingRef = refs.floating;
  const tapoutRefs = React.useMemo(() => [floatingRef, hitAreaRef], [floatingRef, hitAreaRef]);
  const onTapOut = React.useCallback(() => {
    toggleCalendar(false);
  }, [toggleCalendar]);
  useTapOut(tapoutRefs, onTapOut);
  const newValidatedValue = [];
  const validatedStartDate = startDate ? validatePartial(startDate) : null;
  const validatedEndDate = endDate ? validatePartial(endDate) : null;
  if (validatedStartDate) newValidatedValue.push(validatedStartDate);
  if (validatedEndDate) newValidatedValue.push(validatedEndDate);
  const calendarTop = y == null ? "" : `${y}px`;
  const calendarLeft = x == null ? "" : `${x}px`;
  return jsxs(Fragment, {
    children: [jsx("div", {
      ref: refs.setReference,
      css: datePickerTriggerLayoutStyle()
    }), jsxs("div", {
      children: [jsx(DatePickerTrigger, {
        ref: hitAreaRef,
        label: rest.i18n.changeDateButtonLabel,
        onClick: () => toggleCalendar(v => !v),
        disabled: disabled,
        "aria-expanded": calendarOpen,
        "aria-haspopup": "dialog",
        triggerButton: triggerButton
      }), jsx(CSSTransition, {
        in: calendarOpen,
        timeout: 250,
        classNames: "fade",
        unmountOnExit: true,
        mountOnEnter: true,
        onEnter: update,
        children: jsx("div", {
          ref: refs.setFloating,
          css: datePickerCalendarStyle(theme, {
            position,
            top: calendarTop,
            left: calendarLeft
          }),
          children: jsx(FocusScope, {
            contain: true,
            restoreFocus: true,
            children: jsx(CalendarRange, {
              value: newValidatedValue,
              highlightedDates: highlightedDates,
              onChange: newDates => {
                const [newStartDate, newEndDate] = newDates || [];
                setStartDate(newStartDate || {
                  day: undefined,
                  month: undefined,
                  year: undefined
                });
                setEndDate(newEndDate || {
                  day: undefined,
                  month: undefined,
                  year: undefined
                });
                onChange && onChange(newDates);
                if (newStartDate && newEndDate) toggleCalendar(false);
              },
              ...rest
            })
          })
        })
      })]
    })]
  });
};

var MenuDensity;
(function (MenuDensity) {
  MenuDensity["Compact"] = "compact";
  MenuDensity["Regular"] = "regular";
})(MenuDensity || (MenuDensity = {}));
const vars$4 = {
  level: "--menu-level",
  baseOffset: "--menu-base-offset",
  startOffset: "--menu-start-offset",
  gutterV: "--menu-gutterv",
  gutterH: "--menu-gutterH",
  separatorGutterV: "--menu-separator-gutterv",
  separatorGutterH: "--menu-separator-gutterH",
  color: "--menu-color",
  altColor: "--menu-alt-color",
  disabledColor: "--menu-disabled-color",
  separatorColor: "--menu-separator-color",
  outlineColor: "--menu-outline-color",
  outlineOffsetColor: "--menu-outlineoffset-color",
  accentWidth: "--menu-accent-width",
  accentColor: "--menu-accent-color",
  accentDisabledColor: "--menu-accent-disabled-color",
  groupTitleFontSize: "--menu-grouptitle-fontsize",
  groupTitleLineHeight: "--menu-grouptitle-lineheight",
  groupDescFontSize: "--menu-groupdesc-fontsize",
  groupDescLineHeight: "--menu-groupdesc-lineheight",
  buttonWeight: "--menu-button-weight",
  buttonTitleFontSize: "--menu-buttontitle-fontsize",
  buttonTitleLineHeight: "--menu-buttontitle-lineheight",
  buttonDescFontSize: "--menu-buttondesc-fontsize",
  buttonDescLineHeight: "--menu-buttondesc-lineheight",
  labelSpacing: "--menu-label-spacing",
  labelTitleFontSize: "--menu-labeltitle-fontsize",
  labelTitleLineHeight: "--menu-labeltitle-lineheight",
  labelDescFontSize: "--menu-labeldesc-fontsize",
  labelDescLineHeight: "--menu-labeldesc-lineheight",
  labelDescColor: "--menu-labeldesc-color"
};
const listResetStyle = {
  listStyleType: "none",
  padding: 0,
  margin: 0
};
const listItemResetStyle = {
  display: "block",
  width: "100%"
};
const menuColorTokens = (theme, colorScheme) => {
  const light = {
    [vars$4.color]: theme.color(ColorPreset.TextOnLight_01),
    [vars$4.altColor]: theme.color(ColorPreset.TextOnLight_03),
    [vars$4.disabledColor]: theme.color(Color.Greystone_1400_A38),
    [vars$4.separatorColor]: theme.color(ColorPreset.BorderOnLight_05),
    [vars$4.accentColor]: theme.color(Color.Greystone_DarkMatter),
    [vars$4.accentDisabledColor]: theme.color(Color.Greystone_1400_A16),
    [vars$4.outlineColor]: theme.color(Color.Greystone_DarkMatter),
    [vars$4.outlineOffsetColor]: theme.color(Color.Brownstone_50)
  };
  const dark = {
    [vars$4.color]: theme.color(ColorPreset.TextOnDark_01),
    [vars$4.altColor]: theme.color(ColorPreset.TextOnDark_03),
    [vars$4.disabledColor]: theme.color(Color.Greystone_700_A38),
    [vars$4.separatorColor]: theme.color(ColorPreset.BorderOnDark_05),
    [vars$4.accentColor]: theme.color(Color.Dawn_Base),
    [vars$4.accentDisabledColor]: theme.color(Color.Greystone_700_A16),
    [vars$4.outlineColor]: theme.color(Color.White),
    [vars$4.outlineOffsetColor]: theme.color(Color.Slate_1100)
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const menuDensityTokens = (theme, density) => {
  const ts2 = theme.tokens.fontSizes[TypeScale.Size_02];
  const ts3 = theme.tokens.fontSizes[TypeScale.Size_03];
  const ts5 = theme.tokens.fontSizes[TypeScale.Size_05];
  return theme.responsive(density, d => {
    switch (d) {
      case MenuDensity.Compact:
        return {
          [vars$4.gutterV]: theme.spacing(0.5),
          [vars$4.gutterH]: theme.spacing(1),
          [vars$4.separatorGutterV]: theme.spacing(1),
          [vars$4.separatorGutterH]: theme.spacing(1),
          [vars$4.labelSpacing]: theme.spacing(0.25),
          [vars$4.buttonWeight]: FontWeight.Normal,
          [vars$4.buttonTitleFontSize]: ts2.fontSize,
          [vars$4.buttonTitleLineHeight]: ts2.lineHeight,
          [vars$4.buttonDescFontSize]: ts2.fontSize,
          [vars$4.buttonDescLineHeight]: ts2.lineHeight,
          [vars$4.groupTitleFontSize]: ts3.fontSize,
          [vars$4.groupTitleLineHeight]: ts3.lineHeight,
          [vars$4.groupDescFontSize]: ts2.fontSize,
          [vars$4.groupDescLineHeight]: ts2.lineHeight
        };
      case MenuDensity.Regular:
        return {
          [vars$4.gutterV]: theme.spacing(0.75),
          [vars$4.gutterH]: theme.spacing(1.5),
          [vars$4.separatorGutterV]: theme.spacing(1),
          [vars$4.separatorGutterH]: theme.spacing(1.5),
          [vars$4.labelSpacing]: theme.spacing(0.5),
          [vars$4.buttonWeight]: FontWeight.SemiBold,
          [vars$4.buttonTitleFontSize]: ts3.fontSize,
          [vars$4.buttonTitleLineHeight]: ts3.lineHeight,
          [vars$4.buttonDescFontSize]: ts2.fontSize,
          [vars$4.buttonDescLineHeight]: ts2.lineHeight,
          [vars$4.groupTitleFontSize]: ts5.fontSize,
          [vars$4.groupTitleLineHeight]: ts5.lineHeight,
          [vars$4.groupDescFontSize]: ts2.fontSize,
          [vars$4.groupDescLineHeight]: ts2.lineHeight
        };
    }
  });
};
const menuSeparatorStyle = (theme, {
  groupLayout,
  visibility
}) => {
  return [theme.responsive(visibility, v => {
    return {
      display: v === "hidden" ? "none" : "block"
    };
  }), theme.responsive(groupLayout, gl => {
    switch (gl) {
      case "row":
        return {
          width: "auto",
          height: "1px",
          margin: `var(${vars$4.separatorGutterV}) var(${vars$4.separatorGutterH})`,
          marginLeft: `calc(var(${vars$4.startOffset}) + var(${vars$4.separatorGutterH}))`
        };
      case "column":
        return {
          height: "100%",
          width: "1px",
          margin: 0,
          marginLeft: 0
        };
    }
  }), {
    backgroundColor: `var(${vars$4.separatorColor})`
  }];
};
const menuButtonStyle = (theme, props) => {
  const accentColor = props.accent === "visible" ? `var(${vars$4.accentColor})` : "transparent";
  const accentDisabledColor = props.accent === "visible" ? `var(${vars$4.accentDisabledColor})` : "transparent";
  const varOutline = "--menu-buttonoutline-on";
  return {
    [vars$4.labelTitleFontSize]: `var(${vars$4.buttonTitleFontSize})`,
    [vars$4.labelTitleLineHeight]: `var(${vars$4.buttonTitleLineHeight})`,
    [vars$4.labelDescFontSize]: `var(${vars$4.buttonDescFontSize})`,
    [vars$4.labelDescLineHeight]: `var(${vars$4.buttonDescLineHeight})`,
    [varOutline]: 0,
    display: "block",
    width: "100%",
    padding: `var(${vars$4.gutterV}) var(${vars$4.gutterH})`,
    paddingLeft: `calc(var(${vars$4.startOffset}) + var(${vars$4.gutterH}) - var(${vars$4.accentWidth}))`,
    textAlign: "start",
    background: "none",
    border: "none",
    fontFamily: "inherit",
    fontSize: `var(${vars$4.buttonTitleFontSize})`,
    lineHeight: `var(${vars$4.buttonTitleLineHeight})`,
    fontWeight: `var(${vars$4.buttonWeight})`,
    cursor: "pointer",
    textDecoration: "none",
    color: "inherit",
    borderLeft: `var(${vars$4.accentWidth}) solid ${accentColor}`,
    boxShadow: `
      0 0 0 calc(var(${varOutline}) * 1px) var(${vars$4.outlineOffsetColor}),
      0 0 0 calc(var(${varOutline}) * 4px) var(${vars$4.outlineColor})
    `,
    borderRadius: `calc(var(${varOutline}) * ${theme.radius(0.25)})`,
    "&:hover": {
      textDecoration: "underline"
    },
    "&:focus": {
      [varOutline]: 1,
      outline: "none"
    },
    "&:disabled": {
      [vars$4.labelDescColor]: `var(${vars$4.disabledColor})`,
      color: `var(${vars$4.disabledColor})`,
      borderLeft: `var(${vars$4.accentWidth}) solid ${accentDisabledColor}`,
      cursor: "not-allowed",
      textDecoration: "none"
    },
    // Only show focus indicators when use keyboard (Tab) for navigation
    ".js-focus-visible &:focus:not(.focus-visible)": {
      [varOutline]: 0
    },
    "&:focus:not(:focus-visible)": {
      [varOutline]: 0
    }
  };
};
const menuExpanderTriggerStyle = menuButtonStyle;
const menuLabelStyle = {
  display: "flex",
  alignItems: "center",
  "> :not([aria-hidden])": {
    flex: "1 1 auto"
  },
  "> * + *": {
    marginLeft: "8px"
  }
};
const menuTitleStyle = {
  display: "block",
  fontSize: `var(${vars$4.labelTitleFontSize})`,
  lineHeight: `var(${vars$4.labelTitleLineHeight})`
};
const menuDescriptionStyle = {
  display: "block",
  fontSize: `var(${vars$4.labelDescFontSize})`,
  lineHeight: `var(${vars$4.labelDescLineHeight})`,
  color: `var(${vars$4.labelDescColor}, var(${vars$4.altColor}))`,
  fontWeight: FontWeight.Normal,
  "&:last-of-type:not(:first-of-type)": {
    marginTop: `var(${vars$4.labelSpacing})`
  }
};
const menuLevelStyle = level => {
  return {
    [vars$4.level]: level,
    [vars$4.startOffset]: `calc(var(${vars$4.level}) * var(${vars$4.baseOffset}))`
  };
};
const menuGroupLabelStyle = {
  padding: `var(${vars$4.gutterV}) var(${vars$4.gutterH})`,
  paddingLeft: `calc(var(${vars$4.startOffset}) + var(${vars$4.gutterH}))`,
  fontWeight: FontWeight.SemiBold,
  [vars$4.labelTitleFontSize]: `var(${vars$4.groupTitleFontSize})`,
  [vars$4.labelTitleLineHeight]: `var(${vars$4.groupTitleLineHeight})`,
  [vars$4.labelDescFontSize]: `var(${vars$4.groupDescFontSize})`,
  [vars$4.labelDescLineHeight]: `var(${vars$4.groupDescLineHeight})`
};
const menuRootLabelStyle = menuGroupLabelStyle;
const menuRootListStyle = (theme, props) => {
  return [{
    display: "grid",
    justifyContent: "start"
  }, theme.responsive(props.groupLayout, gl => {
    switch (gl) {
      case "row":
        {
          return {
            gridAutoFlow: gl,
            gridAutoColumns: "100%",
            "> [role=separator]": {
              justifySelf: "initial"
            }
          };
        }
      case "column":
        {
          return {
            gridAutoFlow: gl,
            gridAutoColumns: "1fr",
            "> [role=separator]": {
              justifySelf: "center"
            }
          };
        }
    }
  })];
};
const menuRootStyle = (theme, props) => {
  return [menuDensityTokens(theme, props.density), menuColorTokens(theme, props.colorScheme), menuLevelStyle(props.level), {
    [vars$4.baseOffset]: theme.spacing(0.75),
    [vars$4.accentWidth]: "4px",
    color: `var(${vars$4.color})`
  }];
};

const MenuLabel = props => {
  const {
    title,
    description,
    leftIcon,
    rightIcon,
    ...rest
  } = props;
  return jsxs("span", {
    role: "presentation",
    ...rest,
    children: [jsxs("span", {
      css: menuLabelStyle,
      role: "presentation",
      children: [leftIcon ? jsx(Icon, {
        name: leftIcon
      }) : null, jsx("span", {
        css: menuTitleStyle,
        children: title
      }), rightIcon ? jsx(Icon, {
        name: rightIcon
      }) : null]
    }), description ? jsx("span", {
      css: menuDescriptionStyle,
      children: description
    }) : null]
  });
};

var MenuRole;
(function (MenuRole) {
  /**
   * This role indicates that the menu is used for select from a list actions
   * or functions. It also sets up keyboard shortcuts that are expected when
   * navigating this type of menu: Up/Down/Home/End.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/menu_role ARIA: menu role}
   */
  MenuRole["Menu"] = "menu";
  /**
   * This role indicates that the menu is a plain list of navigation links and
   * supporting content. It is typically used for display lists of links in a
   * site's footer, navigation sidebar or other primary navigation elements.
   */
  MenuRole["List"] = "list";
})(MenuRole || (MenuRole = {}));
const menuKeyProp = "data-menu-key";
const MenuRoleContext = /*#__PURE__*/React__default.createContext(MenuRole.List);
const MenuRoleProvider = ({
  value,
  children
}) => {
  return jsx(MenuRoleContext.Provider, {
    value: value,
    children: children
  });
};
const useMenuRole = () => {
  return React__default.useContext(MenuRoleContext);
};
const MenuSelectionContext = /*#__PURE__*/React__default.createContext({
  selectedKey: null,
  interactive: false
});
const MenuSelectionProvider = ({
  children,
  value: selectedKey
}) => {
  const [isClient, setClient] = React__default.useState(false);
  React__default.useEffect(() => {
    setClient(true);
  }, []);
  const value = React__default.useMemo(() => ({
    interactive: isClient,
    selectedKey
  }), [isClient, selectedKey]);
  return jsx(MenuSelectionContext.Provider, {
    value: value,
    children: children
  });
};
const useMenuSelectionState = () => {
  const key = React__default.useId();
  const state = React__default.useContext(MenuSelectionContext);
  const selected = key === state.selectedKey;
  const tabIndex = selected ? 0 : -1;
  return {
    key,
    selected,
    tabIndex: state.interactive ? tabIndex : undefined
  };
};
const MenuLevelContext = /*#__PURE__*/React__default.createContext(-1);
const MenuLevelProvider = ({
  value,
  children
}) => {
  return jsx(MenuLevelContext.Provider, {
    value: value,
    children: children
  });
};
const useMenuLevel = () => {
  return React__default.useContext(MenuLevelContext);
};
const MenuLayout = /*#__PURE__*/React__default.createContext("row");
const MenuLayoutProvider = ({
  value,
  children
}) => {
  return jsx(MenuLayout.Provider, {
    value: value,
    children: children
  });
};
const useMenuLayout = () => {
  return React__default.useContext(MenuLayout);
};
/**
 * Builds a keyboard event handler that allows navigating menus using
 * Up/Down/Home/End keys.
 */
const useMenuKeyboardHandler = ({
  setSelected,
  inboundHandler
}) => {
  return e => {
    inboundHandler === null || inboundHandler === void 0 ? void 0 : inboundHandler(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    const allowedKeys = ["Up", "ArrowUp", "Down", "ArrowDown", "Home", "End"];
    // Short-circuit so we don't do expensive work
    if (!allowedKeys.includes(e.key)) {
      return;
    }
    // If we did indeed catch an allowed key then prevent default behavior.
    // In some browsers, up/down will cause page scroll if not intercepted.
    e.preventDefault();
    const {
      currentTarget: root,
      target
    } = e;
    if (!(target instanceof HTMLElement)) {
      return;
    }
    // Find all menu items under this menu
    const allItems = Array.from(root.querySelectorAll("[role=menuitem]:not(:disabled)"));
    // ... and the subset of menu items that are nested under hidden lists
    const hiddenItems = Array.from(root.querySelectorAll("ul[hidden] [role=menuitem]"));
    // ... and create a list of focusable menu items to traverse
    const fitleredItems = [];
    allItems.forEach(item => {
      const isHTMLElement = item instanceof HTMLElement;
      const isHidden = hiddenItems.indexOf(item) >= 0;
      if (!isHTMLElement || isHidden) {
        return;
      }
      fitleredItems.push(item);
    });
    const lastIndex = fitleredItems.length - 1;
    const currIndex = fitleredItems.indexOf(target);
    let nextIndex = currIndex;
    if (["Up", "ArrowUp"].includes(e.key)) {
      nextIndex = nextIndex > 0 ? nextIndex - 1 : lastIndex;
    } else if (["Down", "ArrowDown"].includes(e.key)) {
      nextIndex = nextIndex < lastIndex ? nextIndex + 1 : 0;
    } else if (e.key === "Home") {
      nextIndex = 0;
    } else if (e.key === "End") {
      nextIndex = lastIndex;
    }
    const nextEl = fitleredItems[nextIndex] || fitleredItems[0];
    if (!nextEl) {
      return;
    }
    const key = nextEl.getAttribute(menuKeyProp);
    setSelected(key);
    nextEl.focus();
  };
};

const MenuLI = props => {
  const menuRole = useMenuRole();
  const role = menuRole === MenuRole.Menu ? "presentation" : undefined;
  const level = useMenuLevel();
  return jsx("li", {
    css: [listItemResetStyle, menuLevelStyle(Math.max(0, level)), process.env.NODE_ENV === "production" ? "" : ";label:MenuLI;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnVMSS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTWdCIiwiZmlsZSI6Ik1lbnVMSS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBNZW51Um9sZSwgdXNlTWVudUxldmVsLCB1c2VNZW51Um9sZSB9IGZyb20gXCIuL21lbnVTdGF0ZVwiO1xyXG5pbXBvcnQgeyBsaXN0SXRlbVJlc2V0U3R5bGUsIG1lbnVMZXZlbFN0eWxlIH0gZnJvbSBcIi4vbWVudVN0eWxlXCI7XHJcbmNvbnN0IE1lbnVMSSA9IChwcm9wcykgPT4ge1xyXG4gICAgY29uc3QgbWVudVJvbGUgPSB1c2VNZW51Um9sZSgpO1xyXG4gICAgY29uc3Qgcm9sZSA9IG1lbnVSb2xlID09PSBNZW51Um9sZS5NZW51ID8gXCJwcmVzZW50YXRpb25cIiA6IHVuZGVmaW5lZDtcclxuICAgIGNvbnN0IGxldmVsID0gdXNlTWVudUxldmVsKCk7XHJcbiAgICByZXR1cm4gKDxsaSBjc3M9e1tsaXN0SXRlbVJlc2V0U3R5bGUsIG1lbnVMZXZlbFN0eWxlKE1hdGgubWF4KDAsIGxldmVsKSldfSB7Li4ucHJvcHN9IHJvbGU9e3JvbGV9IGRhdGEtbGV2ZWw9e2xldmVsfS8+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgTWVudUxJO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1NZW51TEkuanN4Lm1hcCJdfQ== */"],
    ...props,
    role: role,
    "data-level": level
  });
};

const MenuButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    description,
    children,
    leftIcon,
    rightIcon,
    accent = "hidden",
    render,
    ...rest
  } = props;
  const {
    key,
    tabIndex
  } = useMenuSelectionState();
  const {
    theme
  } = useTheme();
  const menuRole = useMenuRole();
  const isMenuRole = menuRole === MenuRole.Menu;
  const role = isMenuRole ? "menuitem" : undefined;
  const label = jsx(MenuLabel, {
    title: children,
    description: description,
    leftIcon: leftIcon,
    rightIcon: rightIcon
  });
  return jsx(MenuLI, {
    children: jsx(ClassNames, {
      children: ({
        css,
        cx
      }) => {
        const className = cx(css(menuButtonStyle(theme, {
          accent
        })), props.className);
        const forwardedProps = {
          ...rest,
          className,
          children: label,
          role,
          tabIndex: isMenuRole ? tabIndex : undefined,
          [menuKeyProp]: isMenuRole ? key : undefined
        };
        return render ? render(forwardedProps) : jsx("button", {
          ref: ref,
          type: "button",
          ...forwardedProps
        });
      }
    })
  });
});

const MenuUL = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("ul", {
    css: listResetStyle,
    ...props,
    ref: ref
  });
});

const MenuGroup = props => {
  const genId = React.useId();
  const {
    title,
    description,
    children,
    labelId = genId,
    leftIcon,
    rightIcon,
    "aria-labelledby": inLabels,
    ...rest
  } = props;
  const level = useMenuLevel();
  const menuRole = useMenuRole();
  const hideDescriptors = menuRole === MenuRole.Menu ? true : undefined;
  const currentLevel = level + 1;
  let labels = labelId;
  if (inLabels) {
    labels = `${inLabels} ${labels}`;
  }
  return jsx(MenuLayoutProvider, {
    value: "row",
    children: jsx(MenuLevelProvider, {
      value: currentLevel,
      children: jsxs(MenuLI, {
        children: [jsx("div", {
          id: labelId,
          css: menuGroupLabelStyle,
          "aria-hidden": hideDescriptors,
          children: jsx(MenuLabel, {
            title: title,
            description: description,
            leftIcon: leftIcon,
            rightIcon: rightIcon
          })
        }), jsx(MenuUL, {
          ...rest,
          role: "group",
          "aria-labelledby": labels,
          children: children
        })]
      })
    })
  });
};

const noop$1 = () => {};
const MenuExpander = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const genId = React.useId();
  const {
    title,
    description,
    children,
    id = genId,
    triggerId = `${genId}_trigger`,
    leftIcon,
    "aria-labelledby": inLabels,
    expanded: inExpanded,
    initialExpanded,
    onToggle = noop$1,
    disabled,
    ...rest
  } = props;
  const [expanded, setExpanded] = useControlledState(inExpanded, initialExpanded || false, onToggle);
  const {
    key,
    tabIndex
  } = useMenuSelectionState();
  const level = useMenuLevel();
  const menuRole = useMenuRole();
  const isMenuRole = menuRole === MenuRole.Menu;
  const buttonRole = isMenuRole ? "menuitem" : undefined;
  const currentLevel = Math.max(level + 1, 1);
  let labels = triggerId;
  if (inLabels) {
    labels = `${inLabels} ${labels}`;
  }
  const interactiveProps = {
    tabIndex: isMenuRole ? tabIndex : undefined,
    [menuKeyProp]: isMenuRole ? key : undefined
  };
  return jsx(MenuLayoutProvider, {
    value: "row",
    children: jsxs(MenuLI, {
      children: [jsx("button", {
        css: menuExpanderTriggerStyle(theme, {
          accent: "hidden"
        }),
        id: triggerId,
        type: "button",
        role: buttonRole,
        ref: ref,
        "aria-controls": id,
        "aria-expanded": !!expanded,
        onClick: () => setExpanded(!expanded),
        disabled: disabled,
        ...interactiveProps,
        children: jsx(MenuLabel, {
          title: title,
          description: description,
          leftIcon: leftIcon,
          rightIcon: expanded ? Glyph.ChevronUp : Glyph.ChevronDown
        })
      }), jsx(MenuLevelProvider, {
        value: currentLevel,
        children: jsx(MenuUL, {
          ...rest,
          id: id,
          role: "group",
          "aria-labelledby": labels,
          hidden: !expanded,
          children: children
        })
      })]
    })
  });
});

const MenuLink = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    description,
    children,
    leftIcon,
    rightIcon,
    accent = "hidden",
    render,
    ...rest
  } = props;
  const {
    key,
    tabIndex
  } = useMenuSelectionState();
  const {
    theme
  } = useTheme();
  const menuRole = useMenuRole();
  const isMenuRole = menuRole === MenuRole.Menu;
  const role = isMenuRole ? "menuitem" : undefined;
  const label = jsx(MenuLabel, {
    title: children,
    description: description,
    leftIcon: leftIcon,
    rightIcon: rightIcon
  });
  return jsx(MenuLI, {
    children: jsx(ClassNames, {
      children: ({
        css,
        cx
      }) => {
        const className = cx(css(menuButtonStyle(theme, {
          accent
        })), props.className);
        const forwardedProps = {
          ...rest,
          className,
          children: label,
          role,
          tabIndex: isMenuRole ? tabIndex : undefined,
          [menuKeyProp]: isMenuRole ? key : undefined
        };
        return render ? render(forwardedProps) : jsx("a", {
          ref: ref,
          ...forwardedProps,
          children: forwardedProps.children
        });
      }
    })
  });
});

const MenuRoot = props => {
  const genLabelId = React.useId();
  const {
    labelId = genLabelId,
    density = MenuDensity.Regular,
    colorScheme = ColorScheme.OnLight,
    groupLayout = "row",
    role: inRole,
    title,
    description,
    ...rest
  } = props;
  const {
    theme
  } = useTheme();
  const rootRef = React.useRef(null);
  const level = useMenuLevel();
  const [selected, setSelected] = React.useState(null);
  const handleKeyDown = useMenuKeyboardHandler({
    setSelected,
    inboundHandler: props.onKeyDown
  });
  // This hook acts both as focus state initializer.
  // It marks the first focusable menu item as selected if there is no active
  // selection.
  useIsomorphicLayoutEffect(() => {
    const rootEl = rootRef.current;
    if (!(rootEl instanceof HTMLElement)) {
      return;
    }
    const firstEl = rootEl.querySelector(`[${menuKeyProp}]:not(:disabled)`);
    const selectedEl = rootEl.querySelector(`[${menuKeyProp}="${selected}"]:not(:disabled)`);
    const el = selectedEl || firstEl;
    if (!(el instanceof HTMLElement)) {
      return;
    }
    setSelected(el.getAttribute(menuKeyProp));
  }, [rootRef, selected]);
  const styleProps = {
    level: Math.max(level, 0),
    density,
    colorScheme,
    groupLayout
  };
  const isMenuRole = inRole === MenuRole.Menu;
  const role = isMenuRole ? inRole : undefined;
  const node = jsx("div", {
    role: "presentation",
    css: menuRootStyle(theme, styleProps),
    children: jsx(MenuRoleProvider, {
      value: inRole,
      children: jsxs(MenuLayoutProvider, {
        value: groupLayout,
        children: [title ? jsx("div", {
          id: labelId,
          css: menuRootLabelStyle,
          children: jsx(MenuLabel, {
            title: title,
            description: description
          })
        }) : null, jsx(MenuUL, {
          css: menuRootListStyle(theme, styleProps),
          ...rest,
          onKeyDown: isMenuRole ? handleKeyDown : props.onKeyDown,
          role: role,
          ref: rootRef,
          children: props.children
        })]
      })
    })
  });
  return isMenuRole ? jsx(MenuSelectionProvider, {
    value: selected,
    children: node
  }) : node;
};

const MenuSeparator = props => {
  const {
    visibility = "visible"
  } = props;
  const {
    theme
  } = useTheme();
  const groupLayout = useMenuLayout();
  return jsx("li", {
    role: "separator",
    css: menuSeparatorStyle(theme, {
      groupLayout,
      visibility
    })
  });
};

const visibleStyle$1 = {
  display: "unset",
  visibility: "visible",
  opacity: 1
};
const hidingStyle$1 = {
  display: "unset",
  visibility: "visible",
  opacity: 0
};
const hiddenStyle$1 = {
  display: "none",
  visibility: "hidden",
  opacity: 0
};
const fadeStyle = {
  transition: "opacity 200ms",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "opacity 50ms"
  },
  "&": hiddenStyle$1,
  "&.fade-enter": hidingStyle$1,
  "&.fade-enter-active": visibleStyle$1,
  "&.fade-enter-done": visibleStyle$1,
  "&.fade-exit": visibleStyle$1,
  "&.fade-exit-active": hidingStyle$1,
  "&.fade-exit-done": hiddenStyle$1
};

const vars$3 = {
  maxWidth: "--dropdown-maxwidth",
  top: "--dropdown-top",
  left: "--dropdown-left",
  bg: "--dropdown-bg",
  color: "--dropdown-color",
  elevation: "--dropdown-elevation",
  borderRadius: "--dropdown-border-radius",
  gutterV: "--dropdown-gutterv",
  gutterH: "--dropdown-gutterh"
};
const dropdownPanelStyle = {
  width: "max-content",
  maxWidth: `var(${vars$3.maxWidth})`,
  padding: `var(${vars$3.gutterV}) var(${vars$3.gutterH})`,
  backgroundColor: `var(${vars$3.bg})`,
  color: `var(${vars$3.color})`,
  filter: `var(${vars$3.elevation})`,
  borderRadius: `var(${vars$3.borderRadius})`,
  top: `var(${vars$3.top})`,
  left: `var(${vars$3.left})`,
  zIndex: ZIndex.Dropdown
};
const dropdownColorTokens = (theme, cs) => {
  const light = {
    [vars$3.bg]: theme.color(ColorPreset.BackgroundLight_01),
    [vars$3.color]: theme.color(ColorPreset.TextOnLight_01)
  };
  const dark = {
    [vars$3.bg]: theme.color(ColorPreset.BackgroundDark_01),
    [vars$3.color]: theme.color(ColorPreset.TextOnDark_01)
  };
  switch (cs) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const dropdownStyle = (theme, props) => {
  const transformation = props.transformRemoval === true ? "none" : "translate3d(0,0,0)";
  return [dropdownColorTokens(theme, props.colorScheme), theme.responsive(props.gutterV, value => ({
    [vars$3.gutterV]: theme.spacing(value)
  })), theme.responsive(props.gutterH, value => ({
    [vars$3.gutterH]: theme.spacing(value)
  })), theme.responsive(props.maxWidth, maxWidth => ({
    [vars$3.maxWidth]: maxWidth
  })), {
    [vars$3.elevation]: theme.tokens.elevation[2],
    [vars$3.borderRadius]: theme.radius(1),
    position: "relative",
    display: "inline-block",
    // On Chrome, the dropdown root, or rather the containing block, is not
    // being picked up correctly. The containing block is what the floating
    // element will be positioned against. When the floating element used
    // fixed positioning there are different rules for finding the containing
    // block [1]. On Firefox and Safari, these rules appear to be observed
    // correctly, but not on Chrome. There are some old issues reported on
    // Popper.js and Floating UI that refer to this. The workaround to make
    // this work consistently is to set a transform value on dropdown's root
    // element that hosts the trigger - there are other ways to do this
    // covered on MDN [1].
    //
    // Tracked this down by stepping through the isContainingBlock function
    // (via getContainingBlock) in floating-ui [2]. Also a commenter hinted at
    // this solution in a GitHub issue [3].
    //
    // [1]: https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // [2]: https://github.com/floating-ui/floating-ui/blob/70e1fd5e8ac927b3612a7ba2390bd57d5eceee30/packages/dom/src/utils/is.ts#L47-L64
    // [3]: https://github.com/floating-ui/floating-ui/issues/1035
    transform: transformation
  }];
};

const Dropdown = props => {
  const {
    maxWidth = "300px",
    gutterV = 1,
    gutterH = 0.5,
    trigger,
    children,
    controls: inControlsId,
    placement = "bottom-start",
    placementStrategy = "flip",
    colorScheme = ColorScheme.OnLight,
    forceOpen = false,
    reference: externalReference,
    offset,
    positionOverride = true,
    appendToBody = false,
    ...rest
  } = props;
  const [openState, setOpen] = React.useState(false);
  const open = openState || forceOpen;
  const {
    theme
  } = useTheme();
  const genControlsId = React.useId();
  const {
    x,
    y,
    strategy,
    update,
    refs
  } = useFloating({
    open,
    initialPlacement: placement,
    placementStrategy,
    positionStrategy: positionOverride === true || appendToBody ? "absolute" : "fixed",
    offset
  });
  const hitAreaRef = React.useRef(null);
  const floatingRef = refs.floating;
  const tapoutRefs = React.useMemo(() => [floatingRef, hitAreaRef], [floatingRef, hitAreaRef]);
  const close = () => setOpen(false);
  // Tapping outside of the tooltip should dismiss it.
  useTapOut(tapoutRefs, () => {
    close();
  });
  useIsomorphicLayoutEffect(() => {
    if (externalReference == null) {
      return;
    }
    refs.setReference(externalReference);
  }, [refs.setReference, externalReference]);
  const controlsId = inControlsId || genControlsId;
  const triggerProps = {
    onClick: () => setOpen(v => !v),
    "aria-controls": controlsId,
    "aria-haspopup": true,
    "aria-expanded": open
  };
  const dropdownTop = y == null ? "" : `${y}px`;
  const dropdownLeft = x == null ? "" : `${x}px`;
  const menuNode = typeof children === "function" ? children({
    close
  }) : children;
  const transformRemoval = positionOverride || appendToBody === true ? true : false;
  const style = dropdownStyle(theme, {
    maxWidth,
    gutterV,
    gutterH,
    placement,
    placementStrategy,
    colorScheme,
    transformRemoval
  });
  const positionStyle = {
    [vars$3.top]: dropdownTop,
    [vars$3.left]: dropdownLeft
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsxs("div", {
      css: style,
      ...rest,
      onKeyDown: e => {
        var _props$onKeyDown;
        (_props$onKeyDown = props.onKeyDown) === null || _props$onKeyDown === void 0 ? void 0 : _props$onKeyDown.call(props, e);
        if (e.isDefaultPrevented()) {
          return;
        }
        if (e.key !== "Escape") {
          return;
        }
        close();
      },
      ref: externalReference ? undefined : refs.reference,
      style: positionStyle,
      children: [jsx("div", {
        ref: hitAreaRef,
        children: trigger(triggerProps)
      }), jsx(DropdownWrapper, {
        appendToBody: appendToBody,
        children: jsx(CSSTransition, {
          in: open,
          timeout: 200,
          classNames: "fade",
          onEnter: update,
          appear: true,
          children: jsx(Fragment, {
            children: jsx("div", {
              id: genControlsId,
              ref: refs.setFloating,
              css: [appendToBody ? style : {}, dropdownPanelStyle, fadeStyle, process.env.NODE_ENV === "production" ? "" : ";label:Dropdown;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
              style: {
                position: strategy,
                ...(appendToBody ? positionStyle : {})
              },
              "data-dropdown-open": open,
              children: open ?
              // eslint-disable-next-line jsx-a11y/no-autofocus
              jsx(FocusScope, {
                restoreFocus: true,
                autoFocus: true,
                children: menuNode
              }) : menuNode
            })
          })
        })
      })]
    })
  );
};
const DropdownWrapper = ({
  children,
  appendToBody
}) => {
  if (!appendToBody) return jsx(Fragment, {
    children: children
  });
  return jsx(BodyPortal, {
    children: children
  });
};

const Menu = {
  Root: MenuRoot,
  Group: MenuGroup,
  Expander: MenuExpander,
  Button: MenuButton,
  Link: MenuLink,
  Separator: MenuSeparator
};

var BannerLeftAccessoryType;
(function (BannerLeftAccessoryType) {
  BannerLeftAccessoryType["Status"] = "bannerStatus";
  BannerLeftAccessoryType["Icon"] = "bannerIcon";
  BannerLeftAccessoryType["Tag"] = "bannerTag";
})(BannerLeftAccessoryType || (BannerLeftAccessoryType = {}));
var BannerVariant;
(function (BannerVariant) {
  BannerVariant["Light"] = "light";
  BannerVariant["Dark"] = "dark";
  BannerVariant["FullBleed"] = "full-bleed";
})(BannerVariant || (BannerVariant = {}));
var BannerStatus;
(function (BannerStatus) {
  BannerStatus["Info"] = "info";
  BannerStatus["Success"] = "success";
  BannerStatus["Warning"] = "warning";
  BannerStatus["Alert"] = "alert";
  BannerStatus["Loading"] = "loading";
})(BannerStatus || (BannerStatus = {}));
var BannerLayout;
(function (BannerLayout) {
  BannerLayout["Vertical"] = "vertical";
  BannerLayout["Horizontal"] = "horizontal";
})(BannerLayout || (BannerLayout = {}));
var BannerButtonVariant;
(function (BannerButtonVariant) {
  BannerButtonVariant["Primary"] = "primary";
  BannerButtonVariant["Secondary"] = "secondary";
  BannerButtonVariant["Text"] = "text";
  BannerButtonVariant["Plain"] = "plain";
})(BannerButtonVariant || (BannerButtonVariant = {}));
var BannerActionType;
(function (BannerActionType) {
  BannerActionType["Primary"] = "primary";
  BannerActionType["Secondary"] = "secondary";
})(BannerActionType || (BannerActionType = {}));

const bannerActionsLayout = theme => {
  return [{
    fontWeight: FontWeight.SemiBold
  }, theme.responsive(["block", "block", "flex"], s => {
    return {
      display: s
    };
  }), theme.responsive([TextAlign.Center, TextAlign.Center, null], t => {
    return {
      textAlign: t
    };
  })];
};
const bannerStyle = (theme, {
  variant,
  backgroundColor,
  elevation
}) => {
  const vl = BannerVariant.Light;
  const vd = BannerVariant.Dark;
  const fb = BannerVariant.FullBleed;
  return [{
    [`--banner-${vl}-bg`]: theme.color(Color.White),
    [`--banner-${vl}-fg`]: theme.color(ColorPreset.TextOnLight_01),
    [`--banner-${vd}-bg`]: theme.color(Color.Greystone_DarkMatter),
    [`--banner-${vd}-fg`]: theme.color(ColorPreset.TextOnDark_01),
    [`--banner-${fb}-bg`]: theme.color(ColorPreset.BackgroundLight_03),
    [`--banner-${fb}-fg`]: theme.color(ColorPreset.TextOnLight_01),
    backgroundColor: backgroundColor ? theme.color(backgroundColor) : `var(--banner-${variant}-bg)`,
    color: `var(--banner-${variant}-fg)`,
    borderRadius: variant === fb ? "unset" : theme.radius(1),
    paddingLeft: [theme.spacing(1.5)],
    paddingRight: [theme.spacing(1.5)],
    width: "100%",
    overflow: "auto"
  }, elevation == null ? {
    filter: variant === fb ? "unset" : theme.tokens.elevation[4]
  } : theme.responsive(elevation, (e, themeValue) => ({
    filter: themeValue.tokens.elevation[e]
  })), theme.responsive([theme.spacing(1.5), theme.spacing(1.5), theme.spacing(1.5)], s => {
    return {
      paddingTop: s,
      paddingBottom: s
    };
  })];
};

const sharedProps = {
  layout: [ButtonLayout.Full, null, ButtonLayout.Inline]
};
const BannerAction = props => {
  if (props.control === "link") {
    const {
      buttonVariant,
      control,
      size = ButtonSize.Sm,
      ...rest
    } = props;
    // Unnecessarily noisy lint rule in this instance since we are forwarding
    // props in this components.
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return jsx(Link, {
      ...rest,
      size: size,
      ...sharedProps
    });
  } else {
    const {
      buttonVariant,
      control,
      size = ButtonSize.Sm,
      ...rest
    } = props;
    return jsx(Button, {
      ...rest,
      size: size,
      ...sharedProps
    });
  }
};

const darkThemeButtonVariants = {
  [BannerButtonVariant.Primary]: ButtonVariant.PrimaryOnDark,
  [BannerButtonVariant.Secondary]: ButtonVariant.SecondaryOnDark,
  [BannerButtonVariant.Text]: ButtonVariant.TextOnDark,
  [BannerButtonVariant.Plain]: ButtonVariant.Inline
};
const lightThemeButtonVariants = {
  [BannerButtonVariant.Primary]: ButtonVariant.PrimaryOnLight,
  [BannerButtonVariant.Secondary]: ButtonVariant.SecondaryOnLight,
  [BannerButtonVariant.Text]: ButtonVariant.TextOnLight,
  [BannerButtonVariant.Plain]: ButtonVariant.Inline
};
const setButtonVariant = (bannerVariant, actionType, buttonVariant) => {
  switch (bannerVariant) {
    case BannerVariant.Dark:
      if (buttonVariant) {
        return darkThemeButtonVariants[buttonVariant];
      }
      return actionType === BannerActionType.Primary ? ButtonVariant.PrimaryOnDark : ButtonVariant.Inline;
    case BannerVariant.Light:
      if (buttonVariant) {
        return lightThemeButtonVariants[buttonVariant];
      }
      return actionType === BannerActionType.Primary ? ButtonVariant.PrimaryOnLight : ButtonVariant.Inline;
    case BannerVariant.FullBleed:
      if (buttonVariant) {
        return lightThemeButtonVariants[buttonVariant];
      }
      return ButtonVariant.Inline;
  }
};

const PrimaryAction = props => {
  if (props.value == null) {
    return null;
  }
  const btnVariant = setButtonVariant(props.variant, BannerActionType.Primary, props.value.buttonVariant);
  return jsx(BannerAction, {
    ...props.value,
    variant: btnVariant
  });
};

const SecondaryAction = props => {
  if (props.value == null) {
    return null;
  }
  const btnVariant = setButtonVariant(props.variant, BannerActionType.Secondary, props.value.buttonVariant);
  return jsx(BannerAction, {
    ...props.value,
    variant: btnVariant
  });
};

const CloseAction = props => {
  const {
    theme
  } = useTheme();
  const {
    variant,
    label,
    onClose: onClick,
    wrapperAlignItems
  } = props;
  const btnProps = {
    label,
    onClick,
    icon: Glyph.Close,
    size: {
      base: ButtonSize.Sm,
      gutters: ButtonGutter.Md
    }
  };
  const shiftMarginValue = `calc(-1 * var(--btn-gutter-${btnProps.size.base}-${btnProps.size.gutters}))`;
  const shiftMargin = `${shiftMarginValue} ${shiftMarginValue} 0 0`;
  // When the button is at the start of the box, make its content box flush with the banner's content box
  const marginStyles = theme.responsive(wrapperAlignItems.map(alignItems => alignItems === AlignItems.Start ? shiftMargin : 0), v => ({
    margin: v
  }));
  switch (variant) {
    case BannerVariant.Dark:
      return jsx(IconButton, {
        ...btnProps,
        css: marginStyles,
        variant: ButtonVariant.TextOnDark
      });
    default:
      return jsx(IconButton, {
        ...btnProps,
        css: marginStyles,
        variant: ButtonVariant.TextOnLight
      });
  }
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "kjj0ot",
  styles: "padding-top:2px"
} : {
  name: "hv1n37-BannerIcon",
  styles: "padding-top:2px;label:BannerIcon;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhbm5lckljb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtpQiIsImZpbGUiOiJCYW5uZXJJY29uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEljb24gfSBmcm9tIFwiLi4vaWNvbnNcIjtcclxuaW1wb3J0IHsgQ29sb3JQcmVzZXQgfSBmcm9tIFwiLi4vdGhlbWVcIjtcclxuaW1wb3J0IHsgQm94IH0gZnJvbSBcIi4uL2xheW91dFwiO1xyXG5pbXBvcnQgeyBCYW5uZXJWYXJpYW50IH0gZnJvbSBcIi4vdHlwZXNcIjtcclxuY29uc3QgQmFubmVySWNvbiA9IChwcm9wcykgPT4ge1xyXG4gICAgcmV0dXJuICg8Qm94IGNzcz17eyBwYWRkaW5nVG9wOiBcIjJweFwiIH19PlxuICAgICAgPEljb24gbmFtZT17cHJvcHMuaWNvbn0gY29sb3I9e3Byb3BzLnZhcmlhbnQgPT09IEJhbm5lclZhcmlhbnQuRGFya1xyXG4gICAgICAgICAgICA/IENvbG9yUHJlc2V0Lkljb25PbkRhcmtfMDFcclxuICAgICAgICAgICAgOiBDb2xvclByZXNldC5JY29uT25MaWdodF8wMX0gc2l6ZT1cIjE2cHhcIi8+XG4gICAgPC9Cb3g+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgQmFubmVySWNvbjtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9QmFubmVySWNvbi5qc3gubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
const BannerIcon = props => {
  return jsx(Box, {
    css: _ref$1,
    children: jsx(Icon, {
      name: props.icon,
      color: props.variant === BannerVariant.Dark ? ColorPreset.IconOnDark_01 : ColorPreset.IconOnLight_01,
      size: "16px"
    })
  });
};

const icons = {
  [BannerStatus.Info]: {
    lightBg: Color.Info_Base,
    darkBg: Color.Brownstone_50,
    glyph: Glyph.InfoCircle
  },
  [BannerStatus.Success]: {
    lightBg: Color.Success_Base,
    darkBg: Color.Brownstone_50,
    glyph: Glyph.TickCircle
  },
  [BannerStatus.Warning]: {
    lightBg: Color.Warning_Base,
    darkBg: Color.Brownstone_50,
    glyph: Glyph.ExclamationCircle
  },
  [BannerStatus.Alert]: {
    lightBg: Color.Alert_Base,
    darkBg: Color.Brownstone_50,
    glyph: Glyph.SubtractCircle
  },
  [BannerStatus.Loading]: {
    lightBg: Color.Greystone_DarkMatter,
    darkBg: Color.Brownstone_50,
    glyph: Glyph.Spinner
  }
};
const BannerStatusIcon = props => {
  const {
    lightBg,
    darkBg,
    glyph
  } = icons[props.value];
  return jsx(Icon, {
    name: glyph,
    color: props.variant === BannerVariant.Dark ? darkBg : lightBg,
    size: "24px"
  });
};

const BannerTag = props => {
  const {
    text,
    variant
  } = props;
  return jsx(Tag, {
    size: TagSize.Md,
    color: TagColor.Primary,
    colorScheme: variant === BannerVariant.Dark ? ColorScheme.OnDark : ColorScheme.OnLight,
    children: text
  });
};

const getBannerLeftAccessoryContent = (bannerVariant, leftAccessory) => {
  switch (leftAccessory.type) {
    case BannerLeftAccessoryType.Icon:
      return jsx(BannerIcon, {
        variant: bannerVariant,
        icon: leftAccessory.name
      });
    case BannerLeftAccessoryType.Status:
      return jsx(BannerStatusIcon, {
        variant: bannerVariant,
        value: leftAccessory.status
      });
    case BannerLeftAccessoryType.Tag:
      return jsx(BannerTag, {
        variant: bannerVariant,
        text: leftAccessory.text
      });
  }
};
function BannerLeftAccessory({
  isVerticallyCentered,
  leftAccessory,
  variant
}) {
  return jsx(Box, {
    layout: "flex",
    alignItems: isVerticallyCentered ? AlignItems.Center : [AlignItems.FlexEnd, null, AlignItems.FlexStart],
    gridArea: "icon",
    "aria-hidden": true,
    children: getBannerLeftAccessoryContent(variant, leftAccessory)
  });
}

const getSmGridTemplateAreas = ({
  closeArea,
  showActions,
  leftAccessoryType
}) => {
  return `${typeof leftAccessoryType === "undefined" ? `'body ${closeArea || "body"}'` : `'icon ${closeArea || "icon"}'
    'body body'`}
    ${showActions ? "'actions actions'" : ""}`;
};
const getLgHorizontalGridTemplateAreas = ({
  closeArea,
  showActions
}) => {
  return `
      'icon body ${showActions ? "actions" : "body"} ${closeArea}'
    `;
};
const getLgVerticalGridTemplateAreas = ({
  closeArea,
  showActions,
  leftAccessoryType
}) => {
  if (leftAccessoryType === BannerLeftAccessoryType.Tag) {
    return `
      'icon icon close'
      'body body ${closeArea}'
      ${showActions ? `'actions actions ${closeArea}'` : ""}
    `;
  }
  return `
    'icon body ${closeArea}'
    'icon ${showActions ? "actions" : "body"} ${closeArea}'
  `;
};
const getGridTemplateAreas = ({
  isCloseable,
  isHorizontal,
  leftAccessoryType,
  showActions
}) => {
  const closeArea = isCloseable ? "close" : "";
  return [getSmGridTemplateAreas({
    closeArea,
    showActions,
    leftAccessoryType
  }), null, isHorizontal ? getLgHorizontalGridTemplateAreas({
    closeArea,
    showActions
  }) : getLgVerticalGridTemplateAreas({
    closeArea,
    showActions,
    leftAccessoryType
  })];
};

const omitBannerProps = props => {
  const {
    closeAction,
    primaryAction,
    secondaryAction,
    leftAccessory,
    title,
    variant,
    backgroundColor,
    elevation,
    layout,
    ...rest
  } = props;
  return rest;
};
const Banner = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme
  } = useTheme();
  const {
    id,
    title,
    children,
    primaryAction,
    secondaryAction,
    closeAction,
    variant,
    layout,
    leftAccessory
  } = props;
  const showActions = !!(primaryAction || secondaryAction);
  const role = closeAction ? "alertdialog" : "alert";
  const headingId = id ? `${id}_heading` : "";
  const isCloseable = !!closeAction;
  const closeWidth = closeAction ? "auto" : "";
  const isHorizontal = layout === BannerLayout.Horizontal;
  const hasLeftAccessory = !!leftAccessory;
  const templateColumns = [`auto auto`, null, `max-content 1fr ${isHorizontal ? "max-content" : ""} ${closeWidth}`];
  const closeActionWrapperAlignItems = [AlignItems.Start, AlignItems.Start, isHorizontal ? AlignItems.Center // Align the close button with the action or left accessory
  : AlignItems.Start];
  return jsx("div", {
    css: bannerStyle(theme, props),
    "aria-live": "off",
    "aria-labelledby": headingId,
    ...omitBannerProps(props),
    ref: ref,
    role: role,
    id: id,
    children: jsxs(XYGrid, {
      templateAreas: getGridTemplateAreas({
        isCloseable,
        isHorizontal,
        leftAccessoryType: leftAccessory === null || leftAccessory === void 0 ? void 0 : leftAccessory.type,
        showActions
      }),
      templateColumns: templateColumns,
      columnGap: hasLeftAccessory ? 1 : 0,
      rowGap: 1,
      children: [jsx(Box, {
        gridArea: "body",
        layout: "flex",
        flexDirection: "column",
        justifyContent: JustifyContent.Center,
        children: jsxs(Interpose, {
          node: jsx(Space, {
            layout: "block",
            v: 0.25
          }),
          children: [title && jsx(H4, {
            id: headingId,
            preset: TypePreset.Heading_02,
            size: TypeScale.Size_03,
            children: title
          }), children && jsx(Box, {
            children: children
          })]
        })
      }), showActions ? jsx(Box, {
        gridArea: "actions",
        css: bannerActionsLayout(theme),
        children: jsxs(XYGrid, {
          rowGap: 1,
          columnGap: 1,
          justifyItems: JustifyItems.Start,
          alignItems: AlignItems.Center,
          templateColumns: ["auto", null, "max-content  max-content"],
          children: [jsx(PrimaryAction, {
            value: primaryAction,
            variant: variant
          }), jsx(SecondaryAction, {
            value: secondaryAction,
            variant: variant,
            prioritized: !primaryAction
          })]
        })
      }) : null, closeAction ? jsx(Box, {
        gridArea: "close",
        layout: "flex",
        justifyContent: JustifyContent.FlexEnd,
        alignItems: closeActionWrapperAlignItems,
        children: jsx(CloseAction, {
          label: closeAction.label,
          onClose: closeAction.onClose,
          variant: variant,
          wrapperAlignItems: closeActionWrapperAlignItems
        })
      }) : null, leftAccessory ? jsx(BannerLeftAccessory, {
        variant: variant,
        leftAccessory: leftAccessory,
        isVerticallyCentered: isHorizontal
      }) : null]
    })
  });
});

const Toast = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    action,
    status,
    ...rest
  } = props;
  return jsx(Banner, {
    "aria-live": "polite",
    leftAccessory: {
      type: BannerLeftAccessoryType.Status,
      status
    },
    ...rest,
    secondaryAction: action,
    ref: ref
  });
});

var ToasterPosition$1;
(function (ToasterPosition) {
  ToasterPosition["TopRight"] = "top-right";
  ToasterPosition["BottomLeft"] = "bottom-left";
})(ToasterPosition$1 || (ToasterPosition$1 = {}));
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const toasterPositionStyles = {
  [ToasterPosition$1.TopRight]: {
    container: theme => {
      const offset = 2;
      return [{
        left: "auto",
        bottom: "auto"
      }, theme.responsive(offset, value => ({
        top: theme.spacing(value)
      })), theme.responsive(offset, value => ({
        right: theme.spacing(value)
      }))];
    },
    entering: () => {
      return {
        transform: "translate3d(100%, 0, 0)",
        opacity: 0
      };
    },
    entered: (_, {
      transitionDuration: d
    }) => {
      return {
        transition: `transform ${d}ms ease-out, opacity ${d}ms ease-out`,
        opacity: 1,
        transform: "translate3d(0, 0, 0)"
      };
    },
    exiting: (_, {
      transitionDuration: d
    }) => {
      return {
        transition: `transform ${d}ms ease-out, opacity ${d}ms ease-out`,
        transform: "translate3d(100%, 0, 0)",
        opacity: 0
      };
    }
  },
  [ToasterPosition$1.BottomLeft]: {
    container: theme => {
      const offset = 2;
      return [{
        right: "auto",
        top: "auto"
      }, theme.responsive(offset, value => ({
        bottom: theme.spacing(value)
      })), theme.responsive(offset, value => ({
        left: theme.spacing(value)
      }))];
    },
    entering: () => {
      return {
        transform: "translate3d(-100%, 0, 0)",
        opacity: 0
      };
    },
    entered: (_, {
      transitionDuration: d
    }) => {
      return {
        transition: `transform ${d}ms ease-out, opacity ${d}ms ease-out`,
        opacity: 1,
        transform: "translate3d(0, 0, 0)"
      };
    },
    exiting: (_, {
      transitionDuration: d
    }) => {
      return {
        transition: `transform ${d}ms ease-out, opacity ${d}ms ease-out`,
        transform: "translate3d(-100%, 0, 0)",
        opacity: 0
      };
    }
  }
};
/* eslint-enable @typescript-eslint/explicit-module-boundary-types */

var ToasterPosition;
(function (ToasterPosition) {
  ToasterPosition["TopRight"] = "top-right";
  ToasterPosition["BottomLeft"] = "bottom-left";
})(ToasterPosition || (ToasterPosition = {}));
const defaults = {
  position: ToasterPosition.TopRight,
  width: ["auto", null, "458px"],
  transitionDuration: 400
};
const containerStyle = (theme, props) => {
  return [{
    position: "fixed",
    zIndex: ZIndex.Toast,
    "> * + *": {
      marginTop: theme.spacing(1)
    }
  }, theme.responsive(props.width, width => ({
    width
  })), toasterPositionStyles[props.position].container(theme, props)];
};
const Toaster = props => {
  const {
    theme
  } = useTheme();
  const config = {
    ...defaults,
    ...props
  };
  const {
    toasts,
    handlers
  } = useToaster();
  const visibleToasts = toasts.filter(t => t.visible);
  const {
    startPause,
    endPause
  } = handlers;
  const enableTransitions = !!config.transitionDuration;
  return jsx("div", {
    css: containerStyle(theme, config),
    onMouseEnter: startPause,
    onMouseLeave: endPause,
    onFocus: startPause,
    onBlur: endPause,
    children: jsx(TransitionGroup, {
      component: null,
      appear: enableTransitions,
      enter: enableTransitions,
      exit: enableTransitions,
      children: visibleToasts.map(toast => {
        const body = typeof toast.message === "function" ? toast.message(toast) : toast.message;
        return jsx(Transition, {
          timeout: config.transitionDuration,
          children: state => {
            var _toasterPositionStyle, _toasterPositionStyle2;
            const style = (_toasterPositionStyle = (_toasterPositionStyle2 = toasterPositionStyles[config.position])[state]) === null || _toasterPositionStyle === void 0 ? void 0 : _toasterPositionStyle.call(_toasterPositionStyle2, theme, config);
            return jsx("div", {
              css: style,
              children: body
            });
          }
        }, toast.id);
      })
    })
  });
};

const defaultHandlers = {
  toast(elementOrRender, options) {
    const duration = (options === null || options === void 0 ? void 0 : options.duration) || 4000;
    return toast(elementOrRender, {
      duration
    });
  },
  dismissToast(id) {
    toast.dismiss(id);
  },
  dismissAllToasts() {
    toast.dismiss();
  }
};
const ToastContext = /*#__PURE__*/React.createContext(defaultHandlers);
const ToastProvider = props => {
  const handlers = React.useMemo(() => ({
    ...defaultHandlers,
    ...props.handlers
  }), [props.handlers, defaultHandlers]);
  return jsx(ToastContext.Provider, {
    value: handlers,
    children: props.children
  });
};
const useToast = () => {
  return React.useContext(ToastContext);
};

const TableFoot = props => {
  return jsx("tfoot", {
    ...props
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "9kuh93",
  styles: "text-align:start"
} : {
  name: "1w6yomv-TableRow",
  styles: "text-align:start;label:TableRow;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYmxlUm93LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDZSIsImZpbGUiOiJUYWJsZVJvdy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBUYWJsZVJvdyA9IChwcm9wcykgPT4ge1xyXG4gICAgcmV0dXJuIDx0ciBjc3M9e3sgdGV4dEFsaWduOiBcInN0YXJ0XCIgfX0gey4uLnByb3BzfS8+O1xyXG59O1xyXG5leHBvcnQgZGVmYXVsdCBUYWJsZVJvdztcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9VGFibGVSb3cuanN4Lm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const TableRow = props => {
  return jsx("tr", {
    css: _ref,
    ...props
  });
};

const Table = {
  Container: TableContainer,
  Head: TableHead,
  Body: TableBody,
  Foot: TableFoot,
  Row: TableRow,
  HeadCell: TableHeadCell,
  Cell: TableCell
};

const TooltipTrigger = props => {
  const {
    colorScheme,
    children,
    ...rest
  } = props;
  let buttonVariant = ButtonVariant.TextOnLight;
  switch (colorScheme) {
    case ColorScheme.OnLight:
      buttonVariant = ButtonVariant.TextOnLight;
      break;
    case ColorScheme.OnDark:
      buttonVariant = ButtonVariant.TextOnDark;
      break;
    case ColorScheme.Auto:
      buttonVariant = ButtonVariant.TextAuto;
      break;
  }
  return jsx(IconButton, {
    icon: Glyph.Tooltip,
    variant: buttonVariant,
    label: children,
    size: {
      base: ButtonSize.Md,
      gutters: ButtonGutter.Sm
    },
    ...rest
  });
};

const vars$2 = {
  gutterV: "--tooltip-gutterv",
  gutterH: "--tooltip-gutterH",
  bg: "--tooltip-bg",
  color: "--tooltip-color",
  borderRadius: "--tooltip-border-radius",
  elevation: "--tooltip-elevation",
  position: "--tooltip-position",
  top: "--tooltip-top",
  left: "--tooltip-left",
  bodyFontSize: "--tooltip-body-fontsize",
  bodyLineHeight: "--tooltip-body-lineheight",
  titleFontSize: "--tooltip-title-fontsize",
  titleLineHeight: "--tooltip-title-lineheight",
  titleSpacing: "--tooltip-title-spacing",
  arrowSize: "--tooltip-arrow-size",
  arrowTop: "--tooltip-arrow-top",
  arrowRight: "--tooltip-arrow-right",
  arrowBottom: "--tooltip-arrow-bottom",
  arrowLeft: "--tooltip-arrow-left",
  arrowTransform: "--tooltip-arrow-transform"
};
const visibleStyle = {
  visibility: "visible",
  opacity: 1
};
const hidingStyle = {
  visibility: "visible",
  opacity: 0
};
const hiddenStyle = {
  visibility: "hidden",
  opacity: 0
};
const tooltipHostStyle = {
  position: "absolute",
  top: `var(${vars$2.top})`,
  left: `var(${vars$2.left})`,
  width: "max-content",
  maxWidth: "300px",
  zIndex: ZIndex.Tooltip,
  filter: `var(${vars$2.elevation})`,
  transition: "opacity 200ms",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "opacity 50ms"
  },
  "&": hiddenStyle,
  "&.tooltip-enter": hidingStyle,
  "&.tooltip-enter-active": visibleStyle,
  "&.tooltip-enter-done": visibleStyle,
  "&.tooltip-exit": visibleStyle,
  "&.tooltip-exit-active": hidingStyle,
  "&.tooltip-exit-done": hiddenStyle
};
const tooltipStyle = {
  padding: `var(${vars$2.gutterV}) var(${vars$2.gutterH})`,
  backgroundColor: `var(${vars$2.bg})`,
  color: `var(${vars$2.color})`,
  borderRadius: `var(${vars$2.borderRadius})`,
  fontSize: `var(${vars$2.bodyFontSize})`,
  lineHeight: `var(${vars$2.bodyLineHeight})`,
  fontWeight: FontWeight.Normal
};
const tooltipShadowStyle = {
  display: "none"
};
const tooltipTitleStyle = {
  fontWeight: FontWeight.SemiBold,
  fontSize: `var(${vars$2.titleFontSize})`,
  lineHeight: `var(${vars$2.titleLineHeight})`,
  marginBottom: `var(${vars$2.titleSpacing})`
};
const tooltipArrowStyle = {
  width: `var(${vars$2.arrowSize})`,
  height: `var(${vars$2.arrowSize})`,
  position: "absolute",
  top: `var(${vars$2.arrowTop})`,
  right: `var(${vars$2.arrowRight})`,
  bottom: `var(${vars$2.arrowBottom})`,
  left: `var(${vars$2.arrowLeft})`,
  borderRadius: "1px",
  transform: `var(${vars$2.arrowTransform})`,
  transformOrigin: "center",
  zIndex: -1,
  background: `var(${vars$2.bg})`
};
const tooltipColorTokens = (theme, colorScheme) => {
  const light = {
    [vars$2.bg]: theme.color(Color.Greystone_DarkMatter),
    [vars$2.color]: theme.color(Color.Brownstone_50)
  };
  const dark = {
    [vars$2.bg]: theme.color(Color.White),
    [vars$2.color]: theme.color(Color.Greystone_DarkMatter)
  };
  switch (colorScheme) {
    case ColorScheme.OnLight:
      return light;
    case ColorScheme.OnDark:
      return dark;
    case ColorScheme.Auto:
      return [light, {
        "@media (prefers-color-scheme: dark)": dark
      }];
  }
};
const tooltipRootStyle = (theme, props) => {
  const bfs = theme.tokens.fontSizes[TypeScale.Size_02];
  const tfs = theme.tokens.fontSizes[TypeScale.Size_03];
  return [{
    all: "initial",
    boxSizing: "border-box"
  }, tooltipColorTokens(theme, props.colorScheme), {
    [vars$2.gutterV]: theme.spacing(1),
    [vars$2.gutterH]: theme.spacing(1),
    [vars$2.borderRadius]: theme.radius(1),
    [vars$2.elevation]: theme.tokens.elevation[2],
    [vars$2.arrowSize]: "8px",
    [vars$2.arrowTransform]: "rotate(45deg)",
    [vars$2.bodyFontSize]: bfs.fontSize,
    [vars$2.bodyLineHeight]: bfs.lineHeight,
    [vars$2.titleFontSize]: tfs.fontSize,
    [vars$2.titleLineHeight]: tfs.lineHeight,
    [vars$2.titleSpacing]: theme.spacing(0.25)
  }, {
    display: "inline-block",
    position: "relative",
    fontFamily: theme.tokens.fontFamilies["sans-serif"]
  }];
};

const Tooltip = props => {
  var _middlewareData$arrow, _middlewareData$arrow2;
  const {
    theme
  } = useTheme();
  const genTooltipId = React.useId();
  const {
    tooltipId = genTooltipId,
    title,
    colorScheme = ColorScheme.OnLight,
    triggeredBy = "hover",
    message,
    forceOpen = false,
    placementStrategy = "auto",
    positionStrategy = "fixed",
    children
  } = props;
  const [dismissed, setDismissed] = React.useState(false);
  const [hovered, setHovered] = React.useState(false);
  const [focused, setFocused] = React.useState(false);
  const canHover = triggeredBy === "hover";
  const openWithHover = canHover && hovered;
  const open = openWithHover || focused || forceOpen;
  // When the tooltip is dismissed with the Escape key and focus returns to the
  // trigger button, we do no want to reopen the tooltip. Use the state variable
  // to track when the tooltip is explicitly dismissed and skip opening it on
  // focus.
  const arrowRef = React.useRef(null);
  const {
    x,
    y,
    strategy,
    update,
    refs,
    placement: finalPlacement,
    middlewareData
  } = useTooltip({
    open,
    initialPlacement: "top",
    arrowRef,
    placementStrategy,
    positionStrategy,
    offsetPadding: 18
  });
  // Tapping outside of the tooltip should dismiss it.
  useTapOut(refs.floating, () => {
    setFocused(false);
  });
  const handleReveal = () => {
    setHovered(true);
  };
  const handleHide = () => {
    setHovered(false);
  };
  const handleClick = () => {
    setFocused(v => !v);
  };
  const handleFocus = () => {
    if (dismissed) {
      setDismissed(false);
      return;
    }
    setFocused(true);
  };
  const handleBlur = () => {
    setDismissed(false);
    setFocused(false);
  };
  const handleDismiss = () => {
    setDismissed(true);
    setHovered(false);
    setFocused(false);
  };
  const tooltipNode =
  // Do not set the role on this div if the tooltip is closed. It makes
  // testing for the presence of a visual tooltip easier in Storybook.
  jsxs("div", {
    id: tooltipId,
    role: open ? "tooltip" : undefined,
    css: tooltipStyle,
    children: [title ? jsx("div", {
      css: tooltipTitleStyle,
      children: title
    }) : null, message]
  });
  const triggerProps = {
    onClick: handleClick,
    "aria-labelledby": tooltipId
  };
  const triggerNode = typeof children === "function" ? children(triggerProps) : jsx(TooltipTrigger, {
    colorScheme: colorScheme,
    ...triggerProps,
    children: children
  });
  const tooltipTop = y == null ? "" : `${y}px`;
  const tooltipLeft = x == null ? "" : `${x}px`;
  const arrowY = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.y;
  const arrowX = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.x;
  const arrowTop = arrowY != null ? `${arrowY}px` : "";
  const arrowLeft = arrowX != null ? `${arrowX}px` : "";
  const staticSide = {
    top: vars$2.arrowBottom,
    right: vars$2.arrowLeft,
    bottom: vars$2.arrowTop,
    left: vars$2.arrowRight
  }[finalPlacement.split("-")[0] || "top"] || "";
  return jsxs("div", {
    role: "presentation",
    css: tooltipRootStyle(theme, {
      colorScheme,
      placement: finalPlacement
    }),
    ref: refs.setReference,
    onMouseEnter: canHover ? handleReveal : undefined,
    onMouseLeave: canHover ? handleHide : undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: e => {
      if (e.key !== "Escape") {
        return;
      }
      handleDismiss();
    },
    style: {
      // These must be passed in the `style` prop instead of `css` prop
      // otherwise emotion will potentially generate lots of class names
      // for this element - a performance nightmare.
      [vars$2.top]: tooltipTop,
      [vars$2.left]: tooltipLeft,
      [vars$2.arrowTop]: arrowTop,
      [vars$2.arrowLeft]: arrowLeft,
      // The arrow is a square rotated by 45 degrees. If we shift half of it
      // behind the tooltip, it will look like an arrow.
      [staticSide]: `calc(-0.5 * var(${vars$2.arrowSize}))`
    },
    children: [triggerNode, !open ? jsx("div", {
      "aria-hidden": true,
      css: tooltipShadowStyle,
      children: tooltipNode
    }) : null, jsx(CSSTransition, {
      in: open,
      timeout: 200,
      classNames: "tooltip",
      mountOnEnter: true,
      unmountOnExit: true,
      onEnter: update,
      appear: true,
      children: jsxs("div", {
        role: "presentation",
        ref: refs.setFloating,
        css: tooltipHostStyle,
        style: {
          position: strategy
        },
        children: [jsx(FocusScope, {
          restoreFocus: true,
          children: tooltipNode
        }), jsx("div", {
          css: tooltipArrowStyle,
          role: "presentation",
          ref: arrowRef
        })]
      })
    })]
  });
};

const vars$1 = {
  trackV: "--progressbar-track-bg",
  fillV: "--progressbar-fill-color",
  labelV: "--progressbar-label-color"
};
const progressBarColorTokens = (theme, progressBarTheme) => {
  const primaryOnLightColor = theme.color(Color.Greystone_DarkMatter);
  const primaryOnDarkColor = theme.color(Color.Dawn_700);
  const infoOnLightColor = theme.color(Color.Info_300);
  const infoOnDarkColor = theme.color(Color.Info_100);
  const lightTrack = theme.color(Color.Greystone_1400_A16);
  const lightFill = progressBarTheme === "primary-on-light" ? primaryOnLightColor : infoOnLightColor;
  const lightLabel = theme.color(ColorPreset.TextOnLight_01);
  const darkTrack = theme.color(Color.White_A25);
  const darkFill = progressBarTheme === "primary-on-dark" ? primaryOnDarkColor : infoOnDarkColor;
  const darkLabel = theme.color(ColorPreset.TextOnDark_02);
  switch (progressBarTheme) {
    case "primary-on-light":
    case "info-on-light":
      return {
        [vars$1.trackV]: lightTrack,
        [vars$1.fillV]: lightFill,
        [vars$1.labelV]: lightLabel
      };
    case "primary-on-dark":
    case "info-on-dark":
      return {
        [vars$1.trackV]: darkTrack,
        [vars$1.fillV]: darkFill,
        [vars$1.labelV]: darkLabel
      };
    case "primary-auto":
      return {
        [vars$1.trackV]: lightTrack,
        [vars$1.fillV]: primaryOnLightColor,
        [vars$1.labelV]: lightLabel,
        "@media (prefers-color-scheme: dark)": {
          [vars$1.trackV]: darkTrack,
          [vars$1.fillV]: primaryOnDarkColor,
          [vars$1.labelV]: darkLabel
        }
      };
    case "info-auto":
      return {
        [vars$1.trackV]: lightTrack,
        [vars$1.fillV]: infoOnLightColor,
        [vars$1.labelV]: lightLabel,
        "@media (prefers-color-scheme: dark)": {
          [vars$1.trackV]: darkTrack,
          [vars$1.fillV]: infoOnDarkColor,
          [vars$1.labelV]: darkLabel
        }
      };
  }
};
const progressBarStyle = (theme, props) => {
  const tagTheme = `${props.color}-${props.colorScheme}`;
  return [progressBarColorTokens(theme, tagTheme), typographyStyle(theme, {
    preset: TypePreset.Code_02
  }), {
    color: `var(${vars$1.labelV})`
  }];
};

const segmentedProgressBarStyle = theme => {
  return [{
    width: "100%",
    height: "4px",
    display: "grid",
    gridAutoColumns: "1fr",
    columnGap: theme.spacing(0.25),
    gridAutoFlow: "column",
    overflow: "hidden"
  }];
};
const segmentStyle = (theme, radius) => {
  return [{
    height: "100%",
    backgroundColor: `var(${vars$1.trackV})`,
    transition: "background 200ms",
    "@media (prefers-reduced-motion: reduce)": {
      transitionDuration: "50ms"
    }
  }, theme.responsive(radius, r => ({
    borderRadius: theme.radius(r || 0)
  }))];
};
const SegmentedProgressBar = props => {
  const {
    theme
  } = useTheme();
  const {
    value,
    max,
    borderRadius = 0.5
  } = props;
  const segmentCSS = segmentStyle(theme, borderRadius);
  return jsx("div", {
    css: segmentedProgressBarStyle(theme),
    children: Array.from({
      length: max
    }).map((_, i) => {
      let style = undefined;
      if (value > i) {
        style = {
          backgroundColor: `var(${vars$1.fillV})`
        };
      }
      return jsx("div", {
        css: segmentCSS,
        style: style
      }, i);
    })
  });
};

const solidProgressBarStyle = (theme, props) => {
  const trackV = `var(${vars$1.trackV})`;
  const fillV = `var(${vars$1.fillV})`;
  return [{
    width: "100%",
    height: "4px",
    backgroundColor: trackV,
    backgroundImage: `linear-gradient(to right, ${fillV}, ${fillV})`,
    backgroundRepeat: "no-repeat",
    transition: "background 200ms",
    "@media (prefers-reduced-motion: reduce)": {
      transitionDuration: "50ms"
    }
  }, theme.responsive(props.borderRadius, r => ({
    borderRadius: theme.radius(r || 0)
  }))];
};
const SolidProgressBar = props => {
  const {
    theme
  } = useTheme();
  const {
    value,
    max,
    borderRadius = 0
  } = props;
  const bsize = max === 0 ? "0" : Math.min(100, 100 * value / max).toFixed(2);
  const backgroundSize = `${bsize}% auto`;
  return jsx("div", {
    css: solidProgressBarStyle(theme, {
      ...props,
      borderRadius
    }),
    style: {
      backgroundSize
    }
  });
};

var ProgressBarVariant;
(function (ProgressBarVariant) {
  ProgressBarVariant["Segmented"] = "segmented";
  ProgressBarVariant["Solid"] = "solid";
})(ProgressBarVariant || (ProgressBarVariant = {}));
var ProgressBarColor;
(function (ProgressBarColor) {
  ProgressBarColor["Primary"] = "primary";
  ProgressBarColor["Info"] = "info";
})(ProgressBarColor || (ProgressBarColor = {}));

const ProgressBar = props => {
  const {
    theme
  } = useTheme();
  const {
    label,
    value,
    max,
    variant,
    labelVisibility = "visible",
    borderRadius,
    colorScheme = ColorScheme.OnLight,
    color = ProgressBarColor.Primary,
    ...rest
  } = props;
  const styleProps = {
    value,
    max,
    variant,
    borderRadius,
    colorScheme
  };
  const node = variant === ProgressBarVariant.Segmented ? jsx(SegmentedProgressBar, {
    ...styleProps
  }) : jsx(SolidProgressBar, {
    ...styleProps
  });
  return jsxs("div", {
    css: progressBarStyle(theme, {
      ...props,
      color
    }),
    role: "progressbar",
    "aria-valuenow": props.value,
    "aria-valuemax": props.max,
    ...rest,
    children: [label && React.Children.count(label) > 0 ? labelVisibility === "hidden" ? jsx(VisuallyHidden, {
      children: label
    }) : jsx(Box, {
      spaceBelow: 0.5,
      children: label
    }) : null, node]
  });
};

var TimelineItemStatus;
(function (TimelineItemStatus) {
  TimelineItemStatus["Alert"] = "alert";
  TimelineItemStatus["Neutral"] = "neutral";
  TimelineItemStatus["Success"] = "success";
  TimelineItemStatus["Warning"] = "warning";
})(TimelineItemStatus || (TimelineItemStatus = {}));

const timelineIconSize = "24px";
const timelineItemStyle = (theme, {
  state
}) => ({
  position: "relative",
  display: "flex",
  gap: theme.spacing(0.5),
  paddingBottom: theme.spacing(2),
  ":before": {
    content: "' '",
    width: "0px",
    height: `calc(100% - ${timelineIconSize})`,
    position: "absolute",
    top: timelineIconSize,
    left: `calc(${timelineIconSize} / 2)`,
    transform: `translateX(-50%)`,
    borderWidth: "1px",
    borderColor: theme.color(ColorPreset.BorderOnLight_03),
    borderStyle: state === "inactive" ? "dashed" : "solid"
  },
  ":last-child": {
    paddingBottom: "0px",
    ":before": {
      content: "none"
    }
  }
});

const statusColor = {
  [TimelineItemStatus.Alert]: Color.Alert_300,
  [TimelineItemStatus.Neutral]: ColorPreset.IconOnLight_02,
  [TimelineItemStatus.Success]: Color.Success_300,
  [TimelineItemStatus.Warning]: Color.Warning_300
};
const TimelineItem = ({
  title,
  state,
  statusProps,
  dateTime,
  children
}) => {
  const {
    theme
  } = useTheme();
  return jsxs(Box, {
    css: timelineItemStyle(theme, {
      state
    }),
    children: [jsx("div", {
      children: jsx(Icon, {
        name: statusProps.icon,
        color: statusColor[statusProps.status],
        size: timelineIconSize
      })
    }), jsxs(Box, {
      layout: "flex",
      flexDirection: "column",
      color: state === "inactive" ? ColorPreset.TextOnLight_03 : ColorPreset.TextOnLight_01,
      css: /*#__PURE__*/css({
        gap: theme.spacing(0.5),
        overflowWrap: "break-word"
      }, process.env.NODE_ENV === "production" ? "" : ";label:TimelineItem;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpbWVsaW5lSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0IwQyIsImZpbGUiOiJUaW1lbGluZUl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSWNvbiB9IGZyb20gXCIuLi8uLi9pY29uc1wiO1xyXG5pbXBvcnQgeyBCb3ggfSBmcm9tIFwiLi4vLi4vbGF5b3V0XCI7XHJcbmltcG9ydCB7IENvbG9yLCBDb2xvclByZXNldCwgRm9udFdlaWdodCwgVHlwZVByZXNldCwgdXNlVGhlbWUsIH0gZnJvbSBcIi4uLy4uL3RoZW1lXCI7XHJcbmltcG9ydCB7IEg1IH0gZnJvbSBcIi4uLy4uL3R5cG9ncmFwaHlcIjtcclxuaW1wb3J0IHsgVGltZWxpbmVJdGVtU3RhdHVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcclxuaW1wb3J0IHsgdGltZWxpbmVJY29uU2l6ZSwgdGltZWxpbmVJdGVtU3R5bGUgfSBmcm9tIFwiLi9zdHlsZXNcIjtcclxuY29uc3Qgc3RhdHVzQ29sb3IgPSB7XHJcbiAgICBbVGltZWxpbmVJdGVtU3RhdHVzLkFsZXJ0XTogQ29sb3IuQWxlcnRfMzAwLFxyXG4gICAgW1RpbWVsaW5lSXRlbVN0YXR1cy5OZXV0cmFsXTogQ29sb3JQcmVzZXQuSWNvbk9uTGlnaHRfMDIsXHJcbiAgICBbVGltZWxpbmVJdGVtU3RhdHVzLlN1Y2Nlc3NdOiBDb2xvci5TdWNjZXNzXzMwMCxcclxuICAgIFtUaW1lbGluZUl0ZW1TdGF0dXMuV2FybmluZ106IENvbG9yLldhcm5pbmdfMzAwLFxyXG59O1xyXG5jb25zdCBUaW1lbGluZUl0ZW0gPSAoeyB0aXRsZSwgc3RhdGUsIHN0YXR1c1Byb3BzLCBkYXRlVGltZSwgY2hpbGRyZW4sIH0pID0+IHtcclxuICAgIGNvbnN0IHsgdGhlbWUgfSA9IHVzZVRoZW1lKCk7XHJcbiAgICByZXR1cm4gKDxCb3ggY3NzPXt0aW1lbGluZUl0ZW1TdHlsZSh0aGVtZSwgeyBzdGF0ZSB9KX0+XG4gICAgICA8ZGl2PlxuICAgICAgICA8SWNvbiBuYW1lPXtzdGF0dXNQcm9wcy5pY29ufSBjb2xvcj17c3RhdHVzQ29sb3Jbc3RhdHVzUHJvcHMuc3RhdHVzXX0gc2l6ZT17dGltZWxpbmVJY29uU2l6ZX0vPlxuICAgICAgPC9kaXY+XG4gICAgICA8Qm94IGxheW91dD1cImZsZXhcIiBmbGV4RGlyZWN0aW9uPVwiY29sdW1uXCIgY29sb3I9e3N0YXRlID09PSBcImluYWN0aXZlXCJcclxuICAgICAgICAgICAgPyBDb2xvclByZXNldC5UZXh0T25MaWdodF8wM1xyXG4gICAgICAgICAgICA6IENvbG9yUHJlc2V0LlRleHRPbkxpZ2h0XzAxfSBjc3M9e3sgZ2FwOiB0aGVtZS5zcGFjaW5nKDAuNSksIG92ZXJmbG93V3JhcDogXCJicmVhay13b3JkXCIgfX0+XG4gICAgICAgIDxINSBwcmVzZXQ9e1R5cGVQcmVzZXQuQm9keV8wM30gd2VpZ2h0PXtGb250V2VpZ2h0LlNlbWlCb2xkfT5cbiAgICAgICAgICB7dGl0bGV9XG4gICAgICAgIDwvSDU+XG4gICAgICAgIHshIWNoaWxkcmVuICYmIDxCb3g+e2NoaWxkcmVufTwvQm94Pn1cbiAgICAgICAgPEJveD5cbiAgICAgICAgICB7ZGF0ZVRpbWUuZGF0ZX1cbiAgICAgICAgICB7ISFkYXRlVGltZS50aW1lICYmIDw+LCB7ZGF0ZVRpbWUudGltZX08Lz59XG4gICAgICAgIDwvQm94PlxuICAgICAgPC9Cb3g+XG4gICAgPC9Cb3g+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgVGltZWxpbmVJdGVtO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1UaW1lbGluZUl0ZW0uanN4Lm1hcCJdfQ== */"),
      children: [jsx(H5, {
        preset: TypePreset.Body_03,
        weight: FontWeight.SemiBold,
        children: title
      }), !!children && jsx(Box, {
        children: children
      }), jsxs(Box, {
        children: [dateTime.date, !!dateTime.time && jsxs(Fragment, {
          children: [", ", dateTime.time]
        })]
      })]
    })]
  });
};

const Timeline = ({
  maxWidth,
  children
}) => jsx(Box, {
  layout: "flex",
  flexDirection: "column",
  maxWidth: maxWidth,
  children: children
});

var SortDirection;
(function (SortDirection) {
  SortDirection["Ascending"] = "ascending";
  SortDirection["Descending"] = "descending";
})(SortDirection || (SortDirection = {}));
var SortMode;
(function (SortMode) {
  SortMode["Single"] = "single";
  SortMode["Controlled"] = "controlled";
  /**
   * @ignore Undocumented feature.
   */
  SortMode["Multi"] = "multi";
})(SortMode || (SortMode = {}));
//#endregion

var DataTableTextOverflow;
(function (DataTableTextOverflow) {
  DataTableTextOverflow["Ellipsis"] = "ellipsis";
  DataTableTextOverflow["Initial"] = "initial";
  DataTableTextOverflow["NoWrap"] = "nowrap";
})(DataTableTextOverflow || (DataTableTextOverflow = {}));

const vars = {
  borderColor: "--datatable-border-color",
  headingColor: "--datatable-heading-color",
  headingItemSpacing: "--datatable-item-spacing",
  rowHoverBg: "--datatable-row-hover-bg",
  rowFocusedOutline: "--datatable-row-focused-outline"
};
const dataTableStyle = theme => {
  return [{
    [vars.headingColor]: theme.color(ColorPreset.TextOnLight_03),
    [vars.headingItemSpacing]: theme.spacing(0.5),
    [vars.borderColor]: theme.color(ColorPreset.BorderOnLight_04),
    [vars.rowHoverBg]: theme.color(Color.Brownstone_700_A12),
    [vars.rowFocusedOutline]: theme.color(ColorPreset.BorderOnLight_01)
  }, {
    border: "none",
    padding: 0,
    margin: 0,
    borderCollapse: "collapse",
    width: "100%",
    position: "relative",
    "thead tr:hover": {
      backgroundColor: "unset"
    }
  }];
};
const dataTableHeaderStyle = (theme, {
  textAlign = TextAlign.Left,
  textOverflow = DataTableTextOverflow.NoWrap
}) => {
  return [theme.responsive(textAlign, val => ({
    textAlign: val
  })), {
    padding: theme.spacing(1),
    fontWeight: FontWeight.Normal,
    color: `var(${vars.headingColor})`,
    whiteSpace: "nowrap"
  }, theme.responsive(textOverflow, to => {
    switch (to) {
      case DataTableTextOverflow.NoWrap:
        return {
          textOverflow: "initial",
          overflow: "initial",
          whiteSpace: "nowrap"
        };
      case DataTableTextOverflow.Ellipsis:
        return {
          textOverflow: to,
          overflow: "hidden",
          whiteSpace: "nowrap"
        };
      default:
        return {
          textOverflow: "initial",
          overflow: "initial",
          whiteSpace: "initial"
        };
    }
  })];
};
const dataTableHeadingContentStyle = {
  display: "inline-grid",
  alignItems: "center",
  gridAutoFlow: "column",
  gap: `var(${vars.headingItemSpacing})`
};
const dataTableCellFadeStyle = (_, state) => {
  switch (state) {
    case "exiting":
    case "entering":
      return {
        opacity: 0
      };
    default:
      return {
        opacity: 1
      };
  }
};
const dataTableCellStyle = (theme, {
  cellStyle,
  removePadding
}) => {
  const {
    maxWidth,
    minWidth,
    textOverflow,
    bg,
    gutterH = 1,
    gutterV = 1,
    ...rest
  } = cellStyle;
  return [typographyStyle(theme, rest), {
    backgroundColor: bg ? theme.color(bg) : undefined,
    transition: "opacity 250ms"
  }, theme.responsive(textOverflow, to => {
    switch (to) {
      case DataTableTextOverflow.NoWrap:
        return {
          textOverflow: "initial",
          overflow: "initial",
          whiteSpace: "nowrap"
        };
      case DataTableTextOverflow.Ellipsis:
        return {
          textOverflow: to,
          overflow: "hidden",
          whiteSpace: "nowrap"
        };
      default:
        return {
          textOverflow: "initial",
          overflow: "initial",
          whiteSpace: "initial"
        };
    }
  }), theme.responsive(maxWidth, mw => ({
    maxWidth: mw
  })), theme.responsive(minWidth, mw => ({
    minWidth: mw
  })), ...(!removePadding ? [theme.responsive(gutterV, v => ({
    paddingTop: theme.spacing(v),
    paddingBottom: theme.spacing(v)
  }))] : []), ...(!removePadding ? [theme.responsive(gutterH, v => ({
    paddingLeft: theme.spacing(v),
    paddingRight: theme.spacing(v)
  }))] : [])];
};
const dataTableRowStyle = hideBottomBorder => ({
  borderBottom: hideBottomBorder ? "" : `1px solid var(${vars.borderColor})`,
  ":hover": {
    backgroundColor: `var(${vars.rowHoverBg})`
  },
  ":hover[tabindex]": {
    cursor: "pointer"
  },
  ":focus-visible": {
    outline: "none",
    boxShadow: `inset 0 0 0 2px var(${vars.rowFocusedOutline})`
  },
  transition: "background-color 150ms ease-in-out"
});
const dataTableRowLinkStyle = (theme, props) => {
  const {
    textOverflow,
    gutterH = 1,
    gutterV = 1
  } = props;
  return [{
    color: "inherit",
    display: "block",
    textDecoration: "none",
    outline: "none",
    width: "100%"
  }, theme.responsive(gutterV, v => ({
    paddingTop: theme.spacing(v),
    paddingBottom: theme.spacing(v)
  })), theme.responsive(gutterH, v => ({
    paddingLeft: theme.spacing(v),
    paddingRight: theme.spacing(v)
  })), theme.responsive(textOverflow, to => {
    switch (to) {
      case DataTableTextOverflow.NoWrap:
        return {
          textOverflow: "initial",
          overflow: "initial",
          whiteSpace: "nowrap"
        };
      case DataTableTextOverflow.Ellipsis:
        return {
          textOverflow: to,
          overflow: "hidden",
          whiteSpace: "nowrap"
        };
      default:
        return {
          textOverflow: "initial",
          overflow: "initial",
          whiteSpace: "initial"
        };
    }
  })];
};
const dataTableCompactRowStyle = (theme, {
  hideTopBorder,
  hideBottomBorder
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  padding: `${theme.spacing(1.5)} 0px`,
  borderTop: hideTopBorder ? "" : `1px solid var(${vars.borderColor})`,
  ":last-child": {
    borderBottom: hideBottomBorder ? "" : `1px solid var(${vars.borderColor})`
  }
});
const compactBodyGridStyle = theme => [{
  flex: "auto",
  display: "grid",
  margin: "0"
}, theme.responsive(["0", theme.spacing(1)], gap => ({
  gap
})), theme.responsive(["1fr", "max-content 1fr", "repeat(2, max-content 1fr)"], columns => ({
  gridTemplateColumns: columns
}))];

/* eslint-disable @typescript-eslint/ban-types */
const DataTableSortIndicator = props => {
  switch (props.direction) {
    case SortDirection.Ascending:
      return jsx(Icon, {
        verticalAlign: "middle",
        name: Glyph.ArrowUp,
        size: "16px",
        color: ColorPreset.IconOnLight_04
      });
    case SortDirection.Descending:
      return jsx(Icon, {
        verticalAlign: "middle",
        name: Glyph.ArrowDown,
        size: "16px",
        color: ColorPreset.IconOnLight_04
      });
    default:
      return jsx(Icon, {
        verticalAlign: "middle",
        name: Glyph.Swap,
        size: "16px",
        color: Color.Greystone_1400_A16
      });
  }
};
const defaultStyleProps = () => ({});
function getHeaderLabelAndAccessories(heading) {
  const renderResult = heading.render();
  let label = null;
  let leftAccessory = null;
  let rightAccessory = null;
  if (renderResult != null && typeof renderResult === "object" && "label" in renderResult) {
    label = renderResult.label;
    leftAccessory = renderResult.leftAccessory;
    rightAccessory = renderResult.rightAccessory;
  } else {
    label = renderResult;
  }
  return {
    label,
    leftAccessory,
    rightAccessory
  };
}
function DataTable(props) {
  const {
    theme
  } = useTheme();
  const {
    headings,
    rows,
    getTableProps,
    getHeadingStyleProps = defaultStyleProps,
    getCellStyleProps = defaultStyleProps,
    emptyState,
    hideBottomBorder
  } = props;
  return jsxs("table", {
    ...getTableProps(),
    css: dataTableStyle(theme),
    children: [jsx("thead", {
      children: jsx("tr", {
        ...headings.getRowProps(),
        css: dataTableRowStyle(),
        children: headings.cells.map(heading => {
          const headingProps = heading.getHeadingProps();
          const ariaSort = headingProps["aria-sort"];
          const {
            label,
            leftAccessory,
            rightAccessory
          } = getHeaderLabelAndAccessories(heading);
          let content = label;
          if (heading.canSort) {
            content = jsx(PlainButton, {
              effect: HoverEffect.TextDecoration,
              onClick: heading.toggleSort,
              "aria-pressed": ariaSort != null,
              children: label
            });
          }
          return createElement("th", {
            ...headingProps,
            key: headingProps.key,
            css: dataTableHeaderStyle(theme, getHeadingStyleProps(heading))
          }, jsxs("div", {
            css: dataTableHeadingContentStyle,
            children: [heading.canSort ? jsx(DataTableSortIndicator, {
              direction: heading.sorted
            }) : null, leftAccessory, content, rightAccessory]
          }));
        })
      })
    }), jsxs("tbody", {
      children: [rows.length === 0 && !!emptyState && jsx("tr", {
        role: "row",
        children: jsx("td", {
          role: "cell",
          colSpan: headings.cells.length,
          children: emptyState
        }, "empty_0")
      }, "empty_state_row"), rows.map((row, index, arr) => {
        const rowProps = row.getRowProps();
        const isLastRow = index === arr.length - 1;
        return createElement("tr", {
          ...rowProps,
          key: rowProps.key,
          css: dataTableRowStyle(hideBottomBorder && isLastRow)
        }, jsx(TransitionGroup, {
          component: null,
          appear: false,
          enter: true,
          exit: false,
          children: row.cells.map(cell => {
            const cellProps = cell.getCellProps();
            const renderCellLink = Boolean(rowProps.link && !cell.omitLink);
            return jsx(Transition, {
              in: cell.type === "data",
              timeout: 250,
              children: state => {
                return jsx("td", {
                  className: state,
                  ...cellProps,
                  css: [dataTableCellFadeStyle(theme, state), dataTableCellStyle(theme, {
                    cellStyle: getCellStyleProps(cell),
                    removePadding: renderCellLink
                  }), process.env.NODE_ENV === "production" ? "" : ";label:DataTable;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
                  children: cell.type === "loading" ? jsx(Shimmer, {}) : renderCellLink ? jsx("a", {
                    href: rowProps.link,
                    css: dataTableRowLinkStyle(theme, getCellStyleProps(cell)),
                    children: cell.render()
                  }) : cell.render()
                });
              }
            }, cellProps.key);
          })
        }));
      })]
    })]
  });
}

function Actions({
  collapsible,
  actions,
  collapsed,
  toggleCollapse,
  rowKey
}) {
  const {
    theme
  } = useTheme();
  return jsxs(Box, {
    layout: "flex",
    flexGrow: 0,
    children: [!!actions && jsx(Box, {
      layout: "flex",
      flexWrap: "wrap",
      css: /*#__PURE__*/css({
        gap: theme.spacing(0.5)
      }, process.env.NODE_ENV === "production" ? "" : ";label:Actions;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbXBhY3RSb3dSaWdodEFjdGlvbnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU93RCIsImZpbGUiOiJDb21wYWN0Um93UmlnaHRBY3Rpb25zLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJ1dHRvblZhcmlhbnQsIEljb25CdXR0b24gfSBmcm9tIFwiLi4vYnV0dG9uc1wiO1xyXG5pbXBvcnQgeyBHbHlwaCB9IGZyb20gXCIuLi9pY29uc1wiO1xyXG5pbXBvcnQgeyBCb3gsIFZpc2liaWxpdHkgfSBmcm9tIFwiLi4vbGF5b3V0XCI7XHJcbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSBcIi4uL3RoZW1lXCI7XHJcbmZ1bmN0aW9uIEFjdGlvbnMoeyBjb2xsYXBzaWJsZSwgYWN0aW9ucywgY29sbGFwc2VkLCB0b2dnbGVDb2xsYXBzZSwgcm93S2V5LCB9KSB7XHJcbiAgICBjb25zdCB7IHRoZW1lIH0gPSB1c2VUaGVtZSgpO1xyXG4gICAgcmV0dXJuICg8Qm94IGxheW91dD1cImZsZXhcIiBmbGV4R3Jvdz17MH0+XG4gICAgICB7ISFhY3Rpb25zICYmICg8Qm94IGxheW91dD1cImZsZXhcIiBmbGV4V3JhcD1cIndyYXBcIiBjc3M9e3sgZ2FwOiB0aGVtZS5zcGFjaW5nKDAuNSkgfX0+XG4gICAgICAgICAge2FjdGlvbnMubWFwKChhY3Rpb24sIGkpID0+ICg8c3BhbiBrZXk9e2Ake3Jvd0tleX1fYWN0aW9uXyR7aX1gfT57YWN0aW9ufTwvc3Bhbj4pKX1cbiAgICAgICAgPC9Cb3g+KX1cbiAgICAgIHshIWNvbGxhcHNpYmxlICYmICg8VmlzaWJpbGl0eSB2aXNpYmxlPXtbXCJibG9ja1wiLCBudWxsLCBcIm5vbmVcIl19PlxuICAgICAgICAgIDxJY29uQnV0dG9uIHZhcmlhbnQ9e2NvbGxhcHNpYmxlLnZhcmlhbnRcclxuICAgICAgICAgICAgICAgID8gY29sbGFwc2libGUudmFyaWFudFxyXG4gICAgICAgICAgICAgICAgOiBCdXR0b25WYXJpYW50LlRleHRPbkxpZ2h0fSBpY29uPXtjb2xsYXBzZWQgPyBHbHlwaC5DaGV2cm9uRG93biA6IEdseXBoLkNoZXZyb25VcH0gc2l6ZT17Y29sbGFwc2libGUuc2l6ZX0gbGFiZWw9e2NvbGxhcHNlZFxyXG4gICAgICAgICAgICAgICAgPyBjb2xsYXBzaWJsZS5sYWJlbFRyYW5zbGF0aW9ucy5leHBhbmRcclxuICAgICAgICAgICAgICAgIDogY29sbGFwc2libGUubGFiZWxUcmFuc2xhdGlvbnMuY29sbGFwc2V9IG9uQ2xpY2s9eygpID0+IHRvZ2dsZUNvbGxhcHNlKCl9Lz5cbiAgICAgICAgPC9WaXNpYmlsaXR5Pil9XG4gICAgPC9Cb3g+KTtcclxufVxyXG5leHBvcnQgZGVmYXVsdCBBY3Rpb25zO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1Db21wYWN0Um93UmlnaHRBY3Rpb25zLmpzeC5tYXAiXX0= */"),
      children: actions.map((action, i) => jsx("span", {
        children: action
      }, `${rowKey}_action_${i}`))
    }), !!collapsible && jsx(Visibility, {
      visible: ["block", null, "none"],
      children: jsx(IconButton, {
        variant: collapsible.variant ? collapsible.variant : ButtonVariant.TextOnLight,
        icon: collapsed ? Glyph.ChevronDown : Glyph.ChevronUp,
        size: collapsible.size,
        label: collapsed ? collapsible.labelTranslations.expand : collapsible.labelTranslations.collapse,
        onClick: () => toggleCollapse()
      })
    })]
  });
}

function CompactRowBody({
  headingsArray,
  alwaysVisibleAmount,
  data,
  rowKey,
  getHeadingStyleProps = () => ({}),
  getCellStyleProps = () => ({})
}) {
  const {
    theme
  } = useTheme();
  return jsx("dl", {
    css: compactBodyGridStyle(theme),
    children: headingsArray.map((heading, index) => {
      const headingProps = heading.getHeadingProps();
      const {
        label,
        leftAccessory,
        rightAccessory
      } = getHeaderLabelAndAccessories(heading);
      const cellInstance = data.cells.find(cell => cell.accessor === heading.accessor);
      let cellRender = null;
      if (cellInstance) {
        cellRender = cellInstance.type === "loading" ? jsx(Shimmer, {}) : cellInstance.render();
      }
      const collapse = !!alwaysVisibleAmount && index >= alwaysVisibleAmount;
      const display = collapse ? theme.responsive(["none", null, "block"], value => ({
        display: value
      })) : undefined;
      return jsxs(React.Fragment, {
        children: [jsx("dt", {
          css: [dataTableHeaderStyle(theme, getHeadingStyleProps(heading)), "padding:0;", display, process.env.NODE_ENV === "production" ? "" : ";label:CompactRowBody;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
          children: jsxs(Box, {
            css: [dataTableHeadingContentStyle, "align-items:start;" + (process.env.NODE_ENV === "production" ? "" : ";label:CompactRowBody;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
            children: [leftAccessory, label, rightAccessory]
          }, `${rowKey}_${headingProps.key}_render`)
        }, `${rowKey}_${headingProps.key}`), jsx("dd", {
          css: ["margin:0;", display, theme.responsive([theme.spacing(1), "0"], mb => ({
            marginBottom: mb,
            ":last-child": {
              marginBottom: "0"
            }
          })), process.env.NODE_ENV === "production" ? "" : ";label:CompactRowBody;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
          children: !!cellInstance && jsx(Box, {
            css: [dataTableCellStyle(theme, {
              cellStyle: getCellStyleProps(cellInstance)
            }), "padding:0px;" + (process.env.NODE_ENV === "production" ? "" : ";label:CompactRowBody;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"],
            children: cellRender
          }, `${rowKey}_${headingProps.key}_value_render`)
        }, `${rowKey}_${headingProps.key}_value`)]
      }, `${rowKey}_${headingProps.key}_fragment`);
    })
  }, `${rowKey}_body_dl`);
}

function DataTableCompactRow(props) {
  const {
    collapsible,
    headingsArray,
    ...rest
  } = props;
  const [collapsed, setCollapsed] = React.useState(!!collapsible);
  const {
    theme
  } = useTheme();
  const extraActions = props.data.compactActions;
  const actionsRight = !!extraActions && !!extraActions.rightActions;
  const rowButtons = !!collapsible || actionsRight;
  const toggleCollapse = () => setCollapsed(state => !state);
  const pickedHeadings = headingsArray.filter(heading => !heading.omittedWhenCompact);
  const showHeadingsCount = collapsible !== null && collapsible !== void 0 && collapsible.alwaysVisibleAmount && collapsible.alwaysVisibleAmount > 0 ? collapsible.alwaysVisibleAmount : 2;
  return jsxs(LI, {
    css: dataTableCompactRowStyle(theme, {
      hideTopBorder: props.hideTopBorder,
      hideBottomBorder: props.hideBottomBorder
    }),
    children: [jsxs(Box, {
      layout: "flex",
      justifyContent: JustifyContent.SpaceBetween,
      children: [jsx(CompactRowBody, {
        ...rest,
        headingsArray: pickedHeadings,
        alwaysVisibleAmount: !!collapsible && collapsed ? showHeadingsCount : undefined
      }), !!rowButtons && jsx(Actions, {
        collapsed: collapsed,
        toggleCollapse: toggleCollapse,
        rowKey: props.rowKey,
        collapsible: !!collapsible ? {
          labelTranslations: collapsible.labelTranslations
        } : undefined,
        actions: !!extraActions ? extraActions.rightActions : undefined
      })]
    }), !!extraActions && !!extraActions.bottomActions && jsx(Box, {
      layout: "flex",
      flexWrap: "wrap",
      css: /*#__PURE__*/css({
        gap: theme.spacing(0.5)
      }, process.env.NODE_ENV === "production" ? "" : ";label:DataTableCompactRow;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: extraActions.bottomActions.map((action, i) => jsx("span", {
        children: action
      }, `${props.rowKey}_action_bottom_${i}`))
    })]
  }, `${props.rowKey}_li`);
}
function DataTableCompact(props) {
  const {
    theme
  } = useTheme();
  const {
    headings,
    rows,
    getHeadingStyleProps,
    getCellStyleProps,
    collapsible,
    emptyState,
    hideBottomBorder,
    hideTopBorder
  } = props;
  if (rows.length === 0 && emptyState) {
    return jsx(Box, {
      children: emptyState
    });
  }
  return jsx(UL, {
    marker: "none",
    css: dataTableStyle(theme),
    children: rows.map((row, index, arr) => {
      const rowProps = row.getRowProps();
      const isFirstItem = index === 0;
      const isLastItem = index === arr.length - 1;
      return jsx(DataTableCompactRow, {
        rowKey: rowProps.key,
        data: row,
        headingsArray: headings.cells,
        getHeadingStyleProps: getHeadingStyleProps,
        getCellStyleProps: getCellStyleProps,
        collapsible: collapsible,
        hideTopBorder: hideTopBorder && isFirstItem,
        hideBottomBorder: hideBottomBorder && isLastItem
      }, rowProps.key);
    })
  });
}

const useBreakpointLayout = (theme, breakpoint) => {
  const [layout, setLayout] = React.useState();
  const mediaQueryChange = ev => {
    setLayout(ev.matches ? "table" : "compact");
  };
  React.useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${theme.tokens.breakpoints[breakpoint]})`);
    setLayout(mediaQuery.matches ? "table" : "compact");
    mediaQuery.addEventListener("change", mediaQueryChange);
    return () => {
      mediaQuery.removeEventListener("change", mediaQueryChange);
    };
  }, [breakpoint]);
  return {
    layout
  };
};
function DataTableResponsive({
  dataTable,
  dataTableCompact,
  tableLayoutBreakpoint,
  ...rest
}) {
  const {
    theme
  } = useTheme();
  const {
    layout
  } = useBreakpointLayout(theme, tableLayoutBreakpoint);
  if (!layout) return jsx(Fragment, {});
  return jsx(Box, {
    ...rest,
    children: layout === "table" ? dataTable : dataTableCompact
  });
}

/* eslint-disable @typescript-eslint/no-namespace */
const defaultGetTableProps = () => ({
  role: "grid",
  "aria-readonly": true
});
const defaultGetHeadingsRowProps = () => ({
  key: "headings_row",
  role: "row"
});
const defaultComparator = (a, b) => {
  return a === b ? 0 : a < b ? -1 : 1;
};
//#endregion
function isPlaceholderItem(item) {
  return !!item && typeof item === "object" && "loading" in item && item.loading === true;
}
const nextSortDirection = current => {
  switch (current) {
    case SortDirection.Ascending:
      return SortDirection.Descending;
    case SortDirection.Descending:
      return undefined;
    case undefined:
      return SortDirection.Ascending;
  }
};
function nextSortState(mode, state, selected) {
  if (!mode || mode === SortMode.Controlled) {
    return state;
  }
  const currentIndex = state.findIndex(([a]) => selected === a);
  const currentValue = currentIndex > -1 ? state[currentIndex] : undefined;
  const nextDirection = nextSortDirection(currentValue === null || currentValue === void 0 ? void 0 : currentValue[1]);
  let nextValue = undefined;
  if (nextDirection) {
    nextValue = [selected, nextDirection];
  }
  const nextState = [...state];
  if (!nextValue) {
    nextState.splice(currentIndex, 1);
    return nextState;
  }
  if (mode === SortMode.Single) {
    return [nextValue];
  }
  if (currentIndex > -1) {
    nextState[currentIndex] = nextValue;
  } else {
    nextState.push(nextValue);
  }
  return nextState;
}
function sortRows(rows, headings, sorts) {
  const sorters = sorts.map(([accessor, direction]) => {
    const heading = headings.find(h => h.accessor === accessor);
    if (!heading) {
      return;
    }
    const {
      comparator = defaultComparator
    } = heading;
    return [heading.accessor, comparator, direction];
  });
  if (!sorters.length) {
    return;
  }
  rows.sort((a, b) => {
    if (isPlaceholderItem(a.item)) {
      return 1;
    }
    if (isPlaceholderItem(b.item)) {
      return -1;
    }
    if (a.item) for (let i = 0; i < sorters.length; i++) {
      const sorter = sorters[i];
      if (!sorter) {
        continue;
      }
      const [accessor, func, dir] = sorter;
      const out = func(a.item[accessor], b.item[accessor]);
      if (out !== 0) {
        return dir === SortDirection.Descending ? -out : out;
      }
    }
    return 0;
  });
}
const noop = () => {};
function makeReducer() {
  const reducer = (state, action) => {
    switch (action.type) {
      case "RESET_SORT":
        return {
          ...state,
          activeSort: action.payload
        };
      case "SORT":
        return {
          ...state,
          activeSort: nextSortState(action.payload.mode, state.activeSort, action.payload.accessor)
        };
      default:
        return state;
    }
  };
  return reducer;
}
function useDataTable(options) {
  const {
    headings,
    data,
    sorting,
    activeSort: inputActiveSort,
    getItemId,
    getRowLink,
    cellRenderers,
    headingRenderers,
    onControlledSort = noop,
    onRowClick,
    omitCompactHeadings,
    omitColumnLinks,
    compactActions
  } = options;
  const reducer = React.useMemo(() => makeReducer(), []);
  const [state, dispatch] = React.useReducer(reducer, {
    activeSort: inputActiveSort || []
  });
  const {
    activeSort
  } = state;
  React.useEffect(() => {
    if (sorting === SortMode.Controlled) {
      dispatch({
        type: "RESET_SORT",
        payload: inputActiveSort || []
      });
    }
  }, [sorting, inputActiveSort, dispatch]);
  //#region Build HeadingsRowInstance
  const headingRow = React.useMemo(() => {
    const cells = headings.map(h => {
      var _activeSort$sortIndex;
      const {
        accessor,
        sorting: headingSort,
        label
      } = h;
      const sortIndex = activeSort.findIndex(([a]) => accessor === a);
      const sorted = sortIndex >= 0 ? (_activeSort$sortIndex = activeSort[sortIndex]) === null || _activeSort$sortIndex === void 0 ? void 0 : _activeSort$sortIndex[1] : undefined;
      const canSort = sorting != null && headingSort !== "disabled";
      const heading = {
        accessor,
        canSort,
        sorted,
        toggleSort: () => {
          if (!canSort) {
            return;
          }
          switch (sorting) {
            case SortMode.Controlled:
              onControlledSort(accessor);
              return;
            case SortMode.Single:
            case SortMode.Multi:
              dispatch({
                type: "SORT",
                payload: {
                  accessor,
                  mode: sorting
                }
              });
              return;
          }
        },
        render() {
          const found = headingRenderers === null || headingRenderers === void 0 ? void 0 : headingRenderers[accessor];
          return found ? found({
            label
          }) : label;
        },
        getHeadingProps() {
          return {
            key: `${String(accessor)}`,
            role: "columnheader",
            scope: "col",
            "aria-sort": sorted == null ? undefined : sorted === SortDirection.Descending ? "descending" : "ascending"
          };
        },
        omittedWhenCompact: !!omitCompactHeadings && omitCompactHeadings.includes(accessor)
      };
      return heading;
    });
    return {
      cells,
      getRowProps: defaultGetHeadingsRowProps
    };
  }, [headings, activeSort, sorting, dispatch, onControlledSort]);
  //#endregion
  //#region Build rows
  const rows = React.useMemo(() => {
    const allRows = data.map(item => {
      const itemId = isPlaceholderItem(item) ? item.id : getItemId(item);
      const itemLink = !isPlaceholderItem(item) && getRowLink ? getRowLink(item) : "";
      const onClick = onRowClick && !isPlaceholderItem(item) ? () => onRowClick(item) : undefined;
      const cells = headings.map(({
        accessor
      }, index) => {
        if (isPlaceholderItem(item)) {
          return {
            type: "loading",
            accessor,
            omitLink: false,
            getCellProps: () => ({
              key: `loading_${String(accessor)}_${index}`,
              role: "gridcell"
            })
          };
        }
        const value = item[accessor];
        const omitLink = Boolean(omitColumnLinks === null || omitColumnLinks === void 0 ? void 0 : omitColumnLinks.includes(accessor));
        const enableCustomClick = Boolean(itemLink) && omitLink;
        return {
          type: "data",
          accessor,
          value,
          item,
          omitLink: omitLink,
          getCellProps: () => ({
            key: `${String(accessor)}_${index}`,
            role: "gridcell",
            onClick: enableCustomClick ? onClick : undefined
          }),
          render() {
            const renderCell = cellRenderers === null || cellRenderers === void 0 ? void 0 : cellRenderers[accessor];
            if (renderCell) {
              return renderCell({
                value,
                item
              });
            }
            return jsx(Fragment, {
              children: value
            });
          }
        };
      });
      const tabIndex = onClick ? 0 : undefined;
      let compactActionsRendered = undefined;
      if (compactActions && !isPlaceholderItem(item)) {
        compactActionsRendered = {
          rightActions: compactActions.rightActions ? compactActions.rightActions(item) : undefined,
          bottomActions: compactActions.bottomActions ? compactActions.bottomActions(item) : undefined
        };
      }
      const rowInstance = {
        cells,
        item,
        getRowProps: () => ({
          role: "row",
          key: itemId,
          onClick: itemLink ? undefined : onClick,
          tabIndex,
          link: itemLink
        }),
        compactActions: compactActionsRendered
      };
      return rowInstance;
    });
    if (sorting && sorting !== SortMode.Controlled) {
      sortRows(allRows, headings, activeSort);
    }
    return allRows;
  }, [headings, data, cellRenderers, getItemId, activeSort, sorting, onRowClick]);
  //#endregion
  return {
    activeSort,
    rows,
    headings: headingRow,
    getTableProps: defaultGetTableProps
  };
}

const resetStyle = (theme, props) => ({
  "*": {
    boxSizing: "border-box"
  },
  "html, body": [{
    fontFamily: theme.tokens.fontFamilies["sans-serif"],
    backgroundColor: props.bg ? theme.color(props.bg) : undefined,
    color: theme.color(props.color),
    textRendering: "optimizeLegibility",
    WebkitFontSmoothing: "antialiased"
  }, theme.responsive(theme.tokens.typePresets[TypePreset.Body_02].size, fs => ({
    ...theme.tokens.fontSizes[fs]
  }))],
  html: {
    textSizeAdjust: "100%"
  },
  body: {
    minHeight: "100vh",
    padding: 0,
    margin: 0
  },
  // :focus-visible polyfill for hiding focus states when elements are interacted
  // with mouse, but remain visible when tabbing through with the keyboard
  ".js-focus-visible :focus:not(.focus-visible)": {
    outline: "none"
  },
  ":focus:not(:focus-visible)": {
    outline: "none"
  }
});
const Reset = props => {
  const {
    theme
  } = useTheme();
  const {
    bg,
    color = ColorPreset.TextOnLight_01
  } = props;
  return jsx(Global, {
    styles: resetStyle(theme, {
      bg,
      color
    })
  });
};

var index = {};

export { AccessorySize, Accordion, AccordionItem, AccordionMode, AccordionOutline, AccordionSize, AccordionVariant, AlignContent, AlignItems, Article, Aside, Avatar, AvatarSize, Banner, BannerActionType, BannerButtonVariant, BannerLayout, BannerLeftAccessoryType, BannerStatus, BannerVariant, BlockQuote, Box, Breadcrumbs, BreadcrumbsItem, Breakpoint, Button, ButtonGroup, ButtonGutter, ButtonLayout, ButtonSize, ButtonVariant, Calendar, CalendarRange, Card, CardActionType, CardButtonVariant, CardGradient, CardLayout, CardType, CardVariant, Carousel, Checkbox, CheckboxesToggle, ChevronToggle, Cite, Code, CodeBlock, CodeSnippet, CodeSnippets, Color, ColorPreset, ColorScheme, Column, Container, DD, DL, DLLayout, DT, DataTable, DataTableCompact, DataTableResponsive, DataTableTextOverflow, DateInput, DatePicker, DateRangePicker, Dialog, Dropdown, DynamicList, DynamicListItem, Field, FieldSet, FlexItem, FocusRing, FontStyle, FontWeight, Footer, Form, FormFieldStatus, FullWidth, Glyph, Grid, GridSemantics, H1, H2, H3, H4, H5, H6, HTMLContent, Header, Hint, HoverEffect, Icon, IconButton, IconLink, Input, InputGutter, Interpose, JustifyContent, JustifyItems, LI, Label, LabelledPanel, Layer, LegacyCard, Legend, LineClamp, Link, ListItem, MainArea, Menu, MenuButton, MenuDensity, MenuExpander, MenuGroup, MenuLink, MenuRole, MenuRoot, MenuSeparator, MoneyText, MoneyTextVariant, Nav, OL, Option, Overflow, P, PasswordInput, PlainButton, PlainLink, ProgressBar, ProgressBarColor, ProgressBarVariant, Radio, ReadingOptimized, Reset, Section, Select, SelectInput, Separator, Shimmer, Sidebar, SidebarLayout, SkipLink, Slider, SortDirection, SortMode, Space, Switch, TabItem, Table, TableBody, TableCell, TableContainer, TableFoot, TableHead, TableHeadCell, TableRow, Tabs, Tag, TagColor, TagSize, TagVariant, Text, TextAlign, TextArea, TextAreaResize, TextWrap, ThemeProvider, Timeline, TimelineItem, TimelineItemStatus, Toast, ToastProvider, Toaster, ToasterPosition, Toggle, ToggleControl, ToggleControlPosition, ToggleVariant, Tooltip, TooltipTheme, TypePreset, TypeScale, UL, Upload, UploadSelectionMode, UploadStatus, Visibility, VisuallyHidden, XYGrid, ZIndex, dateHelpers, index as default, defaultDesignTokens, getHighlightedText, registry as iconRegistry, inputGutterStyle, makeCSSValueHelper, plainButtonStyle, typographyStyle, useDataTable, useTheme, useToast };
//# sourceMappingURL=index.js.map
